import _ from 'lodash';

const matrix = [
	{ key: 'Adjuntas', value: 'Región suroeste' },
	{ key: 'Aguada', value: 'Región Oeste' },
	{ key: 'Aguadilla', value: 'Región Oeste' },
	{ key: 'Aguas Buenas', value: 'Región este' },
	{ key: 'Aibonito', value: 'Región sureste' },
	{ key: 'Añasco', value: 'Región Oeste' },
	{ key: 'Arecibo', value: 'Región Norte' },
	{ key: 'Arroyo', value: 'Región sureste' },
	{ key: 'Barceloneta', value: 'Región Norte' },
	{ key: 'Barranquitas', value: 'Región sureste' },
	{ key: 'Bayamón', value: 'Región Metro Norte' },
	{ key: 'Cabo Rojo', value: 'Región Oeste' },
	{ key: 'Caguas', value: 'Región este' },
	{ key: 'Camuy', value: 'Región Norte' },
	{ key: 'Canóvanas', value: 'Región Noreste' },
	{ key: 'Carolina', value: 'Región Noreste' },
	{ key: 'Cataño', value: 'Región Metro Norte' },
	{ key: 'Cayey', value: 'Región este' },
	{ key: 'Ceiba', value: 'Región Norte' },
	{ key: 'Ciales', value: 'Región este' },
	{ key: 'Cidra', value: 'Región Noreste' },
	{ key: 'Coamo', value: 'Región sureste' },
	{ key: 'Comerío', value: 'Región Metro Norte' },
	{ key: 'Corozal', value: 'Región Metro Norte' },
	{ key: 'Culebra', value: 'Región Noreste' },
	{ key: 'Dorado', value: 'Región Metro Norte' },
	{ key: 'Fajardo', value: 'Región Noreste' },
	{ key: 'Florida', value: 'Región Norte' },
	{ key: 'Guánica', value: 'Región suroeste' },
	{ key: 'Guayama', value: 'Región sureste' },
	{ key: 'Guayanilla', value: 'Región suroeste' },
	{ key: 'Guaynabo', value: 'Región Metro Norte' },
	{ key: 'Gurabo', value: 'Región este' },
	{ key: 'Hatillo', value: 'Región Norte' },
	{ key: 'Hormigueros', value: 'Región este' },
	{ key: 'Humacao', value: 'Región Oeste' },
	{ key: 'Isabela', value: 'Región suroeste' },
	{ key: 'Jayuya', value: 'Región sureste' },
	{ key: 'Juana Díaz', value: 'Región este' },
	{ key: 'Juncos', value: 'Región Oeste' },
	{ key: 'Lajas', value: 'Región Norte' },
	{ key: 'Lares', value: 'Región Oeste' },
	{ key: 'Las Marías', value: 'Región este' },
	{ key: 'Las Piedras', value: 'Región Noreste' },
	{ key: 'Loíza', value: 'Región Noreste' },
	{ key: 'Luquillo', value: 'Región Norte' },
	{ key: 'Manatí', value: 'Región Oeste' },
	{ key: 'Maricao', value: 'Región Oeste' },
	{ key: 'Maunabo', value: 'Región sureste' },
	{ key: 'Mayagüez', value: 'Región Oeste' },
	{ key: 'Moca', value: 'Región Oeste' },
	{ key: 'Morovis', value: 'Región Norte' },
	{ key: 'Naguabo', value: 'Región este' },
	{ key: 'Naranjito', value: 'Región Metro Norte' },
	{ key: 'Orocovis', value: 'Región sureste' },
	{ key: 'Patillas', value: 'Región sureste' },
	{ key: 'Peñuelas', value: 'Región suroeste' },
	{ key: 'Ponce', value: 'Región suroeste' },
	{ key: 'Quebradillas', value: 'Región Norte' },
	{ key: 'Rincón', value: 'Región Oeste' },
	{ key: 'Río Grande', value: 'Región Noreste' },
	{ key: 'Sabana Grande', value: 'Región Oeste' },
	{ key: 'Salinas', value: 'Región sureste' },
	{ key: 'San Germán', value: 'Región Oeste' },
	{ key: 'San Juan', value: 'Región San Juan' },
	{ key: 'San Lorenzo', value: 'Región este' },
	{ key: 'San Sebastián', value: 'Región Oeste' },
	{ key: 'Santa Isabel', value: 'Región sureste' },
	{ key: 'Toa Alta', value: 'Región Metro Norte' },
	{ key: 'Toa Baja', value: 'Región Metro Norte' },
	{ key: 'Trujillo Alto', value: 'Región Noreste' },
	{ key: 'Utuado', value: 'Región Norte' },
	{ key: 'Vega Alta', value: 'Región Metro Norte' },
	{ key: 'Vega Baja', value: 'Región Norte' },
	{ key: 'Vieques', value: 'Región Noreste' },
	{ key: 'Villalba', value: 'Región sureste' },
	{ key: 'Yabucoa', value: 'Región este' },
	{ key: 'Yauco', value: 'Región suroeste' },
];


export const duplicateState = () => {
	return [
		{key: 'No Aplica', text: 'No Aplica', value: 'No Aplica'},
		{key: 'Posible Duplicado', text: 'Posible Duplicado', value: 'Posible Duplicado'},
		{key: 'Duplicado', text: 'Duplicado', value: 'Duplicado'},
	]
}

export const municipalities = () => {
	return [
		{ key: 'Adjuntas', text: 'Adjuntas', value: 'Adjuntas' },
		{ key: 'Aguada', text: 'Aguada', value: 'Aguada' },
		{ key: 'Aguadilla', text: 'Aguadilla', value: 'Aguadilla' },
		{
			key: 'Aguas Buenas',
			text: 'Aguas Buenas',
			value: 'Aguas Buenas',
		},
		{ key: 'Aibonito', text: 'Aibonito', value: 'Aibonito' },
		{ key: 'Añasco', text: 'Añasco', value: 'Añasco' },
		{ key: 'Arecibo', text: 'Arecibo', value: 'Arecibo' },
		{ key: 'Arroyo', text: 'Arroyo', value: 'Arroyo' },
		{
			key: 'Barceloneta',
			text: 'Barceloneta',
			value: 'Barceloneta',
		},
		{
			key: 'Barranquitas',
			text: 'Barranquitas',
			value: 'Barranquitas',
		},
		{ key: 'Bayamón', text: 'Bayamón', value: 'Bayamón' },
		{ key: 'Cabo Rojo', text: 'Cabo Rojo', value: 'Cabo Rojo' },
		{ key: 'Caguas', text: 'Caguas', value: 'Caguas' },
		{ key: 'Camuy', text: 'Camuy', value: 'Camuy' },
		{ key: 'Canóvanas', text: 'Canóvanas', value: 'Canóvanas' },
		{ key: 'Carolina', text: 'Carolina', value: 'Carolina' },
		{ key: 'Cataño', text: 'Cataño', value: 'Cataño' },
		{ key: 'Cayey', text: 'Cayey', value: 'Cayey' },
		{ key: 'Ceiba', text: 'Ceiba', value: 'Ceiba' },
		{ key: 'Ciales', text: 'Ciales', value: 'Ciales' },
		{ key: 'Cidra', text: 'Cidra', value: 'Cidra' },
		{ key: 'Coamo', text: 'Coamo', value: 'Coamo' },
		{ key: 'Comerío', text: 'Comerío', value: 'Comerío' },
		{ key: 'Corozal', text: 'Corozal', value: 'Corozal' },
		{ key: 'Culebra', text: 'Culebra', value: 'Culebra' },
		{ key: 'Dorado', text: 'Dorado', value: 'Dorado' },
		{ key: 'Fajardo', text: 'Fajardo', value: 'Fajardo' },
		{ key: 'Florida', text: 'Florida', value: 'Florida' },
		{ key: 'Guánica', text: 'Guánica', value: 'Guánica' },
		{ key: 'Guayama', text: 'Guayama', value: 'Guayama' },
		{
			key: 'Guayanilla',
			text: 'Guayanilla',
			value: 'Guayanilla',
		},
		{ key: 'Guaynabo', text: 'Guaynabo', value: 'Guaynabo' },
		{ key: 'Gurabo', text: 'Gurabo', value: 'Gurabo' },
		{ key: 'Hatillo', text: 'Hatillo', value: 'Hatillo' },
		{
			key: 'Hormigueros',
			text: 'Hormigueros',
			value: 'Hormigueros',
		},
		{ key: 'Humacao', text: 'Humacao', value: 'Humacao' },
		{ key: 'Isabela', text: 'Isabela', value: 'Isabela' },
		{ key: 'Jayuya', text: 'Jayuya', value: 'Jayuya' },
		{
			key: 'Juana Díaz',
			text: 'Juana Díaz',
			value: 'Juana Díaz',
		},
		{ key: 'Juncos', text: 'Juncos', value: 'Juncos' },
		{ key: 'Lajas', text: 'Lajas', value: 'Lajas' },
		{ key: 'Lares', text: 'Lares', value: 'Lares' },
		{
			key: 'Las Marías',
			text: 'Las Marías',
			value: 'Las Marías',
		},
		{
			key: 'Las Piedras',
			text: 'Las Piedras',
			value: 'Las Piedras',
		},
		{ key: 'Loíza', text: 'Loíza', value: 'Loíza' },
		{ key: 'Luquillo', text: 'Luquillo', value: 'Luquillo' },
		{ key: 'Manatí', text: 'Manatí', value: 'Manatí' },
		{ key: 'Maricao', text: 'Maricao', value: 'Maricao' },
		{ key: 'Maunabo', text: 'Maunabo', value: 'Maunabo' },
		{ key: 'Mayagüez', text: 'Mayagüez', value: 'Mayagüez' },
		{ key: 'Moca', text: 'Moca', value: 'Moca' },
		{ key: 'Morovis', text: 'Morovis', value: 'Morovis' },
		{ key: 'Naguabo', text: 'Naguabo', value: 'Naguabo' },
		{ key: 'Naranjito', text: 'Naranjito', value: 'Naranjito' },
		{ key: 'Orocovis', text: 'Orocovis', value: 'Orocovis' },
		{ key: 'Patillas', text: 'Patillas', value: 'Patillas' },
		{ key: 'Peñuelas', text: 'Peñuelas', value: 'Peñuelas' },
		{ key: 'Ponce', text: 'Ponce', value: 'Ponce' },
		{
			key: 'Quebradillas',
			text: 'Quebradillas',
			value: 'Quebradillas',
		},
		{ key: 'Rincón', text: 'Rincón', value: 'Rincón' },
		{
			key: 'Río Grande',
			text: 'Río Grande',
			value: 'Río Grande',
		},
		{
			key: 'Sabana Grande',
			text: 'Sabana Grande',
			value: 'Sabana Grande',
		},
		{ key: 'Salinas', text: 'Salinas', value: 'Salinas' },
		{
			key: 'San Germán',
			text: 'San Germán',
			value: 'San Germán',
		},
		{ key: 'San Juan', text: 'San Juan', value: 'San Juan' },
		{
			key: 'San Lorenzo',
			text: 'San Lorenzo',
			value: 'San Lorenzo',
		},
		{
			key: 'San Sebastián',
			text: 'San Sebastián',
			value: 'San Sebastián',
		},
		{
			key: 'Santa Isabel',
			text: 'Santa Isabel',
			value: 'Santa Isabel',
		},
		{ key: 'Toa Alta', text: 'Toa Alta', value: 'Toa Alta' },
		{ key: 'Toa Baja', text: 'Toa Baja', value: 'Toa Baja' },
		{
			key: 'Trujillo Alto',
			text: 'Trujillo Alto',
			value: 'Trujillo Alto',
		},
		{ key: 'Utuado', text: 'Utuado', value: 'Utuado' },
		{ key: 'Vega Alta', text: 'Vega Alta', value: 'Vega Alta' },
		{ key: 'Vega Baja', text: 'Vega Baja', value: 'Vega Baja' },
		{ key: 'Vieques', text: 'Vieques', value: 'Vieques' },
		{ key: 'Villalba', text: 'Villalba', value: 'Villalba' },
		{ key: 'Yabucoa', text: 'Yabucoa', value: 'Yabucoa' },
		{ key: 'Yauco', text: 'Yauco', value: 'Yauco' },
	];
};

export const regions = () => {
	return [
		{ key: 'Región este', text: 'Región este', value: 'Región este' },
		{
			key: 'Región Metro Norte',
			text: 'Región Metro Norte',
			value: 'Región Metro Norte',
		},
		{
			key: 'Región Noreste',
			text: 'Región Noreste',
			value: 'Región Noreste',
		},
		{ key: 'Región Norte', text: 'Región Norte', value: 'Región Norte' },
		{ key: 'Región Oeste', text: 'Región Oeste', value: 'Región Oeste' },
		{
			key: 'Región San Juan',
			text: 'Región San Juan',
			value: 'Región San Juan',
		},
		{ key: 'Región sureste', text: 'Región Sureste', value: 'Región sureste' },
		{
			key: 'Región suroeste',
			text: 'Región Suroeste',
			value: 'Región suroeste',
		},
	];
};

export const getRegions = (municipality) => {
	const region = _.find(matrix, (m) => {
		return m.key === municipality;
	});

	return region.value;
};

export const muniGeoJSON = () => {
	return {
		type: 'FeatureCollection',
		features: [
			{
				type: 'Feature',
				properties: {
					id: '071',
					name: 'Isabela',
					events: 0,
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.103276, 18.513426],
							[-67.10339411502086, 18.514532657212502],
							[-67.093752, 18.515757],
							[-67.07969882607986, 18.513326700734734],
							[-67.07929, 18.513256],
							[-67.05297606966441, 18.512073045833525],
							[-67.03794032458721, 18.511397107383498],
							[-67.02358359572727, 18.51075169440242],
							[-67.02356788772867, 18.51075098824252],
							[-67.020276, 18.510603],
							[-67.01957698461113, 18.510315541695093],
							[-66.988958, 18.497724],
							[-66.98121796414934, 18.495659674713295],
							[-66.95954, 18.489878],
							[-66.957733, 18.489129],
							[-66.95733159081969, 18.48920758388473],
							[-66.957727, 18.48718],
							[-66.955688, 18.484443],
							[-66.954046, 18.48325],
							[-66.950527, 18.483407],
							[-66.953024, 18.479566],
							[-66.952668, 18.476718],
							[-66.955622, 18.476714],
							[-66.959472, 18.473343],
							[-66.960926, 18.47229],
							[-66.962695, 18.473447],
							[-66.961798, 18.471336],
							[-66.959841, 18.470183],
							[-66.959072, 18.465513],
							[-66.962964, 18.461243],
							[-66.963562, 18.458422],
							[-66.965091, 18.455394],
							[-66.967702, 18.45551],
							[-66.968428, 18.454659],
							[-66.968324, 18.453353],
							[-66.966987, 18.450175],
							[-66.963566, 18.450213],
							[-66.962587, 18.44793],
							[-66.961041, 18.446572],
							[-66.958373, 18.440694],
							[-66.951871, 18.437298],
							[-66.950074, 18.43766],
							[-66.946376, 18.434582],
							[-66.945189, 18.431587],
							[-66.944192, 18.430747],
							[-66.941655, 18.42195],
							[-66.938594, 18.419225],
							[-66.935238, 18.418394],
							[-66.934059, 18.418846],
							[-66.933428, 18.418815],
							[-66.934847, 18.415573],
							[-66.939458, 18.41089],
							[-66.941514, 18.41005],
							[-66.943638, 18.409981],
							[-66.945765, 18.408476],
							[-66.947557, 18.40605],
							[-66.948159, 18.403508],
							[-66.947066, 18.401478],
							[-66.942623, 18.399569],
							[-66.925601, 18.397899],
							[-66.923211, 18.398457],
							[-66.92202, 18.393204],
							[-66.925544, 18.392873],
							[-66.926991, 18.39274],
							[-66.927222, 18.392718],
							[-66.928138, 18.392633],
							[-66.930914, 18.391417],
							[-66.933316, 18.387935],
							[-66.935389, 18.387732],
							[-66.935531, 18.387438],
							[-66.937159, 18.381749],
							[-66.937123, 18.380926],
							[-66.93686, 18.379417],
							[-66.936547, 18.377683],
							[-66.936608, 18.376777],
							[-66.937856, 18.376504],
							[-66.945592, 18.375229],
							[-66.946145, 18.375568],
							[-66.947276, 18.376341],
							[-66.947651, 18.376591],
							[-66.948939, 18.377113],
							[-66.949252, 18.377434],
							[-66.949728, 18.378248],
							[-66.950297, 18.378913],
							[-66.950656, 18.379332],
							[-66.95135, 18.379496],
							[-66.952882, 18.379324],
							[-66.953795, 18.379593],
							[-66.957251, 18.381807],
							[-66.95897, 18.382143],
							[-66.959678, 18.382102],
							[-66.962947, 18.384174],
							[-66.963817, 18.384297],
							[-66.963928, 18.384319],
							[-66.964447, 18.384414],
							[-66.96631, 18.384806],
							[-66.970504, 18.385693],
							[-66.971135, 18.385917],
							[-66.973999, 18.386302],
							[-66.979803, 18.385993],
							[-66.980179, 18.385672],
							[-66.981392, 18.384852],
							[-66.984293, 18.385105],
							[-66.985263, 18.385572],
							[-66.989353, 18.388146],
							[-66.993662, 18.388704],
							[-66.994422, 18.389533],
							[-66.996021, 18.388828],
							[-66.999986, 18.390589],
							[-67.005906, 18.39413],
							[-67.006093, 18.394263],
							[-67.006975, 18.394257],
							[-67.009337, 18.394823],
							[-67.009979, 18.394419],
							[-67.011287, 18.394354],
							[-67.011423, 18.394422],
							[-67.013834, 18.395127],
							[-67.017604, 18.394854],
							[-67.025045, 18.392063],
							[-67.02638, 18.392052],
							[-67.027258, 18.393555],
							[-67.032349, 18.404305],
							[-67.033193, 18.406204],
							[-67.033309, 18.406493],
							[-67.044275, 18.429761],
							[-67.044579, 18.430472],
							[-67.044931, 18.431187],
							[-67.045482, 18.432329],
							[-67.050883, 18.444017],
							[-67.054111, 18.4526],
							[-67.05654, 18.4608],
							[-67.056537, 18.462791],
							[-67.056474, 18.468409],
							[-67.058599, 18.468434],
							[-67.058764, 18.470203],
							[-67.058454, 18.479951],
							[-67.060998, 18.480104],
							[-67.061751, 18.480636],
							[-67.062985, 18.483447],
							[-67.071961, 18.487069],
							[-67.073588, 18.487599],
							[-67.074224, 18.488512],
							[-67.075776, 18.488836],
							[-67.077192, 18.488862],
							[-67.079939, 18.487973],
							[-67.082715, 18.489135],
							[-67.082581, 18.490008],
							[-67.083236, 18.490599],
							[-67.083238, 18.491071],
							[-67.084581, 18.497235],
							[-67.085127, 18.497388],
							[-67.085352, 18.49882],
							[-67.089416, 18.503211],
							[-67.09194, 18.503479],
							[-67.09639, 18.506601],
							[-67.096036, 18.510264],
							[-67.096104, 18.510518],
							[-67.099721, 18.51221],
							[-67.102676, 18.512801],
							[-67.102813, 18.512906],
							[-67.103276, 18.513426],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '005',
					name: 'Aguadilla',
					events: '',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.103276, 18.513426],
							[-67.102813, 18.512906],
							[-67.102676, 18.512801],
							[-67.099721, 18.51221],
							[-67.096104, 18.510518],
							[-67.096036, 18.510264],
							[-67.09639, 18.506601],
							[-67.09194, 18.503479],
							[-67.089416, 18.503211],
							[-67.085352, 18.49882],
							[-67.085127, 18.497388],
							[-67.084581, 18.497235],
							[-67.083238, 18.491071],
							[-67.083236, 18.490599],
							[-67.082581, 18.490008],
							[-67.082715, 18.489135],
							[-67.079939, 18.487973],
							[-67.077192, 18.488862],
							[-67.075776, 18.488836],
							[-67.074224, 18.488512],
							[-67.073588, 18.487599],
							[-67.071961, 18.487069],
							[-67.062985, 18.483447],
							[-67.061751, 18.480636],
							[-67.060998, 18.480104],
							[-67.058454, 18.479951],
							[-67.058764, 18.470203],
							[-67.058599, 18.468434],
							[-67.056474, 18.468409],
							[-67.056537, 18.462791],
							[-67.05654, 18.4608],
							[-67.074177, 18.456565],
							[-67.074358, 18.451802],
							[-67.076968, 18.446083],
							[-67.08014, 18.445247],
							[-67.087418, 18.441417],
							[-67.086664, 18.438438],
							[-67.094091, 18.436308],
							[-67.096061, 18.436636],
							[-67.097222, 18.436933],
							[-67.097942, 18.437087],
							[-67.098498, 18.437242],
							[-67.098928, 18.436844],
							[-67.112074, 18.423316],
							[-67.118306, 18.416818],
							[-67.119138, 18.416224],
							[-67.120037, 18.415227],
							[-67.1255, 18.409225],
							[-67.124529, 18.407818],
							[-67.124476, 18.40758],
							[-67.123805, 18.404494],
							[-67.120875, 18.404566],
							[-67.120841, 18.404503],
							[-67.123818, 18.39896],
							[-67.124613, 18.39786],
							[-67.124624, 18.397159],
							[-67.123696, 18.396985],
							[-67.127252, 18.396637],
							[-67.130975, 18.391206],
							[-67.132373, 18.389155],
							[-67.133305, 18.387805],
							[-67.134177, 18.387186],
							[-67.136137, 18.385974],
							[-67.140558, 18.388353],
							[-67.141516, 18.389643],
							[-67.144371, 18.391835],
							[-67.145491, 18.392282],
							[-67.150127, 18.392122],
							[-67.151236, 18.393194],
							[-67.15334, 18.394703],
							[-67.153677, 18.394968],
							[-67.154788, 18.39704],
							[-67.15576, 18.398449],
							[-67.155084, 18.399568],
							[-67.15773, 18.411448],
							[-67.159285, 18.410347],
							[-67.162199, 18.409704],
							[-67.161876, 18.411278],
							[-67.16007592617187, 18.413325773779295],
							[-67.15909792617188, 18.413697173779298],
							[-67.158996, 18.414897],
							[-67.16015744822774, 18.41557924257951],
							[-67.159608, 18.415915],
							[-67.15845277082283, 18.417092880729665],
							[-67.156599, 18.418983],
							[-67.15552913256002, 18.423264050066322],
							[-67.155245, 18.424401],
							[-67.15525881746795, 18.424553464797402],
							[-67.15526359834827, 18.42460621801894],
							[-67.1552881422248, 18.424877040225898],
							[-67.15562561417286, 18.428600775454793],
							[-67.15566665106354, 18.42905358498865],
							[-67.15573412911601, 18.429798151767024],
							[-67.15576828990288, 18.430175088950225],
							[-67.1557692444557, 18.43018562168335],
							[-67.15596264260743, 18.432319616864117],
							[-67.15652555885033, 18.43853095104065],
							[-67.156619, 18.439562],
							[-67.15757612710513, 18.442156902820606],
							[-67.161746, 18.453462],
							[-67.16403670821406, 18.45752631230272],
							[-67.169011, 18.466352],
							[-67.16901339052771, 18.472154288860388],
							[-67.169016, 18.478488],
							[-67.16746981087081, 18.48131506337496],
							[-67.164144, 18.487396],
							[-67.14739435344407, 18.501611274305628],
							[-67.14283, 18.505485],
							[-67.138249, 18.507776],
							[-67.12906260088943, 18.510642646697203],
							[-67.125655, 18.511706],
							[-67.11240013631446, 18.51338908475034],
							[-67.10339411502086, 18.514532657212502],
							[-67.103276, 18.513426],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '013',
					name: 'Arecibo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.58677804052712, 18.484948070681355],
							[-66.586831, 18.484644],
							[-66.586961, 18.483937],
							[-66.588525, 18.475633],
							[-66.588514, 18.475542],
							[-66.588854, 18.473525],
							[-66.58891, 18.47321],
							[-66.587272, 18.470503],
							[-66.586567, 18.468864],
							[-66.584675, 18.467122],
							[-66.582038, 18.466195],
							[-66.579868, 18.467957],
							[-66.58052, 18.463309],
							[-66.580813, 18.45949],
							[-66.581263, 18.455007],
							[-66.582718, 18.441888],
							[-66.587415, 18.441596],
							[-66.587399, 18.437531],
							[-66.586608, 18.437409],
							[-66.584139, 18.438677],
							[-66.583163, 18.438327],
							[-66.583818, 18.431879],
							[-66.585627, 18.417978],
							[-66.587319, 18.411101],
							[-66.587619, 18.410307],
							[-66.590917, 18.41062],
							[-66.590998, 18.410261],
							[-66.593455, 18.399407],
							[-66.592617, 18.397895],
							[-66.59093, 18.396772],
							[-66.590507, 18.395165],
							[-66.591326, 18.391991],
							[-66.590076, 18.389736],
							[-66.588985, 18.389544],
							[-66.588181, 18.389408],
							[-66.588273, 18.386988],
							[-66.587785, 18.382964],
							[-66.588856, 18.377413],
							[-66.588569, 18.375704],
							[-66.587629, 18.374738],
							[-66.582374, 18.374238],
							[-66.582946, 18.364405],
							[-66.583014, 18.363218],
							[-66.585172, 18.359211],
							[-66.588111, 18.354953],
							[-66.589751, 18.349562],
							[-66.590785, 18.33806],
							[-66.595272, 18.338019],
							[-66.600183, 18.337108],
							[-66.601832, 18.333943],
							[-66.603081, 18.33268],
							[-66.606361, 18.331839],
							[-66.60688, 18.331193],
							[-66.606989, 18.328186],
							[-66.614618, 18.331591],
							[-66.619029, 18.331805],
							[-66.634756, 18.325331],
							[-66.639155, 18.324559],
							[-66.648119, 18.326321],
							[-66.649423, 18.328087],
							[-66.652022, 18.328382],
							[-66.656172, 18.322769],
							[-66.656593, 18.322375],
							[-66.661789, 18.320686],
							[-66.662588, 18.319933],
							[-66.664361, 18.322193],
							[-66.666888, 18.322414],
							[-66.669339, 18.323448],
							[-66.672061, 18.324388],
							[-66.67246, 18.324365],
							[-66.68298, 18.32076],
							[-66.683281, 18.320892],
							[-66.691935, 18.32135],
							[-66.697769, 18.321078],
							[-66.698029, 18.320963],
							[-66.702916, 18.320592],
							[-66.707046, 18.316686],
							[-66.710474, 18.315439],
							[-66.711439, 18.315606],
							[-66.715886, 18.315205],
							[-66.717302, 18.315681],
							[-66.721266, 18.323819],
							[-66.721626, 18.328731],
							[-66.722681, 18.331751],
							[-66.722529, 18.333369],
							[-66.720374, 18.335108],
							[-66.719793, 18.336641],
							[-66.720934, 18.338191],
							[-66.723462, 18.33985],
							[-66.730441, 18.349484],
							[-66.731773, 18.348264],
							[-66.736443, 18.349309],
							[-66.737938, 18.348431],
							[-66.738528, 18.346599],
							[-66.740436, 18.344756],
							[-66.754313, 18.337174],
							[-66.756314, 18.337053],
							[-66.757682, 18.335449],
							[-66.762126, 18.332278],
							[-66.770091, 18.324774],
							[-66.769352, 18.362233],
							[-66.769324, 18.362599],
							[-66.768981, 18.374116],
							[-66.768458, 18.379104],
							[-66.767172, 18.392097],
							[-66.76772, 18.39463],
							[-66.769807, 18.404757],
							[-66.769812, 18.408051],
							[-66.76983, 18.408115],
							[-66.769518, 18.409576],
							[-66.768734, 18.412766],
							[-66.767837, 18.418229],
							[-66.767911, 18.419744],
							[-66.767951, 18.420573],
							[-66.768004, 18.424151],
							[-66.768168, 18.428385],
							[-66.769847, 18.433796],
							[-66.770446, 18.43729],
							[-66.768101, 18.446658],
							[-66.767683, 18.451776],
							[-66.767256, 18.457077],
							[-66.767282, 18.461589],
							[-66.768013, 18.461467],
							[-66.768149, 18.465663],
							[-66.769155, 18.469008],
							[-66.768506, 18.472362],
							[-66.767923, 18.478097],
							[-66.765978, 18.481897],
							[-66.7648349656073, 18.48406974021553],
							[-66.75844421100666, 18.481038201996387],
							[-66.75263529004883, 18.47828266419278],
							[-66.749301, 18.476701],
							[-66.74387229496769, 18.475185105036594],
							[-66.742067, 18.474681],
							[-66.73457445450025, 18.473546131086287],
							[-66.733986, 18.473457],
							[-66.72920399010398, 18.473282944139225],
							[-66.7278890814433, 18.47323508402104],
							[-66.72673833324835, 18.47319319902457],
							[-66.72514769461311, 18.47313530287152],
							[-66.71940376693271, 18.472926235074006],
							[-66.71537950270486, 18.472779759681984],
							[-66.71384449842239, 18.47272388851118],
							[-66.71132515043897, 18.472632189143887],
							[-66.710743, 18.472611],
							[-66.71061214670122, 18.472653397553437],
							[-66.71023123723883, 18.472776815376584],
							[-66.6977703151224, 18.47681425743],
							[-66.69742989585278, 18.476924556095067],
							[-66.69702271355979, 18.4770564865331],
							[-66.69479548515964, 18.477778126996082],
							[-66.69068554858949, 18.47910978051178],
							[-66.68515580266087, 18.48090146402832],
							[-66.683719, 18.481367],
							[-66.68348461331784, 18.48158516319596],
							[-66.68131122052358, 18.483608120787707],
							[-66.679876, 18.484944],
							[-66.67533874156459, 18.485782012211025],
							[-66.67495188243345, 18.485853463436573],
							[-66.66733539389237, 18.4872601962673],
							[-66.664364, 18.487809],
							[-66.65580937385802, 18.488256010963855],
							[-66.645839, 18.488777],
							[-66.64369586965061, 18.489324573288457],
							[-66.63451691450486, 18.491669811250866],
							[-66.624618, 18.494199],
							[-66.61950796299871, 18.492949722998304],
							[-66.58677804052712, 18.484948070681355],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '065',
					name: 'Hatillo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.7648349656073, 18.48406974021553],
							[-66.765978, 18.481897],
							[-66.767923, 18.478097],
							[-66.768506, 18.472362],
							[-66.769155, 18.469008],
							[-66.768149, 18.465663],
							[-66.768013, 18.461467],
							[-66.767282, 18.461589],
							[-66.767256, 18.457077],
							[-66.767683, 18.451776],
							[-66.768101, 18.446658],
							[-66.770446, 18.43729],
							[-66.769847, 18.433796],
							[-66.768168, 18.428385],
							[-66.768004, 18.424151],
							[-66.767951, 18.420573],
							[-66.767911, 18.419744],
							[-66.767837, 18.418229],
							[-66.768734, 18.412766],
							[-66.769518, 18.409576],
							[-66.76983, 18.408115],
							[-66.769812, 18.408051],
							[-66.769807, 18.404757],
							[-66.76772, 18.39463],
							[-66.767172, 18.392097],
							[-66.768458, 18.379104],
							[-66.768981, 18.374116],
							[-66.769324, 18.362599],
							[-66.769352, 18.362233],
							[-66.770091, 18.324774],
							[-66.770458, 18.320614],
							[-66.785097, 18.32146],
							[-66.793901, 18.321858],
							[-66.794752, 18.321898],
							[-66.826129, 18.323382],
							[-66.825276, 18.329964],
							[-66.824847, 18.333185],
							[-66.824611, 18.339231],
							[-66.824223, 18.342998],
							[-66.821666, 18.347715],
							[-66.82023, 18.350405],
							[-66.821043, 18.356392],
							[-66.821077, 18.357209],
							[-66.819541, 18.36],
							[-66.815761, 18.363984],
							[-66.812199, 18.384678],
							[-66.813881, 18.390332],
							[-66.816251, 18.392141],
							[-66.817017, 18.393387],
							[-66.81776, 18.395723],
							[-66.817679, 18.39655],
							[-66.816644, 18.398167],
							[-66.816641, 18.402498],
							[-66.817046, 18.403909],
							[-66.817687, 18.404577],
							[-66.81958, 18.404289],
							[-66.821059, 18.405453],
							[-66.823561, 18.412493],
							[-66.82321, 18.413338],
							[-66.821515, 18.413847],
							[-66.820867, 18.414651],
							[-66.821993, 18.416646],
							[-66.824181, 18.418317],
							[-66.82489, 18.420446],
							[-66.824101, 18.422064],
							[-66.823798, 18.42473],
							[-66.826812, 18.433214],
							[-66.828879, 18.435468],
							[-66.826146, 18.440351],
							[-66.825945, 18.442484],
							[-66.826445, 18.450377],
							[-66.825955, 18.454519],
							[-66.825345, 18.455161],
							[-66.82645, 18.457633],
							[-66.829284, 18.457852],
							[-66.830775, 18.458569],
							[-66.832878, 18.462541],
							[-66.832751, 18.463559],
							[-66.831183, 18.467868],
							[-66.829534, 18.468282],
							[-66.830559, 18.46968],
							[-66.829241, 18.470401],
							[-66.829164, 18.470487],
							[-66.829908, 18.470985],
							[-66.829115, 18.472917],
							[-66.830882, 18.472174],
							[-66.832284, 18.472198],
							[-66.835029, 18.473585],
							[-66.835575, 18.475755],
							[-66.835258, 18.477842],
							[-66.837594, 18.480654],
							[-66.838697, 18.483483],
							[-66.835845, 18.486626],
							[-66.836558, 18.487371],
							[-66.83666729596337, 18.48769608542933],
							[-66.83663477509681, 18.487700507990557],
							[-66.8190004665744, 18.49009862395017],
							[-66.81103923790968, 18.491181283329457],
							[-66.79932, 18.492775],
							[-66.79308760221153, 18.492327791278687],
							[-66.78283509774394, 18.491592117855898],
							[-66.780311, 18.491411],
							[-66.76499253019358, 18.484144483042492],
							[-66.7648349656073, 18.48406974021553],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 115,
					name: 'Quebradillas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.90143020590587, 18.484552270311163],
							[-66.901383, 18.483285],
							[-66.901383, 18.4797],
							[-66.901383, 18.47935],
							[-66.901382, 18.475733],
							[-66.901383, 18.474816],
							[-66.901368, 18.471679],
							[-66.901358, 18.470093],
							[-66.901345, 18.467913],
							[-66.901184, 18.459297],
							[-66.901181, 18.459161],
							[-66.900919, 18.45041],
							[-66.900735, 18.445796],
							[-66.900717, 18.444106],
							[-66.900756, 18.44185],
							[-66.900887, 18.438493],
							[-66.90109, 18.434914],
							[-66.901275, 18.41799],
							[-66.901074, 18.414465],
							[-66.90104, 18.4143],
							[-66.900486, 18.406694],
							[-66.900316, 18.4049],
							[-66.899237, 18.3974],
							[-66.900292, 18.38936],
							[-66.90081, 18.386139],
							[-66.900599, 18.382227],
							[-66.899578, 18.372198],
							[-66.898982, 18.366265],
							[-66.898919, 18.366114],
							[-66.905721, 18.367222],
							[-66.908511, 18.373004],
							[-66.91197, 18.375715],
							[-66.915365, 18.376282],
							[-66.916728, 18.377189],
							[-66.919497, 18.378578],
							[-66.920387, 18.379563],
							[-66.922687, 18.385149],
							[-66.923442, 18.388224],
							[-66.92202, 18.393204],
							[-66.923211, 18.398457],
							[-66.925601, 18.397899],
							[-66.942623, 18.399569],
							[-66.947066, 18.401478],
							[-66.948159, 18.403508],
							[-66.947557, 18.40605],
							[-66.945765, 18.408476],
							[-66.943638, 18.409981],
							[-66.941514, 18.41005],
							[-66.939458, 18.41089],
							[-66.934847, 18.415573],
							[-66.933428, 18.418815],
							[-66.934059, 18.418846],
							[-66.935238, 18.418394],
							[-66.938594, 18.419225],
							[-66.941655, 18.42195],
							[-66.944192, 18.430747],
							[-66.945189, 18.431587],
							[-66.946376, 18.434582],
							[-66.950074, 18.43766],
							[-66.951871, 18.437298],
							[-66.958373, 18.440694],
							[-66.961041, 18.446572],
							[-66.962587, 18.44793],
							[-66.963566, 18.450213],
							[-66.966987, 18.450175],
							[-66.968324, 18.453353],
							[-66.968428, 18.454659],
							[-66.967702, 18.45551],
							[-66.965091, 18.455394],
							[-66.963562, 18.458422],
							[-66.962964, 18.461243],
							[-66.959072, 18.465513],
							[-66.959841, 18.470183],
							[-66.961798, 18.471336],
							[-66.962695, 18.473447],
							[-66.960926, 18.47229],
							[-66.959472, 18.473343],
							[-66.955622, 18.476714],
							[-66.952668, 18.476718],
							[-66.953024, 18.479566],
							[-66.950527, 18.483407],
							[-66.954046, 18.48325],
							[-66.955688, 18.484443],
							[-66.957727, 18.48718],
							[-66.95733159081969, 18.48920758388473],
							[-66.944636, 18.491693],
							[-66.92424090252472, 18.48729847325081],
							[-66.906872, 18.483556],
							[-66.90143020590587, 18.484552270311163],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '027',
					name: 'Camuy',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.83666729596337, 18.48769608542933],
							[-66.836558, 18.487371],
							[-66.835845, 18.486626],
							[-66.838697, 18.483483],
							[-66.837594, 18.480654],
							[-66.835258, 18.477842],
							[-66.835575, 18.475755],
							[-66.835029, 18.473585],
							[-66.832284, 18.472198],
							[-66.830882, 18.472174],
							[-66.829115, 18.472917],
							[-66.829908, 18.470985],
							[-66.829164, 18.470487],
							[-66.829241, 18.470401],
							[-66.830559, 18.46968],
							[-66.829534, 18.468282],
							[-66.831183, 18.467868],
							[-66.832751, 18.463559],
							[-66.832878, 18.462541],
							[-66.830775, 18.458569],
							[-66.829284, 18.457852],
							[-66.82645, 18.457633],
							[-66.825345, 18.455161],
							[-66.825955, 18.454519],
							[-66.826445, 18.450377],
							[-66.825945, 18.442484],
							[-66.826146, 18.440351],
							[-66.828879, 18.435468],
							[-66.826812, 18.433214],
							[-66.823798, 18.42473],
							[-66.824101, 18.422064],
							[-66.82489, 18.420446],
							[-66.824181, 18.418317],
							[-66.821993, 18.416646],
							[-66.820867, 18.414651],
							[-66.821515, 18.413847],
							[-66.82321, 18.413338],
							[-66.823561, 18.412493],
							[-66.821059, 18.405453],
							[-66.81958, 18.404289],
							[-66.817687, 18.404577],
							[-66.817046, 18.403909],
							[-66.816641, 18.402498],
							[-66.816644, 18.398167],
							[-66.817679, 18.39655],
							[-66.81776, 18.395723],
							[-66.817017, 18.393387],
							[-66.816251, 18.392141],
							[-66.813881, 18.390332],
							[-66.812199, 18.384678],
							[-66.815761, 18.363984],
							[-66.819541, 18.36],
							[-66.821077, 18.357209],
							[-66.821043, 18.356392],
							[-66.82023, 18.350405],
							[-66.821666, 18.347715],
							[-66.824223, 18.342998],
							[-66.829174, 18.34459],
							[-66.831552, 18.345763],
							[-66.841949, 18.350065],
							[-66.845556, 18.350769],
							[-66.846489, 18.351176],
							[-66.848728, 18.353327],
							[-66.85, 18.35323],
							[-66.853475, 18.355014],
							[-66.85431, 18.355084],
							[-66.861869, 18.35602],
							[-66.862811, 18.356055],
							[-66.862903, 18.356058],
							[-66.863108, 18.356065],
							[-66.871446, 18.356112],
							[-66.872873, 18.356813],
							[-66.874621, 18.356732],
							[-66.878171, 18.358488],
							[-66.879781, 18.359913],
							[-66.880979, 18.362998],
							[-66.885488, 18.367019],
							[-66.891099, 18.368036],
							[-66.893216, 18.367055],
							[-66.898149, 18.365783],
							[-66.898919, 18.366114],
							[-66.898982, 18.366265],
							[-66.899578, 18.372198],
							[-66.900599, 18.382227],
							[-66.90081, 18.386139],
							[-66.900292, 18.38936],
							[-66.899237, 18.3974],
							[-66.900316, 18.4049],
							[-66.900486, 18.406694],
							[-66.90104, 18.4143],
							[-66.901074, 18.414465],
							[-66.901275, 18.41799],
							[-66.90109, 18.434914],
							[-66.900887, 18.438493],
							[-66.900756, 18.44185],
							[-66.900717, 18.444106],
							[-66.900735, 18.445796],
							[-66.900919, 18.45041],
							[-66.901181, 18.459161],
							[-66.901184, 18.459297],
							[-66.901345, 18.467913],
							[-66.901358, 18.470093],
							[-66.901368, 18.471679],
							[-66.901383, 18.474816],
							[-66.901382, 18.475733],
							[-66.901383, 18.47935],
							[-66.901383, 18.4797],
							[-66.901383, 18.483285],
							[-66.90143020590587, 18.484552270311163],
							[-66.88166875408794, 18.488170148424715],
							[-66.87148225703133, 18.490035067312984],
							[-66.867386, 18.490785],
							[-66.85814770868859, 18.49076413782801],
							[-66.85394697285922, 18.490754651606977],
							[-66.849673, 18.490745],
							[-66.84814821673739, 18.490375449921586],
							[-66.83694, 18.487659],
							[-66.83666729596337, 18.48769608542933],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '017',
					name: 'Barceloneta',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.586831, 18.484644],
							[-66.58677804052712, 18.484948070681355],
							[-66.584074, 18.484287],
							[-66.565241, 18.485523],
							[-66.562916, 18.48845],
							[-66.563485, 18.490512],
							[-66.558503, 18.489987],
							[-66.55598376287269, 18.48905715099227],
							[-66.53484, 18.481253],
							[-66.5339505397839, 18.481522292205618],
							[-66.53445, 18.478479],
							[-66.530581, 18.472072],
							[-66.530723, 18.465052],
							[-66.532464, 18.460819],
							[-66.537223, 18.456945],
							[-66.53772, 18.45341],
							[-66.532287, 18.456562],
							[-66.529668, 18.456736],
							[-66.527886, 18.456257],
							[-66.526451, 18.454898],
							[-66.526313, 18.453901],
							[-66.530928, 18.449784],
							[-66.537723, 18.447193],
							[-66.539528, 18.445201],
							[-66.540204, 18.443679],
							[-66.53625, 18.444007],
							[-66.536734, 18.43913],
							[-66.537584, 18.435861],
							[-66.536216, 18.434451],
							[-66.53393, 18.434101],
							[-66.530917, 18.434347],
							[-66.53013, 18.436634],
							[-66.531426, 18.437851],
							[-66.531905, 18.43944],
							[-66.52997, 18.441524],
							[-66.528639, 18.441496],
							[-66.527732, 18.440272],
							[-66.527353, 18.436963],
							[-66.528177, 18.43475],
							[-66.526406, 18.428976],
							[-66.526764, 18.427316],
							[-66.527065, 18.426411],
							[-66.529886, 18.424493],
							[-66.533183, 18.423925],
							[-66.535479, 18.421638],
							[-66.543341, 18.418846],
							[-66.543571, 18.418743],
							[-66.542461, 18.416954],
							[-66.542771, 18.41471],
							[-66.543079, 18.405422],
							[-66.547199, 18.404926],
							[-66.550843, 18.406387],
							[-66.552024, 18.409988],
							[-66.553102, 18.411643],
							[-66.564314, 18.413309],
							[-66.5704, 18.411224],
							[-66.574973, 18.406403],
							[-66.575712, 18.400658],
							[-66.578844, 18.394958],
							[-66.580929, 18.395523],
							[-66.582689, 18.395605],
							[-66.582967, 18.389491],
							[-66.588181, 18.389408],
							[-66.588985, 18.389544],
							[-66.590076, 18.389736],
							[-66.591326, 18.391991],
							[-66.590507, 18.395165],
							[-66.59093, 18.396772],
							[-66.592617, 18.397895],
							[-66.593455, 18.399407],
							[-66.590998, 18.410261],
							[-66.590917, 18.41062],
							[-66.587619, 18.410307],
							[-66.587319, 18.411101],
							[-66.585627, 18.417978],
							[-66.583818, 18.431879],
							[-66.583163, 18.438327],
							[-66.584139, 18.438677],
							[-66.586608, 18.437409],
							[-66.587399, 18.437531],
							[-66.587415, 18.441596],
							[-66.582718, 18.441888],
							[-66.581263, 18.455007],
							[-66.580813, 18.45949],
							[-66.58052, 18.463309],
							[-66.579868, 18.467957],
							[-66.582038, 18.466195],
							[-66.584675, 18.467122],
							[-66.586567, 18.468864],
							[-66.587272, 18.470503],
							[-66.58891, 18.47321],
							[-66.588854, 18.473525],
							[-66.588514, 18.475542],
							[-66.588525, 18.475633],
							[-66.586961, 18.483937],
							[-66.586831, 18.484644],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 145,
					name: 'Vega Baja',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.34966249974504, 18.486336233228744],
							[-66.349419, 18.477055],
							[-66.35122, 18.475414],
							[-66.349281, 18.473639],
							[-66.348816, 18.460761],
							[-66.348792, 18.459887],
							[-66.348719, 18.458421],
							[-66.348488, 18.453695],
							[-66.348392, 18.451337],
							[-66.348201, 18.448756],
							[-66.348215, 18.448403],
							[-66.349166, 18.446301],
							[-66.351815, 18.438223],
							[-66.353205, 18.430357],
							[-66.351216, 18.430445],
							[-66.350072, 18.43042],
							[-66.348035, 18.430111],
							[-66.347835, 18.428856],
							[-66.350956, 18.426405],
							[-66.352323, 18.426453],
							[-66.354296, 18.425549],
							[-66.356869, 18.423458],
							[-66.358899, 18.421032],
							[-66.359553, 18.412564],
							[-66.360187, 18.406972],
							[-66.362875, 18.395421],
							[-66.364077, 18.390372],
							[-66.364178, 18.38978],
							[-66.364533, 18.388118],
							[-66.369781, 18.381691],
							[-66.371404, 18.375637],
							[-66.372329, 18.372727],
							[-66.373243, 18.371937],
							[-66.374016, 18.36381],
							[-66.373934, 18.362772],
							[-66.372683, 18.360561],
							[-66.373083, 18.357921],
							[-66.374967, 18.355843],
							[-66.37635, 18.350192],
							[-66.377609, 18.345565],
							[-66.37705, 18.344209],
							[-66.37876, 18.342985],
							[-66.381822, 18.342992],
							[-66.385772, 18.344682],
							[-66.388829, 18.353272],
							[-66.38919, 18.356325],
							[-66.391883, 18.366037],
							[-66.393882, 18.368549],
							[-66.395522, 18.37179],
							[-66.400758, 18.36796],
							[-66.401558, 18.365187],
							[-66.400843, 18.364008],
							[-66.404745, 18.365349],
							[-66.415903, 18.373005],
							[-66.417113, 18.374359],
							[-66.417163, 18.377482],
							[-66.417886, 18.37791],
							[-66.421864, 18.377809],
							[-66.424097, 18.37596],
							[-66.425268, 18.374986],
							[-66.428451, 18.370461],
							[-66.431074, 18.370525],
							[-66.433081, 18.37071],
							[-66.433346, 18.370706],
							[-66.436315, 18.370939],
							[-66.438161, 18.37194],
							[-66.440472, 18.372223],
							[-66.443801, 18.371027],
							[-66.444027, 18.371605],
							[-66.444904, 18.373473],
							[-66.445343, 18.378568],
							[-66.446669, 18.383789],
							[-66.44899, 18.387214],
							[-66.448994, 18.389113],
							[-66.448138, 18.391501],
							[-66.441982, 18.402142],
							[-66.441535, 18.403468],
							[-66.440263, 18.406347],
							[-66.439413, 18.410366],
							[-66.439739, 18.41613],
							[-66.43999, 18.420796],
							[-66.440048, 18.423567],
							[-66.440415, 18.429528],
							[-66.44014, 18.435739],
							[-66.440178, 18.439099],
							[-66.439521, 18.439783],
							[-66.43874, 18.441792],
							[-66.438742, 18.442285],
							[-66.439796, 18.448207],
							[-66.439908, 18.451071],
							[-66.439594, 18.458669],
							[-66.439494, 18.462245],
							[-66.439008, 18.479794],
							[-66.438984, 18.480489],
							[-66.438961, 18.481156],
							[-66.438945, 18.481651],
							[-66.43882755439208, 18.485710375505413],
							[-66.420921, 18.488639],
							[-66.41726315401408, 18.489070250254745],
							[-66.41226381520273, 18.489659658924285],
							[-66.410344, 18.489886],
							[-66.39913291101543, 18.489789647612884],
							[-66.394287, 18.489748],
							[-66.37829112673232, 18.488144743247563],
							[-66.377286, 18.488044],
							[-66.37282, 18.487726],
							[-66.34966249974504, 18.486336233228744],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 143,
					name: 'Vega Alta',
					events: '',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.31503073047097, 18.47468025999214],
							[-66.315426, 18.470683],
							[-66.316206, 18.463016],
							[-66.317422, 18.451074],
							[-66.314073, 18.442617],
							[-66.312113, 18.439231],
							[-66.308507, 18.433846],
							[-66.301837, 18.43374],
							[-66.301865, 18.430992],
							[-66.301721, 18.428491],
							[-66.301307, 18.427329],
							[-66.30071, 18.426109],
							[-66.300297, 18.42527],
							[-66.300279, 18.425234],
							[-66.299835, 18.424088],
							[-66.299602, 18.423718],
							[-66.299514, 18.42139],
							[-66.299529, 18.420891],
							[-66.299554, 18.420578],
							[-66.299684, 18.420316],
							[-66.30173, 18.417156],
							[-66.302392, 18.41551],
							[-66.30327, 18.413327],
							[-66.303289, 18.413279],
							[-66.303889, 18.41111],
							[-66.303883, 18.410888],
							[-66.303813, 18.401642],
							[-66.303778, 18.397448],
							[-66.30378, 18.396012],
							[-66.303792, 18.390099],
							[-66.303663, 18.384093],
							[-66.306857, 18.383656],
							[-66.311492, 18.380784],
							[-66.314174, 18.380778],
							[-66.317045, 18.374171],
							[-66.319056, 18.370866],
							[-66.318976, 18.367399],
							[-66.321209, 18.366104],
							[-66.323591, 18.366811],
							[-66.326119, 18.365948],
							[-66.333612, 18.367948],
							[-66.338606, 18.367542],
							[-66.339385, 18.366564],
							[-66.341028, 18.362556],
							[-66.341202, 18.360395],
							[-66.340672, 18.358036],
							[-66.340976, 18.357626],
							[-66.343219, 18.357793],
							[-66.350273, 18.36121],
							[-66.354458, 18.361045],
							[-66.355278, 18.360643],
							[-66.355225, 18.359589],
							[-66.354747, 18.355126],
							[-66.350976, 18.353394],
							[-66.348863, 18.351605],
							[-66.348675, 18.350843],
							[-66.349249, 18.349706],
							[-66.351197, 18.349219],
							[-66.354752, 18.346931],
							[-66.356626, 18.345002],
							[-66.357589, 18.343226],
							[-66.357777, 18.33798],
							[-66.357317, 18.335811],
							[-66.357825, 18.332471],
							[-66.358294, 18.330796],
							[-66.359491, 18.330759],
							[-66.365272, 18.333229],
							[-66.370554, 18.337153],
							[-66.374295, 18.342624],
							[-66.374614, 18.343884],
							[-66.374695, 18.344117],
							[-66.375715, 18.343982],
							[-66.37705, 18.344209],
							[-66.377609, 18.345565],
							[-66.37635, 18.350192],
							[-66.374967, 18.355843],
							[-66.373083, 18.357921],
							[-66.372683, 18.360561],
							[-66.373934, 18.362772],
							[-66.374016, 18.36381],
							[-66.373243, 18.371937],
							[-66.372329, 18.372727],
							[-66.371404, 18.375637],
							[-66.369781, 18.381691],
							[-66.364533, 18.388118],
							[-66.364178, 18.38978],
							[-66.364077, 18.390372],
							[-66.362875, 18.395421],
							[-66.360187, 18.406972],
							[-66.359553, 18.412564],
							[-66.358899, 18.421032],
							[-66.356869, 18.423458],
							[-66.354296, 18.425549],
							[-66.352323, 18.426453],
							[-66.350956, 18.426405],
							[-66.347835, 18.428856],
							[-66.348035, 18.430111],
							[-66.350072, 18.43042],
							[-66.351216, 18.430445],
							[-66.353205, 18.430357],
							[-66.351815, 18.438223],
							[-66.349166, 18.446301],
							[-66.348215, 18.448403],
							[-66.348201, 18.448756],
							[-66.348392, 18.451337],
							[-66.348488, 18.453695],
							[-66.348719, 18.458421],
							[-66.348792, 18.459887],
							[-66.348816, 18.460761],
							[-66.349281, 18.473639],
							[-66.35122, 18.475414],
							[-66.349419, 18.477055],
							[-66.34966249974504, 18.486336233228744],
							[-66.34101277814752, 18.485817131619136],
							[-66.337728, 18.48562],
							[-66.315477, 18.474724],
							[-66.31503073047097, 18.47468025999214],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '091',
					name: 'Manatí',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.438945, 18.481651],
							[-66.438961, 18.481156],
							[-66.438984, 18.480489],
							[-66.439008, 18.479794],
							[-66.439494, 18.462245],
							[-66.439594, 18.458669],
							[-66.439908, 18.451071],
							[-66.439796, 18.448207],
							[-66.438742, 18.442285],
							[-66.43874, 18.441792],
							[-66.439521, 18.439783],
							[-66.440178, 18.439099],
							[-66.44014, 18.435739],
							[-66.440415, 18.429528],
							[-66.440048, 18.423567],
							[-66.43999, 18.420796],
							[-66.439739, 18.41613],
							[-66.439413, 18.410366],
							[-66.440263, 18.406347],
							[-66.441535, 18.403468],
							[-66.441982, 18.402142],
							[-66.448138, 18.391501],
							[-66.448994, 18.389113],
							[-66.44899, 18.387214],
							[-66.446669, 18.383789],
							[-66.445343, 18.378568],
							[-66.444904, 18.373473],
							[-66.444027, 18.371605],
							[-66.443801, 18.371027],
							[-66.44418, 18.371019],
							[-66.451578, 18.372214],
							[-66.459029, 18.371249],
							[-66.463211, 18.371473],
							[-66.466946, 18.371834],
							[-66.468901, 18.369812],
							[-66.474489, 18.36804],
							[-66.47607, 18.367538],
							[-66.478862, 18.366887],
							[-66.478949, 18.366923],
							[-66.483587, 18.366002],
							[-66.490678, 18.365452],
							[-66.494807, 18.366445],
							[-66.496602, 18.366028],
							[-66.499261, 18.364051],
							[-66.500553, 18.364852],
							[-66.506346, 18.36357],
							[-66.509687, 18.362078],
							[-66.511777, 18.362003],
							[-66.514424, 18.360324],
							[-66.518651, 18.356296],
							[-66.523317, 18.354924],
							[-66.5276, 18.35288],
							[-66.528304, 18.350564],
							[-66.53099, 18.350261],
							[-66.533623, 18.351333],
							[-66.533993, 18.360983],
							[-66.533307, 18.362638],
							[-66.532374, 18.363163],
							[-66.531535, 18.364674],
							[-66.531333, 18.368051],
							[-66.531168, 18.373004],
							[-66.531591, 18.378319],
							[-66.531361, 18.380504],
							[-66.530986, 18.386068],
							[-66.533716, 18.387413],
							[-66.53529, 18.39158],
							[-66.535677, 18.393907],
							[-66.540119, 18.39984],
							[-66.543079, 18.405422],
							[-66.542771, 18.41471],
							[-66.542461, 18.416954],
							[-66.543571, 18.418743],
							[-66.543341, 18.418846],
							[-66.535479, 18.421638],
							[-66.533183, 18.423925],
							[-66.529886, 18.424493],
							[-66.527065, 18.426411],
							[-66.526764, 18.427316],
							[-66.526406, 18.428976],
							[-66.528177, 18.43475],
							[-66.527353, 18.436963],
							[-66.527732, 18.440272],
							[-66.528639, 18.441496],
							[-66.52997, 18.441524],
							[-66.531905, 18.43944],
							[-66.531426, 18.437851],
							[-66.53013, 18.436634],
							[-66.530917, 18.434347],
							[-66.53393, 18.434101],
							[-66.536216, 18.434451],
							[-66.537584, 18.435861],
							[-66.536734, 18.43913],
							[-66.53625, 18.444007],
							[-66.540204, 18.443679],
							[-66.539528, 18.445201],
							[-66.537723, 18.447193],
							[-66.530928, 18.449784],
							[-66.526313, 18.453901],
							[-66.526451, 18.454898],
							[-66.527886, 18.456257],
							[-66.529668, 18.456736],
							[-66.532287, 18.456562],
							[-66.53772, 18.45341],
							[-66.537223, 18.456945],
							[-66.532464, 18.460819],
							[-66.530723, 18.465052],
							[-66.530581, 18.472072],
							[-66.53445, 18.478479],
							[-66.5339505397839, 18.481522292205618],
							[-66.529476, 18.482877],
							[-66.511609, 18.476848],
							[-66.50954034226798, 18.476458571439366],
							[-66.4913285744175, 18.473030173193095],
							[-66.48461462063736, 18.471766259247218],
							[-66.470292, 18.46907],
							[-66.47013498012657, 18.469068294003982],
							[-66.456486, 18.46892],
							[-66.449184, 18.470991],
							[-66.441852, 18.479751],
							[-66.439961, 18.485525],
							[-66.43882755439208, 18.485710375505413],
							[-66.438945, 18.481651],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '051',
					name: 'Dorado',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.19904288221973, 18.46616279598928],
							[-66.199313, 18.464974],
							[-66.204659, 18.463578],
							[-66.207992, 18.464582],
							[-66.214576, 18.465013],
							[-66.230717, 18.454197],
							[-66.231769, 18.452273],
							[-66.230758, 18.450331],
							[-66.235659, 18.452617],
							[-66.236039, 18.452934],
							[-66.239216, 18.455059],
							[-66.241427, 18.455652],
							[-66.244192, 18.454899],
							[-66.248504, 18.451069],
							[-66.251829, 18.451583],
							[-66.254898, 18.454176],
							[-66.257673, 18.454981],
							[-66.257913, 18.453465],
							[-66.258634, 18.449942],
							[-66.258536, 18.448158],
							[-66.257815, 18.444863],
							[-66.254887, 18.439856],
							[-66.255252, 18.438575],
							[-66.256923, 18.437923],
							[-66.257881, 18.434952],
							[-66.257686, 18.434003],
							[-66.257155, 18.432156],
							[-66.257439, 18.431145],
							[-66.262357, 18.428852],
							[-66.263702, 18.427745],
							[-66.264038, 18.426721],
							[-66.262526, 18.424472],
							[-66.260955, 18.425529],
							[-66.259462, 18.425649],
							[-66.259827, 18.422939],
							[-66.260516, 18.422337],
							[-66.263375, 18.419005],
							[-66.263162, 18.416401],
							[-66.261851, 18.414611],
							[-66.260909, 18.415364],
							[-66.261058, 18.416682],
							[-66.260242, 18.417077],
							[-66.257716, 18.416463],
							[-66.256112, 18.414535],
							[-66.255767, 18.411684],
							[-66.259643, 18.410374],
							[-66.259854, 18.409322],
							[-66.258337, 18.407913],
							[-66.257425, 18.40615],
							[-66.257618, 18.402845],
							[-66.256836, 18.39735],
							[-66.256078, 18.396262],
							[-66.254377, 18.395197],
							[-66.254239, 18.395056],
							[-66.252466, 18.394156],
							[-66.252562, 18.39403],
							[-66.254171, 18.392279],
							[-66.255037, 18.390031],
							[-66.257229, 18.389408],
							[-66.257506, 18.387904],
							[-66.257771, 18.387491],
							[-66.267168, 18.386547],
							[-66.270127, 18.385503],
							[-66.271645, 18.383694],
							[-66.27211, 18.384019],
							[-66.278734, 18.384535],
							[-66.280166, 18.383667],
							[-66.284957, 18.383215],
							[-66.285731, 18.383164],
							[-66.29121, 18.38503],
							[-66.303663, 18.384093],
							[-66.303792, 18.390099],
							[-66.30378, 18.396012],
							[-66.303778, 18.397448],
							[-66.303813, 18.401642],
							[-66.303883, 18.410888],
							[-66.303889, 18.41111],
							[-66.303289, 18.413279],
							[-66.30327, 18.413327],
							[-66.302392, 18.41551],
							[-66.30173, 18.417156],
							[-66.299684, 18.420316],
							[-66.299554, 18.420578],
							[-66.299529, 18.420891],
							[-66.299514, 18.42139],
							[-66.299602, 18.423718],
							[-66.299835, 18.424088],
							[-66.300279, 18.425234],
							[-66.300297, 18.42527],
							[-66.30071, 18.426109],
							[-66.301307, 18.427329],
							[-66.301721, 18.428491],
							[-66.301865, 18.430992],
							[-66.301837, 18.43374],
							[-66.308507, 18.433846],
							[-66.312113, 18.439231],
							[-66.314073, 18.442617],
							[-66.317422, 18.451074],
							[-66.316206, 18.463016],
							[-66.315426, 18.470683],
							[-66.31503073047097, 18.47468025999214],
							[-66.291225, 18.472347],
							[-66.28374286477387, 18.472204294374496],
							[-66.283675, 18.472203],
							[-66.2784343590704, 18.476591925685252],
							[-66.276599, 18.478129],
							[-66.269799, 18.480281],
							[-66.26717833195035, 18.479530426793318],
							[-66.26707048773274, 18.479499539638322],
							[-66.26272771482707, 18.478255746481786],
							[-66.258015, 18.476906],
							[-66.25760963688997, 18.476627610554303],
							[-66.25671260498285, 18.476011559884633],
							[-66.25424587951036, 18.474317497647654],
							[-66.251547, 18.472464],
							[-66.241797, 18.46874],
							[-66.220148, 18.466],
							[-66.19904288221973, 18.46616279598928],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 127,
					name: 'San Juan',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.03655341822281, 18.450207906574445],
							[-66.037535, 18.449295],
							[-66.037356, 18.449089],
							[-66.037698, 18.448538],
							[-66.038152, 18.446963],
							[-66.038218, 18.446239],
							[-66.040578, 18.446402],
							[-66.041306, 18.445668],
							[-66.042985, 18.444158],
							[-66.043091, 18.444057],
							[-66.042413, 18.443452],
							[-66.041905, 18.442999],
							[-66.039191, 18.440822],
							[-66.038329, 18.440307],
							[-66.032399, 18.435868],
							[-66.032, 18.434047],
							[-66.03094, 18.430396],
							[-66.029735, 18.427795],
							[-66.025137, 18.424077],
							[-66.024616, 18.423701],
							[-66.02381, 18.423084],
							[-66.023398, 18.422732],
							[-66.020919, 18.4206],
							[-66.019629, 18.419696],
							[-66.017066, 18.418638],
							[-66.014925, 18.417849],
							[-66.014749, 18.41776],
							[-66.009635, 18.41389],
							[-66.008316, 18.412926],
							[-66.007728, 18.412685],
							[-66.006711, 18.412393],
							[-66.006315, 18.412345],
							[-66.005517, 18.41223],
							[-66.003754, 18.411242],
							[-66.00182, 18.410851],
							[-66.001276, 18.410267],
							[-66.001062, 18.409559],
							[-66.000657, 18.409033],
							[-65.998766, 18.407854],
							[-65.99738, 18.408352],
							[-65.997327, 18.408468],
							[-65.997183, 18.408772],
							[-65.99702, 18.408857],
							[-65.996541, 18.408634],
							[-65.995102, 18.407963],
							[-65.99365, 18.407532],
							[-65.992979, 18.406598],
							[-65.992555, 18.405538],
							[-65.99238, 18.404961],
							[-65.991813, 18.402014],
							[-65.991785, 18.401472],
							[-65.991682, 18.399532],
							[-65.99209, 18.398405],
							[-65.993681, 18.397606],
							[-65.994355, 18.397318],
							[-66.000824, 18.395184],
							[-66.001825, 18.394576],
							[-66.003438, 18.392073],
							[-66.003433, 18.391818],
							[-66.003425, 18.391423],
							[-66.003236, 18.38948],
							[-66.002916, 18.385739],
							[-66.002899, 18.385264],
							[-66.000648, 18.381883],
							[-66.000445, 18.381497],
							[-66.000271, 18.381017],
							[-66.000315, 18.380743],
							[-66.000099, 18.38055],
							[-65.999609, 18.380004],
							[-65.999729, 18.380003],
							[-66.001017, 18.379733],
							[-66.002017, 18.379388],
							[-66.002263, 18.379354],
							[-66.002691, 18.379196],
							[-66.006858, 18.37883],
							[-66.008026, 18.378899],
							[-66.012509, 18.380568],
							[-66.013256, 18.38038],
							[-66.013925, 18.379947],
							[-66.013786, 18.378843],
							[-66.015882, 18.378947],
							[-66.018889, 18.37865],
							[-66.019067, 18.378651],
							[-66.024546, 18.379704],
							[-66.025262, 18.379829],
							[-66.028842, 18.376227],
							[-66.030164, 18.374934],
							[-66.030541, 18.374589],
							[-66.031848, 18.373393],
							[-66.03484, 18.369745],
							[-66.035191, 18.369842],
							[-66.035336, 18.369693],
							[-66.035544, 18.368476],
							[-66.034024, 18.362103],
							[-66.034743, 18.358866],
							[-66.034719, 18.358604],
							[-66.032421, 18.355701],
							[-66.032427, 18.355593],
							[-66.032725, 18.355433],
							[-66.034353, 18.351677],
							[-66.036682, 18.345273],
							[-66.035527, 18.344342],
							[-66.034894, 18.341087],
							[-66.034913, 18.340201],
							[-66.034932, 18.333452],
							[-66.03494, 18.332214],
							[-66.035016, 18.330943],
							[-66.035109, 18.330381],
							[-66.035911, 18.328084],
							[-66.035731, 18.31961],
							[-66.036859, 18.318627],
							[-66.036936, 18.318241],
							[-66.037232, 18.317506],
							[-66.04001, 18.315858],
							[-66.040689, 18.31294],
							[-66.041129, 18.312087],
							[-66.041505, 18.312324],
							[-66.044915, 18.311486],
							[-66.04692, 18.309408],
							[-66.047829, 18.306886],
							[-66.046962, 18.304441],
							[-66.047764, 18.302656],
							[-66.048338, 18.29758],
							[-66.053131, 18.303797],
							[-66.052968, 18.303473],
							[-66.052864, 18.303309],
							[-66.056336, 18.304485],
							[-66.058728, 18.303126],
							[-66.059689, 18.301831],
							[-66.062379, 18.303047],
							[-66.063081, 18.302629],
							[-66.065924, 18.303733],
							[-66.066129, 18.303175],
							[-66.066314, 18.303124],
							[-66.069557, 18.301232],
							[-66.072173, 18.29907],
							[-66.072972, 18.29776],
							[-66.076902, 18.296521],
							[-66.080475, 18.297295],
							[-66.082044, 18.299889],
							[-66.085044, 18.299924],
							[-66.084979, 18.301628],
							[-66.084922, 18.30172],
							[-66.083235, 18.305083],
							[-66.082397, 18.306788],
							[-66.082668, 18.309374],
							[-66.085089, 18.316316],
							[-66.086351, 18.317647],
							[-66.087962, 18.317905],
							[-66.089087, 18.322835],
							[-66.088522, 18.323612],
							[-66.087266, 18.327792],
							[-66.086751, 18.332964],
							[-66.089953, 18.33553],
							[-66.091567, 18.336498],
							[-66.092619, 18.337655],
							[-66.094887, 18.338476],
							[-66.095126, 18.339427],
							[-66.095816, 18.337762],
							[-66.096306, 18.337867],
							[-66.096011, 18.338871],
							[-66.095738, 18.339233],
							[-66.096583, 18.340257],
							[-66.097448, 18.340491],
							[-66.099307, 18.343584],
							[-66.098214, 18.349639],
							[-66.096333, 18.353671],
							[-66.09717, 18.354949],
							[-66.097619, 18.355643],
							[-66.097743, 18.355843],
							[-66.094203, 18.354959],
							[-66.089787, 18.356163],
							[-66.088476, 18.357081],
							[-66.088356, 18.357165],
							[-66.09025, 18.361038],
							[-66.091681, 18.36106],
							[-66.091778, 18.361064],
							[-66.091624, 18.361795],
							[-66.091792, 18.363167],
							[-66.090048, 18.365895],
							[-66.089948, 18.366204],
							[-66.090814, 18.367918],
							[-66.091118, 18.368458],
							[-66.090354, 18.374704],
							[-66.091176, 18.375204],
							[-66.094354, 18.376459],
							[-66.09443, 18.376589],
							[-66.09462, 18.376912],
							[-66.094796, 18.37723],
							[-66.096877, 18.378493],
							[-66.097988, 18.379165],
							[-66.098058, 18.379202],
							[-66.099338, 18.379574],
							[-66.100947, 18.379799],
							[-66.10357, 18.381093],
							[-66.105223, 18.382086],
							[-66.106159, 18.3825],
							[-66.105895, 18.386629],
							[-66.107892, 18.389845],
							[-66.108575, 18.398715],
							[-66.108701, 18.398867],
							[-66.108608, 18.398971],
							[-66.106423, 18.402011],
							[-66.106162, 18.401987],
							[-66.105746, 18.40195],
							[-66.102416, 18.402123],
							[-66.098589, 18.40111],
							[-66.096574, 18.400576],
							[-66.095216, 18.406229],
							[-66.096651, 18.408264],
							[-66.097953, 18.410063],
							[-66.099806, 18.41189],
							[-66.098424, 18.417579],
							[-66.098812, 18.418173],
							[-66.099427, 18.419114],
							[-66.107571, 18.427288],
							[-66.108281, 18.438902],
							[-66.108345, 18.442476],
							[-66.108449, 18.445354],
							[-66.109704, 18.447202],
							[-66.118366, 18.454934],
							[-66.12332969307569, 18.46028330228983],
							[-66.12344366214798, 18.46096974345524],
							[-66.12350387823271, 18.461332427809403],
							[-66.12367624579207, 18.46237060585142],
							[-66.12501509535485, 18.470434560709716],
							[-66.11853824990033, 18.469606598772817],
							[-66.118338, 18.469581],
							[-66.11618374280314, 18.46933092883302],
							[-66.11300920578744, 18.468962421220603],
							[-66.10674736152946, 18.468235531829983],
							[-66.09475891377342, 18.46684388503635],
							[-66.092098, 18.466535],
							[-66.08340625743753, 18.462099695365854],
							[-66.083254, 18.462022],
							[-66.073987, 18.4581],
							[-66.07050494261661, 18.457596064104425],
							[-66.0689405485536, 18.45736965935678],
							[-66.06338614918471, 18.45656580665932],
							[-66.0628784025091, 18.456492323730256],
							[-66.05955704268172, 18.456011644564217],
							[-66.05519689063605, 18.45538062764403],
							[-66.05185500039518, 18.454896977242548],
							[-66.05054517716435, 18.454707414903332],
							[-66.04353589259023, 18.453693005974845],
							[-66.04327224723167, 18.453654850268247],
							[-66.03943963639044, 18.45444102680223],
							[-66.03932024016886, 18.454265912333632],
							[-66.0371712176491, 18.4511140124529],
							[-66.0365851352174, 18.4502544248359],
							[-66.03655341822281, 18.450207906574445],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 137,
					name: 'Toa Baja',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.14376429390475, 18.459869332129],
							[-66.14708, 18.453974],
							[-66.147096, 18.453911],
							[-66.151953, 18.44771],
							[-66.156835, 18.447175],
							[-66.157061, 18.447115],
							[-66.158697, 18.445693],
							[-66.16009, 18.445835],
							[-66.160278, 18.446353],
							[-66.159072, 18.44907],
							[-66.159152, 18.450074],
							[-66.161572, 18.448765],
							[-66.161846, 18.448415],
							[-66.163774, 18.444673],
							[-66.164795, 18.438423],
							[-66.1652, 18.437356],
							[-66.167697, 18.434892],
							[-66.169833, 18.435384],
							[-66.170306, 18.433869],
							[-66.170014, 18.431646],
							[-66.169516, 18.430998],
							[-66.169592, 18.430569],
							[-66.16956, 18.426256],
							[-66.17031, 18.424453],
							[-66.171196, 18.423733],
							[-66.172644, 18.420917],
							[-66.173201, 18.420868],
							[-66.176797, 18.419683],
							[-66.179601, 18.420239],
							[-66.186436, 18.420868],
							[-66.187491, 18.419728],
							[-66.187532, 18.419596],
							[-66.190811, 18.418455],
							[-66.19134, 18.418195],
							[-66.194724, 18.417406],
							[-66.195267, 18.417259],
							[-66.195715, 18.417021],
							[-66.196162, 18.416101],
							[-66.197229, 18.415547],
							[-66.198296, 18.413678],
							[-66.197701, 18.40687],
							[-66.196953, 18.405416],
							[-66.196999, 18.404717],
							[-66.197772, 18.403748],
							[-66.196611, 18.401607],
							[-66.196787, 18.399793],
							[-66.195586, 18.396856],
							[-66.197181, 18.394205],
							[-66.195516, 18.391266],
							[-66.197088, 18.390772],
							[-66.196976, 18.389252],
							[-66.202126, 18.390938],
							[-66.210528, 18.39368],
							[-66.210859, 18.393827],
							[-66.212802, 18.394472],
							[-66.218605, 18.396434],
							[-66.218937, 18.396595],
							[-66.220953, 18.397176],
							[-66.233951, 18.401451],
							[-66.235279, 18.400949],
							[-66.237472, 18.398933],
							[-66.244753, 18.39489],
							[-66.244903, 18.394955],
							[-66.249612, 18.39554],
							[-66.249612, 18.395544],
							[-66.252466, 18.394156],
							[-66.254239, 18.395056],
							[-66.254377, 18.395197],
							[-66.256078, 18.396262],
							[-66.256836, 18.39735],
							[-66.257618, 18.402845],
							[-66.257425, 18.40615],
							[-66.258337, 18.407913],
							[-66.259854, 18.409322],
							[-66.259643, 18.410374],
							[-66.255767, 18.411684],
							[-66.256112, 18.414535],
							[-66.257716, 18.416463],
							[-66.260242, 18.417077],
							[-66.261058, 18.416682],
							[-66.260909, 18.415364],
							[-66.261851, 18.414611],
							[-66.263162, 18.416401],
							[-66.263375, 18.419005],
							[-66.260516, 18.422337],
							[-66.259827, 18.422939],
							[-66.259462, 18.425649],
							[-66.260955, 18.425529],
							[-66.262526, 18.424472],
							[-66.264038, 18.426721],
							[-66.263702, 18.427745],
							[-66.262357, 18.428852],
							[-66.257439, 18.431145],
							[-66.257155, 18.432156],
							[-66.257686, 18.434003],
							[-66.257881, 18.434952],
							[-66.256923, 18.437923],
							[-66.255252, 18.438575],
							[-66.254887, 18.439856],
							[-66.257815, 18.444863],
							[-66.258536, 18.448158],
							[-66.258634, 18.449942],
							[-66.257913, 18.453465],
							[-66.257673, 18.454981],
							[-66.254898, 18.454176],
							[-66.251829, 18.451583],
							[-66.248504, 18.451069],
							[-66.244192, 18.454899],
							[-66.241427, 18.455652],
							[-66.239216, 18.455059],
							[-66.236039, 18.452934],
							[-66.235659, 18.452617],
							[-66.230758, 18.450331],
							[-66.231769, 18.452273],
							[-66.230717, 18.454197],
							[-66.214576, 18.465013],
							[-66.207992, 18.464582],
							[-66.204659, 18.463578],
							[-66.199313, 18.464974],
							[-66.19904288221973, 18.46616279598928],
							[-66.19811122361696, 18.466169982411337],
							[-66.192664, 18.466212],
							[-66.183886, 18.460506],
							[-66.1811789321847, 18.457489834681358],
							[-66.179218, 18.455305],
							[-66.17428226416713, 18.452557204432026],
							[-66.17418952632794, 18.45250557593485],
							[-66.17289804709354, 18.451786590754814],
							[-66.172315, 18.451462],
							[-66.17169830350986, 18.451474019645627],
							[-66.16194102565402, 18.451664192646412],
							[-66.159796, 18.451706],
							[-66.15395783750333, 18.454082207283378],
							[-66.153037, 18.454457],
							[-66.14376429390475, 18.459869332129],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '033',
					name: 'Cataño',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.12332969307569, 18.46028330228983],
							[-66.118366, 18.454934],
							[-66.109704, 18.447202],
							[-66.108449, 18.445354],
							[-66.108345, 18.442476],
							[-66.108281, 18.438902],
							[-66.114352, 18.440542],
							[-66.117233, 18.438715],
							[-66.118002, 18.43805],
							[-66.118454, 18.437648],
							[-66.118776, 18.437352],
							[-66.12054, 18.435707],
							[-66.121104, 18.435174],
							[-66.121518, 18.43477],
							[-66.122266, 18.434015],
							[-66.123066, 18.433143],
							[-66.131104, 18.425125],
							[-66.131178, 18.42508],
							[-66.131262, 18.42499],
							[-66.13158, 18.424656],
							[-66.135671, 18.422009],
							[-66.135488, 18.423104],
							[-66.140349, 18.423029],
							[-66.142099, 18.422591],
							[-66.145502, 18.422512],
							[-66.154521, 18.421932],
							[-66.157134, 18.421067],
							[-66.15861, 18.421314],
							[-66.158453, 18.422649],
							[-66.161991, 18.427934],
							[-66.16439, 18.428713],
							[-66.164754, 18.428924],
							[-66.165142, 18.429284],
							[-66.165411, 18.429838],
							[-66.169516, 18.430998],
							[-66.170014, 18.431646],
							[-66.170306, 18.433869],
							[-66.169833, 18.435384],
							[-66.167697, 18.434892],
							[-66.1652, 18.437356],
							[-66.164795, 18.438423],
							[-66.163774, 18.444673],
							[-66.161846, 18.448415],
							[-66.161572, 18.448765],
							[-66.159152, 18.450074],
							[-66.159072, 18.44907],
							[-66.160278, 18.446353],
							[-66.16009, 18.445835],
							[-66.158697, 18.445693],
							[-66.157061, 18.447115],
							[-66.156835, 18.447175],
							[-66.151953, 18.44771],
							[-66.147096, 18.453911],
							[-66.14708, 18.453974],
							[-66.14376429390475, 18.459869332129],
							[-66.13945066149927, 18.462387131250537],
							[-66.138532, 18.453305],
							[-66.133085, 18.445881],
							[-66.12793788524108, 18.44463166403598],
							[-66.12519753327182, 18.4512085045139],
							[-66.12428408261539, 18.45632382252542],
							[-66.12390057458246, 18.457410432334665],
							[-66.12318794607602, 18.459429553341153],
							[-66.12332969307569, 18.46028330228983],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '099',
					name: 'Moca',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.074177, 18.456565],
							[-67.05654, 18.4608],
							[-67.054111, 18.4526],
							[-67.050883, 18.444017],
							[-67.045482, 18.432329],
							[-67.044931, 18.431187],
							[-67.044579, 18.430472],
							[-67.044275, 18.429761],
							[-67.033309, 18.406493],
							[-67.033193, 18.406204],
							[-67.032349, 18.404305],
							[-67.027258, 18.393555],
							[-67.029223, 18.389248],
							[-67.029369, 18.388562],
							[-67.033968, 18.38214],
							[-67.035629, 18.380822],
							[-67.037276, 18.380908],
							[-67.036717, 18.379099],
							[-67.037245, 18.377966],
							[-67.037779, 18.377839],
							[-67.03782, 18.37766],
							[-67.0375, 18.376564],
							[-67.038737, 18.374979],
							[-67.038286, 18.374392],
							[-67.038342, 18.372555],
							[-67.039033, 18.367042],
							[-67.040197, 18.364226],
							[-67.041217, 18.362329],
							[-67.041953, 18.358406],
							[-67.041897, 18.356573],
							[-67.047897, 18.352937],
							[-67.046833, 18.352784],
							[-67.047411, 18.351552],
							[-67.047559, 18.350881],
							[-67.047369, 18.349813],
							[-67.048392, 18.348649],
							[-67.050316, 18.34891],
							[-67.049824, 18.347393],
							[-67.047617, 18.347749],
							[-67.046295, 18.349024],
							[-67.046474, 18.349566],
							[-67.046402, 18.35015],
							[-67.045436, 18.35067],
							[-67.043689, 18.349564],
							[-67.045103, 18.349011],
							[-67.045198, 18.347898],
							[-67.043964, 18.344376],
							[-67.043303, 18.34356],
							[-67.043494, 18.342079],
							[-67.040654, 18.335021],
							[-67.036732, 18.333217],
							[-67.036472, 18.330672],
							[-67.037312, 18.32661],
							[-67.037349, 18.326312],
							[-67.041511, 18.323667],
							[-67.04158, 18.323436],
							[-67.041687, 18.323029],
							[-67.041553, 18.321478],
							[-67.041497, 18.321163],
							[-67.042603, 18.32039],
							[-67.043081, 18.319575],
							[-67.044332, 18.316531],
							[-67.045831, 18.314747],
							[-67.047632, 18.312602],
							[-67.050114, 18.30962],
							[-67.052583, 18.306655],
							[-67.060293, 18.310104],
							[-67.069517, 18.312329],
							[-67.07016, 18.312496],
							[-67.071355, 18.3126],
							[-67.078111, 18.312952],
							[-67.086474, 18.31545],
							[-67.100048, 18.319721],
							[-67.102678, 18.318598],
							[-67.103964, 18.318954],
							[-67.10807, 18.320182],
							[-67.108257, 18.320135],
							[-67.108398, 18.320158],
							[-67.111321, 18.320792],
							[-67.113014, 18.321167],
							[-67.113954, 18.322493],
							[-67.117451, 18.323276],
							[-67.117564, 18.322805],
							[-67.120361, 18.323846],
							[-67.121562, 18.323942],
							[-67.122208, 18.323231],
							[-67.122449, 18.322959],
							[-67.123628, 18.321763],
							[-67.12581, 18.321852],
							[-67.126948, 18.320827],
							[-67.126939, 18.320573],
							[-67.126935, 18.320469],
							[-67.128445, 18.318319],
							[-67.129909, 18.317959],
							[-67.130096, 18.31844],
							[-67.130052, 18.320531],
							[-67.132541, 18.327696],
							[-67.133674, 18.329385],
							[-67.134162, 18.329919],
							[-67.134171, 18.330006],
							[-67.13339, 18.331406],
							[-67.132322, 18.332936],
							[-67.131024, 18.334689],
							[-67.130963, 18.335143],
							[-67.132964, 18.340715],
							[-67.133296, 18.341506],
							[-67.133741, 18.343755],
							[-67.133835, 18.344572],
							[-67.133897, 18.344828],
							[-67.133912, 18.344883],
							[-67.134335, 18.346428],
							[-67.13434, 18.346519],
							[-67.132406, 18.347975],
							[-67.131745, 18.348324],
							[-67.131205, 18.349698],
							[-67.131524, 18.350898],
							[-67.130452, 18.352118],
							[-67.129336, 18.352395],
							[-67.128124, 18.353859],
							[-67.128012, 18.356734],
							[-67.127059, 18.359985],
							[-67.127184, 18.360601],
							[-67.12777, 18.361917],
							[-67.128034, 18.362511],
							[-67.128025, 18.362709],
							[-67.127862, 18.366134],
							[-67.126636, 18.370474],
							[-67.126677, 18.370924],
							[-67.127913, 18.371826],
							[-67.130687, 18.373003],
							[-67.130819, 18.375491],
							[-67.129975, 18.379373],
							[-67.130288, 18.381069],
							[-67.13111, 18.381342],
							[-67.13167, 18.382529],
							[-67.132373, 18.389155],
							[-67.130975, 18.391206],
							[-67.127252, 18.396637],
							[-67.123696, 18.396985],
							[-67.124624, 18.397159],
							[-67.124613, 18.39786],
							[-67.123818, 18.39896],
							[-67.120841, 18.404503],
							[-67.120875, 18.404566],
							[-67.123805, 18.404494],
							[-67.124476, 18.40758],
							[-67.124529, 18.407818],
							[-67.1255, 18.409225],
							[-67.120037, 18.415227],
							[-67.119138, 18.416224],
							[-67.118306, 18.416818],
							[-67.112074, 18.423316],
							[-67.098928, 18.436844],
							[-67.098498, 18.437242],
							[-67.097942, 18.437087],
							[-67.097222, 18.436933],
							[-67.096061, 18.436636],
							[-67.094091, 18.436308],
							[-67.086664, 18.438438],
							[-67.087418, 18.441417],
							[-67.08014, 18.445247],
							[-67.076968, 18.446083],
							[-67.074358, 18.451802],
							[-67.074177, 18.456565],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '087',
					name: 'Loíza',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.99279307892016, 18.458102941872703],
							[-65.992349, 18.460024],
							[-65.99079, 18.460419],
							[-65.958492, 18.451354],
							[-65.92567, 18.444881],
							[-65.916843, 18.444619],
							[-65.907756, 18.446893],
							[-65.904988, 18.450926],
							[-65.90231231782148, 18.449643951029152],
							[-65.89471850351137, 18.446005386666307],
							[-65.878683, 18.438322],
							[-65.87823714916772, 18.438249772120425],
							[-65.87306326374564, 18.437411602162815],
							[-65.86041366907484, 18.43536236655668],
							[-65.85411343498355, 18.434341728001623],
							[-65.84885269881241, 18.43348948821395],
							[-65.84618883574568, 18.433057942129803],
							[-65.83890484726027, 18.431877935264176],
							[-65.83885084347614, 18.431869186645727],
							[-65.838825, 18.431865],
							[-65.831476, 18.426849],
							[-65.8310606652677, 18.426394308895713],
							[-65.82845328812711, 18.42353986138826],
							[-65.828564, 18.423257],
							[-65.829102, 18.422812],
							[-65.829314, 18.422528],
							[-65.833579, 18.417507],
							[-65.835083, 18.414811],
							[-65.835659, 18.414642],
							[-65.836034, 18.414256],
							[-65.836694, 18.414314],
							[-65.841764, 18.409387],
							[-65.842655, 18.408678],
							[-65.842878, 18.407072],
							[-65.84382, 18.405698],
							[-65.84705, 18.404042],
							[-65.852539, 18.4017],
							[-65.852399, 18.400776],
							[-65.854748, 18.397754],
							[-65.856002, 18.39471],
							[-65.856406, 18.391968],
							[-65.859963, 18.382681],
							[-65.859639, 18.382001],
							[-65.863593, 18.38133],
							[-65.867466, 18.378215],
							[-65.872846, 18.37845],
							[-65.876666, 18.378612],
							[-65.876191, 18.386658],
							[-65.876249, 18.38741],
							[-65.873773, 18.390727],
							[-65.872598, 18.400614],
							[-65.87167, 18.405005],
							[-65.869878, 18.405712],
							[-65.869956, 18.408941],
							[-65.874608, 18.40913],
							[-65.878858, 18.410288],
							[-65.884493, 18.410806],
							[-65.887856, 18.411412],
							[-65.891469, 18.411505],
							[-65.899674, 18.413322],
							[-65.899993, 18.413598],
							[-65.909746, 18.400972],
							[-65.910499, 18.401373],
							[-65.916939, 18.401308],
							[-65.917515, 18.401012],
							[-65.91804, 18.400742],
							[-65.91901, 18.400188],
							[-65.919594, 18.409777],
							[-65.920085, 18.411176],
							[-65.922914, 18.411793],
							[-65.924142, 18.411484],
							[-65.928374, 18.412946],
							[-65.927688, 18.414412],
							[-65.926172, 18.415596],
							[-65.93086, 18.422771],
							[-65.9304, 18.428478],
							[-65.932599, 18.428424],
							[-65.949098, 18.434706],
							[-65.954945, 18.435557],
							[-65.957217, 18.433474],
							[-65.961673, 18.433424],
							[-65.966978, 18.432166],
							[-65.967197, 18.432246],
							[-65.96735, 18.433548],
							[-65.970901, 18.440372],
							[-65.976726, 18.442334],
							[-65.979172, 18.442307],
							[-65.980791, 18.442257],
							[-65.984431, 18.442824],
							[-65.985467, 18.443835],
							[-65.985793, 18.444801],
							[-65.985038, 18.450587],
							[-65.986325, 18.454382],
							[-65.990556, 18.457474],
							[-65.992791, 18.457683],
							[-65.99279307892016, 18.458102941872703],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '031',
					name: 'Carolina',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.99279307892016, 18.458102941872703],
							[-65.992791, 18.457683],
							[-65.990556, 18.457474],
							[-65.986325, 18.454382],
							[-65.985038, 18.450587],
							[-65.985793, 18.444801],
							[-65.985467, 18.443835],
							[-65.984431, 18.442824],
							[-65.980791, 18.442257],
							[-65.979172, 18.442307],
							[-65.976726, 18.442334],
							[-65.970901, 18.440372],
							[-65.96735, 18.433548],
							[-65.967197, 18.432246],
							[-65.966978, 18.432166],
							[-65.961673, 18.433424],
							[-65.957217, 18.433474],
							[-65.954945, 18.435557],
							[-65.949098, 18.434706],
							[-65.932599, 18.428424],
							[-65.9304, 18.428478],
							[-65.93086, 18.422771],
							[-65.926172, 18.415596],
							[-65.927688, 18.414412],
							[-65.928374, 18.412946],
							[-65.924142, 18.411484],
							[-65.922914, 18.411793],
							[-65.920085, 18.411176],
							[-65.919594, 18.409777],
							[-65.91901, 18.400188],
							[-65.922207, 18.401536],
							[-65.92413, 18.401568],
							[-65.926949, 18.397904],
							[-65.928908, 18.396086],
							[-65.931031, 18.394191],
							[-65.930394, 18.391902],
							[-65.928894, 18.390802],
							[-65.928741, 18.389999],
							[-65.929451, 18.388099],
							[-65.928943, 18.386884],
							[-65.924163, 18.386129],
							[-65.92412, 18.386157],
							[-65.923684, 18.38581],
							[-65.922422, 18.386855],
							[-65.914643, 18.382644],
							[-65.914847, 18.382472],
							[-65.915021, 18.382326],
							[-65.915502, 18.382191],
							[-65.915711, 18.379986],
							[-65.916432, 18.376724],
							[-65.918227, 18.373446],
							[-65.91912, 18.373004],
							[-65.919274, 18.372264],
							[-65.917205, 18.367748],
							[-65.918648, 18.3626],
							[-65.917905, 18.358155],
							[-65.916461, 18.354901],
							[-65.915727, 18.348994],
							[-65.916886, 18.347482],
							[-65.919439, 18.34659],
							[-65.919801, 18.344886],
							[-65.916396, 18.342891],
							[-65.911792, 18.343613],
							[-65.910252, 18.345543],
							[-65.908897, 18.344762],
							[-65.908072, 18.343631],
							[-65.909454, 18.340763],
							[-65.906559, 18.337743],
							[-65.906286, 18.336594],
							[-65.90666, 18.332774],
							[-65.907686, 18.330113],
							[-65.909389, 18.327984],
							[-65.909636, 18.326431],
							[-65.908856, 18.323164],
							[-65.907818, 18.322727],
							[-65.905237, 18.323122],
							[-65.903149, 18.320406],
							[-65.901913, 18.316168],
							[-65.904326, 18.315407],
							[-65.906013, 18.315432],
							[-65.906403, 18.314499],
							[-65.904887, 18.312495],
							[-65.904553, 18.310004],
							[-65.905278, 18.309201],
							[-65.910109, 18.308202],
							[-65.910928, 18.306768],
							[-65.91053, 18.304462],
							[-65.910488, 18.30433],
							[-65.909906, 18.299681],
							[-65.907177, 18.296698],
							[-65.908488, 18.295461],
							[-65.911545, 18.29405],
							[-65.913131, 18.294105],
							[-65.913433, 18.294588],
							[-65.912943, 18.295277],
							[-65.913889, 18.295806],
							[-65.915379, 18.295135],
							[-65.915713, 18.293814],
							[-65.915646, 18.292198],
							[-65.913473, 18.287282],
							[-65.911423, 18.286355],
							[-65.909139, 18.279364],
							[-65.907308, 18.272347],
							[-65.91372, 18.271464],
							[-65.917801, 18.270172],
							[-65.918535, 18.27013],
							[-65.92036, 18.27073],
							[-65.923567, 18.274774],
							[-65.925471, 18.275416],
							[-65.928271, 18.276662],
							[-65.932934, 18.280386],
							[-65.935281, 18.282756],
							[-65.935814, 18.28322],
							[-65.942562, 18.293438],
							[-65.943137, 18.299311],
							[-65.941738, 18.305109],
							[-65.939038, 18.309199],
							[-65.941659, 18.312003],
							[-65.94237, 18.312228],
							[-65.943423, 18.311612],
							[-65.944973, 18.311315],
							[-65.947978, 18.311711],
							[-65.949955, 18.313813],
							[-65.950477, 18.315563],
							[-65.951363, 18.31623],
							[-65.952324, 18.316207],
							[-65.952674, 18.316199],
							[-65.953858, 18.317625],
							[-65.95616, 18.318022],
							[-65.957822, 18.319848],
							[-65.958398, 18.320739],
							[-65.958714, 18.321643],
							[-65.963249, 18.325156],
							[-65.962564, 18.326977],
							[-65.967098, 18.329849],
							[-65.967194, 18.330038],
							[-65.969828, 18.33411],
							[-65.967695, 18.338592],
							[-65.967609, 18.338656],
							[-65.966982, 18.339764],
							[-65.96975, 18.340431],
							[-65.970148, 18.341813],
							[-65.972814, 18.34424],
							[-65.973004, 18.344998],
							[-65.973755, 18.347212],
							[-65.974716, 18.348822],
							[-65.974692, 18.348874],
							[-65.975561, 18.349917],
							[-65.975602, 18.35122],
							[-65.97589, 18.35284],
							[-65.980802, 18.3552],
							[-65.981956, 18.358329],
							[-65.982043, 18.358487],
							[-65.982557, 18.359166],
							[-65.986376, 18.363005],
							[-65.989734, 18.36724],
							[-65.989683, 18.367549],
							[-65.989492, 18.368717],
							[-65.9895, 18.370058],
							[-65.989828, 18.37054],
							[-65.990203, 18.371046],
							[-65.991531, 18.376451],
							[-65.991506, 18.376873],
							[-65.99784, 18.378275],
							[-65.999055, 18.380012],
							[-65.99909, 18.379926],
							[-65.999609, 18.380004],
							[-66.000099, 18.38055],
							[-66.000315, 18.380743],
							[-66.000271, 18.381017],
							[-66.000445, 18.381497],
							[-66.000648, 18.381883],
							[-66.002899, 18.385264],
							[-66.002916, 18.385739],
							[-66.003236, 18.38948],
							[-66.003425, 18.391423],
							[-66.003433, 18.391818],
							[-66.003438, 18.392073],
							[-66.001825, 18.394576],
							[-66.000824, 18.395184],
							[-65.994355, 18.397318],
							[-65.993681, 18.397606],
							[-65.99209, 18.398405],
							[-65.991682, 18.399532],
							[-65.991785, 18.401472],
							[-65.991813, 18.402014],
							[-65.99238, 18.404961],
							[-65.992555, 18.405538],
							[-65.992979, 18.406598],
							[-65.99365, 18.407532],
							[-65.995102, 18.407963],
							[-65.996541, 18.408634],
							[-65.99702, 18.408857],
							[-65.997183, 18.408772],
							[-65.997327, 18.408468],
							[-65.99738, 18.408352],
							[-65.998766, 18.407854],
							[-66.000657, 18.409033],
							[-66.001062, 18.409559],
							[-66.001276, 18.410267],
							[-66.00182, 18.410851],
							[-66.003754, 18.411242],
							[-66.005517, 18.41223],
							[-66.006315, 18.412345],
							[-66.006711, 18.412393],
							[-66.007728, 18.412685],
							[-66.008316, 18.412926],
							[-66.009635, 18.41389],
							[-66.014749, 18.41776],
							[-66.014925, 18.417849],
							[-66.017066, 18.418638],
							[-66.019629, 18.419696],
							[-66.020919, 18.4206],
							[-66.023398, 18.422732],
							[-66.02381, 18.423084],
							[-66.024616, 18.423701],
							[-66.025137, 18.424077],
							[-66.029735, 18.427795],
							[-66.03094, 18.430396],
							[-66.032, 18.434047],
							[-66.032399, 18.435868],
							[-66.038329, 18.440307],
							[-66.039191, 18.440822],
							[-66.041905, 18.442999],
							[-66.042413, 18.443452],
							[-66.043091, 18.444057],
							[-66.042985, 18.444158],
							[-66.041306, 18.445668],
							[-66.040578, 18.446402],
							[-66.038218, 18.446239],
							[-66.038152, 18.446963],
							[-66.037698, 18.448538],
							[-66.037356, 18.449089],
							[-66.037535, 18.449295],
							[-66.03655341822281, 18.450207906574445],
							[-66.03649147391191, 18.45011705491313],
							[-66.02626082721238, 18.44530484858808],
							[-66.023221, 18.443875],
							[-66.01582371856307, 18.44408409790623],
							[-66.006523, 18.444347],
							[-65.99718, 18.449895],
							[-65.992935, 18.457489],
							[-65.99279307892016, 18.458102941872703],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '061',
					name: 'Guaynabo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.118002, 18.43805],
							[-66.117233, 18.438715],
							[-66.114352, 18.440542],
							[-66.108281, 18.438902],
							[-66.107571, 18.427288],
							[-66.099427, 18.419114],
							[-66.098812, 18.418173],
							[-66.098424, 18.417579],
							[-66.099806, 18.41189],
							[-66.097953, 18.410063],
							[-66.096651, 18.408264],
							[-66.095216, 18.406229],
							[-66.096574, 18.400576],
							[-66.098589, 18.40111],
							[-66.102416, 18.402123],
							[-66.105746, 18.40195],
							[-66.106162, 18.401987],
							[-66.106423, 18.402011],
							[-66.108608, 18.398971],
							[-66.108701, 18.398867],
							[-66.108575, 18.398715],
							[-66.107892, 18.389845],
							[-66.105895, 18.386629],
							[-66.106159, 18.3825],
							[-66.105223, 18.382086],
							[-66.10357, 18.381093],
							[-66.100947, 18.379799],
							[-66.099338, 18.379574],
							[-66.098058, 18.379202],
							[-66.097988, 18.379165],
							[-66.096877, 18.378493],
							[-66.094796, 18.37723],
							[-66.09462, 18.376912],
							[-66.09443, 18.376589],
							[-66.094354, 18.376459],
							[-66.091176, 18.375204],
							[-66.090354, 18.374704],
							[-66.091118, 18.368458],
							[-66.090814, 18.367918],
							[-66.089948, 18.366204],
							[-66.090048, 18.365895],
							[-66.091792, 18.363167],
							[-66.091624, 18.361795],
							[-66.091778, 18.361064],
							[-66.091681, 18.36106],
							[-66.09025, 18.361038],
							[-66.088356, 18.357165],
							[-66.088476, 18.357081],
							[-66.089787, 18.356163],
							[-66.094203, 18.354959],
							[-66.097743, 18.355843],
							[-66.097619, 18.355643],
							[-66.09717, 18.354949],
							[-66.096333, 18.353671],
							[-66.098214, 18.349639],
							[-66.099307, 18.343584],
							[-66.097448, 18.340491],
							[-66.096583, 18.340257],
							[-66.095738, 18.339233],
							[-66.096011, 18.338871],
							[-66.096306, 18.337867],
							[-66.095816, 18.337762],
							[-66.095126, 18.339427],
							[-66.094887, 18.338476],
							[-66.092619, 18.337655],
							[-66.091567, 18.336498],
							[-66.089953, 18.33553],
							[-66.086751, 18.332964],
							[-66.087266, 18.327792],
							[-66.088522, 18.323612],
							[-66.089087, 18.322835],
							[-66.087962, 18.317905],
							[-66.086351, 18.317647],
							[-66.085089, 18.316316],
							[-66.082668, 18.309374],
							[-66.082397, 18.306788],
							[-66.083235, 18.305083],
							[-66.084922, 18.30172],
							[-66.084979, 18.301628],
							[-66.085044, 18.299924],
							[-66.082044, 18.299889],
							[-66.080475, 18.297295],
							[-66.086674, 18.293325],
							[-66.086789, 18.29321],
							[-66.08797, 18.292184],
							[-66.089895, 18.292142],
							[-66.091724, 18.293051],
							[-66.09383, 18.29193],
							[-66.094336, 18.28579],
							[-66.098818, 18.282048],
							[-66.099486, 18.281648],
							[-66.099692, 18.28157],
							[-66.106245, 18.27865],
							[-66.108191, 18.277768],
							[-66.108564, 18.277867],
							[-66.111713, 18.279513],
							[-66.120712, 18.281404],
							[-66.139167, 18.278894],
							[-66.139541, 18.27955],
							[-66.140599, 18.279623],
							[-66.140797, 18.278144],
							[-66.141528, 18.277745],
							[-66.143128, 18.278318],
							[-66.143877, 18.279733],
							[-66.140282, 18.285466],
							[-66.14112, 18.289267],
							[-66.139592, 18.294903],
							[-66.138208, 18.297808],
							[-66.138521, 18.299822],
							[-66.140655, 18.300704],
							[-66.141245, 18.301484],
							[-66.141541, 18.310472],
							[-66.140685, 18.311551],
							[-66.134189, 18.312288],
							[-66.132622, 18.312821],
							[-66.132401, 18.313539],
							[-66.135745, 18.314767],
							[-66.139406, 18.317807],
							[-66.141342, 18.320429],
							[-66.141825, 18.322716],
							[-66.141573, 18.324467],
							[-66.139299, 18.331856],
							[-66.136471, 18.333524],
							[-66.133893, 18.334636],
							[-66.133556, 18.335623],
							[-66.135873, 18.336004],
							[-66.136107, 18.337364],
							[-66.135635, 18.339109],
							[-66.137811, 18.342048],
							[-66.137786, 18.343453],
							[-66.135738, 18.346948],
							[-66.136559, 18.350527],
							[-66.138158, 18.352984],
							[-66.138175, 18.353047],
							[-66.139421, 18.355568],
							[-66.141922, 18.357603],
							[-66.141878, 18.358403],
							[-66.141671, 18.361598],
							[-66.141537, 18.361973],
							[-66.141285, 18.362342],
							[-66.139103, 18.361801],
							[-66.138242, 18.362701],
							[-66.137705, 18.367556],
							[-66.137932, 18.372424],
							[-66.137152, 18.373694],
							[-66.134466, 18.374577],
							[-66.137373, 18.377395],
							[-66.137338, 18.379595],
							[-66.135185, 18.382701],
							[-66.12461, 18.376914],
							[-66.122403, 18.376182],
							[-66.122074, 18.376792],
							[-66.118491, 18.379257],
							[-66.119709, 18.381917],
							[-66.119939, 18.38239],
							[-66.121113, 18.384503],
							[-66.122919, 18.387792],
							[-66.123789, 18.389684],
							[-66.125761, 18.394497],
							[-66.124056, 18.399041],
							[-66.124124, 18.399258],
							[-66.124243, 18.399559],
							[-66.124555, 18.400286],
							[-66.124924, 18.401096],
							[-66.12575, 18.401402],
							[-66.126613, 18.401093],
							[-66.127804, 18.403102],
							[-66.127107, 18.404163],
							[-66.124789, 18.406388],
							[-66.12461, 18.407327],
							[-66.12395, 18.408261],
							[-66.12418, 18.409643],
							[-66.123515, 18.410933],
							[-66.123381, 18.411067],
							[-66.122129, 18.413],
							[-66.122028, 18.413119],
							[-66.121234, 18.414468],
							[-66.123077, 18.416606],
							[-66.127406, 18.419402],
							[-66.127491, 18.419433],
							[-66.131327, 18.421893],
							[-66.130546, 18.423498],
							[-66.13158, 18.424656],
							[-66.131262, 18.42499],
							[-66.131178, 18.42508],
							[-66.131104, 18.425125],
							[-66.123066, 18.433143],
							[-66.122266, 18.434015],
							[-66.121518, 18.43477],
							[-66.121104, 18.435174],
							[-66.12054, 18.435707],
							[-66.118776, 18.437352],
							[-66.118454, 18.437648],
							[-66.118002, 18.43805],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '021',
					name: 'Bayamón',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.169516, 18.430998],
							[-66.165411, 18.429838],
							[-66.165142, 18.429284],
							[-66.164754, 18.428924],
							[-66.16439, 18.428713],
							[-66.161991, 18.427934],
							[-66.158453, 18.422649],
							[-66.15861, 18.421314],
							[-66.157134, 18.421067],
							[-66.154521, 18.421932],
							[-66.145502, 18.422512],
							[-66.142099, 18.422591],
							[-66.140349, 18.423029],
							[-66.135488, 18.423104],
							[-66.135671, 18.422009],
							[-66.13158, 18.424656],
							[-66.130546, 18.423498],
							[-66.131327, 18.421893],
							[-66.127491, 18.419433],
							[-66.127406, 18.419402],
							[-66.123077, 18.416606],
							[-66.121234, 18.414468],
							[-66.122028, 18.413119],
							[-66.122129, 18.413],
							[-66.123381, 18.411067],
							[-66.123515, 18.410933],
							[-66.12418, 18.409643],
							[-66.12395, 18.408261],
							[-66.12461, 18.407327],
							[-66.124789, 18.406388],
							[-66.127107, 18.404163],
							[-66.127804, 18.403102],
							[-66.126613, 18.401093],
							[-66.12575, 18.401402],
							[-66.124924, 18.401096],
							[-66.124555, 18.400286],
							[-66.124243, 18.399559],
							[-66.124124, 18.399258],
							[-66.124056, 18.399041],
							[-66.125761, 18.394497],
							[-66.123789, 18.389684],
							[-66.122919, 18.387792],
							[-66.121113, 18.384503],
							[-66.119939, 18.38239],
							[-66.119709, 18.381917],
							[-66.118491, 18.379257],
							[-66.122074, 18.376792],
							[-66.122403, 18.376182],
							[-66.12461, 18.376914],
							[-66.135185, 18.382701],
							[-66.137338, 18.379595],
							[-66.137373, 18.377395],
							[-66.134466, 18.374577],
							[-66.137152, 18.373694],
							[-66.137932, 18.372424],
							[-66.137705, 18.367556],
							[-66.138242, 18.362701],
							[-66.139103, 18.361801],
							[-66.141285, 18.362342],
							[-66.141537, 18.361973],
							[-66.141671, 18.361598],
							[-66.141878, 18.358403],
							[-66.141922, 18.357603],
							[-66.139421, 18.355568],
							[-66.138175, 18.353047],
							[-66.138158, 18.352984],
							[-66.136559, 18.350527],
							[-66.135738, 18.346948],
							[-66.137786, 18.343453],
							[-66.137811, 18.342048],
							[-66.135635, 18.339109],
							[-66.136107, 18.337364],
							[-66.135873, 18.336004],
							[-66.133556, 18.335623],
							[-66.133893, 18.334636],
							[-66.136471, 18.333524],
							[-66.139299, 18.331856],
							[-66.141573, 18.324467],
							[-66.141825, 18.322716],
							[-66.141342, 18.320429],
							[-66.139406, 18.317807],
							[-66.135745, 18.314767],
							[-66.132401, 18.313539],
							[-66.132622, 18.312821],
							[-66.134189, 18.312288],
							[-66.140685, 18.311551],
							[-66.141541, 18.310472],
							[-66.141245, 18.301484],
							[-66.140655, 18.300704],
							[-66.138521, 18.299822],
							[-66.138208, 18.297808],
							[-66.139592, 18.294903],
							[-66.14112, 18.289267],
							[-66.140282, 18.285466],
							[-66.143877, 18.279733],
							[-66.148513, 18.28105],
							[-66.15097, 18.280784],
							[-66.153587, 18.282041],
							[-66.155031, 18.282219],
							[-66.161332, 18.28275],
							[-66.16173, 18.282545],
							[-66.163754, 18.280873],
							[-66.164222, 18.28061],
							[-66.167855, 18.277728],
							[-66.172483, 18.278403],
							[-66.175447, 18.276793],
							[-66.175446, 18.276717],
							[-66.177041, 18.276211],
							[-66.177081, 18.276175],
							[-66.179024, 18.271538],
							[-66.184315, 18.268339],
							[-66.185958, 18.266333],
							[-66.188658, 18.260612],
							[-66.190771, 18.258742],
							[-66.193772, 18.264835],
							[-66.193099, 18.267288],
							[-66.1934, 18.26794],
							[-66.197494, 18.269914],
							[-66.199762, 18.274408],
							[-66.205653, 18.27569],
							[-66.205805, 18.276158],
							[-66.206221, 18.276644],
							[-66.206589, 18.277137],
							[-66.206559, 18.279622],
							[-66.209247, 18.284701],
							[-66.209816, 18.288663],
							[-66.211506, 18.291621],
							[-66.211072, 18.293109],
							[-66.210399, 18.293596],
							[-66.208678, 18.296024],
							[-66.210097, 18.298295],
							[-66.21062, 18.303048],
							[-66.211274, 18.303689],
							[-66.212954, 18.30488],
							[-66.212369, 18.307025],
							[-66.212028, 18.307039],
							[-66.206206, 18.306622],
							[-66.206062, 18.306668],
							[-66.205867, 18.310378],
							[-66.205364, 18.316495],
							[-66.204338, 18.316414],
							[-66.201531, 18.328983],
							[-66.201865, 18.330217],
							[-66.203616, 18.336673],
							[-66.200234, 18.339158],
							[-66.199549, 18.339855],
							[-66.200527, 18.344093],
							[-66.19956, 18.349133],
							[-66.198818, 18.350849],
							[-66.198737, 18.351036],
							[-66.198483, 18.352423],
							[-66.19878, 18.353515],
							[-66.19969, 18.354646],
							[-66.199515, 18.355233],
							[-66.197293, 18.3602],
							[-66.19754, 18.365114],
							[-66.199564, 18.369636],
							[-66.199232, 18.373005],
							[-66.197781, 18.376697],
							[-66.197666, 18.378409],
							[-66.197333, 18.385285],
							[-66.197129, 18.387501],
							[-66.196976, 18.389252],
							[-66.197088, 18.390772],
							[-66.195516, 18.391266],
							[-66.197181, 18.394205],
							[-66.195586, 18.396856],
							[-66.196787, 18.399793],
							[-66.196611, 18.401607],
							[-66.197772, 18.403748],
							[-66.196999, 18.404717],
							[-66.196953, 18.405416],
							[-66.197701, 18.40687],
							[-66.198296, 18.413678],
							[-66.197229, 18.415547],
							[-66.196162, 18.416101],
							[-66.195715, 18.417021],
							[-66.195267, 18.417259],
							[-66.194724, 18.417406],
							[-66.19134, 18.418195],
							[-66.190811, 18.418455],
							[-66.187532, 18.419596],
							[-66.187491, 18.419728],
							[-66.186436, 18.420868],
							[-66.179601, 18.420239],
							[-66.176797, 18.419683],
							[-66.173201, 18.420868],
							[-66.172644, 18.420917],
							[-66.171196, 18.423733],
							[-66.17031, 18.424453],
							[-66.16956, 18.426256],
							[-66.169592, 18.430569],
							[-66.169516, 18.430998],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 119,
					name: 'Río Grande',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.82845328812711, 18.42353986138826],
							[-65.816691, 18.410663],
							[-65.80647628059523, 18.407055198947074],
							[-65.80628867444895, 18.4069889371512],
							[-65.80073861643602, 18.40502867722145],
							[-65.794556, 18.402845],
							[-65.787666, 18.402544],
							[-65.774937, 18.413951],
							[-65.77053, 18.41294],
							[-65.769749, 18.409473],
							[-65.771695, 18.406277],
							[-65.76157689880301, 18.39624035809231],
							[-65.750455, 18.385208],
							[-65.75024382769794, 18.385087188379412],
							[-65.75041, 18.38501],
							[-65.751176, 18.38467],
							[-65.752764, 18.382107],
							[-65.756393, 18.379728],
							[-65.76078, 18.378003],
							[-65.761092, 18.375118],
							[-65.763197, 18.372388],
							[-65.766733, 18.367691],
							[-65.77017, 18.365965],
							[-65.768464, 18.359863],
							[-65.766513, 18.355635],
							[-65.762113, 18.350695],
							[-65.758992, 18.348134],
							[-65.757685, 18.346881],
							[-65.754129, 18.339758],
							[-65.754129, 18.336505],
							[-65.755117, 18.334448],
							[-65.756081, 18.333626],
							[-65.756, 18.329174],
							[-65.754896, 18.328402],
							[-65.751711, 18.328066],
							[-65.749606, 18.326684],
							[-65.748582, 18.325522],
							[-65.749816, 18.322988],
							[-65.751368, 18.321238],
							[-65.757273, 18.318616],
							[-65.758917, 18.315612],
							[-65.762099, 18.305966],
							[-65.761029, 18.302731],
							[-65.759162, 18.299448],
							[-65.758075, 18.297686],
							[-65.758853, 18.294108],
							[-65.758862, 18.290604],
							[-65.762365, 18.288638],
							[-65.765594, 18.283391],
							[-65.766832, 18.280004],
							[-65.774235, 18.2817],
							[-65.776275, 18.283987],
							[-65.77936, 18.286235],
							[-65.783334, 18.291761],
							[-65.790472, 18.295356],
							[-65.793223, 18.296529],
							[-65.793416, 18.295876],
							[-65.794333, 18.294765],
							[-65.794137, 18.292036],
							[-65.795543, 18.289512],
							[-65.796725, 18.288925],
							[-65.799336, 18.288906],
							[-65.800477, 18.289887],
							[-65.802025, 18.290032],
							[-65.805438, 18.288049],
							[-65.811424, 18.290141],
							[-65.821582, 18.275455],
							[-65.824221, 18.273054],
							[-65.82885, 18.272157],
							[-65.831718, 18.271736],
							[-65.833592, 18.272742],
							[-65.836387, 18.275246],
							[-65.841621, 18.277256],
							[-65.842021, 18.279094],
							[-65.845601, 18.27875],
							[-65.846291, 18.281634],
							[-65.849449, 18.282323],
							[-65.854134, 18.285314],
							[-65.859171, 18.288904],
							[-65.860679, 18.29183],
							[-65.861996, 18.29325],
							[-65.863678, 18.294031],
							[-65.864965, 18.293678],
							[-65.868247, 18.293923],
							[-65.863777, 18.300259],
							[-65.862662, 18.303391],
							[-65.86393, 18.307519],
							[-65.864047, 18.309419],
							[-65.868696, 18.309322],
							[-65.869826, 18.313159],
							[-65.869663, 18.317152],
							[-65.86538, 18.317168],
							[-65.864657, 18.317778],
							[-65.862759, 18.321492],
							[-65.862996, 18.322094],
							[-65.863728, 18.323895],
							[-65.866527, 18.33182],
							[-65.866503, 18.331902],
							[-65.86709, 18.332589],
							[-65.868066, 18.333189],
							[-65.872772, 18.3352],
							[-65.872483, 18.340974],
							[-65.872849, 18.343111],
							[-65.872434, 18.34397],
							[-65.875032, 18.345503],
							[-65.877341, 18.34672],
							[-65.87669, 18.350044],
							[-65.87617, 18.355665],
							[-65.874779, 18.358919],
							[-65.876755, 18.361637],
							[-65.876649, 18.363341],
							[-65.873448, 18.372004],
							[-65.868912, 18.376527],
							[-65.867935, 18.376947],
							[-65.867466, 18.378215],
							[-65.863593, 18.38133],
							[-65.859639, 18.382001],
							[-65.859963, 18.382681],
							[-65.856406, 18.391968],
							[-65.856002, 18.39471],
							[-65.854748, 18.397754],
							[-65.852399, 18.400776],
							[-65.852539, 18.4017],
							[-65.84705, 18.404042],
							[-65.84382, 18.405698],
							[-65.842878, 18.407072],
							[-65.842655, 18.408678],
							[-65.841764, 18.409387],
							[-65.836694, 18.414314],
							[-65.836034, 18.414256],
							[-65.835659, 18.414642],
							[-65.835083, 18.414811],
							[-65.833579, 18.417507],
							[-65.829314, 18.422528],
							[-65.829102, 18.422812],
							[-65.828564, 18.423257],
							[-65.82845328812711, 18.42353986138826],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '003',
					name: 'Aguada',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.16015744822774, 18.41557924257951],
							[-67.158996, 18.414897],
							[-67.15909792617188, 18.413697173779298],
							[-67.16007592617187, 18.413325773779295],
							[-67.161876, 18.411278],
							[-67.162199, 18.409704],
							[-67.159285, 18.410347],
							[-67.15773, 18.411448],
							[-67.155084, 18.399568],
							[-67.15576, 18.398449],
							[-67.154788, 18.39704],
							[-67.153677, 18.394968],
							[-67.15334, 18.394703],
							[-67.151236, 18.393194],
							[-67.150127, 18.392122],
							[-67.145491, 18.392282],
							[-67.144371, 18.391835],
							[-67.141516, 18.389643],
							[-67.140558, 18.388353],
							[-67.136137, 18.385974],
							[-67.134177, 18.387186],
							[-67.133305, 18.387805],
							[-67.132373, 18.389155],
							[-67.13167, 18.382529],
							[-67.13111, 18.381342],
							[-67.130288, 18.381069],
							[-67.129975, 18.379373],
							[-67.130819, 18.375491],
							[-67.130687, 18.373003],
							[-67.127913, 18.371826],
							[-67.126677, 18.370924],
							[-67.126636, 18.370474],
							[-67.127862, 18.366134],
							[-67.128025, 18.362709],
							[-67.128034, 18.362511],
							[-67.12777, 18.361917],
							[-67.127184, 18.360601],
							[-67.127059, 18.359985],
							[-67.128012, 18.356734],
							[-67.128124, 18.353859],
							[-67.129336, 18.352395],
							[-67.130452, 18.352118],
							[-67.131524, 18.350898],
							[-67.131205, 18.349698],
							[-67.131745, 18.348324],
							[-67.132406, 18.347975],
							[-67.13434, 18.346519],
							[-67.134335, 18.346428],
							[-67.133912, 18.344883],
							[-67.133897, 18.344828],
							[-67.133835, 18.344572],
							[-67.133741, 18.343755],
							[-67.133296, 18.341506],
							[-67.132964, 18.340715],
							[-67.130963, 18.335143],
							[-67.131024, 18.334689],
							[-67.132322, 18.332936],
							[-67.13339, 18.331406],
							[-67.134171, 18.330006],
							[-67.134162, 18.329919],
							[-67.133674, 18.329385],
							[-67.132541, 18.327696],
							[-67.130052, 18.320531],
							[-67.130096, 18.31844],
							[-67.129909, 18.317959],
							[-67.13085, 18.317511],
							[-67.132773, 18.317747],
							[-67.135891, 18.317092],
							[-67.138676, 18.31805],
							[-67.139199, 18.319376],
							[-67.141077, 18.321231],
							[-67.143538, 18.322407],
							[-67.145759, 18.32266],
							[-67.146191, 18.322337],
							[-67.146178, 18.322302],
							[-67.157529, 18.319189],
							[-67.164769, 18.315403],
							[-67.16992, 18.316051],
							[-67.17264, 18.318215],
							[-67.17365, 18.31798],
							[-67.173775, 18.31819],
							[-67.174811, 18.317124],
							[-67.175461, 18.3167],
							[-67.178657, 18.315493],
							[-67.182741, 18.312867],
							[-67.187803, 18.315635],
							[-67.188054, 18.317367],
							[-67.189627, 18.322223],
							[-67.19212, 18.323862],
							[-67.193042, 18.324183],
							[-67.193906, 18.324098],
							[-67.195378, 18.325131],
							[-67.195521, 18.330355],
							[-67.1981, 18.331806],
							[-67.20082, 18.332052],
							[-67.201797, 18.332508],
							[-67.201933, 18.332644],
							[-67.20382, 18.334202],
							[-67.209095, 18.335733],
							[-67.21066, 18.336355],
							[-67.211685, 18.337771],
							[-67.21177, 18.339459],
							[-67.213633, 18.340891],
							[-67.213825, 18.341319],
							[-67.216749, 18.342605],
							[-67.21964, 18.34263],
							[-67.219911, 18.346129],
							[-67.22276, 18.345447],
							[-67.224545, 18.347729],
							[-67.225331, 18.34821],
							[-67.225364, 18.348314],
							[-67.22555, 18.348892],
							[-67.226075, 18.350597],
							[-67.224397, 18.355507],
							[-67.227522, 18.36082],
							[-67.22881, 18.36422],
							[-67.23389, 18.367783],
							[-67.238747, 18.372532],
							[-67.2393415096082, 18.375257936647923],
							[-67.226744, 18.378247],
							[-67.2241004727055, 18.379286129187893],
							[-67.216998, 18.382078],
							[-67.21343105779914, 18.383961160773563],
							[-67.202167, 18.389908],
							[-67.19874323540054, 18.392000197794545],
							[-67.19102845929656, 18.39671455156546],
							[-67.1764818742638, 18.405603694565695],
							[-67.16015744822774, 18.41557924257951],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '029',
					name: 'Canóvanas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.916939, 18.401308],
							[-65.910499, 18.401373],
							[-65.909746, 18.400972],
							[-65.899993, 18.413598],
							[-65.899674, 18.413322],
							[-65.891469, 18.411505],
							[-65.887856, 18.411412],
							[-65.884493, 18.410806],
							[-65.878858, 18.410288],
							[-65.874608, 18.40913],
							[-65.869956, 18.408941],
							[-65.869878, 18.405712],
							[-65.87167, 18.405005],
							[-65.872598, 18.400614],
							[-65.873773, 18.390727],
							[-65.876249, 18.38741],
							[-65.876191, 18.386658],
							[-65.876666, 18.378612],
							[-65.872846, 18.37845],
							[-65.867466, 18.378215],
							[-65.867935, 18.376947],
							[-65.868912, 18.376527],
							[-65.873448, 18.372004],
							[-65.876649, 18.363341],
							[-65.876755, 18.361637],
							[-65.874779, 18.358919],
							[-65.87617, 18.355665],
							[-65.87669, 18.350044],
							[-65.877341, 18.34672],
							[-65.875032, 18.345503],
							[-65.872434, 18.34397],
							[-65.872849, 18.343111],
							[-65.872483, 18.340974],
							[-65.872772, 18.3352],
							[-65.868066, 18.333189],
							[-65.86709, 18.332589],
							[-65.866503, 18.331902],
							[-65.866527, 18.33182],
							[-65.863728, 18.323895],
							[-65.862996, 18.322094],
							[-65.862759, 18.321492],
							[-65.864657, 18.317778],
							[-65.86538, 18.317168],
							[-65.869663, 18.317152],
							[-65.869826, 18.313159],
							[-65.868696, 18.309322],
							[-65.864047, 18.309419],
							[-65.86393, 18.307519],
							[-65.862662, 18.303391],
							[-65.863777, 18.300259],
							[-65.868247, 18.293923],
							[-65.864965, 18.293678],
							[-65.863678, 18.294031],
							[-65.861996, 18.29325],
							[-65.860679, 18.29183],
							[-65.859171, 18.288904],
							[-65.854134, 18.285314],
							[-65.849449, 18.282323],
							[-65.846291, 18.281634],
							[-65.845601, 18.27875],
							[-65.842021, 18.279094],
							[-65.841621, 18.277256],
							[-65.836387, 18.275246],
							[-65.838595, 18.273689],
							[-65.839386, 18.271074],
							[-65.839854, 18.265696],
							[-65.840316, 18.265025],
							[-65.842098, 18.264395],
							[-65.845751, 18.259701],
							[-65.846331, 18.258016],
							[-65.849541, 18.256144],
							[-65.852639, 18.25483],
							[-65.857407, 18.256072],
							[-65.858468, 18.255985],
							[-65.861489, 18.256946],
							[-65.866227, 18.255789],
							[-65.867658, 18.253171],
							[-65.873731, 18.252589],
							[-65.874608, 18.253081],
							[-65.88038, 18.256664],
							[-65.881455, 18.256586],
							[-65.8822, 18.256977],
							[-65.885945, 18.260098],
							[-65.889216, 18.261757],
							[-65.891571, 18.261118],
							[-65.896943, 18.261209],
							[-65.904349, 18.265123],
							[-65.906765, 18.26573],
							[-65.911453, 18.265575],
							[-65.91238, 18.266045],
							[-65.912671, 18.266219],
							[-65.914026, 18.267369],
							[-65.914512, 18.267782],
							[-65.916356, 18.268776],
							[-65.918535, 18.27013],
							[-65.917801, 18.270172],
							[-65.91372, 18.271464],
							[-65.907308, 18.272347],
							[-65.909139, 18.279364],
							[-65.911423, 18.286355],
							[-65.913473, 18.287282],
							[-65.915646, 18.292198],
							[-65.915713, 18.293814],
							[-65.915379, 18.295135],
							[-65.913889, 18.295806],
							[-65.912943, 18.295277],
							[-65.913433, 18.294588],
							[-65.913131, 18.294105],
							[-65.911545, 18.29405],
							[-65.908488, 18.295461],
							[-65.907177, 18.296698],
							[-65.909906, 18.299681],
							[-65.910488, 18.30433],
							[-65.91053, 18.304462],
							[-65.910928, 18.306768],
							[-65.910109, 18.308202],
							[-65.905278, 18.309201],
							[-65.904553, 18.310004],
							[-65.904887, 18.312495],
							[-65.906403, 18.314499],
							[-65.906013, 18.315432],
							[-65.904326, 18.315407],
							[-65.901913, 18.316168],
							[-65.903149, 18.320406],
							[-65.905237, 18.323122],
							[-65.907818, 18.322727],
							[-65.908856, 18.323164],
							[-65.909636, 18.326431],
							[-65.909389, 18.327984],
							[-65.907686, 18.330113],
							[-65.90666, 18.332774],
							[-65.906286, 18.336594],
							[-65.906559, 18.337743],
							[-65.909454, 18.340763],
							[-65.908072, 18.343631],
							[-65.908897, 18.344762],
							[-65.910252, 18.345543],
							[-65.911792, 18.343613],
							[-65.916396, 18.342891],
							[-65.919801, 18.344886],
							[-65.919439, 18.34659],
							[-65.916886, 18.347482],
							[-65.915727, 18.348994],
							[-65.916461, 18.354901],
							[-65.917905, 18.358155],
							[-65.918648, 18.3626],
							[-65.917205, 18.367748],
							[-65.919274, 18.372264],
							[-65.91912, 18.373004],
							[-65.918227, 18.373446],
							[-65.916432, 18.376724],
							[-65.915711, 18.379986],
							[-65.915502, 18.382191],
							[-65.915021, 18.382326],
							[-65.914847, 18.382472],
							[-65.914643, 18.382644],
							[-65.922422, 18.386855],
							[-65.923684, 18.38581],
							[-65.92412, 18.386157],
							[-65.924163, 18.386129],
							[-65.928943, 18.386884],
							[-65.929451, 18.388099],
							[-65.928741, 18.389999],
							[-65.928894, 18.390802],
							[-65.930394, 18.391902],
							[-65.931031, 18.394191],
							[-65.928908, 18.396086],
							[-65.926949, 18.397904],
							[-65.92413, 18.401568],
							[-65.922207, 18.401536],
							[-65.91901, 18.400188],
							[-65.91804, 18.400742],
							[-65.917515, 18.401012],
							[-65.916939, 18.401308],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '054',
					name: 'Florida',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.540119, 18.39984],
							[-66.535677, 18.393907],
							[-66.53529, 18.39158],
							[-66.533716, 18.387413],
							[-66.530986, 18.386068],
							[-66.531361, 18.380504],
							[-66.531591, 18.378319],
							[-66.531168, 18.373004],
							[-66.531333, 18.368051],
							[-66.531535, 18.364674],
							[-66.532374, 18.363163],
							[-66.533307, 18.362638],
							[-66.533993, 18.360983],
							[-66.533623, 18.351333],
							[-66.536173, 18.348762],
							[-66.536075, 18.347527],
							[-66.537105, 18.346335],
							[-66.540271, 18.34432],
							[-66.553679, 18.340844],
							[-66.56387, 18.341631],
							[-66.565168, 18.340849],
							[-66.569102, 18.341003],
							[-66.571687, 18.341568],
							[-66.57232, 18.342508],
							[-66.573822, 18.342517],
							[-66.581616, 18.340497],
							[-66.583441, 18.339129],
							[-66.586087, 18.337308],
							[-66.587874, 18.339148],
							[-66.590785, 18.33806],
							[-66.589751, 18.349562],
							[-66.588111, 18.354953],
							[-66.585172, 18.359211],
							[-66.583014, 18.363218],
							[-66.582946, 18.364405],
							[-66.582374, 18.374238],
							[-66.587629, 18.374738],
							[-66.588569, 18.375704],
							[-66.588856, 18.377413],
							[-66.587785, 18.382964],
							[-66.588273, 18.386988],
							[-66.588181, 18.389408],
							[-66.582967, 18.389491],
							[-66.582689, 18.395605],
							[-66.580929, 18.395523],
							[-66.578844, 18.394958],
							[-66.575712, 18.400658],
							[-66.574973, 18.406403],
							[-66.5704, 18.411224],
							[-66.564314, 18.413309],
							[-66.553102, 18.411643],
							[-66.552024, 18.409988],
							[-66.550843, 18.406387],
							[-66.547199, 18.404926],
							[-66.543079, 18.405422],
							[-66.540119, 18.39984],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 135,
					name: 'Toa Alta',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.220953, 18.397176],
							[-66.218937, 18.396595],
							[-66.218605, 18.396434],
							[-66.212802, 18.394472],
							[-66.210859, 18.393827],
							[-66.210528, 18.39368],
							[-66.202126, 18.390938],
							[-66.196976, 18.389252],
							[-66.197129, 18.387501],
							[-66.197333, 18.385285],
							[-66.197666, 18.378409],
							[-66.197781, 18.376697],
							[-66.199232, 18.373005],
							[-66.199564, 18.369636],
							[-66.19754, 18.365114],
							[-66.197293, 18.3602],
							[-66.199515, 18.355233],
							[-66.19969, 18.354646],
							[-66.19878, 18.353515],
							[-66.198483, 18.352423],
							[-66.198737, 18.351036],
							[-66.198818, 18.350849],
							[-66.19956, 18.349133],
							[-66.200527, 18.344093],
							[-66.199549, 18.339855],
							[-66.200234, 18.339158],
							[-66.203616, 18.336673],
							[-66.201865, 18.330217],
							[-66.201531, 18.328983],
							[-66.204338, 18.316414],
							[-66.205364, 18.316495],
							[-66.205357, 18.316868],
							[-66.205582, 18.318692],
							[-66.207488, 18.323683],
							[-66.209087, 18.324138],
							[-66.211724, 18.323557],
							[-66.21447, 18.326746],
							[-66.214465, 18.326842],
							[-66.215836, 18.330943],
							[-66.21598, 18.331631],
							[-66.215849, 18.33316],
							[-66.216696, 18.333954],
							[-66.220777, 18.333138],
							[-66.228045, 18.328185],
							[-66.230935, 18.324526],
							[-66.232892, 18.323429],
							[-66.234545, 18.328059],
							[-66.238404, 18.332605],
							[-66.238535, 18.332633],
							[-66.24584, 18.331377],
							[-66.248446, 18.326114],
							[-66.249612, 18.326429],
							[-66.249898, 18.326582],
							[-66.252625, 18.328427],
							[-66.256973, 18.331356],
							[-66.257924, 18.331698],
							[-66.263634, 18.329816],
							[-66.266657, 18.330115],
							[-66.268507, 18.329076],
							[-66.271074, 18.328552],
							[-66.273453, 18.329506],
							[-66.278076, 18.329975],
							[-66.278205, 18.331505],
							[-66.279359, 18.334255],
							[-66.279714, 18.335128],
							[-66.280097, 18.335998],
							[-66.281816, 18.339341],
							[-66.282463, 18.340639],
							[-66.283182, 18.342082],
							[-66.283516, 18.342754],
							[-66.284041, 18.34377],
							[-66.285145, 18.345844],
							[-66.286522, 18.345835],
							[-66.286512, 18.349093],
							[-66.287328, 18.35081],
							[-66.291097, 18.355912],
							[-66.294431, 18.35941],
							[-66.301752, 18.364808],
							[-66.304244, 18.36792],
							[-66.304499, 18.368599],
							[-66.305353, 18.370045],
							[-66.306193, 18.36969],
							[-66.307037, 18.368109],
							[-66.307368, 18.365457],
							[-66.308125, 18.364779],
							[-66.31142, 18.364767],
							[-66.318623, 18.367419],
							[-66.318976, 18.367399],
							[-66.319056, 18.370866],
							[-66.317045, 18.374171],
							[-66.314174, 18.380778],
							[-66.311492, 18.380784],
							[-66.306857, 18.383656],
							[-66.303663, 18.384093],
							[-66.29121, 18.38503],
							[-66.285731, 18.383164],
							[-66.284957, 18.383215],
							[-66.280166, 18.383667],
							[-66.278734, 18.384535],
							[-66.27211, 18.384019],
							[-66.271645, 18.383694],
							[-66.270127, 18.385503],
							[-66.267168, 18.386547],
							[-66.257771, 18.387491],
							[-66.257506, 18.387904],
							[-66.257229, 18.389408],
							[-66.255037, 18.390031],
							[-66.254171, 18.392279],
							[-66.252562, 18.39403],
							[-66.252466, 18.394156],
							[-66.249612, 18.395544],
							[-66.249612, 18.39554],
							[-66.244903, 18.394955],
							[-66.244753, 18.39489],
							[-66.237472, 18.398933],
							[-66.235279, 18.400949],
							[-66.233951, 18.401451],
							[-66.220953, 18.397176],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 131,
					name: 'San Sebastián',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.009337, 18.394823],
							[-67.006975, 18.394257],
							[-67.006093, 18.394263],
							[-67.005906, 18.39413],
							[-66.999986, 18.390589],
							[-66.996021, 18.388828],
							[-66.994422, 18.389533],
							[-66.993662, 18.388704],
							[-66.989353, 18.388146],
							[-66.985263, 18.385572],
							[-66.984293, 18.385105],
							[-66.981392, 18.384852],
							[-66.980179, 18.385672],
							[-66.979803, 18.385993],
							[-66.973999, 18.386302],
							[-66.971135, 18.385917],
							[-66.970504, 18.385693],
							[-66.96631, 18.384806],
							[-66.964447, 18.384414],
							[-66.963928, 18.384319],
							[-66.963817, 18.384297],
							[-66.962947, 18.384174],
							[-66.959678, 18.382102],
							[-66.95897, 18.382143],
							[-66.957251, 18.381807],
							[-66.953795, 18.379593],
							[-66.952882, 18.379324],
							[-66.95135, 18.379496],
							[-66.950656, 18.379332],
							[-66.950297, 18.378913],
							[-66.949728, 18.378248],
							[-66.949252, 18.377434],
							[-66.948939, 18.377113],
							[-66.947651, 18.376591],
							[-66.947276, 18.376341],
							[-66.946145, 18.375568],
							[-66.945592, 18.375229],
							[-66.937856, 18.376504],
							[-66.936608, 18.376777],
							[-66.936547, 18.377683],
							[-66.93686, 18.379417],
							[-66.937123, 18.380926],
							[-66.937159, 18.381749],
							[-66.935531, 18.387438],
							[-66.935389, 18.387732],
							[-66.933316, 18.387935],
							[-66.930914, 18.391417],
							[-66.928138, 18.392633],
							[-66.927222, 18.392718],
							[-66.926991, 18.39274],
							[-66.925544, 18.392873],
							[-66.92202, 18.393204],
							[-66.923442, 18.388224],
							[-66.922687, 18.385149],
							[-66.920387, 18.379563],
							[-66.919497, 18.378578],
							[-66.916728, 18.377189],
							[-66.915365, 18.376282],
							[-66.91197, 18.375715],
							[-66.908511, 18.373004],
							[-66.905721, 18.367222],
							[-66.898919, 18.366114],
							[-66.898149, 18.365783],
							[-66.893216, 18.367055],
							[-66.892681, 18.366522],
							[-66.891871, 18.365466],
							[-66.896415, 18.348905],
							[-66.897617, 18.343678],
							[-66.904727, 18.32161],
							[-66.904885, 18.320557],
							[-66.90503, 18.319591],
							[-66.905651, 18.315736],
							[-66.905863, 18.315088],
							[-66.909969, 18.302811],
							[-66.909973, 18.295206],
							[-66.909549, 18.293102],
							[-66.910299, 18.2824],
							[-66.910589, 18.278179],
							[-66.90826, 18.273574],
							[-66.908868, 18.266742],
							[-66.9088, 18.266145],
							[-66.908747, 18.266109],
							[-66.907501, 18.264805],
							[-66.906998, 18.262375],
							[-66.908591, 18.255775],
							[-66.907459, 18.25314],
							[-66.907213, 18.253136],
							[-66.908688, 18.252149],
							[-66.912637, 18.254333],
							[-66.921851, 18.257691],
							[-66.924094, 18.260496],
							[-66.930496, 18.258395],
							[-66.929937, 18.257049],
							[-66.928903, 18.2566],
							[-66.927908, 18.256958],
							[-66.927503, 18.255815],
							[-66.928819, 18.254221],
							[-66.930665, 18.253784],
							[-66.932323, 18.253476],
							[-66.933148, 18.256433],
							[-66.936347, 18.258999],
							[-66.940762, 18.261555],
							[-66.942201, 18.263758],
							[-66.9409, 18.26577],
							[-66.941751, 18.266641],
							[-66.945079, 18.271621],
							[-66.945459, 18.272922],
							[-66.946098, 18.273317],
							[-66.959213, 18.271672],
							[-66.962184, 18.270254],
							[-66.964396, 18.271252],
							[-66.965228, 18.271153],
							[-66.965561, 18.268789],
							[-66.965229, 18.265987],
							[-66.967247, 18.26363],
							[-66.969368, 18.263629],
							[-66.970449, 18.266229],
							[-66.97046, 18.268615],
							[-66.972536, 18.272677],
							[-66.975117, 18.274682],
							[-66.982129, 18.274951],
							[-66.982931, 18.274579],
							[-66.990896, 18.276824],
							[-66.992748, 18.275614],
							[-67.001573, 18.276108],
							[-67.006872, 18.279091],
							[-67.014115, 18.278399],
							[-67.015747, 18.277212],
							[-67.017809, 18.276827],
							[-67.018809, 18.277358],
							[-67.019665, 18.279189],
							[-67.020031, 18.280442],
							[-67.022293, 18.281663],
							[-67.037978, 18.280261],
							[-67.039291, 18.28263],
							[-67.038662, 18.283317],
							[-67.038117, 18.284155],
							[-67.033429, 18.285128],
							[-67.031862, 18.286944],
							[-67.031075, 18.288719],
							[-67.031605, 18.289752],
							[-67.033414, 18.289954],
							[-67.033744, 18.289184],
							[-67.0362, 18.287975],
							[-67.037935, 18.289705],
							[-67.040206, 18.29313],
							[-67.040119, 18.293594],
							[-67.040709, 18.300302],
							[-67.04387, 18.301994],
							[-67.052583, 18.306655],
							[-67.050114, 18.30962],
							[-67.047632, 18.312602],
							[-67.045831, 18.314747],
							[-67.044332, 18.316531],
							[-67.043081, 18.319575],
							[-67.042603, 18.32039],
							[-67.041497, 18.321163],
							[-67.041553, 18.321478],
							[-67.041687, 18.323029],
							[-67.04158, 18.323436],
							[-67.041511, 18.323667],
							[-67.037349, 18.326312],
							[-67.037312, 18.32661],
							[-67.036472, 18.330672],
							[-67.036732, 18.333217],
							[-67.040654, 18.335021],
							[-67.043494, 18.342079],
							[-67.043303, 18.34356],
							[-67.043964, 18.344376],
							[-67.045198, 18.347898],
							[-67.045103, 18.349011],
							[-67.043689, 18.349564],
							[-67.045436, 18.35067],
							[-67.046402, 18.35015],
							[-67.046474, 18.349566],
							[-67.046295, 18.349024],
							[-67.047617, 18.347749],
							[-67.049824, 18.347393],
							[-67.050316, 18.34891],
							[-67.048392, 18.348649],
							[-67.047369, 18.349813],
							[-67.047559, 18.350881],
							[-67.047411, 18.351552],
							[-67.046833, 18.352784],
							[-67.047897, 18.352937],
							[-67.041897, 18.356573],
							[-67.041953, 18.358406],
							[-67.041217, 18.362329],
							[-67.040197, 18.364226],
							[-67.039033, 18.367042],
							[-67.038342, 18.372555],
							[-67.038286, 18.374392],
							[-67.038737, 18.374979],
							[-67.0375, 18.376564],
							[-67.03782, 18.37766],
							[-67.037779, 18.377839],
							[-67.037245, 18.377966],
							[-67.036717, 18.379099],
							[-67.037276, 18.380908],
							[-67.035629, 18.380822],
							[-67.033968, 18.38214],
							[-67.029369, 18.388562],
							[-67.029223, 18.389248],
							[-67.027258, 18.393555],
							[-67.02638, 18.392052],
							[-67.025045, 18.392063],
							[-67.017604, 18.394854],
							[-67.013834, 18.395127],
							[-67.011423, 18.394422],
							[-67.011287, 18.394354],
							[-67.009979, 18.394419],
							[-67.009337, 18.394823],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '053',
					name: 'Fajardo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.63489364640242, 18.283923502211348],
							[-65.636046, 18.2845],
							[-65.638822, 18.284],
							[-65.640786, 18.282298],
							[-65.646662, 18.281749],
							[-65.653341, 18.282794],
							[-65.656268, 18.283695],
							[-65.665177, 18.287685],
							[-65.666277, 18.287891],
							[-65.668161, 18.284751],
							[-65.672946, 18.283631],
							[-65.674925, 18.283366],
							[-65.674752, 18.279724],
							[-65.675735, 18.277884],
							[-65.67926, 18.274586],
							[-65.680985, 18.274859],
							[-65.682958, 18.275663],
							[-65.686363, 18.278267],
							[-65.686969, 18.279247],
							[-65.689869, 18.280904],
							[-65.690049, 18.282452],
							[-65.691653, 18.28394],
							[-65.694913, 18.285661],
							[-65.696384, 18.284666],
							[-65.70065, 18.28005],
							[-65.70229, 18.276159],
							[-65.702048, 18.275079],
							[-65.70011, 18.272986],
							[-65.703746, 18.271592],
							[-65.704304, 18.272736],
							[-65.715848, 18.267548],
							[-65.718267, 18.268244],
							[-65.719305, 18.269733],
							[-65.732358, 18.274909],
							[-65.735111, 18.274917],
							[-65.735771, 18.273693],
							[-65.737455, 18.273756],
							[-65.738217, 18.275145],
							[-65.738579, 18.280825],
							[-65.737719, 18.283089],
							[-65.741698, 18.288048],
							[-65.745493, 18.291289],
							[-65.748088, 18.292551],
							[-65.748684, 18.292848],
							[-65.753591, 18.296755],
							[-65.751726, 18.298344],
							[-65.750106, 18.301285],
							[-65.74339, 18.299447],
							[-65.736878, 18.294249],
							[-65.733391, 18.289063],
							[-65.731887, 18.289461],
							[-65.725522, 18.292077],
							[-65.72049, 18.296057],
							[-65.720236, 18.301855],
							[-65.71914, 18.30667],
							[-65.709197, 18.306563],
							[-65.70449, 18.309347],
							[-65.704957, 18.318546],
							[-65.703927, 18.320826],
							[-65.698847, 18.324063],
							[-65.694295, 18.325048],
							[-65.689699, 18.323727],
							[-65.687365, 18.322867],
							[-65.685454, 18.323782],
							[-65.685265, 18.32368],
							[-65.684166, 18.323754],
							[-65.684285, 18.324281],
							[-65.684918, 18.328164],
							[-65.680422, 18.338919],
							[-65.678071, 18.34206],
							[-65.67879, 18.347601],
							[-65.677755, 18.348865],
							[-65.675508, 18.35306],
							[-65.672926, 18.357985],
							[-65.66963685108395, 18.36210188175585],
							[-65.668845, 18.361939],
							[-65.66838093694462, 18.362045475326475],
							[-65.65618763177518, 18.364843125632103],
							[-65.64743657296098, 18.36685098174871],
							[-65.634431, 18.369835],
							[-65.627246, 18.376436],
							[-65.626527, 18.381728],
							[-65.624975, 18.386553],
							[-65.622761, 18.387771],
							[-65.61856596934607, 18.386590800511087],
							[-65.618229, 18.386496],
							[-65.61792282018953, 18.386126988203262],
							[-65.614891, 18.382473],
							[-65.61703719977413, 18.374910690142293],
							[-65.6175774711238, 18.373007],
							[-65.619068, 18.367755],
							[-65.6196499044937, 18.366859899593695],
							[-65.61995675803793, 18.366387889607374],
							[-65.624605, 18.359237844687836],
							[-65.628198, 18.353711],
							[-65.63099301551117, 18.346832612361887],
							[-65.63227631303316, 18.34367448398084],
							[-65.63331205550244, 18.341125575694438],
							[-65.6335553443579, 18.34052685448906],
							[-65.63419, 18.338965],
							[-65.63406556398739, 18.338747991534568],
							[-65.63209462697567, 18.335310803156485],
							[-65.628047, 18.328252],
							[-65.62804003350307, 18.32812383572272],
							[-65.62794868717208, 18.326443315856007],
							[-65.6270379222686, 18.30968776040335],
							[-65.62673050195963, 18.304032076906346],
							[-65.62645633886255, 18.298988234133734],
							[-65.626456, 18.298982],
							[-65.62648733848525, 18.298955797028533],
							[-65.63009232200433, 18.295941570924658],
							[-65.63347935260019, 18.293109581268496],
							[-65.634389, 18.292349],
							[-65.63454014755031, 18.291920064919868],
							[-65.6349113321034, 18.29086669636907],
							[-65.63521626744425, 18.2900013335855],
							[-65.635826, 18.288271],
							[-65.63489364640242, 18.283923502211348],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '089',
					name: 'Luquillo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.766733, 18.367691],
							[-65.763197, 18.372388],
							[-65.761092, 18.375118],
							[-65.76078, 18.378003],
							[-65.756393, 18.379728],
							[-65.752764, 18.382107],
							[-65.751176, 18.38467],
							[-65.75041, 18.38501],
							[-65.75024382769794, 18.385087188379412],
							[-65.74216159553336, 18.380463345402717],
							[-65.742154, 18.380459],
							[-65.733567, 18.382211],
							[-65.73328785756586, 18.3820972732068],
							[-65.73326885819186, 18.382089532578316],
							[-65.73166937508213, 18.38143787929096],
							[-65.72466447632, 18.37858397900393],
							[-65.72449508502619, 18.378514966463076],
							[-65.72354364205017, 18.378127334396638],
							[-65.72305564671638, 18.377928517815487],
							[-65.7206698061132, 18.3769564907508],
							[-65.71887873868017, 18.376226783151196],
							[-65.71769613177241, 18.3757449714494],
							[-65.71543561399989, 18.374824002776062],
							[-65.71259544897524, 18.373666877162357],
							[-65.71150040753754, 18.37322074093977],
							[-65.71104346848354, 18.37303457715045],
							[-65.699069, 18.368156],
							[-65.69192015591342, 18.366685500936796],
							[-65.66963685108395, 18.36210188175585],
							[-65.672926, 18.357985],
							[-65.675508, 18.35306],
							[-65.677755, 18.348865],
							[-65.67879, 18.347601],
							[-65.678071, 18.34206],
							[-65.680422, 18.338919],
							[-65.684918, 18.328164],
							[-65.684285, 18.324281],
							[-65.684166, 18.323754],
							[-65.685265, 18.32368],
							[-65.685454, 18.323782],
							[-65.687365, 18.322867],
							[-65.689699, 18.323727],
							[-65.694295, 18.325048],
							[-65.698847, 18.324063],
							[-65.703927, 18.320826],
							[-65.704957, 18.318546],
							[-65.70449, 18.309347],
							[-65.709197, 18.306563],
							[-65.71914, 18.30667],
							[-65.720236, 18.301855],
							[-65.72049, 18.296057],
							[-65.725522, 18.292077],
							[-65.731887, 18.289461],
							[-65.733391, 18.289063],
							[-65.736878, 18.294249],
							[-65.74339, 18.299447],
							[-65.750106, 18.301285],
							[-65.751726, 18.298344],
							[-65.753591, 18.296755],
							[-65.758862, 18.290604],
							[-65.758853, 18.294108],
							[-65.758075, 18.297686],
							[-65.759162, 18.299448],
							[-65.761029, 18.302731],
							[-65.762099, 18.305966],
							[-65.758917, 18.315612],
							[-65.757273, 18.318616],
							[-65.751368, 18.321238],
							[-65.749816, 18.322988],
							[-65.748582, 18.325522],
							[-65.749606, 18.326684],
							[-65.751711, 18.328066],
							[-65.754896, 18.328402],
							[-65.756, 18.329174],
							[-65.756081, 18.333626],
							[-65.755117, 18.334448],
							[-65.754129, 18.336505],
							[-65.754129, 18.339758],
							[-65.757685, 18.346881],
							[-65.758992, 18.348134],
							[-65.762113, 18.350695],
							[-65.766513, 18.355635],
							[-65.768464, 18.359863],
							[-65.77017, 18.365965],
							[-65.766733, 18.367691],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 139,
					name: 'Trujillo Alto',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.008026, 18.378899],
							[-66.006858, 18.37883],
							[-66.002691, 18.379196],
							[-66.002263, 18.379354],
							[-66.002017, 18.379388],
							[-66.001017, 18.379733],
							[-65.999729, 18.380003],
							[-65.999609, 18.380004],
							[-65.99909, 18.379926],
							[-65.999055, 18.380012],
							[-65.99784, 18.378275],
							[-65.991506, 18.376873],
							[-65.991531, 18.376451],
							[-65.990203, 18.371046],
							[-65.989828, 18.37054],
							[-65.9895, 18.370058],
							[-65.989492, 18.368717],
							[-65.989683, 18.367549],
							[-65.989734, 18.36724],
							[-65.986376, 18.363005],
							[-65.982557, 18.359166],
							[-65.982043, 18.358487],
							[-65.981956, 18.358329],
							[-65.980802, 18.3552],
							[-65.97589, 18.35284],
							[-65.975602, 18.35122],
							[-65.975561, 18.349917],
							[-65.974692, 18.348874],
							[-65.974716, 18.348822],
							[-65.973755, 18.347212],
							[-65.973004, 18.344998],
							[-65.972814, 18.34424],
							[-65.970148, 18.341813],
							[-65.96975, 18.340431],
							[-65.966982, 18.339764],
							[-65.967609, 18.338656],
							[-65.967695, 18.338592],
							[-65.969828, 18.33411],
							[-65.967194, 18.330038],
							[-65.967098, 18.329849],
							[-65.962564, 18.326977],
							[-65.963249, 18.325156],
							[-65.958714, 18.321643],
							[-65.958398, 18.320739],
							[-65.957822, 18.319848],
							[-65.95616, 18.318022],
							[-65.953858, 18.317625],
							[-65.952674, 18.316199],
							[-65.952324, 18.316207],
							[-65.951363, 18.31623],
							[-65.950477, 18.315563],
							[-65.949955, 18.313813],
							[-65.947978, 18.311711],
							[-65.944973, 18.311315],
							[-65.943423, 18.311612],
							[-65.94237, 18.312228],
							[-65.941659, 18.312003],
							[-65.939038, 18.309199],
							[-65.941738, 18.305109],
							[-65.943137, 18.299311],
							[-65.942562, 18.293438],
							[-65.945741, 18.293635],
							[-65.949885, 18.29532],
							[-65.949888, 18.295386],
							[-65.954166, 18.294573],
							[-65.957931, 18.296806],
							[-65.960221, 18.298893],
							[-65.962967, 18.299771],
							[-65.964777, 18.302353],
							[-65.966494, 18.305453],
							[-65.968043, 18.309983],
							[-65.968226, 18.310116],
							[-65.97048, 18.310217],
							[-65.972464, 18.310338],
							[-65.982026, 18.310733],
							[-65.98405, 18.310825],
							[-65.984974, 18.310944],
							[-65.985418, 18.311022],
							[-65.986227, 18.311173],
							[-65.988172, 18.3103],
							[-65.989876, 18.309915],
							[-65.991775, 18.309492],
							[-65.995148, 18.306697],
							[-65.995608, 18.306629],
							[-65.999476, 18.307019],
							[-66.002814, 18.307436],
							[-66.00754, 18.304203],
							[-66.008073, 18.304258],
							[-66.008506, 18.304831],
							[-66.009231, 18.30517],
							[-66.013306, 18.307419],
							[-66.013657, 18.307433],
							[-66.016482, 18.308734],
							[-66.021747, 18.305034],
							[-66.023492, 18.307118],
							[-66.024842, 18.309065],
							[-66.030704, 18.3096],
							[-66.030953, 18.309462],
							[-66.036531, 18.309938],
							[-66.037247, 18.310425],
							[-66.038607, 18.311558],
							[-66.038871, 18.311632],
							[-66.041129, 18.312087],
							[-66.040689, 18.31294],
							[-66.04001, 18.315858],
							[-66.037232, 18.317506],
							[-66.036936, 18.318241],
							[-66.036859, 18.318627],
							[-66.035731, 18.31961],
							[-66.035911, 18.328084],
							[-66.035109, 18.330381],
							[-66.035016, 18.330943],
							[-66.03494, 18.332214],
							[-66.034932, 18.333452],
							[-66.034913, 18.340201],
							[-66.034894, 18.341087],
							[-66.035527, 18.344342],
							[-66.036682, 18.345273],
							[-66.034353, 18.351677],
							[-66.032725, 18.355433],
							[-66.032427, 18.355593],
							[-66.032421, 18.355701],
							[-66.034719, 18.358604],
							[-66.034743, 18.358866],
							[-66.034024, 18.362103],
							[-66.035544, 18.368476],
							[-66.035336, 18.369693],
							[-66.035191, 18.369842],
							[-66.03484, 18.369745],
							[-66.031848, 18.373393],
							[-66.030541, 18.374589],
							[-66.030164, 18.374934],
							[-66.028842, 18.376227],
							[-66.025262, 18.379829],
							[-66.024546, 18.379704],
							[-66.019067, 18.378651],
							[-66.018889, 18.37865],
							[-66.015882, 18.378947],
							[-66.013786, 18.378843],
							[-66.013925, 18.379947],
							[-66.013256, 18.38038],
							[-66.012509, 18.380568],
							[-66.008026, 18.378899],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 101,
					name: 'Morovis',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.428451, 18.370461],
							[-66.425268, 18.374986],
							[-66.424097, 18.37596],
							[-66.421864, 18.377809],
							[-66.417886, 18.37791],
							[-66.417163, 18.377482],
							[-66.417113, 18.374359],
							[-66.415903, 18.373005],
							[-66.404745, 18.365349],
							[-66.400843, 18.364008],
							[-66.401558, 18.365187],
							[-66.400758, 18.36796],
							[-66.395522, 18.37179],
							[-66.393882, 18.368549],
							[-66.391883, 18.366037],
							[-66.38919, 18.356325],
							[-66.388829, 18.353272],
							[-66.385772, 18.344682],
							[-66.381822, 18.342992],
							[-66.37876, 18.342985],
							[-66.37705, 18.344209],
							[-66.375715, 18.343982],
							[-66.374695, 18.344117],
							[-66.374614, 18.343884],
							[-66.374295, 18.342624],
							[-66.370554, 18.337153],
							[-66.365272, 18.333229],
							[-66.365639, 18.331921],
							[-66.366897, 18.327592],
							[-66.368594, 18.321739],
							[-66.37204, 18.31236],
							[-66.372457, 18.309835],
							[-66.373311, 18.301938],
							[-66.37596, 18.300015],
							[-66.375672, 18.297555],
							[-66.377723, 18.293955],
							[-66.38279, 18.291785],
							[-66.384028, 18.290797],
							[-66.38577, 18.284866],
							[-66.389746, 18.274542],
							[-66.390956, 18.273393],
							[-66.392796, 18.273325],
							[-66.397549, 18.269468],
							[-66.400456, 18.267938],
							[-66.401889, 18.267161],
							[-66.409434, 18.263309],
							[-66.412229, 18.262955],
							[-66.42762, 18.260632],
							[-66.428343, 18.260756],
							[-66.437745, 18.256212],
							[-66.437715, 18.255969],
							[-66.441971, 18.259094],
							[-66.444882, 18.257574],
							[-66.452457, 18.256584],
							[-66.455841, 18.257687],
							[-66.457756, 18.25805],
							[-66.458673, 18.259163],
							[-66.463026, 18.284086],
							[-66.462097, 18.286698],
							[-66.458396, 18.291272],
							[-66.458249, 18.292758],
							[-66.459767, 18.29524],
							[-66.459193, 18.296079],
							[-66.461458, 18.299452],
							[-66.46148, 18.300644],
							[-66.458375, 18.303489],
							[-66.457453, 18.302122],
							[-66.457052, 18.299983],
							[-66.455155, 18.30001],
							[-66.454935, 18.301505],
							[-66.45606, 18.304594],
							[-66.454542, 18.313039],
							[-66.454334, 18.32547],
							[-66.454261, 18.326678],
							[-66.454318, 18.326963],
							[-66.454255, 18.327476],
							[-66.454259, 18.328069],
							[-66.454289, 18.332654],
							[-66.460037, 18.343484],
							[-66.461242, 18.344196],
							[-66.464053, 18.349395],
							[-66.465142, 18.352237],
							[-66.464005, 18.359842],
							[-66.464435, 18.360698],
							[-66.463211, 18.371473],
							[-66.459029, 18.371249],
							[-66.451578, 18.372214],
							[-66.44418, 18.371019],
							[-66.443801, 18.371027],
							[-66.440472, 18.372223],
							[-66.438161, 18.37194],
							[-66.436315, 18.370939],
							[-66.433346, 18.370706],
							[-66.433081, 18.37071],
							[-66.431074, 18.370525],
							[-66.428451, 18.370461],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 117,
					name: 'Rincón',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.2393415096082, 18.375257936647923],
							[-67.238747, 18.372532],
							[-67.23389, 18.367783],
							[-67.22881, 18.36422],
							[-67.227522, 18.36082],
							[-67.224397, 18.355507],
							[-67.226075, 18.350597],
							[-67.22555, 18.348892],
							[-67.225364, 18.348314],
							[-67.225331, 18.34821],
							[-67.224545, 18.347729],
							[-67.22276, 18.345447],
							[-67.219911, 18.346129],
							[-67.21964, 18.34263],
							[-67.216749, 18.342605],
							[-67.213825, 18.341319],
							[-67.213633, 18.340891],
							[-67.21177, 18.339459],
							[-67.211685, 18.337771],
							[-67.21066, 18.336355],
							[-67.209095, 18.335733],
							[-67.20382, 18.334202],
							[-67.201933, 18.332644],
							[-67.201797, 18.332508],
							[-67.20082, 18.332052],
							[-67.1981, 18.331806],
							[-67.195521, 18.330355],
							[-67.195378, 18.325131],
							[-67.193906, 18.324098],
							[-67.193042, 18.324183],
							[-67.19212, 18.323862],
							[-67.189627, 18.322223],
							[-67.188054, 18.317367],
							[-67.187803, 18.315635],
							[-67.182741, 18.312867],
							[-67.183144, 18.310922],
							[-67.184015, 18.31094],
							[-67.184696, 18.310802],
							[-67.185518, 18.310627],
							[-67.187047, 18.310781],
							[-67.188366, 18.311828],
							[-67.188824, 18.311791],
							[-67.189653, 18.311773],
							[-67.190436, 18.309296],
							[-67.192029, 18.308688],
							[-67.196457, 18.307679],
							[-67.19664, 18.307752],
							[-67.199408, 18.310325],
							[-67.203364, 18.308422],
							[-67.20637, 18.30728],
							[-67.208161, 18.306162],
							[-67.218101, 18.304663],
							[-67.218719, 18.305072],
							[-67.220291, 18.305852],
							[-67.222647, 18.303301],
							[-67.223991, 18.299533],
							[-67.22559940766368, 18.296669771224476],
							[-67.226081, 18.296722],
							[-67.235137, 18.299935],
							[-67.24120236488257, 18.309913122449103],
							[-67.24483779662864, 18.31589376562886],
							[-67.2470686572892, 18.31956375107391],
							[-67.25171164474834, 18.327201922609163],
							[-67.25632662273742, 18.33479401580824],
							[-67.26037010133942, 18.34144593624372],
							[-67.26512246896381, 18.349264048920773],
							[-67.267484, 18.353149],
							[-67.27135, 18.362329],
							[-67.268259, 18.366989],
							[-67.26086198027281, 18.370116258735482],
							[-67.260671, 18.370197],
							[-67.24534916046835, 18.373832476411998],
							[-67.2393415096082, 18.375257936647923],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '039',
					name: 'Ciales',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.474489, 18.36804],
							[-66.468901, 18.369812],
							[-66.466946, 18.371834],
							[-66.463211, 18.371473],
							[-66.464435, 18.360698],
							[-66.464005, 18.359842],
							[-66.465142, 18.352237],
							[-66.464053, 18.349395],
							[-66.461242, 18.344196],
							[-66.460037, 18.343484],
							[-66.454289, 18.332654],
							[-66.454259, 18.328069],
							[-66.454255, 18.327476],
							[-66.454318, 18.326963],
							[-66.454261, 18.326678],
							[-66.454334, 18.32547],
							[-66.454542, 18.313039],
							[-66.45606, 18.304594],
							[-66.454935, 18.301505],
							[-66.455155, 18.30001],
							[-66.457052, 18.299983],
							[-66.457453, 18.302122],
							[-66.458375, 18.303489],
							[-66.46148, 18.300644],
							[-66.461458, 18.299452],
							[-66.459193, 18.296079],
							[-66.459767, 18.29524],
							[-66.458249, 18.292758],
							[-66.458396, 18.291272],
							[-66.462097, 18.286698],
							[-66.463026, 18.284086],
							[-66.458673, 18.259163],
							[-66.457756, 18.25805],
							[-66.455841, 18.257687],
							[-66.454137, 18.256334],
							[-66.454553, 18.25174],
							[-66.454272, 18.250992],
							[-66.457077, 18.249425],
							[-66.45896, 18.249675],
							[-66.460645, 18.249216],
							[-66.466797, 18.245627],
							[-66.472394, 18.247047],
							[-66.475303, 18.249383],
							[-66.476657, 18.25044],
							[-66.478478, 18.250884],
							[-66.480958, 18.251481],
							[-66.482782, 18.252686],
							[-66.487429, 18.252885],
							[-66.494566, 18.252225],
							[-66.497704, 18.252917],
							[-66.499616, 18.255328],
							[-66.501133, 18.256354],
							[-66.501183, 18.256219],
							[-66.501713, 18.252863],
							[-66.502785, 18.250699],
							[-66.506315, 18.250823],
							[-66.508423, 18.24911],
							[-66.508988, 18.24801],
							[-66.508819, 18.24801],
							[-66.511818, 18.242562],
							[-66.509498, 18.23884],
							[-66.507935, 18.238661],
							[-66.506578, 18.236197],
							[-66.507768, 18.231735],
							[-66.50879, 18.229768],
							[-66.517474, 18.229561],
							[-66.516502, 18.228352],
							[-66.515762, 18.218949],
							[-66.514315, 18.214077],
							[-66.512274, 18.202684],
							[-66.510781, 18.198851],
							[-66.514297, 18.191699],
							[-66.514875, 18.185027],
							[-66.512629, 18.181469],
							[-66.512022, 18.17955],
							[-66.510494, 18.177329],
							[-66.51179, 18.166342],
							[-66.512587, 18.165933],
							[-66.515085, 18.167701],
							[-66.517787, 18.166731],
							[-66.523602, 18.161284],
							[-66.526621, 18.159563],
							[-66.531774, 18.156321],
							[-66.538492, 18.160047],
							[-66.543133, 18.163098],
							[-66.540813, 18.165711],
							[-66.541616, 18.166664],
							[-66.541414, 18.168918],
							[-66.537038, 18.175823],
							[-66.53549, 18.177139],
							[-66.534695, 18.177129],
							[-66.533804, 18.176378],
							[-66.532241, 18.176804],
							[-66.531023, 18.180137],
							[-66.536717, 18.188631],
							[-66.532609, 18.19789],
							[-66.532725, 18.200519],
							[-66.536431, 18.206288],
							[-66.536439, 18.209118],
							[-66.538273, 18.213766],
							[-66.545527, 18.220736],
							[-66.548883, 18.220567],
							[-66.552589, 18.230359],
							[-66.555228, 18.237327],
							[-66.562703, 18.240721],
							[-66.563531, 18.242077],
							[-66.562528, 18.245308],
							[-66.560847, 18.247454],
							[-66.562275, 18.25364],
							[-66.558424, 18.25313],
							[-66.556012, 18.253562],
							[-66.555633, 18.254347],
							[-66.555993, 18.255491],
							[-66.558787, 18.257544],
							[-66.5578, 18.275109],
							[-66.556564, 18.278558],
							[-66.558157, 18.282872],
							[-66.56075, 18.28375],
							[-66.563159, 18.287751],
							[-66.562847, 18.288206],
							[-66.561853, 18.288215],
							[-66.560967, 18.293669],
							[-66.561663, 18.294432],
							[-66.563896, 18.294675],
							[-66.566579, 18.297092],
							[-66.566665, 18.298583],
							[-66.570309, 18.301796],
							[-66.571383, 18.304093],
							[-66.570932, 18.305273],
							[-66.573005, 18.308917],
							[-66.575836, 18.31128],
							[-66.581406, 18.314017],
							[-66.583091, 18.316429],
							[-66.582398, 18.319529],
							[-66.586359, 18.322373],
							[-66.590882, 18.323875],
							[-66.593331, 18.324454],
							[-66.600756, 18.321923],
							[-66.604329, 18.321279],
							[-66.606826, 18.322451],
							[-66.608213, 18.32382],
							[-66.61115, 18.322423],
							[-66.606989, 18.328186],
							[-66.60688, 18.331193],
							[-66.606361, 18.331839],
							[-66.603081, 18.33268],
							[-66.601832, 18.333943],
							[-66.600183, 18.337108],
							[-66.595272, 18.338019],
							[-66.590785, 18.33806],
							[-66.587874, 18.339148],
							[-66.586087, 18.337308],
							[-66.583441, 18.339129],
							[-66.581616, 18.340497],
							[-66.573822, 18.342517],
							[-66.57232, 18.342508],
							[-66.571687, 18.341568],
							[-66.569102, 18.341003],
							[-66.565168, 18.340849],
							[-66.56387, 18.341631],
							[-66.553679, 18.340844],
							[-66.540271, 18.34432],
							[-66.537105, 18.346335],
							[-66.536075, 18.347527],
							[-66.536173, 18.348762],
							[-66.533623, 18.351333],
							[-66.53099, 18.350261],
							[-66.528304, 18.350564],
							[-66.5276, 18.35288],
							[-66.523317, 18.354924],
							[-66.518651, 18.356296],
							[-66.514424, 18.360324],
							[-66.511777, 18.362003],
							[-66.509687, 18.362078],
							[-66.506346, 18.36357],
							[-66.500553, 18.364852],
							[-66.499261, 18.364051],
							[-66.496602, 18.366028],
							[-66.494807, 18.366445],
							[-66.490678, 18.365452],
							[-66.483587, 18.366002],
							[-66.478949, 18.366923],
							[-66.478862, 18.366887],
							[-66.47607, 18.367538],
							[-66.474489, 18.36804],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '047',
					name: 'Corozal',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.304499, 18.368599],
							[-66.304244, 18.36792],
							[-66.301752, 18.364808],
							[-66.294431, 18.35941],
							[-66.291097, 18.355912],
							[-66.287328, 18.35081],
							[-66.286512, 18.349093],
							[-66.286522, 18.345835],
							[-66.285145, 18.345844],
							[-66.284041, 18.34377],
							[-66.283516, 18.342754],
							[-66.283182, 18.342082],
							[-66.282463, 18.340639],
							[-66.281816, 18.339341],
							[-66.280097, 18.335998],
							[-66.279714, 18.335128],
							[-66.279359, 18.334255],
							[-66.278205, 18.331505],
							[-66.278076, 18.329975],
							[-66.280877, 18.321502],
							[-66.283077, 18.314071],
							[-66.283473, 18.307999],
							[-66.285318, 18.303769],
							[-66.285934, 18.298942],
							[-66.287256, 18.28364],
							[-66.288205, 18.281399],
							[-66.289093, 18.276276],
							[-66.287227, 18.272366],
							[-66.288241, 18.269507],
							[-66.289541, 18.268478],
							[-66.293293, 18.262338],
							[-66.294225, 18.260644],
							[-66.296086, 18.257546],
							[-66.302282, 18.255394],
							[-66.302988, 18.254614],
							[-66.304676, 18.255128],
							[-66.30609, 18.25488],
							[-66.306177, 18.253668],
							[-66.306904, 18.252451],
							[-66.308815, 18.251156],
							[-66.310219, 18.251316],
							[-66.313358, 18.249387],
							[-66.313439, 18.249346],
							[-66.318881, 18.24801],
							[-66.326297, 18.247855],
							[-66.327047, 18.244087],
							[-66.33072, 18.243684],
							[-66.332229, 18.242462],
							[-66.333614, 18.241253],
							[-66.334246, 18.24052],
							[-66.335247, 18.240051],
							[-66.336117, 18.239504],
							[-66.336374, 18.239519],
							[-66.338134, 18.239271],
							[-66.341465, 18.239234],
							[-66.342462, 18.23978],
							[-66.349783, 18.240543],
							[-66.350794, 18.241235],
							[-66.358078, 18.246136],
							[-66.357596, 18.24801],
							[-66.357493, 18.248619],
							[-66.358005, 18.250214],
							[-66.364122, 18.259338],
							[-66.365083, 18.260503],
							[-66.37185, 18.268159],
							[-66.374614, 18.270724],
							[-66.377133, 18.273642],
							[-66.38267, 18.274333],
							[-66.383153, 18.275164],
							[-66.382506, 18.27893],
							[-66.378892, 18.288964],
							[-66.37872, 18.291259],
							[-66.377723, 18.293955],
							[-66.375672, 18.297555],
							[-66.37596, 18.300015],
							[-66.373311, 18.301938],
							[-66.372457, 18.309835],
							[-66.37204, 18.31236],
							[-66.368594, 18.321739],
							[-66.366897, 18.327592],
							[-66.365639, 18.331921],
							[-66.365272, 18.333229],
							[-66.359491, 18.330759],
							[-66.358294, 18.330796],
							[-66.357825, 18.332471],
							[-66.357317, 18.335811],
							[-66.357777, 18.33798],
							[-66.357589, 18.343226],
							[-66.356626, 18.345002],
							[-66.354752, 18.346931],
							[-66.351197, 18.349219],
							[-66.349249, 18.349706],
							[-66.348675, 18.350843],
							[-66.348863, 18.351605],
							[-66.350976, 18.353394],
							[-66.354747, 18.355126],
							[-66.355225, 18.359589],
							[-66.355278, 18.360643],
							[-66.354458, 18.361045],
							[-66.350273, 18.36121],
							[-66.343219, 18.357793],
							[-66.340976, 18.357626],
							[-66.340672, 18.358036],
							[-66.341202, 18.360395],
							[-66.341028, 18.362556],
							[-66.339385, 18.366564],
							[-66.338606, 18.367542],
							[-66.333612, 18.367948],
							[-66.326119, 18.365948],
							[-66.323591, 18.366811],
							[-66.321209, 18.366104],
							[-66.318976, 18.367399],
							[-66.318623, 18.367419],
							[-66.31142, 18.364767],
							[-66.308125, 18.364779],
							[-66.307368, 18.365457],
							[-66.307037, 18.368109],
							[-66.306193, 18.36969],
							[-66.305353, 18.370045],
							[-66.304499, 18.368599],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '081',
					name: 'Lares',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.893216, 18.367055],
							[-66.891099, 18.368036],
							[-66.885488, 18.367019],
							[-66.880979, 18.362998],
							[-66.879781, 18.359913],
							[-66.878171, 18.358488],
							[-66.874621, 18.356732],
							[-66.872873, 18.356813],
							[-66.871446, 18.356112],
							[-66.863108, 18.356065],
							[-66.862903, 18.356058],
							[-66.862811, 18.356055],
							[-66.861869, 18.35602],
							[-66.85431, 18.355084],
							[-66.853475, 18.355014],
							[-66.85, 18.35323],
							[-66.848728, 18.353327],
							[-66.846489, 18.351176],
							[-66.845556, 18.350769],
							[-66.841949, 18.350065],
							[-66.831552, 18.345763],
							[-66.829174, 18.34459],
							[-66.824223, 18.342998],
							[-66.824611, 18.339231],
							[-66.824847, 18.333185],
							[-66.825276, 18.329964],
							[-66.826129, 18.323382],
							[-66.825524, 18.321602],
							[-66.824254, 18.319519],
							[-66.827192, 18.313947],
							[-66.825084, 18.306981],
							[-66.823461, 18.30343],
							[-66.826148, 18.302435],
							[-66.826718, 18.300861],
							[-66.826565, 18.295617],
							[-66.824998, 18.29491],
							[-66.831244, 18.285079],
							[-66.829532, 18.284633],
							[-66.830449, 18.277738],
							[-66.8272, 18.277791],
							[-66.826806, 18.273278],
							[-66.827214, 18.272704],
							[-66.828655, 18.270786],
							[-66.828803, 18.269152],
							[-66.826951, 18.2672],
							[-66.82571, 18.266901],
							[-66.82531, 18.266217],
							[-66.826476, 18.257686],
							[-66.826617, 18.248822],
							[-66.827125, 18.243915],
							[-66.82297, 18.239109],
							[-66.817128, 18.23451],
							[-66.817282, 18.230047],
							[-66.822951, 18.232136],
							[-66.823141, 18.23233],
							[-66.825683, 18.232624],
							[-66.829142, 18.231802],
							[-66.830437, 18.231179],
							[-66.833232, 18.228108],
							[-66.832303, 18.227509],
							[-66.82942, 18.223229],
							[-66.829143, 18.221239],
							[-66.829815, 18.220016],
							[-66.830634, 18.221005],
							[-66.832624, 18.221439],
							[-66.834092, 18.220317],
							[-66.834978, 18.218186],
							[-66.832849, 18.215189],
							[-66.835256, 18.209981],
							[-66.834094, 18.202797],
							[-66.834519, 18.201748],
							[-66.835056, 18.200039],
							[-66.834795, 18.198514],
							[-66.833064, 18.196693],
							[-66.832735, 18.195672],
							[-66.835701, 18.189329],
							[-66.835531, 18.187581],
							[-66.836297, 18.185862],
							[-66.835726, 18.185292],
							[-66.834495, 18.184569],
							[-66.834142, 18.184064],
							[-66.834321, 18.182419],
							[-66.833932, 18.18239],
							[-66.83372, 18.182379],
							[-66.832712, 18.181976],
							[-66.832304, 18.181056],
							[-66.830423, 18.179672],
							[-66.827449, 18.178356],
							[-66.827585, 18.175508],
							[-66.82699, 18.174467],
							[-66.826076, 18.174399],
							[-66.824803, 18.173755],
							[-66.826506, 18.172189],
							[-66.827174, 18.17155],
							[-66.827331, 18.171256],
							[-66.83677, 18.170632],
							[-66.843677, 18.171515],
							[-66.846988, 18.171467],
							[-66.850755, 18.170359],
							[-66.855913, 18.171759],
							[-66.8626, 18.173469],
							[-66.862978, 18.174598],
							[-66.862592, 18.175402],
							[-66.861914, 18.17576],
							[-66.861079, 18.174895],
							[-66.860301, 18.175617],
							[-66.860981, 18.17701],
							[-66.862661, 18.178596],
							[-66.862327, 18.179415],
							[-66.862809, 18.181482],
							[-66.864867, 18.182137],
							[-66.863054, 18.183616],
							[-66.862871, 18.184379],
							[-66.864026, 18.186843],
							[-66.867658, 18.18741],
							[-66.870508, 18.187164],
							[-66.894704, 18.187255],
							[-66.89493, 18.18726],
							[-66.898027, 18.187759],
							[-66.898563, 18.187896],
							[-66.90029, 18.193523],
							[-66.900308, 18.193582],
							[-66.901107, 18.196273],
							[-66.901188, 18.196508],
							[-66.904767, 18.208056],
							[-66.912859, 18.233009],
							[-66.911631, 18.23675],
							[-66.908369, 18.244315],
							[-66.906811, 18.246145],
							[-66.906692, 18.25031],
							[-66.907213, 18.253136],
							[-66.907459, 18.25314],
							[-66.908591, 18.255775],
							[-66.906998, 18.262375],
							[-66.907501, 18.264805],
							[-66.908747, 18.266109],
							[-66.9088, 18.266145],
							[-66.908868, 18.266742],
							[-66.90826, 18.273574],
							[-66.910589, 18.278179],
							[-66.910299, 18.2824],
							[-66.909549, 18.293102],
							[-66.909973, 18.295206],
							[-66.909969, 18.302811],
							[-66.905863, 18.315088],
							[-66.905651, 18.315736],
							[-66.90503, 18.319591],
							[-66.904885, 18.320557],
							[-66.904727, 18.32161],
							[-66.897617, 18.343678],
							[-66.896415, 18.348905],
							[-66.891871, 18.365466],
							[-66.892681, 18.366522],
							[-66.893216, 18.367055],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '049',
					name: 'Culebra',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.25941151247194, 18.322155681521245],
							[-65.253174, 18.318524],
							[-65.245095, 18.309668],
							[-65.244424, 18.303493],
							[-65.249857, 18.296691],
							[-65.260282, 18.290823],
							[-65.263937, 18.290685],
							[-65.276037, 18.296067],
							[-65.277099, 18.298978],
							[-65.276007, 18.302613],
							[-65.280502, 18.306202],
							[-65.28662150366276, 18.307392350943932],
							[-65.29642214693233, 18.30929874819606],
							[-65.302536, 18.310488],
							[-65.3025083354987, 18.310112101231013],
							[-65.3022161835613, 18.306142409081556],
							[-65.30216, 18.305379],
							[-65.30242630577987, 18.30314486080296],
							[-65.30282862098902, 18.303012916009312],
							[-65.30338154566815, 18.30283157677323],
							[-65.307027, 18.301636],
							[-65.31186870184978, 18.305793728557635],
							[-65.316371, 18.30966],
							[-65.316885, 18.314047],
							[-65.322785, 18.321157],
							[-65.327318, 18.323666],
							[-65.34206837463793, 18.3452899645646],
							[-65.33570113557938, 18.34953479452074],
							[-65.32933388476953, 18.341954732633845],
							[-65.32175382875828, 18.3383163170297],
							[-65.309833, 18.337973],
							[-65.304409, 18.332054],
							[-65.298328, 18.330529],
							[-65.28520474420675, 18.329616646004176],
							[-65.281657, 18.32937],
							[-65.277319, 18.332582],
							[-65.25941151247194, 18.322155681521245],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 141,
					name: 'Utuado',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.698029, 18.320963],
							[-66.697769, 18.321078],
							[-66.691935, 18.32135],
							[-66.683281, 18.320892],
							[-66.68298, 18.32076],
							[-66.67246, 18.324365],
							[-66.672061, 18.324388],
							[-66.669339, 18.323448],
							[-66.666888, 18.322414],
							[-66.664361, 18.322193],
							[-66.662588, 18.319933],
							[-66.661789, 18.320686],
							[-66.656593, 18.322375],
							[-66.656172, 18.322769],
							[-66.652022, 18.328382],
							[-66.649423, 18.328087],
							[-66.648119, 18.326321],
							[-66.639155, 18.324559],
							[-66.634756, 18.325331],
							[-66.619029, 18.331805],
							[-66.614618, 18.331591],
							[-66.606989, 18.328186],
							[-66.61115, 18.322423],
							[-66.608213, 18.32382],
							[-66.606826, 18.322451],
							[-66.604329, 18.321279],
							[-66.600756, 18.321923],
							[-66.593331, 18.324454],
							[-66.590882, 18.323875],
							[-66.586359, 18.322373],
							[-66.582398, 18.319529],
							[-66.583091, 18.316429],
							[-66.581406, 18.314017],
							[-66.575836, 18.31128],
							[-66.573005, 18.308917],
							[-66.570932, 18.305273],
							[-66.571383, 18.304093],
							[-66.570309, 18.301796],
							[-66.566665, 18.298583],
							[-66.573204, 18.300373],
							[-66.574364, 18.295939],
							[-66.573361, 18.294928],
							[-66.573387, 18.290802],
							[-66.574039, 18.291543],
							[-66.574535, 18.288689],
							[-66.577994, 18.284388],
							[-66.582541, 18.284252],
							[-66.590293, 18.283396],
							[-66.590293, 18.283551],
							[-66.595023, 18.284774],
							[-66.597352, 18.284255],
							[-66.598714, 18.281952],
							[-66.597089, 18.281135],
							[-66.5953, 18.276795],
							[-66.596532, 18.270578],
							[-66.599068, 18.267794],
							[-66.601169, 18.264301],
							[-66.601121, 18.264248],
							[-66.597985, 18.261748],
							[-66.597376, 18.260204],
							[-66.600443, 18.252027],
							[-66.604755, 18.246721],
							[-66.603811, 18.246213],
							[-66.604633, 18.242935],
							[-66.606736, 18.23848],
							[-66.607883, 18.239841],
							[-66.611687, 18.24144],
							[-66.614781, 18.243881],
							[-66.618319, 18.248851],
							[-66.619665, 18.249337],
							[-66.622076, 18.248631],
							[-66.624977, 18.246876],
							[-66.625562, 18.235474],
							[-66.626507, 18.233534],
							[-66.628902, 18.236297],
							[-66.629193, 18.235822],
							[-66.630068, 18.23471],
							[-66.62908, 18.232052],
							[-66.628078, 18.226475],
							[-66.629528, 18.220636],
							[-66.629013, 18.218088],
							[-66.628531, 18.21431],
							[-66.631731, 18.213487],
							[-66.633104, 18.211338],
							[-66.637139, 18.207565],
							[-66.638963, 18.205358],
							[-66.639886, 18.201192],
							[-66.640079, 18.200336],
							[-66.640507, 18.19921],
							[-66.64082, 18.198268],
							[-66.641849, 18.196424],
							[-66.643184, 18.195802],
							[-66.642107, 18.192709],
							[-66.640951, 18.187034],
							[-66.642208, 18.183241],
							[-66.643143, 18.182747],
							[-66.645363, 18.183685],
							[-66.647679, 18.18374],
							[-66.652243, 18.182497],
							[-66.65149, 18.179265],
							[-66.650835, 18.175305],
							[-66.650668, 18.174234],
							[-66.651751, 18.173423],
							[-66.654548, 18.16959],
							[-66.651774, 18.16701],
							[-66.651367, 18.16585],
							[-66.649549, 18.158864],
							[-66.650491, 18.158552],
							[-66.655137, 18.157936],
							[-66.65876, 18.156863],
							[-66.659621, 18.156948],
							[-66.661932, 18.155992],
							[-66.662848, 18.155536],
							[-66.669194, 18.152361],
							[-66.670494, 18.152831],
							[-66.675863, 18.15046],
							[-66.676983, 18.150767],
							[-66.677194, 18.152895],
							[-66.67678, 18.153197],
							[-66.676235, 18.155841],
							[-66.676625, 18.160286],
							[-66.676578, 18.16026],
							[-66.670962, 18.163637],
							[-66.670577, 18.163786],
							[-66.670252, 18.165639],
							[-66.671776, 18.166734],
							[-66.671304, 18.167408],
							[-66.669141, 18.167498],
							[-66.667568, 18.169908],
							[-66.667299, 18.170304],
							[-66.665905, 18.171509],
							[-66.664847, 18.174585],
							[-66.665412, 18.175725],
							[-66.669652, 18.17881],
							[-66.67301, 18.182116],
							[-66.680168, 18.185958],
							[-66.681684, 18.18832],
							[-66.683442, 18.191745],
							[-66.684752, 18.194101],
							[-66.685092, 18.197072],
							[-66.682675, 18.198486],
							[-66.681308, 18.20045],
							[-66.681099, 18.202391],
							[-66.681163, 18.203515],
							[-66.68772, 18.209816],
							[-66.688257, 18.210183],
							[-66.691841, 18.211802],
							[-66.696302, 18.215342],
							[-66.700079, 18.215995],
							[-66.70314, 18.217018],
							[-66.704537, 18.216791],
							[-66.706846, 18.216596],
							[-66.715743, 18.220688],
							[-66.716061, 18.221279],
							[-66.718655, 18.220429],
							[-66.720257, 18.221834],
							[-66.722878, 18.221074],
							[-66.72328, 18.221304],
							[-66.724771, 18.220887],
							[-66.726751, 18.223402],
							[-66.729926, 18.22526],
							[-66.732181, 18.225759],
							[-66.735977, 18.224199],
							[-66.739359, 18.220517],
							[-66.741288, 18.221655],
							[-66.748107, 18.222169],
							[-66.756197, 18.223709],
							[-66.756281, 18.224926],
							[-66.760467, 18.228573],
							[-66.763876, 18.235027],
							[-66.764258, 18.237137],
							[-66.764719, 18.237363],
							[-66.773785, 18.24138],
							[-66.775162, 18.242595],
							[-66.777416, 18.246741],
							[-66.777401, 18.247477],
							[-66.781933, 18.250417],
							[-66.794318, 18.249869],
							[-66.795493, 18.243828],
							[-66.79913, 18.243656],
							[-66.800178, 18.24281],
							[-66.800829, 18.240715],
							[-66.799962, 18.234073],
							[-66.798808, 18.230009],
							[-66.800766, 18.227827],
							[-66.802943, 18.227497],
							[-66.804917, 18.228114],
							[-66.813007, 18.228919],
							[-66.814428, 18.229935],
							[-66.815581, 18.230239],
							[-66.817282, 18.230047],
							[-66.817128, 18.23451],
							[-66.82297, 18.239109],
							[-66.827125, 18.243915],
							[-66.826617, 18.248822],
							[-66.826476, 18.257686],
							[-66.82531, 18.266217],
							[-66.82571, 18.266901],
							[-66.826951, 18.2672],
							[-66.828803, 18.269152],
							[-66.828655, 18.270786],
							[-66.827214, 18.272704],
							[-66.826806, 18.273278],
							[-66.8272, 18.277791],
							[-66.830449, 18.277738],
							[-66.829532, 18.284633],
							[-66.831244, 18.285079],
							[-66.824998, 18.29491],
							[-66.826565, 18.295617],
							[-66.826718, 18.300861],
							[-66.826148, 18.302435],
							[-66.823461, 18.30343],
							[-66.825084, 18.306981],
							[-66.827192, 18.313947],
							[-66.824254, 18.319519],
							[-66.825524, 18.321602],
							[-66.826129, 18.323382],
							[-66.794752, 18.321898],
							[-66.793901, 18.321858],
							[-66.785097, 18.32146],
							[-66.770458, 18.320614],
							[-66.770091, 18.324774],
							[-66.762126, 18.332278],
							[-66.757682, 18.335449],
							[-66.756314, 18.337053],
							[-66.754313, 18.337174],
							[-66.740436, 18.344756],
							[-66.738528, 18.346599],
							[-66.737938, 18.348431],
							[-66.736443, 18.349309],
							[-66.731773, 18.348264],
							[-66.730441, 18.349484],
							[-66.723462, 18.33985],
							[-66.720934, 18.338191],
							[-66.719793, 18.336641],
							[-66.720374, 18.335108],
							[-66.722529, 18.333369],
							[-66.722681, 18.331751],
							[-66.721626, 18.328731],
							[-66.721266, 18.323819],
							[-66.717302, 18.315681],
							[-66.715886, 18.315205],
							[-66.711439, 18.315606],
							[-66.710474, 18.315439],
							[-66.707046, 18.316686],
							[-66.702916, 18.320592],
							[-66.698029, 18.320963],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 105,
					name: 'Naranjito',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.238535, 18.332633],
							[-66.238404, 18.332605],
							[-66.234545, 18.328059],
							[-66.232892, 18.323429],
							[-66.230935, 18.324526],
							[-66.228045, 18.328185],
							[-66.220777, 18.333138],
							[-66.216696, 18.333954],
							[-66.215849, 18.33316],
							[-66.21598, 18.331631],
							[-66.215836, 18.330943],
							[-66.214465, 18.326842],
							[-66.21447, 18.326746],
							[-66.211724, 18.323557],
							[-66.209087, 18.324138],
							[-66.207488, 18.323683],
							[-66.205582, 18.318692],
							[-66.205357, 18.316868],
							[-66.205364, 18.316495],
							[-66.205867, 18.310378],
							[-66.206062, 18.306668],
							[-66.206206, 18.306622],
							[-66.212028, 18.307039],
							[-66.212369, 18.307025],
							[-66.212954, 18.30488],
							[-66.211274, 18.303689],
							[-66.21062, 18.303048],
							[-66.210097, 18.298295],
							[-66.208678, 18.296024],
							[-66.210399, 18.293596],
							[-66.211072, 18.293109],
							[-66.211506, 18.291621],
							[-66.209816, 18.288663],
							[-66.209247, 18.284701],
							[-66.206559, 18.279622],
							[-66.206589, 18.277137],
							[-66.206221, 18.276644],
							[-66.207739, 18.276797],
							[-66.219139, 18.274213],
							[-66.219257, 18.27405],
							[-66.222968, 18.264916],
							[-66.228157, 18.262674],
							[-66.228805, 18.258641],
							[-66.22809, 18.257154],
							[-66.227784, 18.254467],
							[-66.228943, 18.253759],
							[-66.232884, 18.255017],
							[-66.23787, 18.253978],
							[-66.238358, 18.253991],
							[-66.242804, 18.252715],
							[-66.243608, 18.25084],
							[-66.245109, 18.249218],
							[-66.247249, 18.248583],
							[-66.249489, 18.249267],
							[-66.257121, 18.247422],
							[-66.263456, 18.246425],
							[-66.263978, 18.246552],
							[-66.265416, 18.246869],
							[-66.266377, 18.24528],
							[-66.272184, 18.244577],
							[-66.273394, 18.244423],
							[-66.278861, 18.243728],
							[-66.280877, 18.24358],
							[-66.290146, 18.244903],
							[-66.293597, 18.245591],
							[-66.293847, 18.246182],
							[-66.301636, 18.244738],
							[-66.303927, 18.24323],
							[-66.305307, 18.241579],
							[-66.306488, 18.240967],
							[-66.307073, 18.241481],
							[-66.307355, 18.241729],
							[-66.307804, 18.242747],
							[-66.310676, 18.245057],
							[-66.310749, 18.245717],
							[-66.311011, 18.246156],
							[-66.311173, 18.246853],
							[-66.311449, 18.24801],
							[-66.311458, 18.24801],
							[-66.313425, 18.248139],
							[-66.313808, 18.248352],
							[-66.313439, 18.249346],
							[-66.313358, 18.249387],
							[-66.310219, 18.251316],
							[-66.308815, 18.251156],
							[-66.306904, 18.252451],
							[-66.306177, 18.253668],
							[-66.30609, 18.25488],
							[-66.304676, 18.255128],
							[-66.302988, 18.254614],
							[-66.302282, 18.255394],
							[-66.296086, 18.257546],
							[-66.294225, 18.260644],
							[-66.293293, 18.262338],
							[-66.289541, 18.268478],
							[-66.288241, 18.269507],
							[-66.287227, 18.272366],
							[-66.289093, 18.276276],
							[-66.288205, 18.281399],
							[-66.287256, 18.28364],
							[-66.285934, 18.298942],
							[-66.285318, 18.303769],
							[-66.283473, 18.307999],
							[-66.283077, 18.314071],
							[-66.280877, 18.321502],
							[-66.278076, 18.329975],
							[-66.273453, 18.329506],
							[-66.271074, 18.328552],
							[-66.268507, 18.329076],
							[-66.266657, 18.330115],
							[-66.263634, 18.329816],
							[-66.257924, 18.331698],
							[-66.256973, 18.331356],
							[-66.252625, 18.328427],
							[-66.249898, 18.326582],
							[-66.249612, 18.326429],
							[-66.248446, 18.326114],
							[-66.24584, 18.331377],
							[-66.238535, 18.332633],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '011',
					name: 'Añasco',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.121562, 18.323942],
							[-67.120361, 18.323846],
							[-67.117564, 18.322805],
							[-67.117451, 18.323276],
							[-67.113954, 18.322493],
							[-67.113014, 18.321167],
							[-67.111321, 18.320792],
							[-67.108398, 18.320158],
							[-67.108257, 18.320135],
							[-67.10807, 18.320182],
							[-67.103964, 18.318954],
							[-67.102678, 18.318598],
							[-67.100048, 18.319721],
							[-67.086474, 18.31545],
							[-67.078111, 18.312952],
							[-67.071355, 18.3126],
							[-67.07016, 18.312496],
							[-67.069517, 18.312329],
							[-67.060293, 18.310104],
							[-67.052583, 18.306655],
							[-67.04387, 18.301994],
							[-67.040709, 18.300302],
							[-67.040119, 18.293594],
							[-67.040206, 18.29313],
							[-67.037935, 18.289705],
							[-67.038073, 18.289431],
							[-67.041201, 18.281924],
							[-67.040749, 18.275497],
							[-67.040408, 18.271871],
							[-67.04201, 18.270959],
							[-67.044438, 18.270994],
							[-67.051237, 18.268519],
							[-67.05175, 18.26829],
							[-67.051613, 18.266876],
							[-67.058575, 18.268881],
							[-67.061828, 18.270082],
							[-67.064916, 18.261556],
							[-67.064892, 18.261482],
							[-67.067478, 18.259016],
							[-67.072077, 18.254757],
							[-67.076025, 18.257592],
							[-67.079009, 18.258748],
							[-67.08199, 18.25496],
							[-67.086799, 18.249252],
							[-67.090407, 18.249593],
							[-67.091321, 18.249896],
							[-67.094022, 18.249715],
							[-67.096633, 18.252646],
							[-67.105495, 18.252858],
							[-67.107854, 18.251895],
							[-67.107919, 18.25099],
							[-67.109489, 18.249108],
							[-67.114618, 18.247354],
							[-67.116927, 18.247561],
							[-67.118767, 18.248383],
							[-67.118988, 18.24836],
							[-67.123072, 18.242789],
							[-67.124695, 18.244486],
							[-67.127715, 18.245651],
							[-67.135442, 18.245743],
							[-67.136386, 18.246939],
							[-67.136237, 18.248008],
							[-67.134771, 18.248822],
							[-67.134352, 18.249608],
							[-67.135442, 18.251393],
							[-67.137884, 18.253874],
							[-67.138345, 18.255028],
							[-67.138668, 18.259501],
							[-67.137129, 18.260553],
							[-67.135076, 18.261233],
							[-67.134859, 18.262137],
							[-67.136081, 18.262626],
							[-67.135142, 18.263965],
							[-67.135084, 18.264023],
							[-67.13469, 18.264312],
							[-67.135134, 18.264494],
							[-67.13568, 18.26496],
							[-67.138647, 18.265489],
							[-67.140626, 18.266736],
							[-67.140785, 18.2668],
							[-67.141101, 18.267062],
							[-67.141377, 18.267022],
							[-67.14153, 18.267666],
							[-67.141582, 18.269815],
							[-67.142643, 18.270306],
							[-67.142786, 18.269718],
							[-67.142571, 18.268412],
							[-67.142687, 18.268279],
							[-67.143294, 18.267907],
							[-67.143495, 18.267705],
							[-67.144522, 18.269085],
							[-67.147521, 18.271663],
							[-67.149164, 18.271609],
							[-67.149492, 18.271483],
							[-67.149681, 18.270271],
							[-67.148391, 18.269769],
							[-67.148396, 18.269694],
							[-67.1484, 18.269631],
							[-67.148291, 18.269353],
							[-67.148298, 18.269022],
							[-67.149028, 18.268451],
							[-67.153317, 18.271416],
							[-67.157755, 18.273152],
							[-67.16033, 18.273125],
							[-67.161144, 18.273011],
							[-67.161481, 18.272728],
							[-67.162218, 18.272016],
							[-67.162976, 18.271396],
							[-67.165468, 18.270092],
							[-67.169084, 18.269093],
							[-67.171566, 18.26841],
							[-67.178767, 18.2674],
							[-67.178945, 18.267391],
							[-67.181375, 18.267141],
							[-67.181456, 18.267131],
							[-67.183628, 18.26687],
							[-67.18603, 18.266965],
							[-67.18783706143796, 18.266662072065145],
							[-67.187843, 18.266671],
							[-67.18865572947159, 18.2721492854983],
							[-67.18866718899508, 18.27222652957961],
							[-67.1898333559764, 18.280087196487553],
							[-67.189971, 18.281015],
							[-67.19029457171247, 18.281516336746943],
							[-67.19600857301172, 18.29036951739598],
							[-67.196056, 18.290443],
							[-67.19616169325948, 18.29047743561938],
							[-67.19961958839768, 18.29160404257064],
							[-67.19978708165937, 18.291658613072453],
							[-67.209963, 18.294974],
							[-67.22559940766368, 18.296669771224476],
							[-67.223991, 18.299533],
							[-67.222647, 18.303301],
							[-67.220291, 18.305852],
							[-67.218719, 18.305072],
							[-67.218101, 18.304663],
							[-67.208161, 18.306162],
							[-67.20637, 18.30728],
							[-67.203364, 18.308422],
							[-67.199408, 18.310325],
							[-67.19664, 18.307752],
							[-67.196457, 18.307679],
							[-67.192029, 18.308688],
							[-67.190436, 18.309296],
							[-67.189653, 18.311773],
							[-67.188824, 18.311791],
							[-67.188366, 18.311828],
							[-67.187047, 18.310781],
							[-67.185518, 18.310627],
							[-67.184696, 18.310802],
							[-67.184015, 18.31094],
							[-67.183144, 18.310922],
							[-67.182741, 18.312867],
							[-67.178657, 18.315493],
							[-67.175461, 18.3167],
							[-67.174811, 18.317124],
							[-67.173775, 18.31819],
							[-67.17365, 18.31798],
							[-67.17264, 18.318215],
							[-67.16992, 18.316051],
							[-67.164769, 18.315403],
							[-67.157529, 18.319189],
							[-67.146178, 18.322302],
							[-67.146191, 18.322337],
							[-67.145759, 18.32266],
							[-67.143538, 18.322407],
							[-67.141077, 18.321231],
							[-67.139199, 18.319376],
							[-67.138676, 18.31805],
							[-67.135891, 18.317092],
							[-67.132773, 18.317747],
							[-67.13085, 18.317511],
							[-67.129909, 18.317959],
							[-67.128445, 18.318319],
							[-67.126935, 18.320469],
							[-67.126939, 18.320573],
							[-67.126948, 18.320827],
							[-67.12581, 18.321852],
							[-67.123628, 18.321763],
							[-67.122449, 18.322959],
							[-67.122208, 18.323231],
							[-67.121562, 18.323942],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '025',
					name: 'Caguas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.041129, 18.312087],
							[-66.038871, 18.311632],
							[-66.038607, 18.311558],
							[-66.037247, 18.310425],
							[-66.036531, 18.309938],
							[-66.030953, 18.309462],
							[-66.030704, 18.3096],
							[-66.024842, 18.309065],
							[-66.023492, 18.307118],
							[-66.021747, 18.305034],
							[-66.023696, 18.303338],
							[-66.025381, 18.303334],
							[-66.02718, 18.304071],
							[-66.029462, 18.302981],
							[-66.030572, 18.30118],
							[-66.030724, 18.299778],
							[-66.02747, 18.297536],
							[-66.028042, 18.294868],
							[-66.029895, 18.29087],
							[-66.029181, 18.289121],
							[-66.02603, 18.286393],
							[-66.022378, 18.286226],
							[-66.018964, 18.285406],
							[-66.012758, 18.280314],
							[-66.010065, 18.278768],
							[-66.008636, 18.278383],
							[-66.007906, 18.277157],
							[-66.008007, 18.276813],
							[-66.008677, 18.27191],
							[-66.008799, 18.271809],
							[-66.009937, 18.269317],
							[-66.007446, 18.267631],
							[-66.007261, 18.266829],
							[-66.009655, 18.265632],
							[-66.012694, 18.265029],
							[-66.014083, 18.26451],
							[-66.014323, 18.264014],
							[-66.012952, 18.258451],
							[-66.012832, 18.25824],
							[-66.012126, 18.256592],
							[-66.010984, 18.253598],
							[-66.010758, 18.250372],
							[-66.012967, 18.24801],
							[-66.013419, 18.247724],
							[-66.014123, 18.247023],
							[-66.014595, 18.245259],
							[-66.014157, 18.244028],
							[-66.011598, 18.241464],
							[-66.009387, 18.240955],
							[-66.008092, 18.236235],
							[-66.007967, 18.233694],
							[-66.008792, 18.23166],
							[-66.009584, 18.230532],
							[-66.011406, 18.229499],
							[-66.013452, 18.224852],
							[-66.010975, 18.221351],
							[-66.003139, 18.218536],
							[-65.999306, 18.217877],
							[-65.999434, 18.216177],
							[-65.999608, 18.215686],
							[-65.999608, 18.215671],
							[-65.999611, 18.208918],
							[-65.998893, 18.207828],
							[-65.998882, 18.206404],
							[-66.000504, 18.201988],
							[-66.000241, 18.197653],
							[-65.999608, 18.196437],
							[-65.998146, 18.195309],
							[-65.998667, 18.191613],
							[-65.999275, 18.189409],
							[-65.999608, 18.188614],
							[-66.002202, 18.187701],
							[-66.003059, 18.186097],
							[-66.003855, 18.185468],
							[-66.004114, 18.185449],
							[-66.005623, 18.186289],
							[-66.00569, 18.186326],
							[-66.011319, 18.18606],
							[-66.013365, 18.181929],
							[-66.013344, 18.181018],
							[-66.011979, 18.178756],
							[-66.01259, 18.176817],
							[-66.016832, 18.176326],
							[-66.016717, 18.17505],
							[-66.016556, 18.174761],
							[-66.016744, 18.173667],
							[-66.020021, 18.167613],
							[-66.020599, 18.167056],
							[-66.021912, 18.16518],
							[-66.021899, 18.164861],
							[-66.021966, 18.163978],
							[-66.02084, 18.16092],
							[-66.020222, 18.159083],
							[-66.022067, 18.155944],
							[-66.022161, 18.155811],
							[-66.021535, 18.149404],
							[-66.01961, 18.145514],
							[-66.020358, 18.145106],
							[-66.025149, 18.138813],
							[-66.024533, 18.137321],
							[-66.025221, 18.134948],
							[-66.025901, 18.133927],
							[-66.031581, 18.132324],
							[-66.032054, 18.131658],
							[-66.035311, 18.120161],
							[-66.041071, 18.115427],
							[-66.043189, 18.114336],
							[-66.044402, 18.114999],
							[-66.049999, 18.115259],
							[-66.052737, 18.113514],
							[-66.055466, 18.113996],
							[-66.060705, 18.116362],
							[-66.060265, 18.118585],
							[-66.061762, 18.124592],
							[-66.064762, 18.129956],
							[-66.064956, 18.131086],
							[-66.065619, 18.131417],
							[-66.067479, 18.132172],
							[-66.068023, 18.134398],
							[-66.06959, 18.137516],
							[-66.069514, 18.137704],
							[-66.068841, 18.14011],
							[-66.06949, 18.142397],
							[-66.067222, 18.145598],
							[-66.066303, 18.146071],
							[-66.066069, 18.147089],
							[-66.066292, 18.148499],
							[-66.071352, 18.149891],
							[-66.080345, 18.152143],
							[-66.080425, 18.152953],
							[-66.083361, 18.156285],
							[-66.086153, 18.15831],
							[-66.090266, 18.162305],
							[-66.095107, 18.169018],
							[-66.096774, 18.168178],
							[-66.105188, 18.171478],
							[-66.101742, 18.182981],
							[-66.101675, 18.183087],
							[-66.109408, 18.200967],
							[-66.110267, 18.201953],
							[-66.117789, 18.209953],
							[-66.117044, 18.211452],
							[-66.107859, 18.214209],
							[-66.100775, 18.218477],
							[-66.098088, 18.220905],
							[-66.097052, 18.221677],
							[-66.096717, 18.222288],
							[-66.096192, 18.223799],
							[-66.090421, 18.227413],
							[-66.08901, 18.230144],
							[-66.085123, 18.235517],
							[-66.084547, 18.237665],
							[-66.084921, 18.239079],
							[-66.084768, 18.242512],
							[-66.0789, 18.247768],
							[-66.077314, 18.249838],
							[-66.074838, 18.253068],
							[-66.074629, 18.254261],
							[-66.077313, 18.25651],
							[-66.076294, 18.260801],
							[-66.07476, 18.267585],
							[-66.071293, 18.281366],
							[-66.071226, 18.28154],
							[-66.070946, 18.282747],
							[-66.069786, 18.287765],
							[-66.069742, 18.288077],
							[-66.067629, 18.296463],
							[-66.067356, 18.297914],
							[-66.066129, 18.303175],
							[-66.065924, 18.303733],
							[-66.063081, 18.302629],
							[-66.062379, 18.303047],
							[-66.059689, 18.301831],
							[-66.058728, 18.303126],
							[-66.056336, 18.304485],
							[-66.052864, 18.303309],
							[-66.052968, 18.303473],
							[-66.053131, 18.303797],
							[-66.048338, 18.29758],
							[-66.047764, 18.302656],
							[-66.046962, 18.304441],
							[-66.047829, 18.306886],
							[-66.04692, 18.309408],
							[-66.044915, 18.311486],
							[-66.041505, 18.312324],
							[-66.041129, 18.312087],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '063',
					name: 'Gurabo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.985418, 18.311022],
							[-65.984974, 18.310944],
							[-65.98405, 18.310825],
							[-65.982026, 18.310733],
							[-65.972464, 18.310338],
							[-65.97048, 18.310217],
							[-65.968226, 18.310116],
							[-65.968043, 18.309983],
							[-65.966494, 18.305453],
							[-65.964777, 18.302353],
							[-65.962967, 18.299771],
							[-65.960221, 18.298893],
							[-65.957931, 18.296806],
							[-65.954166, 18.294573],
							[-65.949888, 18.295386],
							[-65.949885, 18.29532],
							[-65.945741, 18.293635],
							[-65.942562, 18.293438],
							[-65.935814, 18.28322],
							[-65.935281, 18.282756],
							[-65.932934, 18.280386],
							[-65.928271, 18.276662],
							[-65.925471, 18.275416],
							[-65.923567, 18.274774],
							[-65.92036, 18.27073],
							[-65.918535, 18.27013],
							[-65.921896, 18.26922],
							[-65.925645, 18.268682],
							[-65.930475, 18.265631],
							[-65.931075, 18.264839],
							[-65.936462, 18.259181],
							[-65.940771, 18.250416],
							[-65.940811, 18.250336],
							[-65.942452, 18.251299],
							[-65.943148, 18.252751],
							[-65.943835, 18.25317],
							[-65.945113, 18.253229],
							[-65.946281, 18.252512],
							[-65.945698, 18.249175],
							[-65.945236, 18.247058],
							[-65.945317, 18.246566],
							[-65.94529, 18.245322],
							[-65.946016, 18.244262],
							[-65.9493, 18.244103],
							[-65.94789, 18.241653],
							[-65.946258, 18.241298],
							[-65.942762, 18.2393],
							[-65.941911, 18.237067],
							[-65.940001, 18.2347],
							[-65.941477, 18.232386],
							[-65.943196, 18.231931],
							[-65.944631, 18.233239],
							[-65.949383, 18.231662],
							[-65.948071, 18.229707],
							[-65.951048, 18.229272],
							[-65.9578, 18.228824],
							[-65.958274, 18.228891],
							[-65.958763, 18.22896],
							[-65.965419, 18.229283],
							[-65.968952, 18.228899],
							[-65.975623, 18.227786],
							[-65.980422, 18.226068],
							[-65.980706, 18.224968],
							[-65.981402, 18.221118],
							[-65.982424, 18.221441],
							[-65.98252, 18.221443],
							[-65.989733, 18.219654],
							[-65.990557, 18.217943],
							[-65.991888, 18.211788],
							[-65.992771, 18.210604],
							[-65.993573, 18.21052],
							[-65.994, 18.20858],
							[-65.994018, 18.208464],
							[-65.99623, 18.207541],
							[-65.998893, 18.207828],
							[-65.999611, 18.208918],
							[-65.999608, 18.215671],
							[-65.999608, 18.215686],
							[-65.999434, 18.216177],
							[-65.999306, 18.217877],
							[-66.003139, 18.218536],
							[-66.010975, 18.221351],
							[-66.013452, 18.224852],
							[-66.011406, 18.229499],
							[-66.009584, 18.230532],
							[-66.008792, 18.23166],
							[-66.007967, 18.233694],
							[-66.008092, 18.236235],
							[-66.009387, 18.240955],
							[-66.011598, 18.241464],
							[-66.014157, 18.244028],
							[-66.014595, 18.245259],
							[-66.014123, 18.247023],
							[-66.013419, 18.247724],
							[-66.012967, 18.24801],
							[-66.010758, 18.250372],
							[-66.010984, 18.253598],
							[-66.012126, 18.256592],
							[-66.012832, 18.25824],
							[-66.012952, 18.258451],
							[-66.014323, 18.264014],
							[-66.014083, 18.26451],
							[-66.012694, 18.265029],
							[-66.009655, 18.265632],
							[-66.007261, 18.266829],
							[-66.007446, 18.267631],
							[-66.009937, 18.269317],
							[-66.008799, 18.271809],
							[-66.008677, 18.27191],
							[-66.008007, 18.276813],
							[-66.007906, 18.277157],
							[-66.008636, 18.278383],
							[-66.010065, 18.278768],
							[-66.012758, 18.280314],
							[-66.018964, 18.285406],
							[-66.022378, 18.286226],
							[-66.02603, 18.286393],
							[-66.029181, 18.289121],
							[-66.029895, 18.29087],
							[-66.028042, 18.294868],
							[-66.02747, 18.297536],
							[-66.030724, 18.299778],
							[-66.030572, 18.30118],
							[-66.029462, 18.302981],
							[-66.02718, 18.304071],
							[-66.025381, 18.303334],
							[-66.023696, 18.303338],
							[-66.021747, 18.305034],
							[-66.016482, 18.308734],
							[-66.013657, 18.307433],
							[-66.013306, 18.307419],
							[-66.009231, 18.30517],
							[-66.008506, 18.304831],
							[-66.008073, 18.304258],
							[-66.00754, 18.304203],
							[-66.002814, 18.307436],
							[-65.999476, 18.307019],
							[-65.995608, 18.306629],
							[-65.995148, 18.306697],
							[-65.991775, 18.309492],
							[-65.989876, 18.309915],
							[-65.988172, 18.3103],
							[-65.986227, 18.311173],
							[-65.985418, 18.311022],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '007',
					name: 'Aguas Buenas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.066129, 18.303175],
							[-66.067356, 18.297914],
							[-66.067629, 18.296463],
							[-66.069742, 18.288077],
							[-66.069786, 18.287765],
							[-66.070946, 18.282747],
							[-66.071226, 18.28154],
							[-66.071293, 18.281366],
							[-66.07476, 18.267585],
							[-66.076294, 18.260801],
							[-66.077313, 18.25651],
							[-66.074629, 18.254261],
							[-66.074838, 18.253068],
							[-66.077314, 18.249838],
							[-66.0789, 18.247768],
							[-66.084768, 18.242512],
							[-66.084921, 18.239079],
							[-66.084547, 18.237665],
							[-66.085123, 18.235517],
							[-66.08901, 18.230144],
							[-66.090421, 18.227413],
							[-66.096192, 18.223799],
							[-66.096717, 18.222288],
							[-66.097052, 18.221677],
							[-66.098088, 18.220905],
							[-66.100775, 18.218477],
							[-66.107859, 18.214209],
							[-66.117044, 18.211452],
							[-66.117789, 18.209953],
							[-66.118388, 18.209636],
							[-66.118455, 18.209625],
							[-66.119013, 18.209939],
							[-66.121494, 18.208998],
							[-66.128085, 18.205165],
							[-66.137309, 18.197622],
							[-66.140627, 18.197708],
							[-66.141356, 18.197703],
							[-66.140582, 18.198174],
							[-66.138498, 18.201269],
							[-66.138663, 18.203758],
							[-66.139121, 18.204514],
							[-66.139395, 18.205244],
							[-66.139524, 18.205389],
							[-66.139832, 18.205721],
							[-66.139489, 18.206],
							[-66.13881, 18.206737],
							[-66.139191, 18.210293],
							[-66.140233, 18.210815],
							[-66.142389, 18.210193],
							[-66.146009, 18.214873],
							[-66.146531, 18.219217],
							[-66.146508, 18.219368],
							[-66.145739, 18.221805],
							[-66.144669, 18.221246],
							[-66.143812, 18.22275],
							[-66.144062, 18.222968],
							[-66.145966, 18.223587],
							[-66.145822, 18.224047],
							[-66.144716, 18.224016],
							[-66.143855, 18.225142],
							[-66.146279, 18.230334],
							[-66.150047, 18.225305],
							[-66.150463, 18.223444],
							[-66.152258, 18.222124],
							[-66.154389, 18.222011],
							[-66.159371, 18.220462],
							[-66.162294, 18.220448],
							[-66.165224, 18.22347],
							[-66.169126, 18.22429],
							[-66.169329, 18.226257],
							[-66.176392, 18.230208],
							[-66.175694, 18.233671],
							[-66.176869, 18.234516],
							[-66.177205, 18.235104],
							[-66.178815, 18.238855],
							[-66.178577, 18.243481],
							[-66.178185, 18.243988],
							[-66.178179, 18.245808],
							[-66.181914, 18.248723],
							[-66.187602, 18.254453],
							[-66.190771, 18.258742],
							[-66.188658, 18.260612],
							[-66.185958, 18.266333],
							[-66.184315, 18.268339],
							[-66.179024, 18.271538],
							[-66.177081, 18.276175],
							[-66.177041, 18.276211],
							[-66.175446, 18.276717],
							[-66.175447, 18.276793],
							[-66.172483, 18.278403],
							[-66.167855, 18.277728],
							[-66.164222, 18.28061],
							[-66.163754, 18.280873],
							[-66.16173, 18.282545],
							[-66.161332, 18.28275],
							[-66.155031, 18.282219],
							[-66.153587, 18.282041],
							[-66.15097, 18.280784],
							[-66.148513, 18.28105],
							[-66.143877, 18.279733],
							[-66.143128, 18.278318],
							[-66.141528, 18.277745],
							[-66.140797, 18.278144],
							[-66.140599, 18.279623],
							[-66.139541, 18.27955],
							[-66.139167, 18.278894],
							[-66.120712, 18.281404],
							[-66.111713, 18.279513],
							[-66.108564, 18.277867],
							[-66.108191, 18.277768],
							[-66.106245, 18.27865],
							[-66.099692, 18.28157],
							[-66.099486, 18.281648],
							[-66.098818, 18.282048],
							[-66.094336, 18.28579],
							[-66.09383, 18.29193],
							[-66.091724, 18.293051],
							[-66.089895, 18.292142],
							[-66.08797, 18.292184],
							[-66.086789, 18.29321],
							[-66.086674, 18.293325],
							[-66.080475, 18.297295],
							[-66.076902, 18.296521],
							[-66.072972, 18.29776],
							[-66.072173, 18.29907],
							[-66.069557, 18.301232],
							[-66.066314, 18.303124],
							[-66.066129, 18.303175],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '073',
					name: 'Jayuya',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.566665, 18.298583],
							[-66.566579, 18.297092],
							[-66.563896, 18.294675],
							[-66.561663, 18.294432],
							[-66.560967, 18.293669],
							[-66.561853, 18.288215],
							[-66.562847, 18.288206],
							[-66.563159, 18.287751],
							[-66.56075, 18.28375],
							[-66.558157, 18.282872],
							[-66.556564, 18.278558],
							[-66.5578, 18.275109],
							[-66.558787, 18.257544],
							[-66.555993, 18.255491],
							[-66.555633, 18.254347],
							[-66.556012, 18.253562],
							[-66.558424, 18.25313],
							[-66.562275, 18.25364],
							[-66.560847, 18.247454],
							[-66.562528, 18.245308],
							[-66.563531, 18.242077],
							[-66.562703, 18.240721],
							[-66.555228, 18.237327],
							[-66.552589, 18.230359],
							[-66.548883, 18.220567],
							[-66.545527, 18.220736],
							[-66.538273, 18.213766],
							[-66.536439, 18.209118],
							[-66.536431, 18.206288],
							[-66.532725, 18.200519],
							[-66.532609, 18.19789],
							[-66.536717, 18.188631],
							[-66.531023, 18.180137],
							[-66.532241, 18.176804],
							[-66.533804, 18.176378],
							[-66.534695, 18.177129],
							[-66.53549, 18.177139],
							[-66.537038, 18.175823],
							[-66.541414, 18.168918],
							[-66.541616, 18.166664],
							[-66.540813, 18.165711],
							[-66.543133, 18.163098],
							[-66.544153, 18.158328],
							[-66.546835, 18.155019],
							[-66.547221, 18.15313],
							[-66.552766, 18.152057],
							[-66.559808, 18.15385],
							[-66.56005, 18.154268],
							[-66.561308, 18.157363],
							[-66.56388, 18.158528],
							[-66.566668, 18.158882],
							[-66.572048, 18.163913],
							[-66.572319, 18.166061],
							[-66.574114, 18.168119],
							[-66.574835, 18.16823],
							[-66.580465, 18.167752],
							[-66.581113, 18.168133],
							[-66.586763, 18.169296],
							[-66.586834, 18.169348],
							[-66.587585, 18.169393],
							[-66.587649, 18.169446],
							[-66.590319, 18.172162],
							[-66.591703, 18.172156],
							[-66.591854, 18.172042],
							[-66.598911, 18.169388],
							[-66.607902, 18.16413],
							[-66.612755, 18.158878],
							[-66.622685, 18.156951],
							[-66.623712, 18.156329],
							[-66.625859, 18.157016],
							[-66.626762, 18.157654],
							[-66.627095, 18.158576],
							[-66.6287, 18.158627],
							[-66.629675, 18.157126],
							[-66.632258, 18.153523],
							[-66.631011, 18.15046],
							[-66.631721, 18.149772],
							[-66.638793, 18.153781],
							[-66.639008, 18.154351],
							[-66.640899, 18.15514],
							[-66.641528, 18.154882],
							[-66.642348, 18.155109],
							[-66.649549, 18.158864],
							[-66.651367, 18.16585],
							[-66.651774, 18.16701],
							[-66.654548, 18.16959],
							[-66.651751, 18.173423],
							[-66.650668, 18.174234],
							[-66.650835, 18.175305],
							[-66.65149, 18.179265],
							[-66.652243, 18.182497],
							[-66.647679, 18.18374],
							[-66.645363, 18.183685],
							[-66.643143, 18.182747],
							[-66.642208, 18.183241],
							[-66.640951, 18.187034],
							[-66.642107, 18.192709],
							[-66.643184, 18.195802],
							[-66.641849, 18.196424],
							[-66.64082, 18.198268],
							[-66.640507, 18.19921],
							[-66.640079, 18.200336],
							[-66.639886, 18.201192],
							[-66.638963, 18.205358],
							[-66.637139, 18.207565],
							[-66.633104, 18.211338],
							[-66.631731, 18.213487],
							[-66.628531, 18.21431],
							[-66.629013, 18.218088],
							[-66.629528, 18.220636],
							[-66.628078, 18.226475],
							[-66.62908, 18.232052],
							[-66.630068, 18.23471],
							[-66.629193, 18.235822],
							[-66.628902, 18.236297],
							[-66.626507, 18.233534],
							[-66.625562, 18.235474],
							[-66.624977, 18.246876],
							[-66.622076, 18.248631],
							[-66.619665, 18.249337],
							[-66.618319, 18.248851],
							[-66.614781, 18.243881],
							[-66.611687, 18.24144],
							[-66.607883, 18.239841],
							[-66.606736, 18.23848],
							[-66.604633, 18.242935],
							[-66.603811, 18.246213],
							[-66.604755, 18.246721],
							[-66.600443, 18.252027],
							[-66.597376, 18.260204],
							[-66.597985, 18.261748],
							[-66.601121, 18.264248],
							[-66.601169, 18.264301],
							[-66.599068, 18.267794],
							[-66.596532, 18.270578],
							[-66.5953, 18.276795],
							[-66.597089, 18.281135],
							[-66.598714, 18.281952],
							[-66.597352, 18.284255],
							[-66.595023, 18.284774],
							[-66.590293, 18.283551],
							[-66.590293, 18.283396],
							[-66.582541, 18.284252],
							[-66.577994, 18.284388],
							[-66.574535, 18.288689],
							[-66.574039, 18.291543],
							[-66.573387, 18.290802],
							[-66.573361, 18.294928],
							[-66.574364, 18.295939],
							[-66.573204, 18.300373],
							[-66.566665, 18.298583],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '037',
					name: 'Ceiba',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.753591, 18.296755],
							[-65.748684, 18.292848],
							[-65.748088, 18.292551],
							[-65.745493, 18.291289],
							[-65.741698, 18.288048],
							[-65.737719, 18.283089],
							[-65.738579, 18.280825],
							[-65.738217, 18.275145],
							[-65.737455, 18.273756],
							[-65.735771, 18.273693],
							[-65.735111, 18.274917],
							[-65.732358, 18.274909],
							[-65.719305, 18.269733],
							[-65.718267, 18.268244],
							[-65.715848, 18.267548],
							[-65.704304, 18.272736],
							[-65.703746, 18.271592],
							[-65.70011, 18.272986],
							[-65.702048, 18.275079],
							[-65.70229, 18.276159],
							[-65.70065, 18.28005],
							[-65.696384, 18.284666],
							[-65.694913, 18.285661],
							[-65.691653, 18.28394],
							[-65.690049, 18.282452],
							[-65.689869, 18.280904],
							[-65.686969, 18.279247],
							[-65.686363, 18.278267],
							[-65.682958, 18.275663],
							[-65.680985, 18.274859],
							[-65.67926, 18.274586],
							[-65.675735, 18.277884],
							[-65.674752, 18.279724],
							[-65.674925, 18.283366],
							[-65.672946, 18.283631],
							[-65.668161, 18.284751],
							[-65.666277, 18.287891],
							[-65.665177, 18.287685],
							[-65.656268, 18.283695],
							[-65.653341, 18.282794],
							[-65.646662, 18.281749],
							[-65.640786, 18.282298],
							[-65.638822, 18.284],
							[-65.636046, 18.2845],
							[-65.63489364640242, 18.283923502211348],
							[-65.630833, 18.264989],
							[-65.623111, 18.248012],
							[-65.597618, 18.234289],
							[-65.589947, 18.228225],
							[-65.593795, 18.224059],
							[-65.61139873672396, 18.22670122677773],
							[-65.615981, 18.227389],
							[-65.62224637351115, 18.232106971960253],
							[-65.626731, 18.235484],
							[-65.638181, 18.229121],
							[-65.637565, 18.224444],
							[-65.63676992212771, 18.222767568184278],
							[-65.63444705781735, 18.21786977921384],
							[-65.63194300682449, 18.212589955816686],
							[-65.63019071676833, 18.20889522992512],
							[-65.628414, 18.205149],
							[-65.635281, 18.199975],
							[-65.639688, 18.205656],
							[-65.65825334814302, 18.206780297853904],
							[-65.66053950200288, 18.206918744914447],
							[-65.6622178749665, 18.207020385406537],
							[-65.661073, 18.20908],
							[-65.661328, 18.210215],
							[-65.663774, 18.212642],
							[-65.664292, 18.21448],
							[-65.662405, 18.215227],
							[-65.660232, 18.217622],
							[-65.658071, 18.223059],
							[-65.65825, 18.224591],
							[-65.658259, 18.224709],
							[-65.658709, 18.224743],
							[-65.662034, 18.225139],
							[-65.666376, 18.223182],
							[-65.670722, 18.222998],
							[-65.671669, 18.223664],
							[-65.672654, 18.224805],
							[-65.675363, 18.225271],
							[-65.677603, 18.226702],
							[-65.677893, 18.226883],
							[-65.682269, 18.228791],
							[-65.684157, 18.230408],
							[-65.689318, 18.23379],
							[-65.692583, 18.239175],
							[-65.689863, 18.241647],
							[-65.683043, 18.248663],
							[-65.682114, 18.251843],
							[-65.682203, 18.251858],
							[-65.684234, 18.253503],
							[-65.688437, 18.251596],
							[-65.693356, 18.250756],
							[-65.694418, 18.251901],
							[-65.695735, 18.25543],
							[-65.697189, 18.256708],
							[-65.702475, 18.259497],
							[-65.705697, 18.256496],
							[-65.707608, 18.255882],
							[-65.70971, 18.256541],
							[-65.71126, 18.255808],
							[-65.718779, 18.257602],
							[-65.719771, 18.257736],
							[-65.719812, 18.257746],
							[-65.721749, 18.257372],
							[-65.721849, 18.254333],
							[-65.721345, 18.252405],
							[-65.729865, 18.252922],
							[-65.732285, 18.254386],
							[-65.73218, 18.255352],
							[-65.735344, 18.256056],
							[-65.736217, 18.258046],
							[-65.739352, 18.260759],
							[-65.747587, 18.262811],
							[-65.749606, 18.262807],
							[-65.751511, 18.263623],
							[-65.756362, 18.267574],
							[-65.757972, 18.267523],
							[-65.762401, 18.271332],
							[-65.764652, 18.278267],
							[-65.766832, 18.280004],
							[-65.765594, 18.283391],
							[-65.762365, 18.288638],
							[-65.758862, 18.290604],
							[-65.753591, 18.296755],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 103,
					name: 'Naguabo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.800477, 18.289887],
							[-65.799336, 18.288906],
							[-65.796725, 18.288925],
							[-65.795543, 18.289512],
							[-65.794137, 18.292036],
							[-65.794333, 18.294765],
							[-65.793416, 18.295876],
							[-65.793223, 18.296529],
							[-65.790472, 18.295356],
							[-65.783334, 18.291761],
							[-65.77936, 18.286235],
							[-65.776275, 18.283987],
							[-65.774235, 18.2817],
							[-65.766832, 18.280004],
							[-65.764652, 18.278267],
							[-65.762401, 18.271332],
							[-65.757972, 18.267523],
							[-65.756362, 18.267574],
							[-65.751511, 18.263623],
							[-65.749606, 18.262807],
							[-65.747587, 18.262811],
							[-65.739352, 18.260759],
							[-65.736217, 18.258046],
							[-65.735344, 18.256056],
							[-65.73218, 18.255352],
							[-65.732285, 18.254386],
							[-65.729865, 18.252922],
							[-65.721345, 18.252405],
							[-65.721849, 18.254333],
							[-65.721749, 18.257372],
							[-65.719812, 18.257746],
							[-65.719771, 18.257736],
							[-65.718779, 18.257602],
							[-65.71126, 18.255808],
							[-65.70971, 18.256541],
							[-65.707608, 18.255882],
							[-65.705697, 18.256496],
							[-65.702475, 18.259497],
							[-65.697189, 18.256708],
							[-65.695735, 18.25543],
							[-65.694418, 18.251901],
							[-65.693356, 18.250756],
							[-65.688437, 18.251596],
							[-65.684234, 18.253503],
							[-65.682203, 18.251858],
							[-65.682114, 18.251843],
							[-65.683043, 18.248663],
							[-65.689863, 18.241647],
							[-65.692583, 18.239175],
							[-65.689318, 18.23379],
							[-65.684157, 18.230408],
							[-65.682269, 18.228791],
							[-65.677893, 18.226883],
							[-65.677603, 18.226702],
							[-65.675363, 18.225271],
							[-65.672654, 18.224805],
							[-65.671669, 18.223664],
							[-65.670722, 18.222998],
							[-65.666376, 18.223182],
							[-65.662034, 18.225139],
							[-65.658709, 18.224743],
							[-65.658259, 18.224709],
							[-65.65825, 18.224591],
							[-65.658071, 18.223059],
							[-65.660232, 18.217622],
							[-65.662405, 18.215227],
							[-65.664292, 18.21448],
							[-65.663774, 18.212642],
							[-65.661328, 18.210215],
							[-65.661073, 18.20908],
							[-65.6622178749665, 18.207020385406537],
							[-65.66241910074913, 18.20703257142717],
							[-65.66277831071301, 18.207054324802783],
							[-65.664127, 18.207136],
							[-65.66717821595589, 18.20574391567124],
							[-65.68462644763586, 18.19778334839662],
							[-65.6906103242324, 18.195053269321363],
							[-65.690749, 18.19499],
							[-65.694515, 18.187011],
							[-65.69329052661585, 18.18420284166367],
							[-65.691021, 18.178998],
							[-65.695856, 18.179324],
							[-65.70774163205769, 18.18536125934495],
							[-65.710895, 18.186963],
							[-65.712533, 18.189146],
							[-65.71339303029079, 18.18930806205626],
							[-65.717999, 18.190176],
							[-65.72442349528718, 18.187361295609474],
							[-65.728471, 18.185588],
							[-65.734664, 18.180368],
							[-65.738834, 18.174066],
							[-65.73912877120713, 18.173444940780975],
							[-65.73917491039718, 18.17334772921944],
							[-65.739204, 18.173616],
							[-65.740529, 18.176695],
							[-65.740571, 18.182129],
							[-65.741755, 18.182392],
							[-65.746424, 18.18117],
							[-65.74822, 18.179807],
							[-65.749904, 18.177226],
							[-65.750917, 18.176475],
							[-65.751888, 18.176405],
							[-65.754534, 18.177375],
							[-65.76615, 18.182088],
							[-65.765306, 18.184028],
							[-65.764213, 18.18638],
							[-65.760505, 18.195581],
							[-65.766038, 18.198557],
							[-65.76882, 18.197993],
							[-65.777059, 18.199616],
							[-65.785739, 18.204085],
							[-65.786924, 18.203715],
							[-65.79121, 18.204326],
							[-65.79331, 18.206532],
							[-65.796072, 18.205064],
							[-65.796739, 18.204415],
							[-65.797455, 18.203644],
							[-65.798868, 18.204155],
							[-65.799845, 18.2026],
							[-65.800328, 18.202603],
							[-65.804218, 18.20406],
							[-65.80713, 18.205384],
							[-65.812391, 18.204508],
							[-65.816786, 18.205006],
							[-65.817597, 18.205863],
							[-65.819451, 18.205594],
							[-65.819979, 18.204411],
							[-65.822848, 18.203037],
							[-65.824131, 18.200726],
							[-65.826063, 18.200408],
							[-65.831388, 18.214222],
							[-65.83068, 18.218493],
							[-65.828892, 18.229813],
							[-65.825095, 18.238046],
							[-65.823154, 18.242247],
							[-65.82115, 18.246693],
							[-65.817247, 18.252327],
							[-65.815664, 18.262527],
							[-65.819867, 18.267681],
							[-65.82377, 18.268738],
							[-65.82441, 18.27161],
							[-65.824221, 18.273054],
							[-65.821582, 18.275455],
							[-65.811424, 18.290141],
							[-65.805438, 18.288049],
							[-65.802025, 18.290032],
							[-65.800477, 18.289887],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 107,
					name: 'Orocovis',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.377723, 18.293955],
							[-66.37872, 18.291259],
							[-66.378892, 18.288964],
							[-66.382506, 18.27893],
							[-66.383153, 18.275164],
							[-66.38267, 18.274333],
							[-66.377133, 18.273642],
							[-66.374614, 18.270724],
							[-66.37185, 18.268159],
							[-66.365083, 18.260503],
							[-66.364122, 18.259338],
							[-66.358005, 18.250214],
							[-66.357493, 18.248619],
							[-66.357596, 18.24801],
							[-66.358078, 18.246136],
							[-66.350794, 18.241235],
							[-66.351565, 18.23196],
							[-66.351515, 18.231654],
							[-66.350398, 18.227491],
							[-66.351182, 18.224965],
							[-66.352055, 18.224941],
							[-66.353382, 18.226075],
							[-66.354467, 18.222876],
							[-66.353558, 18.219337],
							[-66.351532, 18.218379],
							[-66.352117, 18.211717],
							[-66.352461, 18.210255],
							[-66.350631, 18.206549],
							[-66.350736, 18.205036],
							[-66.352949, 18.198373],
							[-66.351797, 18.195115],
							[-66.351873, 18.194001],
							[-66.352169, 18.1932],
							[-66.354969, 18.192067],
							[-66.356026, 18.192298],
							[-66.358991, 18.197544],
							[-66.359995, 18.198837],
							[-66.363655, 18.200684],
							[-66.364806, 18.1994],
							[-66.367305, 18.196934],
							[-66.367535, 18.195301],
							[-66.367506, 18.193909],
							[-66.367083, 18.192168],
							[-66.364777, 18.186922],
							[-66.36591, 18.185312],
							[-66.366857, 18.185778],
							[-66.37354, 18.184128],
							[-66.373581, 18.181601],
							[-66.372963, 18.180435],
							[-66.373002, 18.175189],
							[-66.373026, 18.175003],
							[-66.373045, 18.17452],
							[-66.373768, 18.173694],
							[-66.375532, 18.173204],
							[-66.37558, 18.173176],
							[-66.382107, 18.172262],
							[-66.387337, 18.172838],
							[-66.388696, 18.17256],
							[-66.389121, 18.170273],
							[-66.390124, 18.168363],
							[-66.391792, 18.166343],
							[-66.392418, 18.166333],
							[-66.394302, 18.166021],
							[-66.401011, 18.164989],
							[-66.403171, 18.166861],
							[-66.405328, 18.165647],
							[-66.405401, 18.165574],
							[-66.407494, 18.164043],
							[-66.413372, 18.163217],
							[-66.416618, 18.164766],
							[-66.421962, 18.168988],
							[-66.42256, 18.171382],
							[-66.430165, 18.172463],
							[-66.431041, 18.173457],
							[-66.43244, 18.173918],
							[-66.433769, 18.174382],
							[-66.434291, 18.1748],
							[-66.435335, 18.175264],
							[-66.435517, 18.175273],
							[-66.439042, 18.175744],
							[-66.444068, 18.176652],
							[-66.445494, 18.175492],
							[-66.451085, 18.177924],
							[-66.451248, 18.177976],
							[-66.452983, 18.17848],
							[-66.453485, 18.178318],
							[-66.453872, 18.178508],
							[-66.453971, 18.178175],
							[-66.457976, 18.176651],
							[-66.459812, 18.17724],
							[-66.460536, 18.177118],
							[-66.461283, 18.177132],
							[-66.461889, 18.177499],
							[-66.46235, 18.177498],
							[-66.46363, 18.178845],
							[-66.465263, 18.177779],
							[-66.465773, 18.177756],
							[-66.467513, 18.177494],
							[-66.469139, 18.177918],
							[-66.470676, 18.177265],
							[-66.472353, 18.175674],
							[-66.472872, 18.172431],
							[-66.475601, 18.172276],
							[-66.477375, 18.170011],
							[-66.483743, 18.168611],
							[-66.489441, 18.166503],
							[-66.491154, 18.167128],
							[-66.492447, 18.166861],
							[-66.496523, 18.166675],
							[-66.501863, 18.164852],
							[-66.504784, 18.163827],
							[-66.504971, 18.163739],
							[-66.508655, 18.160602],
							[-66.510671, 18.159775],
							[-66.512001, 18.157108],
							[-66.513457, 18.155679],
							[-66.516287, 18.154305],
							[-66.519074, 18.154453],
							[-66.521899, 18.151954],
							[-66.52842, 18.152782],
							[-66.530679, 18.152661],
							[-66.537336, 18.149025],
							[-66.538287, 18.148517],
							[-66.540874, 18.14732],
							[-66.542336, 18.147508],
							[-66.547221, 18.15313],
							[-66.546835, 18.155019],
							[-66.544153, 18.158328],
							[-66.543133, 18.163098],
							[-66.538492, 18.160047],
							[-66.531774, 18.156321],
							[-66.526621, 18.159563],
							[-66.523602, 18.161284],
							[-66.517787, 18.166731],
							[-66.515085, 18.167701],
							[-66.512587, 18.165933],
							[-66.51179, 18.166342],
							[-66.510494, 18.177329],
							[-66.512022, 18.17955],
							[-66.512629, 18.181469],
							[-66.514875, 18.185027],
							[-66.514297, 18.191699],
							[-66.510781, 18.198851],
							[-66.512274, 18.202684],
							[-66.514315, 18.214077],
							[-66.515762, 18.218949],
							[-66.516502, 18.228352],
							[-66.517474, 18.229561],
							[-66.50879, 18.229768],
							[-66.507768, 18.231735],
							[-66.506578, 18.236197],
							[-66.507935, 18.238661],
							[-66.509498, 18.23884],
							[-66.511818, 18.242562],
							[-66.508819, 18.24801],
							[-66.508988, 18.24801],
							[-66.508423, 18.24911],
							[-66.506315, 18.250823],
							[-66.502785, 18.250699],
							[-66.501713, 18.252863],
							[-66.501183, 18.256219],
							[-66.501133, 18.256354],
							[-66.499616, 18.255328],
							[-66.497704, 18.252917],
							[-66.494566, 18.252225],
							[-66.487429, 18.252885],
							[-66.482782, 18.252686],
							[-66.480958, 18.251481],
							[-66.478478, 18.250884],
							[-66.476657, 18.25044],
							[-66.475303, 18.249383],
							[-66.472394, 18.247047],
							[-66.466797, 18.245627],
							[-66.460645, 18.249216],
							[-66.45896, 18.249675],
							[-66.457077, 18.249425],
							[-66.454272, 18.250992],
							[-66.454553, 18.25174],
							[-66.454137, 18.256334],
							[-66.455841, 18.257687],
							[-66.452457, 18.256584],
							[-66.444882, 18.257574],
							[-66.441971, 18.259094],
							[-66.437715, 18.255969],
							[-66.437745, 18.256212],
							[-66.428343, 18.260756],
							[-66.42762, 18.260632],
							[-66.412229, 18.262955],
							[-66.409434, 18.263309],
							[-66.401889, 18.267161],
							[-66.400456, 18.267938],
							[-66.397549, 18.269468],
							[-66.392796, 18.273325],
							[-66.390956, 18.273393],
							[-66.389746, 18.274542],
							[-66.38577, 18.284866],
							[-66.384028, 18.290797],
							[-66.38279, 18.291785],
							[-66.377723, 18.293955],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '083',
					name: 'Las Marías',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.038073, 18.289431],
							[-67.037935, 18.289705],
							[-67.0362, 18.287975],
							[-67.033744, 18.289184],
							[-67.033414, 18.289954],
							[-67.031605, 18.289752],
							[-67.031075, 18.288719],
							[-67.031862, 18.286944],
							[-67.033429, 18.285128],
							[-67.038117, 18.284155],
							[-67.038662, 18.283317],
							[-67.039291, 18.28263],
							[-67.037978, 18.280261],
							[-67.022293, 18.281663],
							[-67.020031, 18.280442],
							[-67.019665, 18.279189],
							[-67.018809, 18.277358],
							[-67.017809, 18.276827],
							[-67.015747, 18.277212],
							[-67.014115, 18.278399],
							[-67.006872, 18.279091],
							[-67.001573, 18.276108],
							[-66.992748, 18.275614],
							[-66.990896, 18.276824],
							[-66.982931, 18.274579],
							[-66.982129, 18.274951],
							[-66.975117, 18.274682],
							[-66.972536, 18.272677],
							[-66.97046, 18.268615],
							[-66.970449, 18.266229],
							[-66.969368, 18.263629],
							[-66.967247, 18.26363],
							[-66.965229, 18.265987],
							[-66.965561, 18.268789],
							[-66.965228, 18.271153],
							[-66.964396, 18.271252],
							[-66.962184, 18.270254],
							[-66.959213, 18.271672],
							[-66.946098, 18.273317],
							[-66.945459, 18.272922],
							[-66.945079, 18.271621],
							[-66.941751, 18.266641],
							[-66.9409, 18.26577],
							[-66.942201, 18.263758],
							[-66.940762, 18.261555],
							[-66.936347, 18.258999],
							[-66.933148, 18.256433],
							[-66.932323, 18.253476],
							[-66.930665, 18.253784],
							[-66.928819, 18.254221],
							[-66.927503, 18.255815],
							[-66.927908, 18.256958],
							[-66.928903, 18.2566],
							[-66.929937, 18.257049],
							[-66.930496, 18.258395],
							[-66.924094, 18.260496],
							[-66.921851, 18.257691],
							[-66.912637, 18.254333],
							[-66.908688, 18.252149],
							[-66.907213, 18.253136],
							[-66.906692, 18.25031],
							[-66.906811, 18.246145],
							[-66.908369, 18.244315],
							[-66.911631, 18.23675],
							[-66.912859, 18.233009],
							[-66.904767, 18.208056],
							[-66.901188, 18.196508],
							[-66.901107, 18.196273],
							[-66.900308, 18.193582],
							[-66.90029, 18.193523],
							[-66.898563, 18.187896],
							[-66.914738, 18.192035],
							[-66.941375, 18.198412],
							[-66.945861, 18.199371],
							[-66.94591, 18.201427],
							[-66.947604, 18.201557],
							[-66.950873, 18.201598],
							[-66.953063, 18.200037],
							[-66.956982, 18.200334],
							[-66.958036, 18.199823],
							[-66.957836, 18.204318],
							[-66.963181, 18.205941],
							[-66.966865, 18.206618],
							[-66.970203, 18.204763],
							[-66.971162, 18.204513],
							[-66.977474, 18.207773],
							[-66.97911, 18.207663],
							[-66.98062, 18.206307],
							[-66.987596, 18.20496],
							[-66.989388, 18.204],
							[-66.991225, 18.199986],
							[-66.991545, 18.199914],
							[-66.994132, 18.198866],
							[-66.999622, 18.19765],
							[-67.003518, 18.194089],
							[-67.003803, 18.193501],
							[-67.019837, 18.195471],
							[-67.019574, 18.201022],
							[-67.018857, 18.204522],
							[-67.021987, 18.204711],
							[-67.02515, 18.206071],
							[-67.028532, 18.208823],
							[-67.032184, 18.208735],
							[-67.033166, 18.208175],
							[-67.032963, 18.218056],
							[-67.035943, 18.21944],
							[-67.037391, 18.221402],
							[-67.042242, 18.224316],
							[-67.044234, 18.223968],
							[-67.052054, 18.230719],
							[-67.051357, 18.233504],
							[-67.051698, 18.2348],
							[-67.053016, 18.237276],
							[-67.056749, 18.240281],
							[-67.056916, 18.242729],
							[-67.055926, 18.245346],
							[-67.06193, 18.244835],
							[-67.065193, 18.246412],
							[-67.067439, 18.246316],
							[-67.069876, 18.248008],
							[-67.074247, 18.248008],
							[-67.075569, 18.248664],
							[-67.078617, 18.252505],
							[-67.081164, 18.254889],
							[-67.08199, 18.25496],
							[-67.079009, 18.258748],
							[-67.076025, 18.257592],
							[-67.072077, 18.254757],
							[-67.067478, 18.259016],
							[-67.064892, 18.261482],
							[-67.064916, 18.261556],
							[-67.061828, 18.270082],
							[-67.058575, 18.268881],
							[-67.051613, 18.266876],
							[-67.05175, 18.26829],
							[-67.051237, 18.268519],
							[-67.044438, 18.270994],
							[-67.04201, 18.270959],
							[-67.040408, 18.271871],
							[-67.040749, 18.275497],
							[-67.041201, 18.281924],
							[-67.038073, 18.289431],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '045',
					name: 'Comerío',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.206221, 18.276644],
							[-66.205805, 18.276158],
							[-66.205653, 18.27569],
							[-66.199762, 18.274408],
							[-66.197494, 18.269914],
							[-66.1934, 18.26794],
							[-66.193099, 18.267288],
							[-66.193772, 18.264835],
							[-66.190771, 18.258742],
							[-66.187602, 18.254453],
							[-66.181914, 18.248723],
							[-66.178179, 18.245808],
							[-66.178185, 18.243988],
							[-66.178577, 18.243481],
							[-66.178815, 18.238855],
							[-66.177205, 18.235104],
							[-66.176869, 18.234516],
							[-66.175694, 18.233671],
							[-66.176392, 18.230208],
							[-66.169329, 18.226257],
							[-66.169126, 18.22429],
							[-66.171492, 18.222675],
							[-66.171463, 18.222379],
							[-66.171444, 18.222317],
							[-66.171377, 18.222147],
							[-66.171336, 18.221833],
							[-66.169678, 18.217659],
							[-66.170382, 18.216305],
							[-66.172018, 18.215599],
							[-66.173883, 18.2159],
							[-66.175463, 18.214905],
							[-66.177412, 18.213487],
							[-66.177499, 18.213427],
							[-66.179814, 18.211058],
							[-66.184431, 18.207173],
							[-66.184745, 18.204655],
							[-66.183386, 18.202252],
							[-66.185165, 18.201051],
							[-66.193547, 18.200122],
							[-66.200362, 18.197151],
							[-66.205574, 18.196628],
							[-66.206782, 18.197159],
							[-66.208987, 18.193707],
							[-66.209138, 18.193451],
							[-66.213438, 18.185813],
							[-66.213641, 18.183799],
							[-66.21203, 18.182084],
							[-66.212196, 18.178896],
							[-66.213108, 18.177733],
							[-66.212198, 18.175835],
							[-66.211293, 18.175428],
							[-66.211275, 18.173634],
							[-66.211852, 18.173087],
							[-66.214013, 18.172821],
							[-66.218494, 18.174324],
							[-66.223118, 18.175897],
							[-66.223706, 18.175612],
							[-66.224071, 18.174361],
							[-66.230083, 18.180918],
							[-66.230826, 18.182786],
							[-66.230754, 18.184397],
							[-66.240594, 18.184799],
							[-66.244205, 18.187437],
							[-66.244844, 18.188387],
							[-66.244543, 18.190624],
							[-66.242172, 18.192151],
							[-66.242249, 18.192211],
							[-66.244295, 18.193348],
							[-66.248767, 18.19139],
							[-66.255364, 18.187053],
							[-66.255656, 18.184764],
							[-66.259681, 18.184123],
							[-66.263231, 18.184943],
							[-66.263502, 18.184956],
							[-66.263553, 18.184959],
							[-66.263843, 18.190825],
							[-66.264112, 18.196443],
							[-66.264215, 18.198394],
							[-66.264387, 18.202474],
							[-66.264328, 18.202492],
							[-66.264459, 18.205451],
							[-66.264538, 18.205759],
							[-66.26543, 18.206326],
							[-66.266314, 18.207067],
							[-66.267518, 18.209093],
							[-66.26773, 18.210379],
							[-66.268023, 18.211208],
							[-66.269211, 18.21389],
							[-66.270994, 18.217433],
							[-66.270286, 18.219305],
							[-66.269384, 18.222013],
							[-66.268966, 18.223249],
							[-66.268469, 18.224558],
							[-66.268332, 18.224911],
							[-66.267383, 18.227642],
							[-66.265579, 18.232835],
							[-66.265807, 18.236787],
							[-66.268412, 18.242106],
							[-66.266377, 18.24528],
							[-66.265416, 18.246869],
							[-66.263978, 18.246552],
							[-66.263456, 18.246425],
							[-66.257121, 18.247422],
							[-66.249489, 18.249267],
							[-66.247249, 18.248583],
							[-66.245109, 18.249218],
							[-66.243608, 18.25084],
							[-66.242804, 18.252715],
							[-66.238358, 18.253991],
							[-66.23787, 18.253978],
							[-66.232884, 18.255017],
							[-66.228943, 18.253759],
							[-66.227784, 18.254467],
							[-66.22809, 18.257154],
							[-66.228805, 18.258641],
							[-66.228157, 18.262674],
							[-66.222968, 18.264916],
							[-66.219257, 18.27405],
							[-66.219139, 18.274213],
							[-66.207739, 18.276797],
							[-66.206221, 18.276644],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '085',
					name: 'Las Piedras',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.82885, 18.272157],
							[-65.824221, 18.273054],
							[-65.82441, 18.27161],
							[-65.82377, 18.268738],
							[-65.819867, 18.267681],
							[-65.815664, 18.262527],
							[-65.817247, 18.252327],
							[-65.82115, 18.246693],
							[-65.823154, 18.242247],
							[-65.825095, 18.238046],
							[-65.828892, 18.229813],
							[-65.83068, 18.218493],
							[-65.831388, 18.214222],
							[-65.826063, 18.200408],
							[-65.825721, 18.192406],
							[-65.827775, 18.187814],
							[-65.828037, 18.187212],
							[-65.830202, 18.185253],
							[-65.832723, 18.184306],
							[-65.835293, 18.180034],
							[-65.835944, 18.177884],
							[-65.836615, 18.175296],
							[-65.842111, 18.177122],
							[-65.842274, 18.177124],
							[-65.845852, 18.178337],
							[-65.846621, 18.177993],
							[-65.849917, 18.176037],
							[-65.852459, 18.176669],
							[-65.854868, 18.176826],
							[-65.855635, 18.175679],
							[-65.856487, 18.17285],
							[-65.855941, 18.171692],
							[-65.855019, 18.169636],
							[-65.855, 18.169482],
							[-65.855315, 18.169139],
							[-65.855576, 18.16738],
							[-65.855626, 18.167289],
							[-65.855675, 18.1672],
							[-65.856382, 18.164441],
							[-65.85703, 18.164683],
							[-65.857911, 18.162922],
							[-65.861945, 18.155855],
							[-65.861886, 18.153748],
							[-65.861745, 18.151343],
							[-65.861801, 18.147022],
							[-65.861329, 18.145727],
							[-65.864387, 18.139382],
							[-65.864979, 18.138779],
							[-65.867542, 18.137789],
							[-65.871745, 18.129836],
							[-65.873384, 18.129068],
							[-65.874152, 18.128469],
							[-65.875558, 18.12526],
							[-65.875565, 18.124972],
							[-65.875987, 18.123016],
							[-65.877625, 18.1181],
							[-65.880496, 18.118763],
							[-65.880677, 18.118852],
							[-65.882226, 18.119818],
							[-65.88362, 18.12236],
							[-65.885087, 18.122522],
							[-65.889361, 18.121313],
							[-65.892892, 18.122436],
							[-65.893153, 18.122504],
							[-65.893226, 18.122571],
							[-65.893496, 18.123016],
							[-65.893717, 18.12337],
							[-65.894047, 18.123839],
							[-65.894701, 18.124133],
							[-65.899459, 18.124008],
							[-65.900504, 18.125405],
							[-65.900525, 18.125426],
							[-65.907422, 18.126118],
							[-65.909524, 18.123844],
							[-65.910256, 18.123598],
							[-65.913982, 18.123016],
							[-65.914649, 18.122278],
							[-65.919638, 18.120975],
							[-65.920763, 18.121312],
							[-65.921893, 18.121416],
							[-65.924266, 18.121558],
							[-65.924635, 18.121565],
							[-65.926266, 18.119969],
							[-65.9275, 18.122232],
							[-65.926913, 18.123415],
							[-65.92673, 18.124555],
							[-65.925214, 18.128643],
							[-65.92554, 18.130238],
							[-65.925718, 18.13119],
							[-65.925657, 18.131341],
							[-65.925302, 18.134446],
							[-65.924658, 18.135346],
							[-65.921102, 18.135876],
							[-65.920561, 18.137255],
							[-65.921338, 18.138156],
							[-65.926177, 18.138954],
							[-65.927582, 18.142126],
							[-65.928019, 18.142585],
							[-65.928287, 18.142848],
							[-65.926549, 18.143917],
							[-65.926069, 18.144188],
							[-65.925211, 18.145875],
							[-65.924386, 18.147187],
							[-65.916474, 18.160937],
							[-65.916112, 18.164384],
							[-65.91605, 18.16438],
							[-65.910423, 18.174838],
							[-65.910228, 18.175142],
							[-65.906651, 18.17991],
							[-65.904714, 18.182632],
							[-65.904441, 18.183011],
							[-65.902909, 18.185975],
							[-65.902917, 18.186732],
							[-65.901133, 18.192709],
							[-65.898922, 18.195505],
							[-65.896429, 18.201032],
							[-65.896034, 18.202547],
							[-65.895077, 18.201404],
							[-65.895006, 18.201297],
							[-65.893185, 18.200232],
							[-65.890776, 18.20005],
							[-65.890583, 18.200029],
							[-65.887737, 18.198624],
							[-65.887556, 18.198454],
							[-65.886746, 18.199966],
							[-65.886366, 18.200684],
							[-65.882631, 18.207989],
							[-65.874782, 18.215909],
							[-65.869165, 18.220957],
							[-65.86558, 18.228374],
							[-65.861904, 18.23491],
							[-65.861844, 18.235021],
							[-65.858043, 18.242068],
							[-65.851934, 18.248011],
							[-65.851729, 18.249401],
							[-65.853224, 18.250714],
							[-65.85331, 18.253199],
							[-65.852639, 18.25483],
							[-65.849541, 18.256144],
							[-65.846331, 18.258016],
							[-65.845751, 18.259701],
							[-65.842098, 18.264395],
							[-65.840316, 18.265025],
							[-65.839854, 18.265696],
							[-65.839386, 18.271074],
							[-65.838595, 18.273689],
							[-65.836387, 18.275246],
							[-65.833592, 18.272742],
							[-65.831718, 18.271736],
							[-65.82885, 18.272157],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '097',
					name: 'Mayagüez',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.16033, 18.273125],
							[-67.157755, 18.273152],
							[-67.153317, 18.271416],
							[-67.149028, 18.268451],
							[-67.148298, 18.269022],
							[-67.148291, 18.269353],
							[-67.1484, 18.269631],
							[-67.148396, 18.269694],
							[-67.148391, 18.269769],
							[-67.149681, 18.270271],
							[-67.149492, 18.271483],
							[-67.149164, 18.271609],
							[-67.147521, 18.271663],
							[-67.144522, 18.269085],
							[-67.143495, 18.267705],
							[-67.143294, 18.267907],
							[-67.142687, 18.268279],
							[-67.142571, 18.268412],
							[-67.142786, 18.269718],
							[-67.142643, 18.270306],
							[-67.141582, 18.269815],
							[-67.14153, 18.267666],
							[-67.141377, 18.267022],
							[-67.141101, 18.267062],
							[-67.140785, 18.2668],
							[-67.140626, 18.266736],
							[-67.138647, 18.265489],
							[-67.13568, 18.26496],
							[-67.135134, 18.264494],
							[-67.13469, 18.264312],
							[-67.135084, 18.264023],
							[-67.135142, 18.263965],
							[-67.136081, 18.262626],
							[-67.134859, 18.262137],
							[-67.135076, 18.261233],
							[-67.137129, 18.260553],
							[-67.138668, 18.259501],
							[-67.138345, 18.255028],
							[-67.137884, 18.253874],
							[-67.135442, 18.251393],
							[-67.134352, 18.249608],
							[-67.134771, 18.248822],
							[-67.136237, 18.248008],
							[-67.136386, 18.246939],
							[-67.135442, 18.245743],
							[-67.127715, 18.245651],
							[-67.124695, 18.244486],
							[-67.123072, 18.242789],
							[-67.118988, 18.24836],
							[-67.118767, 18.248383],
							[-67.116927, 18.247561],
							[-67.114618, 18.247354],
							[-67.109489, 18.249108],
							[-67.107919, 18.25099],
							[-67.107854, 18.251895],
							[-67.105495, 18.252858],
							[-67.096633, 18.252646],
							[-67.094022, 18.249715],
							[-67.091321, 18.249896],
							[-67.090407, 18.249593],
							[-67.086799, 18.249252],
							[-67.08199, 18.25496],
							[-67.081164, 18.254889],
							[-67.078617, 18.252505],
							[-67.075569, 18.248664],
							[-67.074247, 18.248008],
							[-67.069876, 18.248008],
							[-67.067439, 18.246316],
							[-67.065193, 18.246412],
							[-67.06193, 18.244835],
							[-67.055926, 18.245346],
							[-67.056916, 18.242729],
							[-67.056749, 18.240281],
							[-67.053016, 18.237276],
							[-67.051698, 18.2348],
							[-67.051357, 18.233504],
							[-67.052054, 18.230719],
							[-67.044234, 18.223968],
							[-67.042242, 18.224316],
							[-67.037391, 18.221402],
							[-67.035943, 18.21944],
							[-67.032963, 18.218056],
							[-67.033166, 18.208175],
							[-67.032184, 18.208735],
							[-67.028532, 18.208823],
							[-67.02515, 18.206071],
							[-67.021987, 18.204711],
							[-67.018857, 18.204522],
							[-67.019574, 18.201022],
							[-67.019837, 18.195471],
							[-67.017385, 18.189893],
							[-67.017981, 18.188125],
							[-67.019408, 18.186822],
							[-67.023743, 18.18461],
							[-67.027429, 18.18565],
							[-67.02919, 18.185623],
							[-67.031312, 18.184848],
							[-67.033911, 18.185463],
							[-67.034168, 18.182912],
							[-67.035048, 18.180584],
							[-67.040947, 18.177809],
							[-67.045742, 18.176204],
							[-67.050589, 18.176973],
							[-67.051138, 18.177436],
							[-67.051462, 18.174026],
							[-67.051498, 18.173828],
							[-67.0523, 18.172433],
							[-67.053697, 18.171905],
							[-67.056672, 18.173124],
							[-67.060478, 18.173773],
							[-67.065576, 18.172292],
							[-67.068119, 18.172909],
							[-67.072309, 18.17303],
							[-67.077074, 18.169112],
							[-67.078614, 18.167481],
							[-67.081229, 18.167689],
							[-67.084489, 18.164977],
							[-67.085863, 18.162727],
							[-67.085221, 18.158056],
							[-67.087123, 18.15533],
							[-67.086349, 18.149832],
							[-67.086464, 18.149757],
							[-67.089094, 18.151122],
							[-67.092908, 18.152145],
							[-67.097987, 18.15865],
							[-67.099311, 18.157434],
							[-67.100993, 18.157008],
							[-67.107587, 18.159528],
							[-67.111271, 18.15979],
							[-67.113116, 18.159936],
							[-67.117776, 18.158053],
							[-67.12083, 18.156003],
							[-67.122759, 18.15644],
							[-67.124624, 18.157927],
							[-67.12859, 18.157886],
							[-67.131365, 18.156381],
							[-67.136693, 18.151983],
							[-67.137779, 18.152979],
							[-67.138037, 18.153358],
							[-67.144598, 18.154105],
							[-67.147093, 18.155067],
							[-67.15047, 18.154041],
							[-67.157582, 18.156164],
							[-67.159708, 18.153157],
							[-67.161934, 18.152319],
							[-67.163707, 18.154793],
							[-67.166936, 18.15582],
							[-67.166531, 18.156496],
							[-67.170328, 18.158944],
							[-67.171788, 18.16012],
							[-67.173482, 18.162967],
							[-67.177355, 18.165117],
							[-67.180009, 18.168048],
							[-67.18055209145241, 18.168338689812515],
							[-67.1710363533324, 18.178340292159987],
							[-67.1607863974162, 18.189113600742022],
							[-67.15560282322745, 18.194561843129584],
							[-67.155185, 18.195001],
							[-67.15318240982668, 18.201749411012642],
							[-67.152665, 18.203493],
							[-67.1544966792673, 18.20803306559019],
							[-67.1559431435812, 18.211618323651592],
							[-67.15697622028286, 18.214178944426745],
							[-67.158001, 18.216719],
							[-67.16197312095773, 18.22041252430144],
							[-67.17181154811696, 18.229560903766068],
							[-67.17225677644029, 18.229974904661162],
							[-67.173, 18.230666],
							[-67.1743485039003, 18.240293729369707],
							[-67.17522669806493, 18.246563652466886],
							[-67.175429, 18.248008],
							[-67.17781695797821, 18.251598016090483],
							[-67.18783706143796, 18.266662072065145],
							[-67.18603, 18.266965],
							[-67.183628, 18.26687],
							[-67.181456, 18.267131],
							[-67.181375, 18.267141],
							[-67.178945, 18.267391],
							[-67.178767, 18.2674],
							[-67.171566, 18.26841],
							[-67.169084, 18.269093],
							[-67.165468, 18.270092],
							[-67.162976, 18.271396],
							[-67.162218, 18.272016],
							[-67.161481, 18.272728],
							[-67.161144, 18.273011],
							[-67.16033, 18.273125],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '077',
					name: 'Juncos',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.921896, 18.26922],
							[-65.918535, 18.27013],
							[-65.916356, 18.268776],
							[-65.914512, 18.267782],
							[-65.914026, 18.267369],
							[-65.912671, 18.266219],
							[-65.91238, 18.266045],
							[-65.911453, 18.265575],
							[-65.906765, 18.26573],
							[-65.904349, 18.265123],
							[-65.896943, 18.261209],
							[-65.891571, 18.261118],
							[-65.889216, 18.261757],
							[-65.885945, 18.260098],
							[-65.8822, 18.256977],
							[-65.881455, 18.256586],
							[-65.88038, 18.256664],
							[-65.874608, 18.253081],
							[-65.873731, 18.252589],
							[-65.867658, 18.253171],
							[-65.866227, 18.255789],
							[-65.861489, 18.256946],
							[-65.858468, 18.255985],
							[-65.857407, 18.256072],
							[-65.852639, 18.25483],
							[-65.85331, 18.253199],
							[-65.853224, 18.250714],
							[-65.851729, 18.249401],
							[-65.851934, 18.248011],
							[-65.858043, 18.242068],
							[-65.861844, 18.235021],
							[-65.861904, 18.23491],
							[-65.86558, 18.228374],
							[-65.869165, 18.220957],
							[-65.874782, 18.215909],
							[-65.882631, 18.207989],
							[-65.886366, 18.200684],
							[-65.886746, 18.199966],
							[-65.887556, 18.198454],
							[-65.887737, 18.198624],
							[-65.890583, 18.200029],
							[-65.890776, 18.20005],
							[-65.893185, 18.200232],
							[-65.895006, 18.201297],
							[-65.895077, 18.201404],
							[-65.896034, 18.202547],
							[-65.896429, 18.201032],
							[-65.898922, 18.195505],
							[-65.901133, 18.192709],
							[-65.902917, 18.186732],
							[-65.902909, 18.185975],
							[-65.904441, 18.183011],
							[-65.904714, 18.182632],
							[-65.906651, 18.17991],
							[-65.910228, 18.175142],
							[-65.910423, 18.174838],
							[-65.91605, 18.16438],
							[-65.916112, 18.164384],
							[-65.916474, 18.160937],
							[-65.924386, 18.147187],
							[-65.925211, 18.145875],
							[-65.926069, 18.144188],
							[-65.926549, 18.143917],
							[-65.928287, 18.142848],
							[-65.928537, 18.143119],
							[-65.928901, 18.143785],
							[-65.928584, 18.144102],
							[-65.928162, 18.144349],
							[-65.928003, 18.144607],
							[-65.92806, 18.145751],
							[-65.928106, 18.148044],
							[-65.928034, 18.148127],
							[-65.927966, 18.148156],
							[-65.928211, 18.14997],
							[-65.928362, 18.153475],
							[-65.928549, 18.154196],
							[-65.928688, 18.154412],
							[-65.929874, 18.157073],
							[-65.931472, 18.160755],
							[-65.931491, 18.161017],
							[-65.931915, 18.161652],
							[-65.9319, 18.161868],
							[-65.931721, 18.162239],
							[-65.929666, 18.163915],
							[-65.931357, 18.169898],
							[-65.930703, 18.172481],
							[-65.930658, 18.173473],
							[-65.930667, 18.173571],
							[-65.930709, 18.176522],
							[-65.930671, 18.176593],
							[-65.931046, 18.177809],
							[-65.930604, 18.177643],
							[-65.928577, 18.177221],
							[-65.927275, 18.177195],
							[-65.927812, 18.179711],
							[-65.927076, 18.181819],
							[-65.927334, 18.182805],
							[-65.928367, 18.189618],
							[-65.928194, 18.190528],
							[-65.928966, 18.191498],
							[-65.92981, 18.193482],
							[-65.929695, 18.193829],
							[-65.929298, 18.195736],
							[-65.92929, 18.195786],
							[-65.933652, 18.196168],
							[-65.933774, 18.196306],
							[-65.934978, 18.197671],
							[-65.935267, 18.197974],
							[-65.935406, 18.198129],
							[-65.937128, 18.199599],
							[-65.93785, 18.200679],
							[-65.946994, 18.209066],
							[-65.947061, 18.209182],
							[-65.94756, 18.21084],
							[-65.947516, 18.210794],
							[-65.947546, 18.21199],
							[-65.947756, 18.212609],
							[-65.949253, 18.213434],
							[-65.951008, 18.217817],
							[-65.951481, 18.220243],
							[-65.951549, 18.22036],
							[-65.950879, 18.222858],
							[-65.951123, 18.224784],
							[-65.95113, 18.224883],
							[-65.949989, 18.226147],
							[-65.949053, 18.226643],
							[-65.951048, 18.229272],
							[-65.948071, 18.229707],
							[-65.949383, 18.231662],
							[-65.944631, 18.233239],
							[-65.943196, 18.231931],
							[-65.941477, 18.232386],
							[-65.940001, 18.2347],
							[-65.941911, 18.237067],
							[-65.942762, 18.2393],
							[-65.946258, 18.241298],
							[-65.94789, 18.241653],
							[-65.9493, 18.244103],
							[-65.946016, 18.244262],
							[-65.94529, 18.245322],
							[-65.945317, 18.246566],
							[-65.945236, 18.247058],
							[-65.945698, 18.249175],
							[-65.946281, 18.252512],
							[-65.945113, 18.253229],
							[-65.943835, 18.25317],
							[-65.943148, 18.252751],
							[-65.942452, 18.251299],
							[-65.940811, 18.250336],
							[-65.940771, 18.250416],
							[-65.936462, 18.259181],
							[-65.931075, 18.264839],
							[-65.930475, 18.265631],
							[-65.925645, 18.268682],
							[-65.921896, 18.26922],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '001',
					name: 'Adjuntas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.756197, 18.223709],
							[-66.748107, 18.222169],
							[-66.741288, 18.221655],
							[-66.739359, 18.220517],
							[-66.735977, 18.224199],
							[-66.732181, 18.225759],
							[-66.729926, 18.22526],
							[-66.726751, 18.223402],
							[-66.724771, 18.220887],
							[-66.72328, 18.221304],
							[-66.722878, 18.221074],
							[-66.720257, 18.221834],
							[-66.718655, 18.220429],
							[-66.716061, 18.221279],
							[-66.715743, 18.220688],
							[-66.706846, 18.216596],
							[-66.704537, 18.216791],
							[-66.70314, 18.217018],
							[-66.700079, 18.215995],
							[-66.696302, 18.215342],
							[-66.691841, 18.211802],
							[-66.688257, 18.210183],
							[-66.68772, 18.209816],
							[-66.681163, 18.203515],
							[-66.681099, 18.202391],
							[-66.681308, 18.20045],
							[-66.682675, 18.198486],
							[-66.685092, 18.197072],
							[-66.684752, 18.194101],
							[-66.683442, 18.191745],
							[-66.681684, 18.18832],
							[-66.680168, 18.185958],
							[-66.67301, 18.182116],
							[-66.669652, 18.17881],
							[-66.665412, 18.175725],
							[-66.664847, 18.174585],
							[-66.665905, 18.171509],
							[-66.667299, 18.170304],
							[-66.667568, 18.169908],
							[-66.669141, 18.167498],
							[-66.671304, 18.167408],
							[-66.671776, 18.166734],
							[-66.670252, 18.165639],
							[-66.670577, 18.163786],
							[-66.670962, 18.163637],
							[-66.676578, 18.16026],
							[-66.676625, 18.160286],
							[-66.676235, 18.155841],
							[-66.67678, 18.153197],
							[-66.677194, 18.152895],
							[-66.676983, 18.150767],
							[-66.675863, 18.15046],
							[-66.670494, 18.152831],
							[-66.672735, 18.146848],
							[-66.672313, 18.145902],
							[-66.673341, 18.140087],
							[-66.674786, 18.135421],
							[-66.676966, 18.12993],
							[-66.680939, 18.129411],
							[-66.682942, 18.130342],
							[-66.684784, 18.131629],
							[-66.686329, 18.13166],
							[-66.68823, 18.131259],
							[-66.690694, 18.129625],
							[-66.693097, 18.130163],
							[-66.694071, 18.130534],
							[-66.69495, 18.130743],
							[-66.697643, 18.130713],
							[-66.698249, 18.130601],
							[-66.702546, 18.129013],
							[-66.704887, 18.129695],
							[-66.705953, 18.129501],
							[-66.706889, 18.129308],
							[-66.707917, 18.129169],
							[-66.710227, 18.127932],
							[-66.713521, 18.131311],
							[-66.714304, 18.131932],
							[-66.714708, 18.131833],
							[-66.716463, 18.131469],
							[-66.717164, 18.131519],
							[-66.717035, 18.13066],
							[-66.717454, 18.129184],
							[-66.717589, 18.128912],
							[-66.718156, 18.128002],
							[-66.723578, 18.123015],
							[-66.725138, 18.121275],
							[-66.725619, 18.120413],
							[-66.725182, 18.116794],
							[-66.727169, 18.113876],
							[-66.7275, 18.113018],
							[-66.731398, 18.111907],
							[-66.737791, 18.115806],
							[-66.739437, 18.116624],
							[-66.739464, 18.116992],
							[-66.74649, 18.115787],
							[-66.747489, 18.115392],
							[-66.747747, 18.114394],
							[-66.749619, 18.113664],
							[-66.754781, 18.119909],
							[-66.754839, 18.120061],
							[-66.756192, 18.122618],
							[-66.756756, 18.125215],
							[-66.759058, 18.128964],
							[-66.763972, 18.132614],
							[-66.764707, 18.132646],
							[-66.76546, 18.133705],
							[-66.767131, 18.135002],
							[-66.76905, 18.134983],
							[-66.774494, 18.133197],
							[-66.780771, 18.135948],
							[-66.782322, 18.136463],
							[-66.7844, 18.138652],
							[-66.786712, 18.136803],
							[-66.788544, 18.134404],
							[-66.789359, 18.134369],
							[-66.790587, 18.134821],
							[-66.794012, 18.133633],
							[-66.797558, 18.133445],
							[-66.799881, 18.138049],
							[-66.802328, 18.140071],
							[-66.803395, 18.142784],
							[-66.803414, 18.145374],
							[-66.804058, 18.148056],
							[-66.817006, 18.150581],
							[-66.818091, 18.150509],
							[-66.821028, 18.152818],
							[-66.826278, 18.160216],
							[-66.823959, 18.167529],
							[-66.826359, 18.169207],
							[-66.827331, 18.171256],
							[-66.827174, 18.17155],
							[-66.826506, 18.172189],
							[-66.824803, 18.173755],
							[-66.826076, 18.174399],
							[-66.82699, 18.174467],
							[-66.827585, 18.175508],
							[-66.827449, 18.178356],
							[-66.830423, 18.179672],
							[-66.832304, 18.181056],
							[-66.832712, 18.181976],
							[-66.83372, 18.182379],
							[-66.833932, 18.18239],
							[-66.834321, 18.182419],
							[-66.834142, 18.184064],
							[-66.834495, 18.184569],
							[-66.835726, 18.185292],
							[-66.836297, 18.185862],
							[-66.835531, 18.187581],
							[-66.835701, 18.189329],
							[-66.832735, 18.195672],
							[-66.833064, 18.196693],
							[-66.834795, 18.198514],
							[-66.835056, 18.200039],
							[-66.834519, 18.201748],
							[-66.834094, 18.202797],
							[-66.835256, 18.209981],
							[-66.832849, 18.215189],
							[-66.834978, 18.218186],
							[-66.834092, 18.220317],
							[-66.832624, 18.221439],
							[-66.830634, 18.221005],
							[-66.829815, 18.220016],
							[-66.829143, 18.221239],
							[-66.82942, 18.223229],
							[-66.832303, 18.227509],
							[-66.833232, 18.228108],
							[-66.830437, 18.231179],
							[-66.829142, 18.231802],
							[-66.825683, 18.232624],
							[-66.823141, 18.23233],
							[-66.822951, 18.232136],
							[-66.817282, 18.230047],
							[-66.815581, 18.230239],
							[-66.814428, 18.229935],
							[-66.813007, 18.228919],
							[-66.804917, 18.228114],
							[-66.802943, 18.227497],
							[-66.800766, 18.227827],
							[-66.798808, 18.230009],
							[-66.799962, 18.234073],
							[-66.800829, 18.240715],
							[-66.800178, 18.24281],
							[-66.79913, 18.243656],
							[-66.795493, 18.243828],
							[-66.794318, 18.249869],
							[-66.781933, 18.250417],
							[-66.777401, 18.247477],
							[-66.777416, 18.246741],
							[-66.775162, 18.242595],
							[-66.773785, 18.24138],
							[-66.764719, 18.237363],
							[-66.764258, 18.237137],
							[-66.763876, 18.235027],
							[-66.760467, 18.228573],
							[-66.756281, 18.224926],
							[-66.756197, 18.223709],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '019',
					name: 'Barranquitas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.313439, 18.249346],
							[-66.313808, 18.248352],
							[-66.313425, 18.248139],
							[-66.311458, 18.24801],
							[-66.311449, 18.24801],
							[-66.311173, 18.246853],
							[-66.311011, 18.246156],
							[-66.310749, 18.245717],
							[-66.310676, 18.245057],
							[-66.307804, 18.242747],
							[-66.307355, 18.241729],
							[-66.307073, 18.241481],
							[-66.306488, 18.240967],
							[-66.305307, 18.241579],
							[-66.303927, 18.24323],
							[-66.301636, 18.244738],
							[-66.293847, 18.246182],
							[-66.293597, 18.245591],
							[-66.290146, 18.244903],
							[-66.280877, 18.24358],
							[-66.278861, 18.243728],
							[-66.273394, 18.244423],
							[-66.272184, 18.244577],
							[-66.266377, 18.24528],
							[-66.268412, 18.242106],
							[-66.265807, 18.236787],
							[-66.265579, 18.232835],
							[-66.267383, 18.227642],
							[-66.268332, 18.224911],
							[-66.268469, 18.224558],
							[-66.268966, 18.223249],
							[-66.269384, 18.222013],
							[-66.270286, 18.219305],
							[-66.270994, 18.217433],
							[-66.269211, 18.21389],
							[-66.268023, 18.211208],
							[-66.26773, 18.210379],
							[-66.267518, 18.209093],
							[-66.266314, 18.207067],
							[-66.26543, 18.206326],
							[-66.264538, 18.205759],
							[-66.264459, 18.205451],
							[-66.264328, 18.202492],
							[-66.264387, 18.202474],
							[-66.264215, 18.198394],
							[-66.264112, 18.196443],
							[-66.263843, 18.190825],
							[-66.263553, 18.184959],
							[-66.263502, 18.184956],
							[-66.263231, 18.184943],
							[-66.259681, 18.184123],
							[-66.255656, 18.184764],
							[-66.255364, 18.187053],
							[-66.248767, 18.19139],
							[-66.244295, 18.193348],
							[-66.242249, 18.192211],
							[-66.242172, 18.192151],
							[-66.244543, 18.190624],
							[-66.244844, 18.188387],
							[-66.244205, 18.187437],
							[-66.240594, 18.184799],
							[-66.241529, 18.183884],
							[-66.242791, 18.180249],
							[-66.244819, 18.177201],
							[-66.248134, 18.17361],
							[-66.249078, 18.169975],
							[-66.247123, 18.168006],
							[-66.248385, 18.165579],
							[-66.249612, 18.165592],
							[-66.249612, 18.165604],
							[-66.251612, 18.165342],
							[-66.254034, 18.165522],
							[-66.255624, 18.166273],
							[-66.256897, 18.170876],
							[-66.259809, 18.171009],
							[-66.273416, 18.173724],
							[-66.27565, 18.172576],
							[-66.277095, 18.173942],
							[-66.278689, 18.173962],
							[-66.280562, 18.172276],
							[-66.286757, 18.16964],
							[-66.291196, 18.169064],
							[-66.292334, 18.167707],
							[-66.292426, 18.165759],
							[-66.294879, 18.165119],
							[-66.298899, 18.163016],
							[-66.300032, 18.160622],
							[-66.301626, 18.159226],
							[-66.302525, 18.159589],
							[-66.304307, 18.161479],
							[-66.30916, 18.159539],
							[-66.311117, 18.157356],
							[-66.314848, 18.152088],
							[-66.317232, 18.154175],
							[-66.321592, 18.155822],
							[-66.3222, 18.156704],
							[-66.322323, 18.165503],
							[-66.324952, 18.166023],
							[-66.32984, 18.164766],
							[-66.331151, 18.168227],
							[-66.33389, 18.167385],
							[-66.338375, 18.168668],
							[-66.339828, 18.166036],
							[-66.341919, 18.16818],
							[-66.342507, 18.16806],
							[-66.348895, 18.166164],
							[-66.349446, 18.165825],
							[-66.349856, 18.165665],
							[-66.350863, 18.165462],
							[-66.355477, 18.167948],
							[-66.355105, 18.168517],
							[-66.355633, 18.16945],
							[-66.358138, 18.169467],
							[-66.366029, 18.170236],
							[-66.366632, 18.170656],
							[-66.369119, 18.172615],
							[-66.371982, 18.17319],
							[-66.373768, 18.173694],
							[-66.373045, 18.17452],
							[-66.373026, 18.175003],
							[-66.373002, 18.175189],
							[-66.372963, 18.180435],
							[-66.373581, 18.181601],
							[-66.37354, 18.184128],
							[-66.366857, 18.185778],
							[-66.36591, 18.185312],
							[-66.364777, 18.186922],
							[-66.367083, 18.192168],
							[-66.367506, 18.193909],
							[-66.367535, 18.195301],
							[-66.367305, 18.196934],
							[-66.364806, 18.1994],
							[-66.363655, 18.200684],
							[-66.359995, 18.198837],
							[-66.358991, 18.197544],
							[-66.356026, 18.192298],
							[-66.354969, 18.192067],
							[-66.352169, 18.1932],
							[-66.351873, 18.194001],
							[-66.351797, 18.195115],
							[-66.352949, 18.198373],
							[-66.350736, 18.205036],
							[-66.350631, 18.206549],
							[-66.352461, 18.210255],
							[-66.352117, 18.211717],
							[-66.351532, 18.218379],
							[-66.353558, 18.219337],
							[-66.354467, 18.222876],
							[-66.353382, 18.226075],
							[-66.352055, 18.224941],
							[-66.351182, 18.224965],
							[-66.350398, 18.227491],
							[-66.351515, 18.231654],
							[-66.351565, 18.23196],
							[-66.350794, 18.241235],
							[-66.349783, 18.240543],
							[-66.342462, 18.23978],
							[-66.341465, 18.239234],
							[-66.338134, 18.239271],
							[-66.336374, 18.239519],
							[-66.336117, 18.239504],
							[-66.335247, 18.240051],
							[-66.334246, 18.24052],
							[-66.333614, 18.241253],
							[-66.332229, 18.242462],
							[-66.33072, 18.243684],
							[-66.327047, 18.244087],
							[-66.326297, 18.247855],
							[-66.318881, 18.24801],
							[-66.313439, 18.249346],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '041',
					name: 'Cidra',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.146279, 18.230334],
							[-66.143855, 18.225142],
							[-66.144716, 18.224016],
							[-66.145822, 18.224047],
							[-66.145966, 18.223587],
							[-66.144062, 18.222968],
							[-66.143812, 18.22275],
							[-66.144669, 18.221246],
							[-66.145739, 18.221805],
							[-66.146508, 18.219368],
							[-66.146531, 18.219217],
							[-66.146009, 18.214873],
							[-66.142389, 18.210193],
							[-66.140233, 18.210815],
							[-66.139191, 18.210293],
							[-66.13881, 18.206737],
							[-66.139489, 18.206],
							[-66.139832, 18.205721],
							[-66.139524, 18.205389],
							[-66.139395, 18.205244],
							[-66.139121, 18.204514],
							[-66.138663, 18.203758],
							[-66.138498, 18.201269],
							[-66.140582, 18.198174],
							[-66.141356, 18.197703],
							[-66.140627, 18.197708],
							[-66.137309, 18.197622],
							[-66.128085, 18.205165],
							[-66.121494, 18.208998],
							[-66.119013, 18.209939],
							[-66.118455, 18.209625],
							[-66.118388, 18.209636],
							[-66.117789, 18.209953],
							[-66.110267, 18.201953],
							[-66.109408, 18.200967],
							[-66.101675, 18.183087],
							[-66.101742, 18.182981],
							[-66.105188, 18.171478],
							[-66.096774, 18.168178],
							[-66.095107, 18.169018],
							[-66.094936, 18.166929],
							[-66.094466, 18.164674],
							[-66.095443, 18.163319],
							[-66.096522, 18.159887],
							[-66.098079, 18.158343],
							[-66.098189, 18.157761],
							[-66.100077, 18.15339],
							[-66.09955, 18.1532],
							[-66.102663, 18.151094],
							[-66.105213, 18.150518],
							[-66.106766, 18.148887],
							[-66.108364, 18.148491],
							[-66.109801, 18.146998],
							[-66.1105, 18.142864],
							[-66.114157, 18.139772],
							[-66.117804, 18.138926],
							[-66.118057, 18.138709],
							[-66.118627, 18.138119],
							[-66.119511, 18.138029],
							[-66.121748, 18.140762],
							[-66.123394, 18.140794],
							[-66.124279, 18.139867],
							[-66.129449, 18.138611],
							[-66.13205, 18.132605],
							[-66.137592, 18.133839],
							[-66.138275, 18.134344],
							[-66.139432, 18.13736],
							[-66.14827, 18.138879],
							[-66.150321, 18.141665],
							[-66.15672, 18.141538],
							[-66.157186, 18.142207],
							[-66.15663, 18.144344],
							[-66.157269, 18.145258],
							[-66.159579, 18.146466],
							[-66.16161, 18.14627],
							[-66.162362, 18.146171],
							[-66.162862, 18.145935],
							[-66.163493, 18.1456],
							[-66.1637, 18.145374],
							[-66.164209, 18.144964],
							[-66.164288, 18.144929],
							[-66.164891, 18.144353],
							[-66.164786, 18.143982],
							[-66.163413, 18.141384],
							[-66.162968, 18.13966],
							[-66.162886, 18.1395],
							[-66.162775, 18.138598],
							[-66.163477, 18.138094],
							[-66.166025, 18.137191],
							[-66.166345, 18.134411],
							[-66.167828, 18.133817],
							[-66.168188, 18.133584],
							[-66.168638, 18.133461],
							[-66.16887, 18.133477],
							[-66.172955, 18.13343],
							[-66.175137, 18.133724],
							[-66.176863, 18.135777],
							[-66.177926, 18.139327],
							[-66.180096, 18.141456],
							[-66.181715, 18.144315],
							[-66.183064, 18.144355],
							[-66.183597, 18.143739],
							[-66.183678, 18.142429],
							[-66.182677, 18.139216],
							[-66.185259, 18.13752],
							[-66.191928, 18.139924],
							[-66.193108, 18.140942],
							[-66.19422, 18.140534],
							[-66.195899, 18.13753],
							[-66.197273, 18.136544],
							[-66.200091, 18.137523],
							[-66.201157, 18.138588],
							[-66.201547, 18.140254],
							[-66.201298, 18.141458],
							[-66.200121, 18.144032],
							[-66.199677, 18.145507],
							[-66.201803, 18.146822],
							[-66.203081, 18.145912],
							[-66.204005, 18.142641],
							[-66.204118, 18.141988],
							[-66.204283, 18.140674],
							[-66.204311, 18.138281],
							[-66.205203, 18.137522],
							[-66.206643, 18.137167],
							[-66.208539, 18.137854],
							[-66.210083, 18.139694],
							[-66.211513, 18.142457],
							[-66.212718, 18.143595],
							[-66.214235, 18.144075],
							[-66.216904, 18.143158],
							[-66.217031, 18.143124],
							[-66.220479, 18.142874],
							[-66.219593, 18.145089],
							[-66.218076, 18.14487],
							[-66.216531, 18.14648],
							[-66.217021, 18.147586],
							[-66.21873, 18.148531],
							[-66.221129, 18.148612],
							[-66.226085, 18.149473],
							[-66.228045, 18.151611],
							[-66.229095, 18.159291],
							[-66.22802, 18.160068],
							[-66.224514, 18.1605],
							[-66.223706, 18.164849],
							[-66.224323, 18.166443],
							[-66.237279, 18.17817],
							[-66.240246, 18.179967],
							[-66.242791, 18.180249],
							[-66.241529, 18.183884],
							[-66.240594, 18.184799],
							[-66.230754, 18.184397],
							[-66.230826, 18.182786],
							[-66.230083, 18.180918],
							[-66.224071, 18.174361],
							[-66.223706, 18.175612],
							[-66.223118, 18.175897],
							[-66.218494, 18.174324],
							[-66.214013, 18.172821],
							[-66.211852, 18.173087],
							[-66.211275, 18.173634],
							[-66.211293, 18.175428],
							[-66.212198, 18.175835],
							[-66.213108, 18.177733],
							[-66.212196, 18.178896],
							[-66.21203, 18.182084],
							[-66.213641, 18.183799],
							[-66.213438, 18.185813],
							[-66.209138, 18.193451],
							[-66.208987, 18.193707],
							[-66.206782, 18.197159],
							[-66.205574, 18.196628],
							[-66.200362, 18.197151],
							[-66.193547, 18.200122],
							[-66.185165, 18.201051],
							[-66.183386, 18.202252],
							[-66.184745, 18.204655],
							[-66.184431, 18.207173],
							[-66.179814, 18.211058],
							[-66.177499, 18.213427],
							[-66.177412, 18.213487],
							[-66.175463, 18.214905],
							[-66.173883, 18.2159],
							[-66.172018, 18.215599],
							[-66.170382, 18.216305],
							[-66.169678, 18.217659],
							[-66.171336, 18.221833],
							[-66.171377, 18.222147],
							[-66.171444, 18.222317],
							[-66.171463, 18.222379],
							[-66.171492, 18.222675],
							[-66.169126, 18.22429],
							[-66.165224, 18.22347],
							[-66.162294, 18.220448],
							[-66.159371, 18.220462],
							[-66.154389, 18.222011],
							[-66.152258, 18.222124],
							[-66.150463, 18.223444],
							[-66.150047, 18.225305],
							[-66.146279, 18.230334],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 129,
					name: 'San Lorenzo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.968952, 18.228899],
							[-65.965419, 18.229283],
							[-65.958763, 18.22896],
							[-65.958274, 18.228891],
							[-65.9578, 18.228824],
							[-65.951048, 18.229272],
							[-65.949053, 18.226643],
							[-65.949989, 18.226147],
							[-65.95113, 18.224883],
							[-65.951123, 18.224784],
							[-65.950879, 18.222858],
							[-65.951549, 18.22036],
							[-65.951481, 18.220243],
							[-65.951008, 18.217817],
							[-65.949253, 18.213434],
							[-65.947756, 18.212609],
							[-65.947546, 18.21199],
							[-65.947516, 18.210794],
							[-65.94756, 18.21084],
							[-65.947061, 18.209182],
							[-65.946994, 18.209066],
							[-65.93785, 18.200679],
							[-65.937128, 18.199599],
							[-65.935406, 18.198129],
							[-65.935267, 18.197974],
							[-65.934978, 18.197671],
							[-65.933774, 18.196306],
							[-65.933652, 18.196168],
							[-65.92929, 18.195786],
							[-65.929298, 18.195736],
							[-65.929695, 18.193829],
							[-65.92981, 18.193482],
							[-65.928966, 18.191498],
							[-65.928194, 18.190528],
							[-65.928367, 18.189618],
							[-65.927334, 18.182805],
							[-65.927076, 18.181819],
							[-65.927812, 18.179711],
							[-65.927275, 18.177195],
							[-65.928577, 18.177221],
							[-65.930604, 18.177643],
							[-65.931046, 18.177809],
							[-65.930671, 18.176593],
							[-65.930709, 18.176522],
							[-65.930667, 18.173571],
							[-65.930658, 18.173473],
							[-65.930703, 18.172481],
							[-65.931357, 18.169898],
							[-65.929666, 18.163915],
							[-65.931721, 18.162239],
							[-65.9319, 18.161868],
							[-65.931915, 18.161652],
							[-65.931491, 18.161017],
							[-65.931472, 18.160755],
							[-65.929874, 18.157073],
							[-65.928688, 18.154412],
							[-65.928549, 18.154196],
							[-65.928362, 18.153475],
							[-65.928211, 18.14997],
							[-65.927966, 18.148156],
							[-65.928034, 18.148127],
							[-65.928106, 18.148044],
							[-65.92806, 18.145751],
							[-65.928003, 18.144607],
							[-65.928162, 18.144349],
							[-65.928584, 18.144102],
							[-65.928901, 18.143785],
							[-65.928537, 18.143119],
							[-65.928287, 18.142848],
							[-65.928019, 18.142585],
							[-65.927582, 18.142126],
							[-65.926177, 18.138954],
							[-65.921338, 18.138156],
							[-65.920561, 18.137255],
							[-65.921102, 18.135876],
							[-65.924658, 18.135346],
							[-65.925302, 18.134446],
							[-65.925657, 18.131341],
							[-65.925718, 18.13119],
							[-65.92554, 18.130238],
							[-65.925214, 18.128643],
							[-65.92673, 18.124555],
							[-65.926913, 18.123415],
							[-65.9275, 18.122232],
							[-65.926266, 18.119969],
							[-65.927038, 18.115876],
							[-65.925858, 18.108397],
							[-65.924852, 18.108161],
							[-65.924531, 18.108136],
							[-65.924315, 18.108067],
							[-65.924573, 18.106328],
							[-65.925461, 18.105585],
							[-65.927445, 18.105265],
							[-65.928369, 18.104983],
							[-65.92873, 18.101976],
							[-65.930321, 18.100731],
							[-65.931937, 18.100753],
							[-65.930357, 18.097507],
							[-65.933813, 18.095288],
							[-65.936121, 18.092679],
							[-65.941677, 18.089267],
							[-65.944166, 18.089639],
							[-65.944499, 18.08989],
							[-65.951399, 18.092326],
							[-65.952441, 18.092746],
							[-65.955043, 18.091733],
							[-65.955748, 18.091766],
							[-65.960443, 18.088778],
							[-65.962051, 18.086497],
							[-65.964541, 18.08711],
							[-65.966174, 18.089261],
							[-65.967789, 18.089165],
							[-65.97345, 18.090932],
							[-65.975809, 18.092864],
							[-65.976079, 18.09438],
							[-65.977167, 18.09464],
							[-65.977633, 18.095003],
							[-65.978733, 18.094755],
							[-65.983378, 18.089303],
							[-65.984901, 18.088545],
							[-65.986651, 18.089679],
							[-65.990781, 18.090134],
							[-65.993693, 18.089656],
							[-65.994741, 18.088131],
							[-65.995282, 18.085026],
							[-65.996225, 18.084565],
							[-65.999608, 18.082407],
							[-66.003184, 18.078723],
							[-66.006538, 18.075935],
							[-66.010246, 18.075565],
							[-66.013973, 18.076957],
							[-66.017593, 18.081269],
							[-66.018305, 18.081736],
							[-66.019444, 18.083723],
							[-66.012717, 18.094457],
							[-66.018159, 18.099506],
							[-66.018444, 18.100207],
							[-66.019551, 18.102097],
							[-66.02097, 18.102919],
							[-66.022223, 18.102857],
							[-66.025206, 18.102485],
							[-66.028065, 18.10157],
							[-66.042041, 18.103839],
							[-66.050891, 18.109385],
							[-66.051878, 18.109907],
							[-66.052737, 18.113514],
							[-66.049999, 18.115259],
							[-66.044402, 18.114999],
							[-66.043189, 18.114336],
							[-66.041071, 18.115427],
							[-66.035311, 18.120161],
							[-66.032054, 18.131658],
							[-66.031581, 18.132324],
							[-66.025901, 18.133927],
							[-66.025221, 18.134948],
							[-66.024533, 18.137321],
							[-66.025149, 18.138813],
							[-66.020358, 18.145106],
							[-66.01961, 18.145514],
							[-66.021535, 18.149404],
							[-66.022161, 18.155811],
							[-66.022067, 18.155944],
							[-66.020222, 18.159083],
							[-66.02084, 18.16092],
							[-66.021966, 18.163978],
							[-66.021899, 18.164861],
							[-66.021912, 18.16518],
							[-66.020599, 18.167056],
							[-66.020021, 18.167613],
							[-66.016744, 18.173667],
							[-66.016556, 18.174761],
							[-66.016717, 18.17505],
							[-66.016832, 18.176326],
							[-66.01259, 18.176817],
							[-66.011979, 18.178756],
							[-66.013344, 18.181018],
							[-66.013365, 18.181929],
							[-66.011319, 18.18606],
							[-66.00569, 18.186326],
							[-66.005623, 18.186289],
							[-66.004114, 18.185449],
							[-66.003855, 18.185468],
							[-66.003059, 18.186097],
							[-66.002202, 18.187701],
							[-65.999608, 18.188614],
							[-65.999275, 18.189409],
							[-65.998667, 18.191613],
							[-65.998146, 18.195309],
							[-65.999608, 18.196437],
							[-66.000241, 18.197653],
							[-66.000504, 18.201988],
							[-65.998882, 18.206404],
							[-65.998893, 18.207828],
							[-65.99623, 18.207541],
							[-65.994018, 18.208464],
							[-65.994, 18.20858],
							[-65.993573, 18.21052],
							[-65.992771, 18.210604],
							[-65.991888, 18.211788],
							[-65.990557, 18.217943],
							[-65.989733, 18.219654],
							[-65.98252, 18.221443],
							[-65.982424, 18.221441],
							[-65.981402, 18.221118],
							[-65.980706, 18.224968],
							[-65.980422, 18.226068],
							[-65.975623, 18.227786],
							[-65.968952, 18.228899],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '093',
					name: 'Maricao',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.970203, 18.204763],
							[-66.966865, 18.206618],
							[-66.963181, 18.205941],
							[-66.957836, 18.204318],
							[-66.958036, 18.199823],
							[-66.956982, 18.200334],
							[-66.953063, 18.200037],
							[-66.950873, 18.201598],
							[-66.947604, 18.201557],
							[-66.94591, 18.201427],
							[-66.945861, 18.199371],
							[-66.941375, 18.198412],
							[-66.914738, 18.192035],
							[-66.898563, 18.187896],
							[-66.898027, 18.187759],
							[-66.89493, 18.18726],
							[-66.894704, 18.187255],
							[-66.870508, 18.187164],
							[-66.867658, 18.18741],
							[-66.864026, 18.186843],
							[-66.862871, 18.184379],
							[-66.863054, 18.183616],
							[-66.864867, 18.182137],
							[-66.862809, 18.181482],
							[-66.862327, 18.179415],
							[-66.862661, 18.178596],
							[-66.860981, 18.17701],
							[-66.860301, 18.175617],
							[-66.861079, 18.174895],
							[-66.861914, 18.17576],
							[-66.862592, 18.175402],
							[-66.862978, 18.174598],
							[-66.8626, 18.173469],
							[-66.855913, 18.171759],
							[-66.850755, 18.170359],
							[-66.846988, 18.171467],
							[-66.843677, 18.171515],
							[-66.83677, 18.170632],
							[-66.839205, 18.166616],
							[-66.842883, 18.164232],
							[-66.844003, 18.161037],
							[-66.85012, 18.162886],
							[-66.852119, 18.15462],
							[-66.85219, 18.154328],
							[-66.852356, 18.153669],
							[-66.854203, 18.146515],
							[-66.854554, 18.145152],
							[-66.855001, 18.144532],
							[-66.856145, 18.139262],
							[-66.858501, 18.137979],
							[-66.859648, 18.138136],
							[-66.86134, 18.138367],
							[-66.864018, 18.138375],
							[-66.864849, 18.138408],
							[-66.866019, 18.138962],
							[-66.870247, 18.139043],
							[-66.877735, 18.145899],
							[-66.880627, 18.147971],
							[-66.884516, 18.151249],
							[-66.887391, 18.153252],
							[-66.889385, 18.152395],
							[-66.890002, 18.151664],
							[-66.889904, 18.151644],
							[-66.889777, 18.149051],
							[-66.890416, 18.148303],
							[-66.891678, 18.147715],
							[-66.895208, 18.148471],
							[-66.898031, 18.147583],
							[-66.898409, 18.14734],
							[-66.900295, 18.146776],
							[-66.903003, 18.146264],
							[-66.903743, 18.146522],
							[-66.914349, 18.153306],
							[-66.920532, 18.153606],
							[-66.923899, 18.151798],
							[-66.924261, 18.151573],
							[-66.926251, 18.151172],
							[-66.927475, 18.151397],
							[-66.930052, 18.148934],
							[-66.931321, 18.149779],
							[-66.933944, 18.150229],
							[-66.934593, 18.148884],
							[-66.934654, 18.148813],
							[-66.934934, 18.148487],
							[-66.935199, 18.148236],
							[-66.939065, 18.147856],
							[-66.946671, 18.148105],
							[-66.947212, 18.147699],
							[-66.948093, 18.147267],
							[-66.949823, 18.146813],
							[-66.951121, 18.146361],
							[-66.958127, 18.145714],
							[-66.964291, 18.147055],
							[-66.968822, 18.144014],
							[-66.97048, 18.141992],
							[-66.971865, 18.14154],
							[-66.975544, 18.143394],
							[-66.977856, 18.143801],
							[-66.982414, 18.14729],
							[-66.982484, 18.147992],
							[-66.984802, 18.148601],
							[-66.988699, 18.148507],
							[-66.989718, 18.148981],
							[-66.992322, 18.150698],
							[-66.993349, 18.152342],
							[-66.993751, 18.153172],
							[-66.997563, 18.156711],
							[-66.999622, 18.157265],
							[-67.002329, 18.156849],
							[-67.009465, 18.158708],
							[-67.012564, 18.162598],
							[-67.013273, 18.165308],
							[-67.013844, 18.165874],
							[-67.015121, 18.166177],
							[-67.018026, 18.165214],
							[-67.020118, 18.165744],
							[-67.026395, 18.166651],
							[-67.041119, 18.16918],
							[-67.043754, 18.169149],
							[-67.051462, 18.174026],
							[-67.051138, 18.177436],
							[-67.050589, 18.176973],
							[-67.045742, 18.176204],
							[-67.040947, 18.177809],
							[-67.035048, 18.180584],
							[-67.034168, 18.182912],
							[-67.033911, 18.185463],
							[-67.031312, 18.184848],
							[-67.02919, 18.185623],
							[-67.027429, 18.18565],
							[-67.023743, 18.18461],
							[-67.019408, 18.186822],
							[-67.017981, 18.188125],
							[-67.017385, 18.189893],
							[-67.019837, 18.195471],
							[-67.003803, 18.193501],
							[-67.003518, 18.194089],
							[-66.999622, 18.19765],
							[-66.994132, 18.198866],
							[-66.991545, 18.199914],
							[-66.991225, 18.199986],
							[-66.989388, 18.204],
							[-66.987596, 18.20496],
							[-66.98062, 18.206307],
							[-66.97911, 18.207663],
							[-66.977474, 18.207773],
							[-66.971162, 18.204513],
							[-66.970203, 18.204763],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '069',
					name: 'Humacao',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.796072, 18.205064],
							[-65.79331, 18.206532],
							[-65.79121, 18.204326],
							[-65.786924, 18.203715],
							[-65.785739, 18.204085],
							[-65.777059, 18.199616],
							[-65.76882, 18.197993],
							[-65.766038, 18.198557],
							[-65.760505, 18.195581],
							[-65.764213, 18.18638],
							[-65.765306, 18.184028],
							[-65.76615, 18.182088],
							[-65.754534, 18.177375],
							[-65.751888, 18.176405],
							[-65.750917, 18.176475],
							[-65.749904, 18.177226],
							[-65.74822, 18.179807],
							[-65.746424, 18.18117],
							[-65.741755, 18.182392],
							[-65.740571, 18.182129],
							[-65.740529, 18.176695],
							[-65.739204, 18.173616],
							[-65.73917491039718, 18.17334772921944],
							[-65.73958295074522, 18.172488021033054],
							[-65.74119734880662, 18.169086614196292],
							[-65.74134778529199, 18.16876965662427],
							[-65.743632, 18.163957],
							[-65.749606, 18.1610459809221],
							[-65.758728, 18.156601],
							[-65.76459355158248, 18.15074547377733],
							[-65.766919, 18.148424],
							[-65.76805374174506, 18.14638274164285],
							[-65.777584, 18.129239],
							[-65.78121526240263, 18.120602150494996],
							[-65.78135107114363, 18.120279133448186],
							[-65.79045178987185, 18.098633344923947],
							[-65.796711, 18.083746],
							[-65.796289, 18.079835],
							[-65.794686, 18.078607],
							[-65.795028, 18.073561],
							[-65.79670048513722, 18.069864962729223],
							[-65.798714, 18.069455],
							[-65.806345, 18.071043],
							[-65.808966, 18.071804],
							[-65.809177, 18.072841],
							[-65.810922, 18.075235],
							[-65.811806, 18.077711],
							[-65.812378, 18.078221],
							[-65.813963, 18.08026],
							[-65.814101, 18.081737],
							[-65.817825, 18.082578],
							[-65.818166, 18.082653],
							[-65.818464, 18.08062],
							[-65.820648, 18.081356],
							[-65.822716, 18.083829],
							[-65.825337, 18.083515],
							[-65.828245, 18.084055],
							[-65.82945, 18.084946],
							[-65.830874, 18.089347],
							[-65.832933, 18.090199],
							[-65.835731, 18.091042],
							[-65.837339, 18.090846],
							[-65.837901, 18.090089],
							[-65.840325, 18.090996],
							[-65.840694, 18.094371],
							[-65.84248, 18.096507],
							[-65.847873, 18.09864],
							[-65.848238, 18.099224],
							[-65.84807, 18.101776],
							[-65.847316, 18.103432],
							[-65.845573, 18.106066],
							[-65.843092, 18.108212],
							[-65.842025, 18.110116],
							[-65.842544, 18.112057],
							[-65.846004, 18.112421],
							[-65.846062, 18.114001],
							[-65.845087, 18.114987],
							[-65.847439, 18.117074],
							[-65.849417, 18.117411],
							[-65.850923, 18.118227],
							[-65.855555, 18.117427],
							[-65.860302, 18.115637],
							[-65.863255, 18.112334],
							[-65.86543, 18.107993],
							[-65.866427, 18.108646],
							[-65.867694, 18.108555],
							[-65.870277, 18.108448],
							[-65.871366, 18.111434],
							[-65.874649, 18.115008],
							[-65.877625, 18.1181],
							[-65.875987, 18.123016],
							[-65.875565, 18.124972],
							[-65.875558, 18.12526],
							[-65.874152, 18.128469],
							[-65.873384, 18.129068],
							[-65.871745, 18.129836],
							[-65.867542, 18.137789],
							[-65.864979, 18.138779],
							[-65.864387, 18.139382],
							[-65.861329, 18.145727],
							[-65.861801, 18.147022],
							[-65.861745, 18.151343],
							[-65.861886, 18.153748],
							[-65.861945, 18.155855],
							[-65.857911, 18.162922],
							[-65.85703, 18.164683],
							[-65.856382, 18.164441],
							[-65.855675, 18.1672],
							[-65.855626, 18.167289],
							[-65.855576, 18.16738],
							[-65.855315, 18.169139],
							[-65.855, 18.169482],
							[-65.855019, 18.169636],
							[-65.855941, 18.171692],
							[-65.856487, 18.17285],
							[-65.855635, 18.175679],
							[-65.854868, 18.176826],
							[-65.852459, 18.176669],
							[-65.849917, 18.176037],
							[-65.846621, 18.177993],
							[-65.845852, 18.178337],
							[-65.842274, 18.177124],
							[-65.842111, 18.177122],
							[-65.836615, 18.175296],
							[-65.835944, 18.177884],
							[-65.835293, 18.180034],
							[-65.832723, 18.184306],
							[-65.830202, 18.185253],
							[-65.828037, 18.187212],
							[-65.827775, 18.187814],
							[-65.825721, 18.192406],
							[-65.826063, 18.200408],
							[-65.824131, 18.200726],
							[-65.822848, 18.203037],
							[-65.819979, 18.204411],
							[-65.819451, 18.205594],
							[-65.817597, 18.205863],
							[-65.816786, 18.205006],
							[-65.812391, 18.204508],
							[-65.80713, 18.205384],
							[-65.804218, 18.20406],
							[-65.800328, 18.202603],
							[-65.799845, 18.2026],
							[-65.798868, 18.204155],
							[-65.797455, 18.203644],
							[-65.796739, 18.204415],
							[-65.796072, 18.205064],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '009',
					name: 'Aibonito',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.277095, 18.173942],
							[-66.27565, 18.172576],
							[-66.273416, 18.173724],
							[-66.259809, 18.171009],
							[-66.256897, 18.170876],
							[-66.255624, 18.166273],
							[-66.254034, 18.165522],
							[-66.251612, 18.165342],
							[-66.249612, 18.165604],
							[-66.249612, 18.165592],
							[-66.248385, 18.165579],
							[-66.247123, 18.168006],
							[-66.249078, 18.169975],
							[-66.248134, 18.17361],
							[-66.244819, 18.177201],
							[-66.242791, 18.180249],
							[-66.240246, 18.179967],
							[-66.237279, 18.17817],
							[-66.224323, 18.166443],
							[-66.223706, 18.164849],
							[-66.224514, 18.1605],
							[-66.22802, 18.160068],
							[-66.229095, 18.159291],
							[-66.228045, 18.151611],
							[-66.226085, 18.149473],
							[-66.221129, 18.148612],
							[-66.21873, 18.148531],
							[-66.217021, 18.147586],
							[-66.216531, 18.14648],
							[-66.218076, 18.14487],
							[-66.219593, 18.145089],
							[-66.220479, 18.142874],
							[-66.217031, 18.143124],
							[-66.216999, 18.141931],
							[-66.216953, 18.136641],
							[-66.218651, 18.133328],
							[-66.220736, 18.131321],
							[-66.220645, 18.128872],
							[-66.219239, 18.128125],
							[-66.219099, 18.127556],
							[-66.220396, 18.120582],
							[-66.221796, 18.118901],
							[-66.224982, 18.118271],
							[-66.2268, 18.116701],
							[-66.224902, 18.112987],
							[-66.224593, 18.110188],
							[-66.225926, 18.108642],
							[-66.224337, 18.103976],
							[-66.225076, 18.10304],
							[-66.227059, 18.102238],
							[-66.224789, 18.098332],
							[-66.22449, 18.095303],
							[-66.224725, 18.095096],
							[-66.231786, 18.095784],
							[-66.236131, 18.093999],
							[-66.23924, 18.093122],
							[-66.239847, 18.087145],
							[-66.23979, 18.087136],
							[-66.240376, 18.082987],
							[-66.241516, 18.081316],
							[-66.242976, 18.077122],
							[-66.244552, 18.07694],
							[-66.24621, 18.076794],
							[-66.257528, 18.075884],
							[-66.259375, 18.077609],
							[-66.259949, 18.082612],
							[-66.26298, 18.085582],
							[-66.266135, 18.085317],
							[-66.272729, 18.086508],
							[-66.273405, 18.091502],
							[-66.277155, 18.095696],
							[-66.27915, 18.095018],
							[-66.281678, 18.095403],
							[-66.29016, 18.102205],
							[-66.294956, 18.105903],
							[-66.310768, 18.118168],
							[-66.311518, 18.118753],
							[-66.320913, 18.126005],
							[-66.318032, 18.130597],
							[-66.315735, 18.134315],
							[-66.313068, 18.136283],
							[-66.313077, 18.13825],
							[-66.316233, 18.138992],
							[-66.316745, 18.140182],
							[-66.316658, 18.142478],
							[-66.314317, 18.150317],
							[-66.314295, 18.151422],
							[-66.314848, 18.152088],
							[-66.311117, 18.157356],
							[-66.30916, 18.159539],
							[-66.304307, 18.161479],
							[-66.302525, 18.159589],
							[-66.301626, 18.159226],
							[-66.300032, 18.160622],
							[-66.298899, 18.163016],
							[-66.294879, 18.165119],
							[-66.292426, 18.165759],
							[-66.292334, 18.167707],
							[-66.291196, 18.169064],
							[-66.286757, 18.16964],
							[-66.280562, 18.172276],
							[-66.278689, 18.173962],
							[-66.277095, 18.173942],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 149,
					name: 'Villalba',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.452983, 18.17848],
							[-66.451248, 18.177976],
							[-66.451085, 18.177924],
							[-66.445494, 18.175492],
							[-66.444068, 18.176652],
							[-66.438626, 18.17279],
							[-66.434915, 18.173338],
							[-66.432549, 18.172574],
							[-66.428929, 18.165541],
							[-66.428553, 18.164152],
							[-66.428767, 18.162127],
							[-66.428216, 18.158121],
							[-66.429248, 18.156655],
							[-66.428568, 18.154944],
							[-66.427848, 18.155146],
							[-66.427328, 18.154379],
							[-66.424298, 18.152507],
							[-66.419722, 18.146889],
							[-66.41908, 18.144098],
							[-66.420007, 18.143211],
							[-66.41902, 18.139519],
							[-66.419317, 18.139521],
							[-66.42325, 18.132262],
							[-66.423343, 18.132],
							[-66.42417, 18.131991],
							[-66.424242, 18.132074],
							[-66.424554, 18.131922],
							[-66.426321, 18.124548],
							[-66.42696, 18.118411],
							[-66.430056, 18.116499],
							[-66.430761, 18.114833],
							[-66.429642, 18.112166],
							[-66.427759, 18.11066],
							[-66.428065, 18.10894],
							[-66.427422, 18.103677],
							[-66.426772, 18.101911],
							[-66.42549, 18.100494],
							[-66.423022, 18.099498],
							[-66.421659, 18.098633],
							[-66.421722, 18.097506],
							[-66.423144, 18.09666],
							[-66.424484, 18.096625],
							[-66.425647, 18.094827],
							[-66.4256, 18.093838],
							[-66.428887, 18.091352],
							[-66.42934, 18.090835],
							[-66.4305, 18.082035],
							[-66.434573, 18.083755],
							[-66.438846, 18.084843],
							[-66.443983, 18.084822],
							[-66.451115, 18.083326],
							[-66.452863, 18.082682],
							[-66.454635, 18.08125],
							[-66.463316, 18.084909],
							[-66.471406, 18.085984],
							[-66.481877, 18.088011],
							[-66.484626, 18.089598],
							[-66.48503, 18.091274],
							[-66.487792, 18.094225],
							[-66.490713, 18.095316],
							[-66.492858, 18.096125],
							[-66.497113, 18.096345],
							[-66.501876, 18.095666],
							[-66.504946, 18.09391],
							[-66.505648, 18.092599],
							[-66.505268, 18.091464],
							[-66.501935, 18.08802],
							[-66.501948, 18.085958],
							[-66.503914, 18.083198],
							[-66.504692, 18.082406],
							[-66.50749, 18.080915],
							[-66.518245, 18.08503],
							[-66.5221, 18.089738],
							[-66.521077, 18.092519],
							[-66.521418, 18.094181],
							[-66.524376, 18.098266],
							[-66.52644, 18.098705],
							[-66.528745, 18.100673],
							[-66.528775, 18.104892],
							[-66.53, 18.106708],
							[-66.529888, 18.107969],
							[-66.526233, 18.111582],
							[-66.525819, 18.112295],
							[-66.525421, 18.115695],
							[-66.526428, 18.117036],
							[-66.526536, 18.11967],
							[-66.523199, 18.122484],
							[-66.525795, 18.127475],
							[-66.525937, 18.128041],
							[-66.526851, 18.130682],
							[-66.528334, 18.131379],
							[-66.527638, 18.134617],
							[-66.52632, 18.136414],
							[-66.52702, 18.13845],
							[-66.526909, 18.140207],
							[-66.522101, 18.148746],
							[-66.521899, 18.151954],
							[-66.519074, 18.154453],
							[-66.516287, 18.154305],
							[-66.513457, 18.155679],
							[-66.512001, 18.157108],
							[-66.510671, 18.159775],
							[-66.508655, 18.160602],
							[-66.504971, 18.163739],
							[-66.504784, 18.163827],
							[-66.501863, 18.164852],
							[-66.496523, 18.166675],
							[-66.492447, 18.166861],
							[-66.491154, 18.167128],
							[-66.489441, 18.166503],
							[-66.483743, 18.168611],
							[-66.477375, 18.170011],
							[-66.475601, 18.172276],
							[-66.472872, 18.172431],
							[-66.472353, 18.175674],
							[-66.470676, 18.177265],
							[-66.469139, 18.177918],
							[-66.467513, 18.177494],
							[-66.465773, 18.177756],
							[-66.465263, 18.177779],
							[-66.46363, 18.178845],
							[-66.46235, 18.177498],
							[-66.461889, 18.177499],
							[-66.461283, 18.177132],
							[-66.460536, 18.177118],
							[-66.459812, 18.17724],
							[-66.457976, 18.176651],
							[-66.453971, 18.178175],
							[-66.453872, 18.178508],
							[-66.453485, 18.178318],
							[-66.452983, 18.17848],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '043',
					name: 'Coamo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.444068, 18.176652],
							[-66.439042, 18.175744],
							[-66.435517, 18.175273],
							[-66.435335, 18.175264],
							[-66.434291, 18.1748],
							[-66.433769, 18.174382],
							[-66.43244, 18.173918],
							[-66.431041, 18.173457],
							[-66.430165, 18.172463],
							[-66.42256, 18.171382],
							[-66.421962, 18.168988],
							[-66.416618, 18.164766],
							[-66.413372, 18.163217],
							[-66.407494, 18.164043],
							[-66.405401, 18.165574],
							[-66.405328, 18.165647],
							[-66.403171, 18.166861],
							[-66.401011, 18.164989],
							[-66.394302, 18.166021],
							[-66.392418, 18.166333],
							[-66.391792, 18.166343],
							[-66.390124, 18.168363],
							[-66.389121, 18.170273],
							[-66.388696, 18.17256],
							[-66.387337, 18.172838],
							[-66.382107, 18.172262],
							[-66.37558, 18.173176],
							[-66.375532, 18.173204],
							[-66.373768, 18.173694],
							[-66.371982, 18.17319],
							[-66.369119, 18.172615],
							[-66.366632, 18.170656],
							[-66.366029, 18.170236],
							[-66.358138, 18.169467],
							[-66.355633, 18.16945],
							[-66.355105, 18.168517],
							[-66.355477, 18.167948],
							[-66.350863, 18.165462],
							[-66.349856, 18.165665],
							[-66.349446, 18.165825],
							[-66.348895, 18.166164],
							[-66.342507, 18.16806],
							[-66.341919, 18.16818],
							[-66.339828, 18.166036],
							[-66.338375, 18.168668],
							[-66.33389, 18.167385],
							[-66.331151, 18.168227],
							[-66.32984, 18.164766],
							[-66.324952, 18.166023],
							[-66.322323, 18.165503],
							[-66.3222, 18.156704],
							[-66.321592, 18.155822],
							[-66.317232, 18.154175],
							[-66.314848, 18.152088],
							[-66.314295, 18.151422],
							[-66.314317, 18.150317],
							[-66.316658, 18.142478],
							[-66.316745, 18.140182],
							[-66.316233, 18.138992],
							[-66.313077, 18.13825],
							[-66.313068, 18.136283],
							[-66.315735, 18.134315],
							[-66.318032, 18.130597],
							[-66.320913, 18.126005],
							[-66.311518, 18.118753],
							[-66.310768, 18.118168],
							[-66.294956, 18.105903],
							[-66.29016, 18.102205],
							[-66.281678, 18.095403],
							[-66.27915, 18.095018],
							[-66.277155, 18.095696],
							[-66.273405, 18.091502],
							[-66.272729, 18.086508],
							[-66.266135, 18.085317],
							[-66.26298, 18.085582],
							[-66.259949, 18.082612],
							[-66.259375, 18.077609],
							[-66.257528, 18.075884],
							[-66.258572, 18.074425],
							[-66.26102, 18.072997],
							[-66.265786, 18.070845],
							[-66.266282, 18.070587],
							[-66.268723, 18.069225],
							[-66.277217, 18.069473],
							[-66.279383, 18.068916],
							[-66.284812, 18.059722],
							[-66.292329, 18.056761],
							[-66.297944, 18.056942],
							[-66.29891, 18.055179],
							[-66.303644, 18.050522],
							[-66.308075, 18.048107],
							[-66.309654, 18.047719],
							[-66.312629, 18.044965],
							[-66.312986, 18.04339],
							[-66.31212, 18.040721],
							[-66.31342, 18.036722],
							[-66.312611, 18.034569],
							[-66.312757, 18.032288],
							[-66.314164, 18.031462],
							[-66.314641, 18.030495],
							[-66.315002, 18.029639],
							[-66.315171, 18.029694],
							[-66.315763, 18.029937],
							[-66.318885, 18.029748],
							[-66.32135, 18.025287],
							[-66.321688, 18.024521],
							[-66.323432, 18.020854],
							[-66.325739, 18.018295],
							[-66.328484, 18.019538],
							[-66.330573, 18.019332],
							[-66.331274, 18.015852],
							[-66.331548, 18.016344],
							[-66.333656, 18.01963],
							[-66.335884, 18.022614],
							[-66.341682, 18.023698],
							[-66.346687, 18.025025],
							[-66.348436, 18.026156],
							[-66.349288, 18.029133],
							[-66.348416, 18.030445],
							[-66.348518, 18.03057],
							[-66.352193, 18.031588],
							[-66.352865, 18.032176],
							[-66.356847, 18.036849],
							[-66.358423, 18.036853],
							[-66.360856, 18.037082],
							[-66.366491, 18.03559],
							[-66.37081, 18.033692],
							[-66.371959, 18.032597],
							[-66.374613, 18.034016],
							[-66.380904, 18.037514],
							[-66.384618, 18.038629],
							[-66.388269, 18.040141],
							[-66.393124, 18.038576],
							[-66.395176, 18.037044],
							[-66.427096, 18.042646],
							[-66.425904, 18.046464],
							[-66.424086, 18.048453],
							[-66.424811, 18.049033],
							[-66.425186, 18.048284],
							[-66.425815, 18.048307],
							[-66.425778, 18.050015],
							[-66.425328, 18.05125],
							[-66.430522, 18.062386],
							[-66.431654, 18.063422],
							[-66.430898, 18.066714],
							[-66.429293, 18.068626],
							[-66.427736, 18.071634],
							[-66.427897, 18.072153],
							[-66.430196, 18.076304],
							[-66.4305, 18.082035],
							[-66.42934, 18.090835],
							[-66.428887, 18.091352],
							[-66.4256, 18.093838],
							[-66.425647, 18.094827],
							[-66.424484, 18.096625],
							[-66.423144, 18.09666],
							[-66.421722, 18.097506],
							[-66.421659, 18.098633],
							[-66.423022, 18.099498],
							[-66.42549, 18.100494],
							[-66.426772, 18.101911],
							[-66.427422, 18.103677],
							[-66.428065, 18.10894],
							[-66.427759, 18.11066],
							[-66.429642, 18.112166],
							[-66.430761, 18.114833],
							[-66.430056, 18.116499],
							[-66.42696, 18.118411],
							[-66.426321, 18.124548],
							[-66.424554, 18.131922],
							[-66.424242, 18.132074],
							[-66.42417, 18.131991],
							[-66.423343, 18.132],
							[-66.42325, 18.132262],
							[-66.419317, 18.139521],
							[-66.41902, 18.139519],
							[-66.420007, 18.143211],
							[-66.41908, 18.144098],
							[-66.419722, 18.146889],
							[-66.424298, 18.152507],
							[-66.427328, 18.154379],
							[-66.427848, 18.155146],
							[-66.428568, 18.154944],
							[-66.429248, 18.156655],
							[-66.428216, 18.158121],
							[-66.428767, 18.162127],
							[-66.428553, 18.164152],
							[-66.428929, 18.165541],
							[-66.432549, 18.172574],
							[-66.434915, 18.173338],
							[-66.438626, 18.17279],
							[-66.444068, 18.176652],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 125,
					name: 'San Germán',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.051462, 18.174026],
							[-67.043754, 18.169149],
							[-67.041119, 18.16918],
							[-67.026395, 18.166651],
							[-67.020118, 18.165744],
							[-67.018026, 18.165214],
							[-67.015121, 18.166177],
							[-67.013844, 18.165874],
							[-67.013273, 18.165308],
							[-67.012564, 18.162598],
							[-67.009465, 18.158708],
							[-67.002329, 18.156849],
							[-66.999622, 18.157265],
							[-66.997563, 18.156711],
							[-66.993751, 18.153172],
							[-66.993349, 18.152342],
							[-66.992322, 18.150698],
							[-66.989718, 18.148981],
							[-66.988699, 18.148507],
							[-66.984802, 18.148601],
							[-66.982484, 18.147992],
							[-66.982414, 18.14729],
							[-66.977856, 18.143801],
							[-66.976618, 18.143291],
							[-66.972865, 18.140385],
							[-66.970463, 18.132486],
							[-66.974175, 18.126279],
							[-66.976071, 18.12512],
							[-66.978037, 18.12301],
							[-66.978083, 18.123014],
							[-66.979262, 18.121237],
							[-66.983212, 18.108681],
							[-66.98369, 18.105584],
							[-66.984108, 18.101644],
							[-66.983201, 18.095239],
							[-66.983578, 18.088383],
							[-66.982313, 18.086341],
							[-66.982266, 18.086286],
							[-66.981116, 18.080114],
							[-66.980589, 18.078685],
							[-66.981236, 18.072323],
							[-66.981396, 18.066977],
							[-66.981849, 18.056494],
							[-66.983317, 18.052513],
							[-66.990538, 18.054195],
							[-66.991765, 18.053737],
							[-66.99233, 18.052483],
							[-66.993597, 18.052531],
							[-67.006276, 18.05846],
							[-67.007872, 18.060223],
							[-67.008947, 18.059243],
							[-67.01069, 18.058938],
							[-67.011443, 18.05909],
							[-67.013083, 18.057544],
							[-67.026555, 18.05997],
							[-67.027165, 18.058792],
							[-67.029438, 18.058324],
							[-67.035144, 18.0585],
							[-67.036181, 18.057761],
							[-67.037836, 18.058914],
							[-67.039413, 18.059806],
							[-67.03969, 18.059962],
							[-67.040116, 18.060071],
							[-67.043048, 18.061805],
							[-67.044881, 18.061859],
							[-67.048742, 18.062898],
							[-67.04929, 18.063104],
							[-67.05016, 18.063965],
							[-67.052343, 18.065009],
							[-67.053006, 18.063575],
							[-67.055428, 18.063009],
							[-67.056387, 18.063068],
							[-67.057656, 18.063556],
							[-67.061251, 18.064192],
							[-67.065564, 18.06408],
							[-67.066027, 18.064155],
							[-67.067835, 18.06613],
							[-67.068254, 18.066347],
							[-67.068263, 18.066307],
							[-67.069879, 18.065381],
							[-67.070188, 18.065182],
							[-67.072876, 18.06321],
							[-67.073779, 18.062233],
							[-67.07707, 18.063457],
							[-67.085088, 18.059339],
							[-67.087147, 18.060891],
							[-67.087718, 18.061042],
							[-67.089718, 18.061309],
							[-67.089954, 18.061277],
							[-67.092814, 18.060189],
							[-67.094417, 18.060364],
							[-67.099572, 18.058789],
							[-67.099945, 18.058872],
							[-67.101863, 18.057972],
							[-67.102464, 18.057523],
							[-67.109044, 18.056085],
							[-67.107095, 18.06201],
							[-67.102951, 18.065942],
							[-67.100815, 18.067072],
							[-67.098775, 18.069052],
							[-67.09867, 18.069391],
							[-67.098522, 18.070453],
							[-67.098497, 18.070636],
							[-67.098545, 18.070774],
							[-67.098646, 18.071495],
							[-67.098693, 18.071538],
							[-67.106017, 18.074749],
							[-67.105735, 18.080325],
							[-67.105229, 18.087688],
							[-67.103279, 18.092998],
							[-67.104359, 18.093316],
							[-67.104036, 18.094595],
							[-67.103006, 18.104545],
							[-67.099599, 18.105798],
							[-67.100584, 18.106265],
							[-67.099321, 18.10708],
							[-67.085961, 18.106655],
							[-67.081383, 18.106985],
							[-67.078225, 18.113421],
							[-67.07969, 18.117168],
							[-67.079866, 18.117287],
							[-67.081487, 18.11838],
							[-67.084394, 18.120306],
							[-67.085305, 18.120784],
							[-67.090949, 18.125521],
							[-67.090692, 18.126335],
							[-67.092404, 18.127264],
							[-67.09226, 18.129064],
							[-67.09115, 18.132292],
							[-67.092808, 18.136692],
							[-67.093, 18.140298],
							[-67.09129, 18.142033],
							[-67.091831, 18.144156],
							[-67.0921, 18.144697],
							[-67.09215, 18.146916],
							[-67.09125, 18.148026],
							[-67.089574, 18.148865],
							[-67.08823, 18.148874],
							[-67.08704, 18.148428],
							[-67.086997, 18.147528],
							[-67.088059, 18.146141],
							[-67.087018, 18.144772],
							[-67.086351, 18.144386],
							[-67.084966, 18.146194],
							[-67.084199, 18.147788],
							[-67.086349, 18.149832],
							[-67.087123, 18.15533],
							[-67.085221, 18.158056],
							[-67.085863, 18.162727],
							[-67.084489, 18.164977],
							[-67.081229, 18.167689],
							[-67.078614, 18.167481],
							[-67.077074, 18.169112],
							[-67.072309, 18.17303],
							[-67.068119, 18.172909],
							[-67.065576, 18.172292],
							[-67.060478, 18.173773],
							[-67.056672, 18.173124],
							[-67.053697, 18.171905],
							[-67.0523, 18.172433],
							[-67.051498, 18.173828],
							[-67.051462, 18.174026],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 113,
					name: 'Ponce',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.612755, 18.158878],
							[-66.607902, 18.16413],
							[-66.598911, 18.169388],
							[-66.591854, 18.172042],
							[-66.591703, 18.172156],
							[-66.590319, 18.172162],
							[-66.587649, 18.169446],
							[-66.587585, 18.169393],
							[-66.586834, 18.169348],
							[-66.586763, 18.169296],
							[-66.581113, 18.168133],
							[-66.580465, 18.167752],
							[-66.574835, 18.16823],
							[-66.574114, 18.168119],
							[-66.572319, 18.166061],
							[-66.572048, 18.163913],
							[-66.566668, 18.158882],
							[-66.56388, 18.158528],
							[-66.561308, 18.157363],
							[-66.56005, 18.154268],
							[-66.559808, 18.15385],
							[-66.552766, 18.152057],
							[-66.552175, 18.150881],
							[-66.552348, 18.150281],
							[-66.553788, 18.14856],
							[-66.56027, 18.145458],
							[-66.563114, 18.143585],
							[-66.564561, 18.139412],
							[-66.564527, 18.138354],
							[-66.563294, 18.137888],
							[-66.56275, 18.137087],
							[-66.562687, 18.133105],
							[-66.563271, 18.131226],
							[-66.565363, 18.129715],
							[-66.565091, 18.127536],
							[-66.564479, 18.125083],
							[-66.562051, 18.123015],
							[-66.561779, 18.119798],
							[-66.562143, 18.118227],
							[-66.561587, 18.115293],
							[-66.555698, 18.115719],
							[-66.555113, 18.113104],
							[-66.55537, 18.109113],
							[-66.554577, 18.10608],
							[-66.552682, 18.103477],
							[-66.550908, 18.102052],
							[-66.549031, 18.096776],
							[-66.549801, 18.093982],
							[-66.552457, 18.092478],
							[-66.553561, 18.090342],
							[-66.55349, 18.087985],
							[-66.555343, 18.086404],
							[-66.555508, 18.084651],
							[-66.545591, 18.06807],
							[-66.546237, 18.065722],
							[-66.546134, 18.062927],
							[-66.545679, 18.062151],
							[-66.544573, 18.060293],
							[-66.543844, 18.057739],
							[-66.546174, 18.053798],
							[-66.545652, 18.05238],
							[-66.54422, 18.051762],
							[-66.542961, 18.050536],
							[-66.541851, 18.045188],
							[-66.53734, 18.041286],
							[-66.537708, 18.039475],
							[-66.539599, 18.03569],
							[-66.542423, 18.032472],
							[-66.542196, 18.031038],
							[-66.538905, 18.025506],
							[-66.539319, 18.024284],
							[-66.540656, 18.022889],
							[-66.540666, 18.022781],
							[-66.540522, 18.022716],
							[-66.538374, 18.022697],
							[-66.536966, 18.019346],
							[-66.535803, 18.016391],
							[-66.537201, 18.013056],
							[-66.533364, 18.005885],
							[-66.533339, 18.005729],
							[-66.532833, 18.004374],
							[-66.53101, 18.004075],
							[-66.53042, 18.003075],
							[-66.530905, 18.000883],
							[-66.532585, 17.999854],
							[-66.532388, 17.998665],
							[-66.533271, 17.998202],
							[-66.533322, 17.99802],
							[-66.535707, 17.996682],
							[-66.53566, 17.994291],
							[-66.539855, 17.988938],
							[-66.538852, 17.986103],
							[-66.539165, 17.984847],
							[-66.539859, 17.98107],
							[-66.540566, 17.980551],
							[-66.53939, 17.978337],
							[-66.537602, 17.977431],
							[-66.53752043538144, 17.976482574202794],
							[-66.5560980795074, 17.970283502338134],
							[-66.55821531955574, 17.96957701215426],
							[-66.583233, 17.961229],
							[-66.58930554634951, 17.96893853471952],
							[-66.589658, 17.969386],
							[-66.594392, 17.970682],
							[-66.59850173013915, 17.970038298022928],
							[-66.59949865440076, 17.969882151001965],
							[-66.605035, 17.969015],
							[-66.61146469835889, 17.973141348837473],
							[-66.61717753630056, 17.976807642477315],
							[-66.623788, 17.98105],
							[-66.62400929757287, 17.981096017739528],
							[-66.62539910473419, 17.98138502128852],
							[-66.62889961039866, 17.982112934187853],
							[-66.631944, 17.982746],
							[-66.63777394836575, 17.98168863867825],
							[-66.645651, 17.98026],
							[-66.657797, 17.974605],
							[-66.66299642868935, 17.96960112155555],
							[-66.664391, 17.968259],
							[-66.672819, 17.966451],
							[-66.69911289630915, 17.977567176483205],
							[-66.699102, 17.977611],
							[-66.698097, 17.981617],
							[-66.693204, 17.983328],
							[-66.688369, 17.988805],
							[-66.686768, 17.991486],
							[-66.687316, 17.9929],
							[-66.689016, 17.994717],
							[-66.68825, 17.995923],
							[-66.687818, 17.998414],
							[-66.689443, 18.00009],
							[-66.690022, 18.003736],
							[-66.688177, 18.013355],
							[-66.686338, 18.016967],
							[-66.687677, 18.023258],
							[-66.689424, 18.029842],
							[-66.68936, 18.029939],
							[-66.68941, 18.03204],
							[-66.689446, 18.040257],
							[-66.688462, 18.042315],
							[-66.685942, 18.045486],
							[-66.685586, 18.047514],
							[-66.686541, 18.050103],
							[-66.686575, 18.050278],
							[-66.687044, 18.051528],
							[-66.687577, 18.052016],
							[-66.686416, 18.055146],
							[-66.685029, 18.059633],
							[-66.684763, 18.061976],
							[-66.684408, 18.065015],
							[-66.680822, 18.069522],
							[-66.680142, 18.070452],
							[-66.679465, 18.072647],
							[-66.680638, 18.074986],
							[-66.680819, 18.075538],
							[-66.680353, 18.077052],
							[-66.678078, 18.088758],
							[-66.67804, 18.100289],
							[-66.67964, 18.105286],
							[-66.681595, 18.107415],
							[-66.684568, 18.112033],
							[-66.684826, 18.114964],
							[-66.684367, 18.115775],
							[-66.684411, 18.117058],
							[-66.684243, 18.11747],
							[-66.684437, 18.117769],
							[-66.686652, 18.121307],
							[-66.688193, 18.122389],
							[-66.68825, 18.122368],
							[-66.688502, 18.123178],
							[-66.690257, 18.124656],
							[-66.693916, 18.12975],
							[-66.694071, 18.130534],
							[-66.693097, 18.130163],
							[-66.690694, 18.129625],
							[-66.68823, 18.131259],
							[-66.686329, 18.13166],
							[-66.684784, 18.131629],
							[-66.682942, 18.130342],
							[-66.680939, 18.129411],
							[-66.676966, 18.12993],
							[-66.674786, 18.135421],
							[-66.673341, 18.140087],
							[-66.672313, 18.145902],
							[-66.672735, 18.146848],
							[-66.670494, 18.152831],
							[-66.669194, 18.152361],
							[-66.662848, 18.155536],
							[-66.661932, 18.155992],
							[-66.659621, 18.156948],
							[-66.65876, 18.156863],
							[-66.655137, 18.157936],
							[-66.650491, 18.158552],
							[-66.649549, 18.158864],
							[-66.642348, 18.155109],
							[-66.641528, 18.154882],
							[-66.640899, 18.15514],
							[-66.639008, 18.154351],
							[-66.638793, 18.153781],
							[-66.631721, 18.149772],
							[-66.631011, 18.15046],
							[-66.632258, 18.153523],
							[-66.629675, 18.157126],
							[-66.6287, 18.158627],
							[-66.627095, 18.158576],
							[-66.626762, 18.157654],
							[-66.625859, 18.157016],
							[-66.623712, 18.156329],
							[-66.622685, 18.156951],
							[-66.612755, 18.158878],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 153,
					name: 'Yauco',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.827331, 18.171256],
							[-66.826359, 18.169207],
							[-66.823959, 18.167529],
							[-66.826278, 18.160216],
							[-66.821028, 18.152818],
							[-66.818091, 18.150509],
							[-66.817006, 18.150581],
							[-66.804058, 18.148056],
							[-66.803414, 18.145374],
							[-66.803395, 18.142784],
							[-66.802328, 18.140071],
							[-66.799881, 18.138049],
							[-66.797558, 18.133445],
							[-66.798937, 18.132741],
							[-66.796268, 18.121461],
							[-66.80087, 18.120024],
							[-66.810159, 18.113899],
							[-66.810666, 18.11303],
							[-66.810249, 18.111129],
							[-66.810065, 18.11052],
							[-66.809824, 18.108003],
							[-66.808859, 18.105473],
							[-66.805877, 18.103902],
							[-66.805176, 18.101027],
							[-66.805675, 18.100011],
							[-66.806622, 18.097514],
							[-66.80527, 18.094031],
							[-66.803912, 18.093505],
							[-66.80221, 18.090992],
							[-66.805219, 18.08696],
							[-66.80645, 18.085272],
							[-66.808667, 18.081939],
							[-66.809201, 18.081226],
							[-66.813605, 18.075113],
							[-66.815617, 18.071633],
							[-66.816985, 18.069662],
							[-66.817532, 18.067876],
							[-66.818703, 18.062297],
							[-66.819277, 18.055174],
							[-66.822498, 18.050276],
							[-66.823994, 18.047706],
							[-66.824182, 18.046706],
							[-66.824295, 18.044173],
							[-66.824488, 18.043162],
							[-66.824411, 18.040865],
							[-66.821909, 18.03679],
							[-66.822146, 18.034287],
							[-66.821497, 18.032694],
							[-66.818062, 18.029528],
							[-66.820711, 18.025194],
							[-66.82132, 18.021507],
							[-66.822405, 18.020809],
							[-66.829664, 18.018709],
							[-66.829879, 18.014944],
							[-66.826462, 18.007682],
							[-66.82569, 18.001983],
							[-66.825979, 17.999698],
							[-66.830463, 17.998772],
							[-66.831423, 17.997046],
							[-66.831292, 17.994756],
							[-66.833159, 17.98993],
							[-66.835282, 17.988274],
							[-66.835408, 17.986456],
							[-66.836683, 17.965971],
							[-66.85228797692847, 17.955003539699288],
							[-66.856474, 17.956553],
							[-66.85939312377155, 17.95437435565658],
							[-66.861361, 17.960395],
							[-66.862143, 17.962368],
							[-66.863357, 17.965377],
							[-66.863503, 17.976157],
							[-66.863864, 17.987465],
							[-66.862895, 17.991788],
							[-66.862822, 17.995162],
							[-66.863098, 17.995596],
							[-66.863045, 17.996561],
							[-66.864299, 17.999267],
							[-66.865985, 18.003116],
							[-66.868899, 18.007103],
							[-66.875272, 18.011315],
							[-66.875165, 18.012823],
							[-66.875105, 18.013721],
							[-66.875698, 18.014548],
							[-66.876052, 18.014803],
							[-66.877848, 18.016095],
							[-66.879678, 18.015776],
							[-66.882339, 18.016731],
							[-66.8848, 18.02168],
							[-66.884462, 18.024818],
							[-66.884645, 18.024814],
							[-66.885692, 18.027287],
							[-66.886807, 18.031551],
							[-66.886795, 18.032498],
							[-66.887159, 18.033826],
							[-66.887341, 18.033958],
							[-66.891516, 18.036368],
							[-66.896, 18.041061],
							[-66.898646, 18.042285],
							[-66.899659, 18.046692],
							[-66.901697, 18.051771],
							[-66.90125, 18.053659],
							[-66.90313, 18.056159],
							[-66.904019, 18.058269],
							[-66.909048, 18.064892],
							[-66.909864, 18.068522],
							[-66.909195, 18.070452],
							[-66.9122, 18.074093],
							[-66.912911, 18.07594],
							[-66.913145, 18.081604],
							[-66.914166, 18.084736],
							[-66.914995, 18.085475],
							[-66.918655, 18.089538],
							[-66.919736, 18.092305],
							[-66.918248, 18.094864],
							[-66.916679, 18.095977],
							[-66.915654, 18.09768],
							[-66.91988, 18.10305],
							[-66.920947, 18.106936],
							[-66.921003, 18.107008],
							[-66.921206, 18.107272],
							[-66.923767, 18.11502],
							[-66.917025, 18.120765],
							[-66.91727, 18.122373],
							[-66.918109, 18.123498],
							[-66.916889, 18.124129],
							[-66.916443, 18.126023],
							[-66.9178, 18.132182],
							[-66.921233, 18.139198],
							[-66.924513, 18.142829],
							[-66.925423, 18.145672],
							[-66.925189, 18.146256],
							[-66.925064, 18.147657],
							[-66.925046, 18.147726],
							[-66.925047, 18.148986],
							[-66.92567, 18.150473],
							[-66.92593, 18.150583],
							[-66.926251, 18.151172],
							[-66.924261, 18.151573],
							[-66.923899, 18.151798],
							[-66.920532, 18.153606],
							[-66.914349, 18.153306],
							[-66.903743, 18.146522],
							[-66.903003, 18.146264],
							[-66.900295, 18.146776],
							[-66.898409, 18.14734],
							[-66.898031, 18.147583],
							[-66.895208, 18.148471],
							[-66.891678, 18.147715],
							[-66.890416, 18.148303],
							[-66.889777, 18.149051],
							[-66.889904, 18.151644],
							[-66.890002, 18.151664],
							[-66.889385, 18.152395],
							[-66.887391, 18.153252],
							[-66.884516, 18.151249],
							[-66.880627, 18.147971],
							[-66.877735, 18.145899],
							[-66.870247, 18.139043],
							[-66.866019, 18.138962],
							[-66.864849, 18.138408],
							[-66.864018, 18.138375],
							[-66.86134, 18.138367],
							[-66.859648, 18.138136],
							[-66.858501, 18.137979],
							[-66.856145, 18.139262],
							[-66.855001, 18.144532],
							[-66.854554, 18.145152],
							[-66.854203, 18.146515],
							[-66.852356, 18.153669],
							[-66.85219, 18.154328],
							[-66.852119, 18.15462],
							[-66.85012, 18.162886],
							[-66.844003, 18.161037],
							[-66.842883, 18.164232],
							[-66.839205, 18.166616],
							[-66.83677, 18.170632],
							[-66.827331, 18.171256],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '035',
					name: 'Cayey',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.094936, 18.166929],
							[-66.095107, 18.169018],
							[-66.090266, 18.162305],
							[-66.086153, 18.15831],
							[-66.083361, 18.156285],
							[-66.080425, 18.152953],
							[-66.080345, 18.152143],
							[-66.071352, 18.149891],
							[-66.066292, 18.148499],
							[-66.066069, 18.147089],
							[-66.066303, 18.146071],
							[-66.067222, 18.145598],
							[-66.06949, 18.142397],
							[-66.068841, 18.14011],
							[-66.069514, 18.137704],
							[-66.06959, 18.137516],
							[-66.068023, 18.134398],
							[-66.067479, 18.132172],
							[-66.065619, 18.131417],
							[-66.064956, 18.131086],
							[-66.064762, 18.129956],
							[-66.061762, 18.124592],
							[-66.060265, 18.118585],
							[-66.060705, 18.116362],
							[-66.055466, 18.113996],
							[-66.052737, 18.113514],
							[-66.051878, 18.109907],
							[-66.053224, 18.10949],
							[-66.053147, 18.107293],
							[-66.054147, 18.10721],
							[-66.063629, 18.102912],
							[-66.070383, 18.101882],
							[-66.073999, 18.105475],
							[-66.074449, 18.105807],
							[-66.074949, 18.10565],
							[-66.077989, 18.103085],
							[-66.078643, 18.102997],
							[-66.085722, 18.105346],
							[-66.088253, 18.107507],
							[-66.098205, 18.106964],
							[-66.102703, 18.105009],
							[-66.102965, 18.10265],
							[-66.105957, 18.099124],
							[-66.109197, 18.09917],
							[-66.109208, 18.097929],
							[-66.112909, 18.091691],
							[-66.122145, 18.093769],
							[-66.12634, 18.097156],
							[-66.128056, 18.09422],
							[-66.128129, 18.092247],
							[-66.129006, 18.088809],
							[-66.127559, 18.086309],
							[-66.126109, 18.082485],
							[-66.12461, 18.08269],
							[-66.124159, 18.082035],
							[-66.123725, 18.079472],
							[-66.12394, 18.079137],
							[-66.124415, 18.078097],
							[-66.12461, 18.077646],
							[-66.126238, 18.077612],
							[-66.126113, 18.076342],
							[-66.125076, 18.074364],
							[-66.121511, 18.072864],
							[-66.122465, 18.070925],
							[-66.120068, 18.062812],
							[-66.122614, 18.060446],
							[-66.122777, 18.060367],
							[-66.125232, 18.05165],
							[-66.129605, 18.042349],
							[-66.128513, 18.039526],
							[-66.135193, 18.037336],
							[-66.138987, 18.036917],
							[-66.140524, 18.037687],
							[-66.142559, 18.038206],
							[-66.143114, 18.039755],
							[-66.150087, 18.0421],
							[-66.15574, 18.043419],
							[-66.157954, 18.048961],
							[-66.160685, 18.0498],
							[-66.166145, 18.050063],
							[-66.167515, 18.0517],
							[-66.1709, 18.051984],
							[-66.173325, 18.053289],
							[-66.177978, 18.053494],
							[-66.180481, 18.052359],
							[-66.188139, 18.050402],
							[-66.196041, 18.04915],
							[-66.198602, 18.047743],
							[-66.198735, 18.047571],
							[-66.201967, 18.046078],
							[-66.202048, 18.046189],
							[-66.20276, 18.048598],
							[-66.204309, 18.05506],
							[-66.203829, 18.055156],
							[-66.201368, 18.057609],
							[-66.200677, 18.064076],
							[-66.201045, 18.065092],
							[-66.201681, 18.067639],
							[-66.206068, 18.067653],
							[-66.208561, 18.07078],
							[-66.211736, 18.074602],
							[-66.215803, 18.079563],
							[-66.215258, 18.085952],
							[-66.217146, 18.090153],
							[-66.218344, 18.092567],
							[-66.223351, 18.095003],
							[-66.224725, 18.095096],
							[-66.22449, 18.095303],
							[-66.224789, 18.098332],
							[-66.227059, 18.102238],
							[-66.225076, 18.10304],
							[-66.224337, 18.103976],
							[-66.225926, 18.108642],
							[-66.224593, 18.110188],
							[-66.224902, 18.112987],
							[-66.2268, 18.116701],
							[-66.224982, 18.118271],
							[-66.221796, 18.118901],
							[-66.220396, 18.120582],
							[-66.219099, 18.127556],
							[-66.219239, 18.128125],
							[-66.220645, 18.128872],
							[-66.220736, 18.131321],
							[-66.218651, 18.133328],
							[-66.216953, 18.136641],
							[-66.216999, 18.141931],
							[-66.217031, 18.143124],
							[-66.216904, 18.143158],
							[-66.214235, 18.144075],
							[-66.212718, 18.143595],
							[-66.211513, 18.142457],
							[-66.210083, 18.139694],
							[-66.208539, 18.137854],
							[-66.206643, 18.137167],
							[-66.205203, 18.137522],
							[-66.204311, 18.138281],
							[-66.204283, 18.140674],
							[-66.204118, 18.141988],
							[-66.204005, 18.142641],
							[-66.203081, 18.145912],
							[-66.201803, 18.146822],
							[-66.199677, 18.145507],
							[-66.200121, 18.144032],
							[-66.201298, 18.141458],
							[-66.201547, 18.140254],
							[-66.201157, 18.138588],
							[-66.200091, 18.137523],
							[-66.197273, 18.136544],
							[-66.195899, 18.13753],
							[-66.19422, 18.140534],
							[-66.193108, 18.140942],
							[-66.191928, 18.139924],
							[-66.185259, 18.13752],
							[-66.182677, 18.139216],
							[-66.183678, 18.142429],
							[-66.183597, 18.143739],
							[-66.183064, 18.144355],
							[-66.181715, 18.144315],
							[-66.180096, 18.141456],
							[-66.177926, 18.139327],
							[-66.176863, 18.135777],
							[-66.175137, 18.133724],
							[-66.172955, 18.13343],
							[-66.16887, 18.133477],
							[-66.168638, 18.133461],
							[-66.168188, 18.133584],
							[-66.167828, 18.133817],
							[-66.166345, 18.134411],
							[-66.166025, 18.137191],
							[-66.163477, 18.138094],
							[-66.162775, 18.138598],
							[-66.162886, 18.1395],
							[-66.162968, 18.13966],
							[-66.163413, 18.141384],
							[-66.164786, 18.143982],
							[-66.164891, 18.144353],
							[-66.164288, 18.144929],
							[-66.164209, 18.144964],
							[-66.1637, 18.145374],
							[-66.163493, 18.1456],
							[-66.162862, 18.145935],
							[-66.162362, 18.146171],
							[-66.16161, 18.14627],
							[-66.159579, 18.146466],
							[-66.157269, 18.145258],
							[-66.15663, 18.144344],
							[-66.157186, 18.142207],
							[-66.15672, 18.141538],
							[-66.150321, 18.141665],
							[-66.14827, 18.138879],
							[-66.139432, 18.13736],
							[-66.138275, 18.134344],
							[-66.137592, 18.133839],
							[-66.13205, 18.132605],
							[-66.129449, 18.138611],
							[-66.124279, 18.139867],
							[-66.123394, 18.140794],
							[-66.121748, 18.140762],
							[-66.119511, 18.138029],
							[-66.118627, 18.138119],
							[-66.118057, 18.138709],
							[-66.117804, 18.138926],
							[-66.114157, 18.139772],
							[-66.1105, 18.142864],
							[-66.109801, 18.146998],
							[-66.108364, 18.148491],
							[-66.106766, 18.148887],
							[-66.105213, 18.150518],
							[-66.102663, 18.151094],
							[-66.09955, 18.1532],
							[-66.100077, 18.15339],
							[-66.098189, 18.157761],
							[-66.098079, 18.158343],
							[-66.096522, 18.159887],
							[-66.095443, 18.163319],
							[-66.094466, 18.164674],
							[-66.094936, 18.166929],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '023',
					name: 'Cabo Rojo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.171788, 18.16012],
							[-67.170328, 18.158944],
							[-67.166531, 18.156496],
							[-67.166936, 18.15582],
							[-67.163707, 18.154793],
							[-67.161934, 18.152319],
							[-67.159708, 18.153157],
							[-67.153423, 18.149267],
							[-67.153936, 18.145391],
							[-67.147402, 18.140707],
							[-67.146125, 18.139517],
							[-67.142935, 18.13854],
							[-67.141273, 18.136967],
							[-67.140508, 18.133072],
							[-67.136482, 18.133043],
							[-67.133536, 18.129607],
							[-67.135218, 18.124503],
							[-67.132075, 18.120441],
							[-67.11952, 18.111761],
							[-67.117289, 18.111761],
							[-67.110747, 18.108601],
							[-67.110498, 18.107942],
							[-67.108295, 18.106352],
							[-67.105795, 18.105488],
							[-67.103232, 18.105147],
							[-67.100584, 18.106265],
							[-67.099599, 18.105798],
							[-67.103006, 18.104545],
							[-67.104036, 18.094595],
							[-67.104359, 18.093316],
							[-67.103279, 18.092998],
							[-67.105229, 18.087688],
							[-67.105735, 18.080325],
							[-67.106017, 18.074749],
							[-67.098693, 18.071538],
							[-67.098646, 18.071495],
							[-67.098545, 18.070774],
							[-67.098497, 18.070636],
							[-67.098522, 18.070453],
							[-67.09867, 18.069391],
							[-67.098775, 18.069052],
							[-67.100815, 18.067072],
							[-67.102951, 18.065942],
							[-67.107095, 18.06201],
							[-67.109044, 18.056085],
							[-67.110334, 18.052348],
							[-67.110569, 18.051824],
							[-67.114178, 18.046318],
							[-67.113697, 18.04313],
							[-67.110957, 18.039661],
							[-67.115568, 18.033957],
							[-67.113808, 18.029093],
							[-67.110171, 18.015527],
							[-67.110478, 18.012863],
							[-67.111403, 18.012515],
							[-67.109931, 18.009979],
							[-67.109588, 17.998722],
							[-67.109476, 17.996968],
							[-67.10937, 17.981337],
							[-67.110044, 17.979276],
							[-67.108959, 17.977519],
							[-67.104005, 17.976441],
							[-67.102234, 17.974891],
							[-67.103972, 17.97027],
							[-67.107213, 17.964015],
							[-67.106488, 17.956926],
							[-67.107142, 17.955285],
							[-67.107273, 17.95493],
							[-67.109513, 17.948911],
							[-67.109682, 17.948481],
							[-67.109985, 17.945806],
							[-67.128251, 17.948153],
							[-67.133733, 17.951919],
							[-67.167031, 17.963073],
							[-67.178566, 17.964792],
							[-67.183508, 17.962706],
							[-67.18871655557827, 17.950988789648996],
							[-67.1874741363469, 17.946252064260356],
							[-67.18383185752387, 17.938283600385947],
							[-67.183694, 17.937982],
							[-67.18366710597188, 17.937205023583942],
							[-67.18345899331462, 17.93119258744782],
							[-67.183457, 17.931135],
							[-67.18373232293769, 17.931176099142622],
							[-67.1866344530006, 17.931609317887006],
							[-67.19291420341999, 17.932546734726625],
							[-67.194785, 17.932826],
							[-67.196924, 17.935651],
							[-67.197273, 17.937461],
							[-67.19751737128907, 17.941514012158205],
							[-67.19766839028543, 17.943549128993034],
							[-67.19898846203543, 17.94781994829849],
							[-67.20097337128907, 17.949896012158202],
							[-67.20109003326766, 17.9499436392329],
							[-67.210034, 17.953595],
							[-67.212101, 17.956027],
							[-67.21433, 17.962436],
							[-67.215271, 17.983464],
							[-67.211973, 17.992993],
							[-67.207694, 17.998019],
							[-67.1969436223831, 18.001937705816996],
							[-67.177893, 18.008882],
							[-67.174299, 18.011149],
							[-67.172397, 18.014906],
							[-67.172138, 18.021422],
							[-67.17331804361882, 18.023694838171547],
							[-67.173761, 18.024548],
							[-67.17794129205008, 18.026112716657252],
							[-67.193269, 18.03185],
							[-67.209887, 18.035439],
							[-67.20470995156593, 18.04762407602322],
							[-67.20441044165631, 18.048329024231638],
							[-67.196694, 18.066491],
							[-67.19082019709238, 18.0643294249651],
							[-67.190656, 18.064269],
							[-67.18978210357567, 18.06477040653587],
							[-67.18824572423404, 18.06565191906071],
							[-67.18709740309525, 18.066310779433895],
							[-67.184589, 18.06775],
							[-67.18430691800214, 18.068687673492146],
							[-67.18426445418093, 18.068828828191183],
							[-67.183938, 18.069914],
							[-67.186465, 18.074195],
							[-67.192999, 18.076877],
							[-67.198212, 18.076828],
							[-67.19872293399837, 18.083461332771886],
							[-67.199314, 18.091135],
							[-67.19529, 18.096149],
							[-67.183921, 18.103683],
							[-67.18366503596846, 18.104393046284162],
							[-67.182182, 18.108507],
							[-67.18060557743944, 18.12042232325941],
							[-67.17780520164163, 18.14158884530324],
							[-67.17779439319614, 18.141670540481396],
							[-67.176554, 18.151046],
							[-67.178618, 18.159318],
							[-67.180822, 18.168055],
							[-67.18055209145241, 18.168338689812515],
							[-67.180009, 18.168048],
							[-67.177355, 18.165117],
							[-67.173482, 18.162967],
							[-67.171788, 18.16012],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 147,
					name: 'Vieques',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.42614304205551, 18.158902946251104],
							[-65.42234654875581, 18.15933527380914],
							[-65.399517, 18.161935],
							[-65.371373, 18.157517],
							[-65.334289, 18.147761],
							[-65.313476, 18.144296],
							[-65.308717, 18.145172],
							[-65.302295, 18.141089],
							[-65.294896, 18.14283],
							[-65.287962, 18.148097],
							[-65.275165, 18.13443],
							[-65.276214, 18.131936],
							[-65.283248, 18.132999],
							[-65.296036, 18.12799],
							[-65.322794, 18.126589],
							[-65.327184, 18.124106],
							[-65.338506, 18.112439],
							[-65.342037, 18.11138],
							[-65.350493, 18.111914],
							[-65.364733, 18.120377],
							[-65.38195769810115, 18.115431871593966],
							[-65.397837, 18.110873],
							[-65.399791, 18.108832],
							[-65.411767, 18.106211],
							[-65.423765, 18.097764],
							[-65.426311, 18.093749],
							[-65.4381896632388, 18.09012271216376],
							[-65.44096836951113, 18.089274435842327],
							[-65.4502547667702, 18.086439508313365],
							[-65.45056181398081, 18.086345773728706],
							[-65.45138, 18.086096],
							[-65.45681, 18.087778],
							[-65.465849, 18.087715],
							[-65.4686060762075, 18.09236963225439],
							[-65.468768, 18.092643],
							[-65.47146013828446, 18.0935489282251],
							[-65.47460861839897, 18.094608419492086],
							[-65.47979, 18.096352],
							[-65.48982044992349, 18.094633954600912],
							[-65.49790149704465, 18.09324980873186],
							[-65.49816721828297, 18.093204295205105],
							[-65.507265, 18.091646],
							[-65.524209, 18.081977],
							[-65.542087, 18.081177],
							[-65.55584533275369, 18.084901778412632],
							[-65.558646, 18.08566],
							[-65.569305, 18.091616],
							[-65.570628, 18.097325],
							[-65.57686, 18.103224],
							[-65.575579, 18.115669],
							[-65.546199, 18.119329],
							[-65.5381687810876, 18.12247503892863],
							[-65.51171180847994, 18.132840219089413],
							[-65.50289812024398, 18.134077433192893],
							[-65.49779880317637, 18.1347932455549],
							[-65.49500384907851, 18.135185584895236],
							[-65.489829, 18.135912],
							[-65.48524830453793, 18.137553560420393],
							[-65.47455510487588, 18.141385627729367],
							[-65.46791, 18.143767],
							[-65.45707345862687, 18.14864681554833],
							[-65.45493433891474, 18.14961008503363],
							[-65.45246312188624, 18.150722901647686],
							[-65.45109775484485, 18.151337741667977],
							[-65.45036993344931, 18.15166548776704],
							[-65.44142843018568, 18.155691946500397],
							[-65.44136533551419, 18.155720358735294],
							[-65.43793688875601, 18.157264226582157],
							[-65.437058, 18.15766],
							[-65.4368972874848, 18.157678301217402],
							[-65.42614304205551, 18.158902946251104],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '067',
					name: 'Hormigueros',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.124624, 18.157927],
							[-67.122759, 18.15644],
							[-67.12083, 18.156003],
							[-67.117776, 18.158053],
							[-67.113116, 18.159936],
							[-67.111271, 18.15979],
							[-67.107587, 18.159528],
							[-67.100993, 18.157008],
							[-67.099311, 18.157434],
							[-67.097987, 18.15865],
							[-67.092908, 18.152145],
							[-67.089094, 18.151122],
							[-67.086464, 18.149757],
							[-67.086349, 18.149832],
							[-67.084199, 18.147788],
							[-67.084966, 18.146194],
							[-67.086351, 18.144386],
							[-67.087018, 18.144772],
							[-67.088059, 18.146141],
							[-67.086997, 18.147528],
							[-67.08704, 18.148428],
							[-67.08823, 18.148874],
							[-67.089574, 18.148865],
							[-67.09125, 18.148026],
							[-67.09215, 18.146916],
							[-67.0921, 18.144697],
							[-67.091831, 18.144156],
							[-67.09129, 18.142033],
							[-67.093, 18.140298],
							[-67.092808, 18.136692],
							[-67.09115, 18.132292],
							[-67.09226, 18.129064],
							[-67.092404, 18.127264],
							[-67.090692, 18.126335],
							[-67.090949, 18.125521],
							[-67.085305, 18.120784],
							[-67.084394, 18.120306],
							[-67.081487, 18.11838],
							[-67.079866, 18.117287],
							[-67.07969, 18.117168],
							[-67.078225, 18.113421],
							[-67.081383, 18.106985],
							[-67.085961, 18.106655],
							[-67.099321, 18.10708],
							[-67.100584, 18.106265],
							[-67.103232, 18.105147],
							[-67.105795, 18.105488],
							[-67.108295, 18.106352],
							[-67.110498, 18.107942],
							[-67.110747, 18.108601],
							[-67.117289, 18.111761],
							[-67.11952, 18.111761],
							[-67.132075, 18.120441],
							[-67.135218, 18.124503],
							[-67.133536, 18.129607],
							[-67.136482, 18.133043],
							[-67.140508, 18.133072],
							[-67.141273, 18.136967],
							[-67.142935, 18.13854],
							[-67.146125, 18.139517],
							[-67.147402, 18.140707],
							[-67.153936, 18.145391],
							[-67.153423, 18.149267],
							[-67.159708, 18.153157],
							[-67.157582, 18.156164],
							[-67.15047, 18.154041],
							[-67.147093, 18.155067],
							[-67.144598, 18.154105],
							[-67.138037, 18.153358],
							[-67.137779, 18.152979],
							[-67.136693, 18.151983],
							[-67.131365, 18.156381],
							[-67.12859, 18.157886],
							[-67.124624, 18.157927],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '075',
					name: 'Juana Díaz',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.52842, 18.152782],
							[-66.521899, 18.151954],
							[-66.522101, 18.148746],
							[-66.526909, 18.140207],
							[-66.52702, 18.13845],
							[-66.52632, 18.136414],
							[-66.527638, 18.134617],
							[-66.528334, 18.131379],
							[-66.526851, 18.130682],
							[-66.525937, 18.128041],
							[-66.525795, 18.127475],
							[-66.523199, 18.122484],
							[-66.526536, 18.11967],
							[-66.526428, 18.117036],
							[-66.525421, 18.115695],
							[-66.525819, 18.112295],
							[-66.526233, 18.111582],
							[-66.529888, 18.107969],
							[-66.53, 18.106708],
							[-66.528775, 18.104892],
							[-66.528745, 18.100673],
							[-66.52644, 18.098705],
							[-66.524376, 18.098266],
							[-66.521418, 18.094181],
							[-66.521077, 18.092519],
							[-66.5221, 18.089738],
							[-66.518245, 18.08503],
							[-66.50749, 18.080915],
							[-66.504692, 18.082406],
							[-66.503914, 18.083198],
							[-66.501948, 18.085958],
							[-66.501935, 18.08802],
							[-66.505268, 18.091464],
							[-66.505648, 18.092599],
							[-66.504946, 18.09391],
							[-66.501876, 18.095666],
							[-66.497113, 18.096345],
							[-66.492858, 18.096125],
							[-66.490713, 18.095316],
							[-66.487792, 18.094225],
							[-66.48503, 18.091274],
							[-66.484626, 18.089598],
							[-66.481877, 18.088011],
							[-66.471406, 18.085984],
							[-66.463316, 18.084909],
							[-66.454635, 18.08125],
							[-66.452863, 18.082682],
							[-66.451115, 18.083326],
							[-66.443983, 18.084822],
							[-66.438846, 18.084843],
							[-66.434573, 18.083755],
							[-66.4305, 18.082035],
							[-66.430196, 18.076304],
							[-66.427897, 18.072153],
							[-66.427736, 18.071634],
							[-66.429293, 18.068626],
							[-66.430898, 18.066714],
							[-66.431654, 18.063422],
							[-66.430522, 18.062386],
							[-66.425328, 18.05125],
							[-66.425778, 18.050015],
							[-66.425815, 18.048307],
							[-66.425186, 18.048284],
							[-66.424811, 18.049033],
							[-66.424086, 18.048453],
							[-66.425904, 18.046464],
							[-66.427096, 18.042646],
							[-66.427481, 18.04047],
							[-66.426085, 18.030815],
							[-66.422395, 18.024805],
							[-66.421249, 18.021262],
							[-66.421169, 18.019183],
							[-66.42537, 18.012002],
							[-66.427948, 18.011076],
							[-66.431543, 18.009675],
							[-66.435017, 18.006711],
							[-66.435744, 18.002806],
							[-66.435091, 17.999039],
							[-66.434841, 17.99668],
							[-66.437105, 17.992184],
							[-66.438206, 17.991636],
							[-66.437889, 17.994371],
							[-66.439544, 17.995211],
							[-66.442804, 17.990579],
							[-66.446093, 17.988156],
							[-66.449294, 17.984235],
							[-66.449412, 17.98415],
							[-66.45038817822538, 17.983241831376528],
							[-66.454888, 17.986784],
							[-66.461342, 17.990273],
							[-66.4776012318916, 17.99026704899345],
							[-66.48305121930449, 17.99026505425526],
							[-66.48332821681893, 17.990264952871996],
							[-66.49087363583992, 17.990262191189384],
							[-66.49113788444095, 17.99026209447232],
							[-66.491396, 17.990262],
							[-66.4918198923855, 17.990156993532924],
							[-66.5049845972065, 17.986895837657915],
							[-66.510143, 17.985618],
							[-66.51551503938326, 17.983825433732136],
							[-66.52263665949884, 17.981449059494906],
							[-66.53752043538144, 17.976482574202794],
							[-66.537602, 17.977431],
							[-66.53939, 17.978337],
							[-66.540566, 17.980551],
							[-66.539859, 17.98107],
							[-66.539165, 17.984847],
							[-66.538852, 17.986103],
							[-66.539855, 17.988938],
							[-66.53566, 17.994291],
							[-66.535707, 17.996682],
							[-66.533322, 17.99802],
							[-66.533271, 17.998202],
							[-66.532388, 17.998665],
							[-66.532585, 17.999854],
							[-66.530905, 18.000883],
							[-66.53042, 18.003075],
							[-66.53101, 18.004075],
							[-66.532833, 18.004374],
							[-66.533339, 18.005729],
							[-66.533364, 18.005885],
							[-66.537201, 18.013056],
							[-66.535803, 18.016391],
							[-66.536966, 18.019346],
							[-66.538374, 18.022697],
							[-66.540522, 18.022716],
							[-66.540666, 18.022781],
							[-66.540656, 18.022889],
							[-66.539319, 18.024284],
							[-66.538905, 18.025506],
							[-66.542196, 18.031038],
							[-66.542423, 18.032472],
							[-66.539599, 18.03569],
							[-66.537708, 18.039475],
							[-66.53734, 18.041286],
							[-66.541851, 18.045188],
							[-66.542961, 18.050536],
							[-66.54422, 18.051762],
							[-66.545652, 18.05238],
							[-66.546174, 18.053798],
							[-66.543844, 18.057739],
							[-66.544573, 18.060293],
							[-66.545679, 18.062151],
							[-66.546134, 18.062927],
							[-66.546237, 18.065722],
							[-66.545591, 18.06807],
							[-66.555508, 18.084651],
							[-66.555343, 18.086404],
							[-66.55349, 18.087985],
							[-66.553561, 18.090342],
							[-66.552457, 18.092478],
							[-66.549801, 18.093982],
							[-66.549031, 18.096776],
							[-66.550908, 18.102052],
							[-66.552682, 18.103477],
							[-66.554577, 18.10608],
							[-66.55537, 18.109113],
							[-66.555113, 18.113104],
							[-66.555698, 18.115719],
							[-66.561587, 18.115293],
							[-66.562143, 18.118227],
							[-66.561779, 18.119798],
							[-66.562051, 18.123015],
							[-66.564479, 18.125083],
							[-66.565091, 18.127536],
							[-66.565363, 18.129715],
							[-66.563271, 18.131226],
							[-66.562687, 18.133105],
							[-66.56275, 18.137087],
							[-66.563294, 18.137888],
							[-66.564527, 18.138354],
							[-66.564561, 18.139412],
							[-66.563114, 18.143585],
							[-66.56027, 18.145458],
							[-66.553788, 18.14856],
							[-66.552348, 18.150281],
							[-66.552175, 18.150881],
							[-66.552766, 18.152057],
							[-66.547221, 18.15313],
							[-66.542336, 18.147508],
							[-66.540874, 18.14732],
							[-66.538287, 18.148517],
							[-66.537336, 18.149025],
							[-66.530679, 18.152661],
							[-66.52842, 18.152782],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 121,
					name: 'Sabana Grande',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.927475, 18.151397],
							[-66.926251, 18.151172],
							[-66.92593, 18.150583],
							[-66.92567, 18.150473],
							[-66.925047, 18.148986],
							[-66.925046, 18.147726],
							[-66.925064, 18.147657],
							[-66.925189, 18.146256],
							[-66.925423, 18.145672],
							[-66.924513, 18.142829],
							[-66.921233, 18.139198],
							[-66.9178, 18.132182],
							[-66.916443, 18.126023],
							[-66.916889, 18.124129],
							[-66.918109, 18.123498],
							[-66.91727, 18.122373],
							[-66.917025, 18.120765],
							[-66.923767, 18.11502],
							[-66.921206, 18.107272],
							[-66.921003, 18.107008],
							[-66.920947, 18.106936],
							[-66.91988, 18.10305],
							[-66.915654, 18.09768],
							[-66.916679, 18.095977],
							[-66.918248, 18.094864],
							[-66.919736, 18.092305],
							[-66.918655, 18.089538],
							[-66.914995, 18.085475],
							[-66.914166, 18.084736],
							[-66.913145, 18.081604],
							[-66.912911, 18.07594],
							[-66.9122, 18.074093],
							[-66.909195, 18.070452],
							[-66.909864, 18.068522],
							[-66.909048, 18.064892],
							[-66.904019, 18.058269],
							[-66.90313, 18.056159],
							[-66.90125, 18.053659],
							[-66.901697, 18.051771],
							[-66.899659, 18.046692],
							[-66.898646, 18.042285],
							[-66.896, 18.041061],
							[-66.891516, 18.036368],
							[-66.887341, 18.033958],
							[-66.887159, 18.033826],
							[-66.886795, 18.032498],
							[-66.886807, 18.031551],
							[-66.885692, 18.027287],
							[-66.884645, 18.024814],
							[-66.887026, 18.024772],
							[-66.889951, 18.023547],
							[-66.891715, 18.024017],
							[-66.893689, 18.025579],
							[-66.895027, 18.023247],
							[-66.898649, 18.024007],
							[-66.900876, 18.025014],
							[-66.90661, 18.024764],
							[-66.910887, 18.023883],
							[-66.911746, 18.02438],
							[-66.913571, 18.02586],
							[-66.917424, 18.027227],
							[-66.919536, 18.027692],
							[-66.922594, 18.027212],
							[-66.930811, 18.030583],
							[-66.933879, 18.030727],
							[-66.936178, 18.029742],
							[-66.936271, 18.029416],
							[-66.937887, 18.029819],
							[-66.938507, 18.029973],
							[-66.941347, 18.031515],
							[-66.947056, 18.033429],
							[-66.953195, 18.033648],
							[-66.958748, 18.032477],
							[-66.959267, 18.03215],
							[-66.959316, 18.035035],
							[-66.960371, 18.036519],
							[-66.966752, 18.037816],
							[-66.966933, 18.038121],
							[-66.967736, 18.03843],
							[-66.967976, 18.038476],
							[-66.968532, 18.038584],
							[-66.982675, 18.041202],
							[-66.982061, 18.042843],
							[-66.983341, 18.050767],
							[-66.983317, 18.052513],
							[-66.981849, 18.056494],
							[-66.981396, 18.066977],
							[-66.981236, 18.072323],
							[-66.980589, 18.078685],
							[-66.981116, 18.080114],
							[-66.982266, 18.086286],
							[-66.982313, 18.086341],
							[-66.983578, 18.088383],
							[-66.983201, 18.095239],
							[-66.984108, 18.101644],
							[-66.98369, 18.105584],
							[-66.983212, 18.108681],
							[-66.979262, 18.121237],
							[-66.978083, 18.123014],
							[-66.978037, 18.12301],
							[-66.976071, 18.12512],
							[-66.974175, 18.126279],
							[-66.970463, 18.132486],
							[-66.972865, 18.140385],
							[-66.976618, 18.143291],
							[-66.977856, 18.143801],
							[-66.975544, 18.143394],
							[-66.971865, 18.14154],
							[-66.97048, 18.141992],
							[-66.968822, 18.144014],
							[-66.964291, 18.147055],
							[-66.958127, 18.145714],
							[-66.951121, 18.146361],
							[-66.949823, 18.146813],
							[-66.948093, 18.147267],
							[-66.947212, 18.147699],
							[-66.946671, 18.148105],
							[-66.939065, 18.147856],
							[-66.935199, 18.148236],
							[-66.934934, 18.148487],
							[-66.934654, 18.148813],
							[-66.934593, 18.148884],
							[-66.933944, 18.150229],
							[-66.931321, 18.149779],
							[-66.930052, 18.148934],
							[-66.927475, 18.151397],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '059',
					name: 'Guayanilla',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.790587, 18.134821],
							[-66.789359, 18.134369],
							[-66.788544, 18.134404],
							[-66.786712, 18.136803],
							[-66.7844, 18.138652],
							[-66.782322, 18.136463],
							[-66.780771, 18.135948],
							[-66.774494, 18.133197],
							[-66.76905, 18.134983],
							[-66.769404, 18.133203],
							[-66.768751, 18.127607],
							[-66.766444, 18.124338],
							[-66.761278, 18.112323],
							[-66.761569, 18.111195],
							[-66.763026, 18.11004],
							[-66.765565, 18.106416],
							[-66.764565, 18.10119],
							[-66.765817, 18.0985],
							[-66.765889, 18.098428],
							[-66.76715, 18.096632],
							[-66.767787, 18.093164],
							[-66.767926, 18.091567],
							[-66.768806, 18.090369],
							[-66.769529, 18.087039],
							[-66.768867, 18.085188],
							[-66.765574, 18.082196],
							[-66.766088, 18.076265],
							[-66.766207, 18.075011],
							[-66.767853, 18.073379],
							[-66.768469, 18.071952],
							[-66.768595, 18.070561],
							[-66.768112, 18.067659],
							[-66.767109, 18.066163],
							[-66.766986, 18.064886],
							[-66.767208, 18.062403],
							[-66.768584, 18.060527],
							[-66.769258, 18.058996],
							[-66.76899, 18.058171],
							[-66.76838, 18.056257],
							[-66.766616, 18.049709],
							[-66.768112, 18.048921],
							[-66.767451, 18.047915],
							[-66.767464, 18.047832],
							[-66.766211, 18.041207],
							[-66.765132, 18.03898],
							[-66.762965, 18.046997],
							[-66.758792, 18.052763],
							[-66.75564, 18.056235],
							[-66.755149, 18.056185],
							[-66.753962, 18.052551],
							[-66.753881, 18.049911],
							[-66.746599, 18.044764],
							[-66.741742, 18.045117],
							[-66.739494, 18.047349],
							[-66.738798, 18.047449],
							[-66.736336, 18.043507],
							[-66.737896, 18.041587],
							[-66.738424, 18.041091],
							[-66.738768, 18.038188],
							[-66.738452, 18.037462],
							[-66.73972, 18.035431],
							[-66.740003, 18.035023],
							[-66.74172, 18.030531],
							[-66.734223, 18.020529],
							[-66.732974, 18.017218],
							[-66.734845, 18.014096],
							[-66.73765, 18.013354],
							[-66.741628, 18.01372],
							[-66.748822, 18.010752],
							[-66.751522, 18.006306],
							[-66.75116, 18.005092],
							[-66.75302287568819, 17.99848578468946],
							[-66.75392348429213, 17.999541443126308],
							[-66.755341, 18.001203],
							[-66.75854144776865, 18.002991752993317],
							[-66.76355492452886, 18.005793820769462],
							[-66.764491, 18.006317],
							[-66.76821947996855, 18.006084931611312],
							[-66.770307, 18.005955],
							[-66.77596998680019, 18.003349165500133],
							[-66.79619303619778, 17.994043489595864],
							[-66.7969646427722, 17.993688433314986],
							[-66.799656, 17.99245],
							[-66.80294818563954, 17.98849389786671],
							[-66.806866, 17.983786],
							[-66.807924, 17.979606],
							[-66.806903, 17.976046],
							[-66.805683, 17.975052],
							[-66.79510619238282, 17.977437975830078],
							[-66.789302, 17.980793],
							[-66.784953, 17.978326],
							[-66.787245, 17.972914],
							[-66.80827, 17.965635],
							[-66.8224, 17.954499],
							[-66.838584, 17.949931],
							[-66.85228797692847, 17.955003539699288],
							[-66.836683, 17.965971],
							[-66.835408, 17.986456],
							[-66.835282, 17.988274],
							[-66.833159, 17.98993],
							[-66.831292, 17.994756],
							[-66.831423, 17.997046],
							[-66.830463, 17.998772],
							[-66.825979, 17.999698],
							[-66.82569, 18.001983],
							[-66.826462, 18.007682],
							[-66.829879, 18.014944],
							[-66.829664, 18.018709],
							[-66.822405, 18.020809],
							[-66.82132, 18.021507],
							[-66.820711, 18.025194],
							[-66.818062, 18.029528],
							[-66.821497, 18.032694],
							[-66.822146, 18.034287],
							[-66.821909, 18.03679],
							[-66.824411, 18.040865],
							[-66.824488, 18.043162],
							[-66.824295, 18.044173],
							[-66.824182, 18.046706],
							[-66.823994, 18.047706],
							[-66.822498, 18.050276],
							[-66.819277, 18.055174],
							[-66.818703, 18.062297],
							[-66.817532, 18.067876],
							[-66.816985, 18.069662],
							[-66.815617, 18.071633],
							[-66.813605, 18.075113],
							[-66.809201, 18.081226],
							[-66.808667, 18.081939],
							[-66.80645, 18.085272],
							[-66.805219, 18.08696],
							[-66.80221, 18.090992],
							[-66.803912, 18.093505],
							[-66.80527, 18.094031],
							[-66.806622, 18.097514],
							[-66.805675, 18.100011],
							[-66.805176, 18.101027],
							[-66.805877, 18.103902],
							[-66.808859, 18.105473],
							[-66.809824, 18.108003],
							[-66.810065, 18.11052],
							[-66.810249, 18.111129],
							[-66.810666, 18.11303],
							[-66.810159, 18.113899],
							[-66.80087, 18.120024],
							[-66.796268, 18.121461],
							[-66.798937, 18.132741],
							[-66.797558, 18.133445],
							[-66.794012, 18.133633],
							[-66.790587, 18.134821],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 111,
					name: 'Peñuelas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.767131, 18.135002],
							[-66.76546, 18.133705],
							[-66.764707, 18.132646],
							[-66.763972, 18.132614],
							[-66.759058, 18.128964],
							[-66.756756, 18.125215],
							[-66.756192, 18.122618],
							[-66.754839, 18.120061],
							[-66.754781, 18.119909],
							[-66.749619, 18.113664],
							[-66.747747, 18.114394],
							[-66.747489, 18.115392],
							[-66.74649, 18.115787],
							[-66.739464, 18.116992],
							[-66.739437, 18.116624],
							[-66.737791, 18.115806],
							[-66.731398, 18.111907],
							[-66.7275, 18.113018],
							[-66.727169, 18.113876],
							[-66.725182, 18.116794],
							[-66.725619, 18.120413],
							[-66.725138, 18.121275],
							[-66.723578, 18.123015],
							[-66.718156, 18.128002],
							[-66.717589, 18.128912],
							[-66.717454, 18.129184],
							[-66.717035, 18.13066],
							[-66.717164, 18.131519],
							[-66.716463, 18.131469],
							[-66.714708, 18.131833],
							[-66.714304, 18.131932],
							[-66.713521, 18.131311],
							[-66.710227, 18.127932],
							[-66.707917, 18.129169],
							[-66.706889, 18.129308],
							[-66.705953, 18.129501],
							[-66.704887, 18.129695],
							[-66.702546, 18.129013],
							[-66.698249, 18.130601],
							[-66.697643, 18.130713],
							[-66.69495, 18.130743],
							[-66.694071, 18.130534],
							[-66.693916, 18.12975],
							[-66.690257, 18.124656],
							[-66.688502, 18.123178],
							[-66.68825, 18.122368],
							[-66.688193, 18.122389],
							[-66.686652, 18.121307],
							[-66.684437, 18.117769],
							[-66.684243, 18.11747],
							[-66.684411, 18.117058],
							[-66.684367, 18.115775],
							[-66.684826, 18.114964],
							[-66.684568, 18.112033],
							[-66.681595, 18.107415],
							[-66.67964, 18.105286],
							[-66.67804, 18.100289],
							[-66.678078, 18.088758],
							[-66.680353, 18.077052],
							[-66.680819, 18.075538],
							[-66.680638, 18.074986],
							[-66.679465, 18.072647],
							[-66.680142, 18.070452],
							[-66.680822, 18.069522],
							[-66.684408, 18.065015],
							[-66.684763, 18.061976],
							[-66.685029, 18.059633],
							[-66.686416, 18.055146],
							[-66.687577, 18.052016],
							[-66.687044, 18.051528],
							[-66.686575, 18.050278],
							[-66.686541, 18.050103],
							[-66.685586, 18.047514],
							[-66.685942, 18.045486],
							[-66.688462, 18.042315],
							[-66.689446, 18.040257],
							[-66.68941, 18.03204],
							[-66.68936, 18.029939],
							[-66.689424, 18.029842],
							[-66.687677, 18.023258],
							[-66.686338, 18.016967],
							[-66.688177, 18.013355],
							[-66.690022, 18.003736],
							[-66.689443, 18.00009],
							[-66.687818, 17.998414],
							[-66.68825, 17.995923],
							[-66.689016, 17.994717],
							[-66.687316, 17.9929],
							[-66.686768, 17.991486],
							[-66.688369, 17.988805],
							[-66.693204, 17.983328],
							[-66.698097, 17.981617],
							[-66.699102, 17.977611],
							[-66.69911289630915, 17.977567176483205],
							[-66.709856, 17.982109],
							[-66.713394, 17.987763],
							[-66.716957, 17.990344],
							[-66.72702331770536, 17.991278361387025],
							[-66.73111831152647, 17.991658461063842],
							[-66.73491701775177, 17.99132968642293],
							[-66.746248, 17.990349],
							[-66.750427, 17.995443],
							[-66.75302287568819, 17.99848578468946],
							[-66.75116, 18.005092],
							[-66.751522, 18.006306],
							[-66.748822, 18.010752],
							[-66.741628, 18.01372],
							[-66.73765, 18.013354],
							[-66.734845, 18.014096],
							[-66.732974, 18.017218],
							[-66.734223, 18.020529],
							[-66.74172, 18.030531],
							[-66.740003, 18.035023],
							[-66.73972, 18.035431],
							[-66.738452, 18.037462],
							[-66.738768, 18.038188],
							[-66.738424, 18.041091],
							[-66.737896, 18.041587],
							[-66.736336, 18.043507],
							[-66.738798, 18.047449],
							[-66.739494, 18.047349],
							[-66.741742, 18.045117],
							[-66.746599, 18.044764],
							[-66.753881, 18.049911],
							[-66.753962, 18.052551],
							[-66.755149, 18.056185],
							[-66.75564, 18.056235],
							[-66.758792, 18.052763],
							[-66.762965, 18.046997],
							[-66.765132, 18.03898],
							[-66.766211, 18.041207],
							[-66.767464, 18.047832],
							[-66.767451, 18.047915],
							[-66.768112, 18.048921],
							[-66.766616, 18.049709],
							[-66.76838, 18.056257],
							[-66.76899, 18.058171],
							[-66.769258, 18.058996],
							[-66.768584, 18.060527],
							[-66.767208, 18.062403],
							[-66.766986, 18.064886],
							[-66.767109, 18.066163],
							[-66.768112, 18.067659],
							[-66.768595, 18.070561],
							[-66.768469, 18.071952],
							[-66.767853, 18.073379],
							[-66.766207, 18.075011],
							[-66.766088, 18.076265],
							[-66.765574, 18.082196],
							[-66.768867, 18.085188],
							[-66.769529, 18.087039],
							[-66.768806, 18.090369],
							[-66.767926, 18.091567],
							[-66.767787, 18.093164],
							[-66.76715, 18.096632],
							[-66.765889, 18.098428],
							[-66.765817, 18.0985],
							[-66.764565, 18.10119],
							[-66.765565, 18.106416],
							[-66.763026, 18.11004],
							[-66.761569, 18.111195],
							[-66.761278, 18.112323],
							[-66.766444, 18.124338],
							[-66.768751, 18.127607],
							[-66.769404, 18.133203],
							[-66.76905, 18.134983],
							[-66.767131, 18.135002],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 151,
					name: 'Yabucoa',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.907422, 18.126118],
							[-65.900525, 18.125426],
							[-65.900504, 18.125405],
							[-65.899459, 18.124008],
							[-65.894701, 18.124133],
							[-65.894047, 18.123839],
							[-65.893717, 18.12337],
							[-65.893496, 18.123016],
							[-65.893226, 18.122571],
							[-65.893153, 18.122504],
							[-65.892892, 18.122436],
							[-65.889361, 18.121313],
							[-65.885087, 18.122522],
							[-65.88362, 18.12236],
							[-65.882226, 18.119818],
							[-65.880677, 18.118852],
							[-65.880496, 18.118763],
							[-65.877625, 18.1181],
							[-65.874649, 18.115008],
							[-65.871366, 18.111434],
							[-65.870277, 18.108448],
							[-65.867694, 18.108555],
							[-65.866427, 18.108646],
							[-65.86543, 18.107993],
							[-65.863255, 18.112334],
							[-65.860302, 18.115637],
							[-65.855555, 18.117427],
							[-65.850923, 18.118227],
							[-65.849417, 18.117411],
							[-65.847439, 18.117074],
							[-65.845087, 18.114987],
							[-65.846062, 18.114001],
							[-65.846004, 18.112421],
							[-65.842544, 18.112057],
							[-65.842025, 18.110116],
							[-65.843092, 18.108212],
							[-65.845573, 18.106066],
							[-65.847316, 18.103432],
							[-65.84807, 18.101776],
							[-65.848238, 18.099224],
							[-65.847873, 18.09864],
							[-65.84248, 18.096507],
							[-65.840694, 18.094371],
							[-65.840325, 18.090996],
							[-65.837901, 18.090089],
							[-65.837339, 18.090846],
							[-65.835731, 18.091042],
							[-65.832933, 18.090199],
							[-65.830874, 18.089347],
							[-65.82945, 18.084946],
							[-65.828245, 18.084055],
							[-65.825337, 18.083515],
							[-65.822716, 18.083829],
							[-65.820648, 18.081356],
							[-65.818464, 18.08062],
							[-65.818166, 18.082653],
							[-65.817825, 18.082578],
							[-65.814101, 18.081737],
							[-65.813963, 18.08026],
							[-65.812378, 18.078221],
							[-65.811806, 18.077711],
							[-65.810922, 18.075235],
							[-65.809177, 18.072841],
							[-65.808966, 18.071804],
							[-65.806345, 18.071043],
							[-65.798714, 18.069455],
							[-65.79670048513722, 18.069864962729223],
							[-65.79671105356883, 18.069841607474086],
							[-65.79685914713139, 18.069514334415206],
							[-65.80174440778426, 18.058718360777835],
							[-65.801831, 18.058527],
							[-65.80210758332692, 18.05846262836638],
							[-65.809174, 18.056818],
							[-65.817107, 18.063378],
							[-65.825848, 18.057482],
							[-65.82674936022174, 18.05630964708282],
							[-65.82720328440311, 18.05571925122845],
							[-65.83109, 18.050664],
							[-65.833932438427, 18.04024053546679],
							[-65.8341033201192, 18.039613897703553],
							[-65.834274, 18.038988],
							[-65.83425607042206, 18.03875407002705],
							[-65.83423990669328, 18.03854317936088],
							[-65.8340122131251, 18.03557242620473],
							[-65.83306358725827, 18.023195557984195],
							[-65.832429, 18.014916],
							[-65.839591, 18.015077],
							[-65.84936848938803, 18.012380112476894],
							[-65.85120062497519, 18.011874761521288],
							[-65.857293, 18.016945],
							[-65.857295, 18.017837],
							[-65.85737, 18.017945],
							[-65.857355, 18.018038],
							[-65.857638, 18.019508],
							[-65.858943, 18.021194],
							[-65.86319, 18.024032],
							[-65.864627, 18.025698],
							[-65.867644, 18.026048],
							[-65.874606, 18.023404],
							[-65.880938, 18.020861],
							[-65.882224, 18.023965],
							[-65.888172, 18.030154],
							[-65.897377, 18.034025],
							[-65.900228, 18.032931],
							[-65.904715, 18.034106],
							[-65.906205, 18.035253],
							[-65.912062, 18.033103],
							[-65.915624, 18.034321],
							[-65.916901, 18.034247],
							[-65.923215, 18.035299],
							[-65.925134, 18.036826],
							[-65.933736, 18.0368],
							[-65.935184, 18.040723],
							[-65.941466, 18.040846],
							[-65.943141, 18.043836],
							[-65.948639, 18.045716],
							[-65.950367, 18.04595],
							[-65.952017, 18.044694],
							[-65.953069, 18.046696],
							[-65.955112, 18.047768],
							[-65.959082, 18.052224],
							[-65.960659, 18.053225],
							[-65.966349, 18.053913],
							[-65.966392, 18.053885],
							[-65.972241, 18.052898],
							[-65.973582, 18.054146],
							[-65.973677, 18.054901],
							[-65.977794, 18.061024],
							[-65.980277, 18.061091],
							[-65.988523, 18.058941],
							[-65.989949, 18.059295],
							[-65.991881, 18.060629],
							[-65.999608, 18.060055],
							[-66.003155, 18.062055],
							[-66.010607, 18.067812],
							[-66.010669, 18.067894],
							[-66.00992, 18.072476],
							[-66.009691, 18.073805],
							[-66.010246, 18.075565],
							[-66.006538, 18.075935],
							[-66.003184, 18.078723],
							[-65.999608, 18.082407],
							[-65.996225, 18.084565],
							[-65.995282, 18.085026],
							[-65.994741, 18.088131],
							[-65.993693, 18.089656],
							[-65.990781, 18.090134],
							[-65.986651, 18.089679],
							[-65.984901, 18.088545],
							[-65.983378, 18.089303],
							[-65.978733, 18.094755],
							[-65.977633, 18.095003],
							[-65.977167, 18.09464],
							[-65.976079, 18.09438],
							[-65.975809, 18.092864],
							[-65.97345, 18.090932],
							[-65.967789, 18.089165],
							[-65.966174, 18.089261],
							[-65.964541, 18.08711],
							[-65.962051, 18.086497],
							[-65.960443, 18.088778],
							[-65.955748, 18.091766],
							[-65.955043, 18.091733],
							[-65.952441, 18.092746],
							[-65.951399, 18.092326],
							[-65.944499, 18.08989],
							[-65.944166, 18.089639],
							[-65.941677, 18.089267],
							[-65.936121, 18.092679],
							[-65.933813, 18.095288],
							[-65.930357, 18.097507],
							[-65.931937, 18.100753],
							[-65.930321, 18.100731],
							[-65.92873, 18.101976],
							[-65.928369, 18.104983],
							[-65.927445, 18.105265],
							[-65.925461, 18.105585],
							[-65.924573, 18.106328],
							[-65.924315, 18.108067],
							[-65.924531, 18.108136],
							[-65.924852, 18.108161],
							[-65.925858, 18.108397],
							[-65.927038, 18.115876],
							[-65.926266, 18.119969],
							[-65.924635, 18.121565],
							[-65.924266, 18.121558],
							[-65.921893, 18.121416],
							[-65.920763, 18.121312],
							[-65.919638, 18.120975],
							[-65.914649, 18.122278],
							[-65.913982, 18.123016],
							[-65.910256, 18.123598],
							[-65.909524, 18.123844],
							[-65.907422, 18.126118],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 109,
					name: 'Patillas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.053224, 18.10949],
							[-66.051878, 18.109907],
							[-66.050891, 18.109385],
							[-66.042041, 18.103839],
							[-66.028065, 18.10157],
							[-66.025206, 18.102485],
							[-66.022223, 18.102857],
							[-66.02097, 18.102919],
							[-66.019551, 18.102097],
							[-66.018444, 18.100207],
							[-66.018159, 18.099506],
							[-66.012717, 18.094457],
							[-66.019444, 18.083723],
							[-66.018305, 18.081736],
							[-66.017593, 18.081269],
							[-66.013973, 18.076957],
							[-66.010246, 18.075565],
							[-66.009691, 18.073805],
							[-66.00992, 18.072476],
							[-66.010669, 18.067894],
							[-66.010607, 18.067812],
							[-66.003155, 18.062055],
							[-65.999608, 18.060055],
							[-65.991881, 18.060629],
							[-65.989949, 18.059295],
							[-65.988523, 18.058941],
							[-65.988181, 18.055576],
							[-65.987873, 18.054752],
							[-65.986043, 18.051698],
							[-65.985578, 18.04521],
							[-65.982212, 18.041272],
							[-65.980143, 18.04026],
							[-65.980041, 18.0385],
							[-65.980972, 18.035814],
							[-65.981901, 18.03484],
							[-65.979413, 18.033008],
							[-65.97565, 18.032859],
							[-65.972316, 18.025208],
							[-65.971954, 18.024463],
							[-65.966133, 18.027981],
							[-65.960924, 18.028259],
							[-65.959813, 18.02818],
							[-65.957648, 18.02602],
							[-65.954252, 18.024332],
							[-65.952848, 18.023111],
							[-65.953564, 18.021704],
							[-65.952833, 18.019285],
							[-65.954915, 18.013448],
							[-65.954037, 18.011585],
							[-65.953302, 18.007407],
							[-65.952385, 18.006029],
							[-65.948761, 18.004595],
							[-65.94868, 18.003886],
							[-65.945935, 17.998021],
							[-65.943137, 17.992612],
							[-65.937919, 17.992037],
							[-65.926154, 17.985998],
							[-65.920488, 17.985074],
							[-65.913007, 17.984929],
							[-65.9104926090737, 17.981872745828092],
							[-65.924738, 17.976087],
							[-65.93898446148664, 17.973775070618732],
							[-65.94243999423756, 17.973214303462463],
							[-65.95992021807656, 17.970377596037082],
							[-65.96583349944665, 17.969417983086736],
							[-65.976611, 17.967669],
							[-65.97686193320443, 17.967724060541897],
							[-65.98455, 17.969411],
							[-65.985358, 17.971854],
							[-65.995185, 17.978989],
							[-66.00234404372085, 17.979874607831558],
							[-66.007731, 17.980541],
							[-66.01611132604474, 17.979702704881397],
							[-66.0165735907175, 17.979656463933658],
							[-66.01664642176792, 17.97964917854718],
							[-66.01685474063656, 17.979628340134717],
							[-66.017308, 17.979583],
							[-66.01831347637697, 17.979029026389437],
							[-66.01952002957326, 17.97836426822526],
							[-66.019687, 17.978624],
							[-66.021984, 17.982267],
							[-66.023411, 17.985032],
							[-66.023972, 17.9903],
							[-66.026334, 17.992766],
							[-66.027968, 17.994493],
							[-66.028981, 17.994665],
							[-66.031185, 17.996139],
							[-66.031797, 17.996342],
							[-66.03315, 17.997598],
							[-66.035176, 17.998522],
							[-66.03772, 17.998425],
							[-66.038447, 18.000647],
							[-66.039036, 18.003208],
							[-66.03978, 18.004213],
							[-66.044628, 18.006501],
							[-66.046928, 18.009097],
							[-66.045656, 18.011119],
							[-66.042248, 18.016539],
							[-66.042661, 18.022057],
							[-66.04408, 18.022819],
							[-66.04331, 18.025187],
							[-66.043265, 18.028019],
							[-66.043683, 18.029445],
							[-66.045146, 18.03082],
							[-66.046068, 18.031398],
							[-66.046484, 18.031864],
							[-66.048108, 18.035614],
							[-66.048955, 18.035986],
							[-66.050902, 18.036282],
							[-66.051388, 18.036782],
							[-66.052375, 18.037604],
							[-66.052523, 18.037955],
							[-66.054054, 18.037871],
							[-66.055055, 18.038207],
							[-66.056333, 18.038982],
							[-66.057015, 18.040167],
							[-66.058449, 18.040106],
							[-66.059814, 18.039409],
							[-66.060977, 18.039288],
							[-66.064798, 18.039049],
							[-66.068341, 18.037701],
							[-66.073812, 18.03687],
							[-66.073854, 18.036797],
							[-66.079668, 18.034062],
							[-66.081955, 18.032854],
							[-66.082393, 18.032375],
							[-66.084299, 18.034984],
							[-66.08563, 18.038715],
							[-66.086779, 18.044102],
							[-66.086115, 18.047951],
							[-66.086778, 18.049774],
							[-66.089378, 18.056198],
							[-66.085678, 18.063172],
							[-66.08436, 18.062833],
							[-66.081145, 18.06389],
							[-66.079304, 18.067422],
							[-66.079581, 18.071113],
							[-66.080419, 18.072464],
							[-66.079903, 18.074929],
							[-66.070523, 18.079695],
							[-66.067767, 18.079457],
							[-66.067145, 18.080955],
							[-66.062546, 18.088056],
							[-66.060668, 18.089608],
							[-66.060366, 18.090137],
							[-66.060054, 18.090735],
							[-66.060512, 18.09875],
							[-66.059874, 18.100953],
							[-66.058015, 18.104288],
							[-66.055867, 18.105178],
							[-66.053147, 18.107293],
							[-66.053224, 18.10949],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '057',
					name: 'Guayama',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.074949, 18.10565],
							[-66.074449, 18.105807],
							[-66.073999, 18.105475],
							[-66.070383, 18.101882],
							[-66.063629, 18.102912],
							[-66.054147, 18.10721],
							[-66.053147, 18.107293],
							[-66.055867, 18.105178],
							[-66.058015, 18.104288],
							[-66.059874, 18.100953],
							[-66.060512, 18.09875],
							[-66.060054, 18.090735],
							[-66.060366, 18.090137],
							[-66.060668, 18.089608],
							[-66.062546, 18.088056],
							[-66.067145, 18.080955],
							[-66.067767, 18.079457],
							[-66.070523, 18.079695],
							[-66.079903, 18.074929],
							[-66.080419, 18.072464],
							[-66.079581, 18.071113],
							[-66.079304, 18.067422],
							[-66.081145, 18.06389],
							[-66.08436, 18.062833],
							[-66.085678, 18.063172],
							[-66.089378, 18.056198],
							[-66.086778, 18.049774],
							[-66.086115, 18.047951],
							[-66.086779, 18.044102],
							[-66.08563, 18.038715],
							[-66.084299, 18.034984],
							[-66.082393, 18.032375],
							[-66.082021, 18.030725],
							[-66.085598, 18.027468],
							[-66.093883, 18.023318],
							[-66.095136, 18.022048],
							[-66.093555, 18.021143],
							[-66.091439, 18.01804],
							[-66.088373, 18.015054],
							[-66.08655, 18.014127],
							[-66.085704, 18.012934],
							[-66.08385, 18.012918],
							[-66.082542, 18.010752],
							[-66.081271, 18.004458],
							[-66.079774, 18.001796],
							[-66.077203, 18.000133],
							[-66.072476, 17.995112],
							[-66.07161, 17.993732],
							[-66.071601, 17.991838],
							[-66.071632, 17.990928],
							[-66.071714, 17.989624],
							[-66.071756, 17.988948],
							[-66.071883, 17.986924],
							[-66.072401, 17.978682],
							[-66.072357, 17.978407],
							[-66.069692, 17.97429],
							[-66.070754, 17.968842],
							[-66.070001, 17.966674],
							[-66.06996832535535, 17.966356991878897],
							[-66.08141, 17.966552],
							[-66.09803640067582, 17.95822971785399],
							[-66.116194, 17.949141],
							[-66.127009, 17.946953],
							[-66.140661, 17.94102],
							[-66.14414969908809, 17.937624640813045],
							[-66.147912, 17.933963],
							[-66.155387, 17.929406],
							[-66.159742, 17.928613],
							[-66.16043810436845, 17.930077155094466],
							[-66.161232, 17.931747],
							[-66.17271088882244, 17.933196530258723],
							[-66.17562608378906, 17.933564655029297],
							[-66.17776155251224, 17.933904958820936],
							[-66.18691388378906, 17.935363455029297],
							[-66.18756656838653, 17.935032169205233],
							[-66.18972608378905, 17.933936055029296],
							[-66.19569531192708, 17.93141016512476],
							[-66.200174, 17.929515],
							[-66.206961, 17.932268],
							[-66.213374, 17.944614],
							[-66.202655, 17.944753],
							[-66.18555363652344, 17.94099684482422],
							[-66.17954763652344, 17.94372744482422],
							[-66.17484572882553, 17.9482075885374],
							[-66.174839, 17.948214],
							[-66.17485222751525, 17.94822889518678],
							[-66.176814, 17.950438],
							[-66.18858654982242, 17.95548921007117],
							[-66.19847819777176, 17.959733387627942],
							[-66.20124457924754, 17.96092035002623],
							[-66.20620688688727, 17.963049511397738],
							[-66.206121, 17.96795],
							[-66.206116, 17.968248],
							[-66.206105, 17.968925],
							[-66.206098, 17.969327],
							[-66.205901, 17.976944],
							[-66.205879, 17.977802],
							[-66.205865, 17.978348],
							[-66.205884, 17.982328],
							[-66.205886, 17.982685],
							[-66.205845, 17.987322],
							[-66.205788, 17.98977],
							[-66.205572, 17.998278],
							[-66.205577, 17.998545],
							[-66.205658, 18.011503],
							[-66.205657, 18.011853],
							[-66.20335, 18.013258],
							[-66.201579, 18.016828],
							[-66.201524, 18.017987],
							[-66.200349, 18.018947],
							[-66.196611, 18.020562],
							[-66.194809, 18.020012],
							[-66.192509, 18.020322],
							[-66.190044, 18.022543],
							[-66.189063, 18.024202],
							[-66.184025, 18.025486],
							[-66.182281, 18.024539],
							[-66.18051, 18.025069],
							[-66.179952, 18.02574],
							[-66.180937, 18.028852],
							[-66.179173, 18.030233],
							[-66.177744, 18.032185],
							[-66.174903, 18.032736],
							[-66.166145, 18.050063],
							[-66.160685, 18.0498],
							[-66.157954, 18.048961],
							[-66.15574, 18.043419],
							[-66.150087, 18.0421],
							[-66.143114, 18.039755],
							[-66.142559, 18.038206],
							[-66.140524, 18.037687],
							[-66.138987, 18.036917],
							[-66.135193, 18.037336],
							[-66.128513, 18.039526],
							[-66.129605, 18.042349],
							[-66.125232, 18.05165],
							[-66.122777, 18.060367],
							[-66.122614, 18.060446],
							[-66.120068, 18.062812],
							[-66.122465, 18.070925],
							[-66.121511, 18.072864],
							[-66.125076, 18.074364],
							[-66.126113, 18.076342],
							[-66.126238, 18.077612],
							[-66.12461, 18.077646],
							[-66.124415, 18.078097],
							[-66.12394, 18.079137],
							[-66.123725, 18.079472],
							[-66.124159, 18.082035],
							[-66.12461, 18.08269],
							[-66.126109, 18.082485],
							[-66.127559, 18.086309],
							[-66.129006, 18.088809],
							[-66.128129, 18.092247],
							[-66.128056, 18.09422],
							[-66.12634, 18.097156],
							[-66.122145, 18.093769],
							[-66.112909, 18.091691],
							[-66.109208, 18.097929],
							[-66.109197, 18.09917],
							[-66.105957, 18.099124],
							[-66.102965, 18.10265],
							[-66.102703, 18.105009],
							[-66.098205, 18.106964],
							[-66.088253, 18.107507],
							[-66.085722, 18.105346],
							[-66.078643, 18.102997],
							[-66.077989, 18.103085],
							[-66.074949, 18.10565],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 123,
					name: 'Salinas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.224725, 18.095096],
							[-66.223351, 18.095003],
							[-66.218344, 18.092567],
							[-66.217146, 18.090153],
							[-66.215258, 18.085952],
							[-66.215803, 18.079563],
							[-66.211736, 18.074602],
							[-66.208561, 18.07078],
							[-66.206068, 18.067653],
							[-66.201681, 18.067639],
							[-66.201045, 18.065092],
							[-66.200677, 18.064076],
							[-66.201368, 18.057609],
							[-66.203829, 18.055156],
							[-66.204309, 18.05506],
							[-66.20276, 18.048598],
							[-66.202048, 18.046189],
							[-66.201967, 18.046078],
							[-66.198735, 18.047571],
							[-66.198602, 18.047743],
							[-66.196041, 18.04915],
							[-66.188139, 18.050402],
							[-66.180481, 18.052359],
							[-66.177978, 18.053494],
							[-66.173325, 18.053289],
							[-66.1709, 18.051984],
							[-66.167515, 18.0517],
							[-66.166145, 18.050063],
							[-66.174903, 18.032736],
							[-66.177744, 18.032185],
							[-66.179173, 18.030233],
							[-66.180937, 18.028852],
							[-66.179952, 18.02574],
							[-66.18051, 18.025069],
							[-66.182281, 18.024539],
							[-66.184025, 18.025486],
							[-66.189063, 18.024202],
							[-66.190044, 18.022543],
							[-66.192509, 18.020322],
							[-66.194809, 18.020012],
							[-66.196611, 18.020562],
							[-66.200349, 18.018947],
							[-66.201524, 18.017987],
							[-66.201579, 18.016828],
							[-66.20335, 18.013258],
							[-66.205657, 18.011853],
							[-66.205658, 18.011503],
							[-66.205577, 17.998545],
							[-66.205572, 17.998278],
							[-66.205788, 17.98977],
							[-66.205845, 17.987322],
							[-66.205886, 17.982685],
							[-66.205884, 17.982328],
							[-66.205865, 17.978348],
							[-66.205879, 17.977802],
							[-66.205901, 17.976944],
							[-66.206098, 17.969327],
							[-66.206105, 17.968925],
							[-66.206116, 17.968248],
							[-66.206121, 17.96795],
							[-66.20620688688727, 17.963049511397738],
							[-66.206807, 17.963307],
							[-66.21149325979113, 17.96115191258319],
							[-66.215355, 17.959376],
							[-66.218081, 17.95729],
							[-66.2206478150983, 17.954734645603136],
							[-66.22095114922115, 17.95443266585202],
							[-66.22403686089103, 17.951360731730894],
							[-66.22553912835022, 17.949865171821017],
							[-66.22636421011619, 17.949043774004007],
							[-66.22650643530483, 17.94890218384374],
							[-66.231519, 17.943912],
							[-66.229181, 17.934651],
							[-66.232013, 17.931154],
							[-66.252737, 17.934574],
							[-66.260684, 17.936083],
							[-66.27052544819482, 17.94668896339555],
							[-66.270905, 17.947098],
							[-66.27501268485278, 17.94810371635039],
							[-66.27540122005608, 17.94819884443851],
							[-66.27548391651894, 17.94821909165508],
							[-66.275651, 17.94826],
							[-66.290782, 17.946491],
							[-66.29667760328145, 17.95731029110242],
							[-66.297679, 17.959148],
							[-66.30507228601117, 17.965875272596424],
							[-66.31370101969257, 17.97372669935702],
							[-66.31550778351358, 17.975370703487656],
							[-66.31695, 17.976683],
							[-66.32049388678392, 17.977661807901413],
							[-66.323659, 17.978536],
							[-66.32737649985447, 17.978011598079046],
							[-66.33814373833401, 17.97649273842522],
							[-66.337942, 17.978604],
							[-66.339345, 17.980301],
							[-66.342026, 17.987003],
							[-66.342225, 17.993933],
							[-66.340539, 17.995654],
							[-66.339777, 17.996049],
							[-66.33871, 17.997905],
							[-66.338031, 18.001887],
							[-66.335607, 18.00482],
							[-66.335402, 18.004935],
							[-66.331375, 18.014053],
							[-66.331274, 18.015852],
							[-66.330573, 18.019332],
							[-66.328484, 18.019538],
							[-66.325739, 18.018295],
							[-66.323432, 18.020854],
							[-66.321688, 18.024521],
							[-66.32135, 18.025287],
							[-66.318885, 18.029748],
							[-66.315763, 18.029937],
							[-66.315171, 18.029694],
							[-66.315002, 18.029639],
							[-66.314641, 18.030495],
							[-66.314164, 18.031462],
							[-66.312757, 18.032288],
							[-66.312611, 18.034569],
							[-66.31342, 18.036722],
							[-66.31212, 18.040721],
							[-66.312986, 18.04339],
							[-66.312629, 18.044965],
							[-66.309654, 18.047719],
							[-66.308075, 18.048107],
							[-66.303644, 18.050522],
							[-66.29891, 18.055179],
							[-66.297944, 18.056942],
							[-66.292329, 18.056761],
							[-66.284812, 18.059722],
							[-66.279383, 18.068916],
							[-66.277217, 18.069473],
							[-66.268723, 18.069225],
							[-66.266282, 18.070587],
							[-66.265786, 18.070845],
							[-66.26102, 18.072997],
							[-66.258572, 18.074425],
							[-66.257528, 18.075884],
							[-66.24621, 18.076794],
							[-66.244552, 18.07694],
							[-66.242976, 18.077122],
							[-66.241516, 18.081316],
							[-66.240376, 18.082987],
							[-66.23979, 18.087136],
							[-66.239847, 18.087145],
							[-66.23924, 18.093122],
							[-66.236131, 18.093999],
							[-66.231786, 18.095784],
							[-66.224725, 18.095096],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '079',
					name: 'Lajas',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-67.068263, 18.066307],
							[-67.068254, 18.066347],
							[-67.067835, 18.06613],
							[-67.066027, 18.064155],
							[-67.065564, 18.06408],
							[-67.061251, 18.064192],
							[-67.057656, 18.063556],
							[-67.056387, 18.063068],
							[-67.055428, 18.063009],
							[-67.053006, 18.063575],
							[-67.052343, 18.065009],
							[-67.05016, 18.063965],
							[-67.04929, 18.063104],
							[-67.048742, 18.062898],
							[-67.044881, 18.061859],
							[-67.043048, 18.061805],
							[-67.040116, 18.060071],
							[-67.03969, 18.059962],
							[-67.039413, 18.059806],
							[-67.037836, 18.058914],
							[-67.036181, 18.057761],
							[-67.035144, 18.0585],
							[-67.029438, 18.058324],
							[-67.027165, 18.058792],
							[-67.026555, 18.05997],
							[-67.013083, 18.057544],
							[-67.011443, 18.05909],
							[-67.01069, 18.058938],
							[-67.008947, 18.059243],
							[-67.007872, 18.060223],
							[-67.006276, 18.05846],
							[-66.993597, 18.052531],
							[-66.99233, 18.052483],
							[-66.991765, 18.053737],
							[-66.990538, 18.054195],
							[-66.983317, 18.052513],
							[-66.983341, 18.050767],
							[-66.982061, 18.042843],
							[-66.982675, 18.041202],
							[-66.968532, 18.038584],
							[-66.967976, 18.038476],
							[-66.967736, 18.03843],
							[-66.966933, 18.038121],
							[-66.966752, 18.037816],
							[-66.960371, 18.036519],
							[-66.959316, 18.035035],
							[-66.959267, 18.03215],
							[-66.958748, 18.032477],
							[-66.95956, 18.019367],
							[-66.960058, 18.013124],
							[-66.960498, 18.007499],
							[-66.960511, 18.007343],
							[-66.961025, 18.000788],
							[-66.961756, 17.994059],
							[-66.962434, 17.99061],
							[-66.9735, 17.967884],
							[-66.98106061572858, 17.952521206453817],
							[-66.982669, 17.9551],
							[-66.982206, 17.961192],
							[-66.987287, 17.970663],
							[-66.996738, 17.972899],
							[-67.003972, 17.970799],
							[-67.014744, 17.968468],
							[-67.01642960213472, 17.96885656077027],
							[-67.024522, 17.970722],
							[-67.04108986424613, 17.972073846231694],
							[-67.04752331806499, 17.9725987805366],
							[-67.05558712449066, 17.973256742611117],
							[-67.062478, 17.973819],
							[-67.076534, 17.967759],
							[-67.08372380696355, 17.958920616219707],
							[-67.089827, 17.951418],
							[-67.101468, 17.946621],
							[-67.109985, 17.945806],
							[-67.109682, 17.948481],
							[-67.109513, 17.948911],
							[-67.107273, 17.95493],
							[-67.107142, 17.955285],
							[-67.106488, 17.956926],
							[-67.107213, 17.964015],
							[-67.103972, 17.97027],
							[-67.102234, 17.974891],
							[-67.104005, 17.976441],
							[-67.108959, 17.977519],
							[-67.110044, 17.979276],
							[-67.10937, 17.981337],
							[-67.109476, 17.996968],
							[-67.109588, 17.998722],
							[-67.109931, 18.009979],
							[-67.111403, 18.012515],
							[-67.110478, 18.012863],
							[-67.110171, 18.015527],
							[-67.113808, 18.029093],
							[-67.115568, 18.033957],
							[-67.110957, 18.039661],
							[-67.113697, 18.04313],
							[-67.114178, 18.046318],
							[-67.110569, 18.051824],
							[-67.110334, 18.052348],
							[-67.109044, 18.056085],
							[-67.102464, 18.057523],
							[-67.101863, 18.057972],
							[-67.099945, 18.058872],
							[-67.099572, 18.058789],
							[-67.094417, 18.060364],
							[-67.092814, 18.060189],
							[-67.089954, 18.061277],
							[-67.089718, 18.061309],
							[-67.087718, 18.061042],
							[-67.087147, 18.060891],
							[-67.085088, 18.059339],
							[-67.07707, 18.063457],
							[-67.073779, 18.062233],
							[-67.072876, 18.06321],
							[-67.070188, 18.065182],
							[-67.069879, 18.065381],
							[-67.068263, 18.066307],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '095',
					name: 'Maunabo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-65.988523, 18.058941],
							[-65.980277, 18.061091],
							[-65.977794, 18.061024],
							[-65.973677, 18.054901],
							[-65.973582, 18.054146],
							[-65.972241, 18.052898],
							[-65.966392, 18.053885],
							[-65.966349, 18.053913],
							[-65.960659, 18.053225],
							[-65.959082, 18.052224],
							[-65.955112, 18.047768],
							[-65.953069, 18.046696],
							[-65.952017, 18.044694],
							[-65.950367, 18.04595],
							[-65.948639, 18.045716],
							[-65.943141, 18.043836],
							[-65.941466, 18.040846],
							[-65.935184, 18.040723],
							[-65.933736, 18.0368],
							[-65.925134, 18.036826],
							[-65.923215, 18.035299],
							[-65.916901, 18.034247],
							[-65.915624, 18.034321],
							[-65.912062, 18.033103],
							[-65.906205, 18.035253],
							[-65.904715, 18.034106],
							[-65.900228, 18.032931],
							[-65.897377, 18.034025],
							[-65.888172, 18.030154],
							[-65.882224, 18.023965],
							[-65.880938, 18.020861],
							[-65.874606, 18.023404],
							[-65.867644, 18.026048],
							[-65.864627, 18.025698],
							[-65.86319, 18.024032],
							[-65.858943, 18.021194],
							[-65.857638, 18.019508],
							[-65.857355, 18.018038],
							[-65.85737, 18.017945],
							[-65.857295, 18.017837],
							[-65.857293, 18.016945],
							[-65.85120062497519, 18.011874761521288],
							[-65.870335, 18.006597],
							[-65.875122, 18.002826],
							[-65.884937, 17.988521],
							[-65.896102, 17.99026],
							[-65.89622763930757, 17.990174313910448],
							[-65.905319, 17.983974],
							[-65.9104926090737, 17.981872745828092],
							[-65.913007, 17.984929],
							[-65.920488, 17.985074],
							[-65.926154, 17.985998],
							[-65.937919, 17.992037],
							[-65.943137, 17.992612],
							[-65.945935, 17.998021],
							[-65.94868, 18.003886],
							[-65.948761, 18.004595],
							[-65.952385, 18.006029],
							[-65.953302, 18.007407],
							[-65.954037, 18.011585],
							[-65.954915, 18.013448],
							[-65.952833, 18.019285],
							[-65.953564, 18.021704],
							[-65.952848, 18.023111],
							[-65.954252, 18.024332],
							[-65.957648, 18.02602],
							[-65.959813, 18.02818],
							[-65.960924, 18.028259],
							[-65.966133, 18.027981],
							[-65.971954, 18.024463],
							[-65.972316, 18.025208],
							[-65.97565, 18.032859],
							[-65.979413, 18.033008],
							[-65.981901, 18.03484],
							[-65.980972, 18.035814],
							[-65.980041, 18.0385],
							[-65.980143, 18.04026],
							[-65.982212, 18.041272],
							[-65.985578, 18.04521],
							[-65.986043, 18.051698],
							[-65.987873, 18.054752],
							[-65.988181, 18.055576],
							[-65.988523, 18.058941],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: 133,
					name: 'Santa Isabel',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.384618, 18.038629],
							[-66.380904, 18.037514],
							[-66.374613, 18.034016],
							[-66.371959, 18.032597],
							[-66.37081, 18.033692],
							[-66.366491, 18.03559],
							[-66.360856, 18.037082],
							[-66.358423, 18.036853],
							[-66.356847, 18.036849],
							[-66.352865, 18.032176],
							[-66.352193, 18.031588],
							[-66.348518, 18.03057],
							[-66.348416, 18.030445],
							[-66.349288, 18.029133],
							[-66.348436, 18.026156],
							[-66.346687, 18.025025],
							[-66.341682, 18.023698],
							[-66.335884, 18.022614],
							[-66.333656, 18.01963],
							[-66.331548, 18.016344],
							[-66.331274, 18.015852],
							[-66.331375, 18.014053],
							[-66.335402, 18.004935],
							[-66.335607, 18.00482],
							[-66.338031, 18.001887],
							[-66.33871, 17.997905],
							[-66.339777, 17.996049],
							[-66.340539, 17.995654],
							[-66.342225, 17.993933],
							[-66.342026, 17.987003],
							[-66.339345, 17.980301],
							[-66.337942, 17.978604],
							[-66.33814373833401, 17.97649273842522],
							[-66.33839, 17.976458],
							[-66.35333254219798, 17.971361515830075],
							[-66.362511, 17.968231],
							[-66.36488965954457, 17.965105733748736],
							[-66.36505298284847, 17.964891147003506],
							[-66.365098, 17.964832],
							[-66.36527174229803, 17.964495991179536],
							[-66.36840193490457, 17.958442356932316],
							[-66.368777, 17.957717],
							[-66.36885411411357, 17.95754578145641],
							[-66.36892630772563, 17.9573854880349],
							[-66.371591, 17.951469],
							[-66.37969264419054, 17.943970708135193],
							[-66.385059, 17.939004],
							[-66.391227, 17.945819],
							[-66.398945, 17.950925],
							[-66.40014621316514, 17.951504471935653],
							[-66.40799096584568, 17.955288824415625],
							[-66.412131, 17.957286],
							[-66.41710636806094, 17.960581976209003],
							[-66.42627753680677, 17.966657497381462],
							[-66.43774520467751, 17.97425435454094],
							[-66.43789945489202, 17.97435653894841],
							[-66.44258608736018, 17.977461239731593],
							[-66.445481, 17.979379],
							[-66.45038817822538, 17.983241831376528],
							[-66.449412, 17.98415],
							[-66.449294, 17.984235],
							[-66.446093, 17.988156],
							[-66.442804, 17.990579],
							[-66.439544, 17.995211],
							[-66.437889, 17.994371],
							[-66.438206, 17.991636],
							[-66.437105, 17.992184],
							[-66.434841, 17.99668],
							[-66.435091, 17.999039],
							[-66.435744, 18.002806],
							[-66.435017, 18.006711],
							[-66.431543, 18.009675],
							[-66.427948, 18.011076],
							[-66.42537, 18.012002],
							[-66.421169, 18.019183],
							[-66.421249, 18.021262],
							[-66.422395, 18.024805],
							[-66.426085, 18.030815],
							[-66.427481, 18.04047],
							[-66.427096, 18.042646],
							[-66.395176, 18.037044],
							[-66.393124, 18.038576],
							[-66.388269, 18.040141],
							[-66.384618, 18.038629],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '015',
					name: 'Arroyo',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.057015, 18.040167],
							[-66.056333, 18.038982],
							[-66.055055, 18.038207],
							[-66.054054, 18.037871],
							[-66.052523, 18.037955],
							[-66.052375, 18.037604],
							[-66.051388, 18.036782],
							[-66.050902, 18.036282],
							[-66.048955, 18.035986],
							[-66.048108, 18.035614],
							[-66.046484, 18.031864],
							[-66.046068, 18.031398],
							[-66.045146, 18.03082],
							[-66.043683, 18.029445],
							[-66.043265, 18.028019],
							[-66.04331, 18.025187],
							[-66.04408, 18.022819],
							[-66.042661, 18.022057],
							[-66.042248, 18.016539],
							[-66.045656, 18.011119],
							[-66.046928, 18.009097],
							[-66.044628, 18.006501],
							[-66.03978, 18.004213],
							[-66.039036, 18.003208],
							[-66.038447, 18.000647],
							[-66.03772, 17.998425],
							[-66.035176, 17.998522],
							[-66.03315, 17.997598],
							[-66.031797, 17.996342],
							[-66.031185, 17.996139],
							[-66.028981, 17.994665],
							[-66.027968, 17.994493],
							[-66.026334, 17.992766],
							[-66.023972, 17.9903],
							[-66.023411, 17.985032],
							[-66.021984, 17.982267],
							[-66.019687, 17.978624],
							[-66.01952002957326, 17.97836426822526],
							[-66.01953963850758, 17.978353464558065],
							[-66.024, 17.975896],
							[-66.04419716089865, 17.95707780842194],
							[-66.04540054265674, 17.95595658803959],
							[-66.046585, 17.954853],
							[-66.049033, 17.954561],
							[-66.04950133208916, 17.954799500564143],
							[-66.0559437478312, 17.958080334451925],
							[-66.058217, 17.959238],
							[-66.05869614699598, 17.959563065120975],
							[-66.06344872075381, 17.962787328189442],
							[-66.06692956552561, 17.96514881899773],
							[-66.068678, 17.966335],
							[-66.06996832535535, 17.966356991878897],
							[-66.070001, 17.966674],
							[-66.070754, 17.968842],
							[-66.069692, 17.97429],
							[-66.072357, 17.978407],
							[-66.072401, 17.978682],
							[-66.071883, 17.986924],
							[-66.071756, 17.988948],
							[-66.071714, 17.989624],
							[-66.071632, 17.990928],
							[-66.071601, 17.991838],
							[-66.07161, 17.993732],
							[-66.072476, 17.995112],
							[-66.077203, 18.000133],
							[-66.079774, 18.001796],
							[-66.081271, 18.004458],
							[-66.082542, 18.010752],
							[-66.08385, 18.012918],
							[-66.085704, 18.012934],
							[-66.08655, 18.014127],
							[-66.088373, 18.015054],
							[-66.091439, 18.01804],
							[-66.093555, 18.021143],
							[-66.095136, 18.022048],
							[-66.093883, 18.023318],
							[-66.085598, 18.027468],
							[-66.082021, 18.030725],
							[-66.082393, 18.032375],
							[-66.081955, 18.032854],
							[-66.079668, 18.034062],
							[-66.073854, 18.036797],
							[-66.073812, 18.03687],
							[-66.068341, 18.037701],
							[-66.064798, 18.039049],
							[-66.060977, 18.039288],
							[-66.059814, 18.039409],
							[-66.058449, 18.040106],
							[-66.057015, 18.040167],
						],
					],
				},
			},
			{
				type: 'Feature',
				properties: {
					id: '055',
					name: 'Guánica',
				},
				geometry: {
					type: 'Polygon',
					coordinates: [
						[
							[-66.958748, 18.032477],
							[-66.953195, 18.033648],
							[-66.947056, 18.033429],
							[-66.941347, 18.031515],
							[-66.938507, 18.029973],
							[-66.937887, 18.029819],
							[-66.936271, 18.029416],
							[-66.936178, 18.029742],
							[-66.933879, 18.030727],
							[-66.930811, 18.030583],
							[-66.922594, 18.027212],
							[-66.919536, 18.027692],
							[-66.917424, 18.027227],
							[-66.913571, 18.02586],
							[-66.911746, 18.02438],
							[-66.910887, 18.023883],
							[-66.90661, 18.024764],
							[-66.900876, 18.025014],
							[-66.898649, 18.024007],
							[-66.895027, 18.023247],
							[-66.893689, 18.025579],
							[-66.891715, 18.024017],
							[-66.889951, 18.023547],
							[-66.887026, 18.024772],
							[-66.884645, 18.024814],
							[-66.884462, 18.024818],
							[-66.8848, 18.02168],
							[-66.882339, 18.016731],
							[-66.879678, 18.015776],
							[-66.877848, 18.016095],
							[-66.876052, 18.014803],
							[-66.875698, 18.014548],
							[-66.875105, 18.013721],
							[-66.875165, 18.012823],
							[-66.875272, 18.011315],
							[-66.868899, 18.007103],
							[-66.865985, 18.003116],
							[-66.864299, 17.999267],
							[-66.863045, 17.996561],
							[-66.863098, 17.995596],
							[-66.862822, 17.995162],
							[-66.862895, 17.991788],
							[-66.863864, 17.987465],
							[-66.863503, 17.976157],
							[-66.863357, 17.965377],
							[-66.862143, 17.962368],
							[-66.861361, 17.960395],
							[-66.85939312377155, 17.95437435565658],
							[-66.862545, 17.952022],
							[-66.871697, 17.952707],
							[-66.88344, 17.952526],
							[-66.899639, 17.948298],
							[-66.904585, 17.950527],
							[-66.906532, 17.955356],
							[-66.906276, 17.963368],
							[-66.9070605192682, 17.96377373395561],
							[-66.90820003252736, 17.964363062020386],
							[-66.90845519358675, 17.964495025007327],
							[-66.92155760087569, 17.9712712658887],
							[-66.9216698308912, 17.971329308476022],
							[-66.924529, 17.972808],
							[-66.92469282875264, 17.972704504106776],
							[-66.92841569675316, 17.97035264863046],
							[-66.928651, 17.970204],
							[-66.92883237183356, 17.969475940745262],
							[-66.92887494751125, 17.969305034295484],
							[-66.93018316463575, 17.96405361478888],
							[-66.930414, 17.963127],
							[-66.92831889179436, 17.96253675638499],
							[-66.916127, 17.959102],
							[-66.909483, 17.952559],
							[-66.909359, 17.94988],
							[-66.912522, 17.947446],
							[-66.91322272226836, 17.94728620964292],
							[-66.930313, 17.943389],
							[-66.932636, 17.939998],
							[-66.931581, 17.9369],
							[-66.919298, 17.932062],
							[-66.923826, 17.926923],
							[-66.927261, 17.926875],
							[-66.93706598062077, 17.93087073102183],
							[-66.959998, 17.940216],
							[-66.980516, 17.951648],
							[-66.98106061572858, 17.952521206453817],
							[-66.9735, 17.967884],
							[-66.962434, 17.99061],
							[-66.961756, 17.994059],
							[-66.961025, 18.000788],
							[-66.960511, 18.007343],
							[-66.960498, 18.007499],
							[-66.960058, 18.013124],
							[-66.95956, 18.019367],
							[-66.958748, 18.032477],
						],
					],
				},
			},
		],
	};
};
